[
  { "id": 1796236, "name": "Shanghai", "country": "CN", "admin1": "Shanghai", "pop": "24874500" },
  { "id": 1816670, "name": "Beijing", "country": "CN", "admin1": "Beijing", "pop": "18960744" },
  { "id": 1795565, "name": "Shenzhen", "country": "CN", "admin1": "Guangdong", "pop": "17494398" },
  { "id": 1809858, "name": "Guangzhou", "country": "CN", "admin1": "Guangdong", "pop": "16096724" },
  { "id": 2314302, "name": "Kinshasa", "country": "CD", "admin1": "Kinshasa", "pop": "16000000" },
  { "id": 745044, "name": "Istanbul", "country": "TR", "admin1": "Istanbul", "pop": "15701602" },
  { "id": 2332459, "name": "Lagos", "country": "NG", "admin1": "Lagos", "pop": "15388000" },
  {
    "id": 1566083,
    "name": "Ho Chi Minh City",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "14002598"
  },
  { "id": 1815286, "name": "Chengdu", "country": "CN", "admin1": "Sichuan", "pop": "13568357" },
  { "id": 1172451, "name": "Lahore", "country": "PK", "admin1": "Punjab", "pop": "13004135" },
  { "id": 1275339, "name": "Mumbai", "country": "IN", "admin1": "Maharashtra", "pop": "12691836" },
  { "id": 3448439, "name": "São Paulo", "country": "BR", "admin1": "São Paulo", "pop": "12400232" },
  {
    "id": 3530597,
    "name": "Mexico City",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "12294193"
  },
  { "id": 1174872, "name": "Karachi", "country": "PK", "admin1": "Sindh", "pop": "11624219" },
  { "id": 1792947, "name": "Tianjin", "country": "CN", "admin1": "Tianjin", "pop": "11090314" },
  { "id": 1273294, "name": "Delhi", "country": "IN", "admin1": "Delhi", "pop": "11034555" },
  { "id": 1791247, "name": "Wuhan", "country": "CN", "admin1": "Hubei", "pop": "10392693" },
  { "id": 524901, "name": "Moscow", "country": "RU", "admin1": "Moscow", "pop": "10381222" },
  {
    "id": 1185241,
    "name": "Dhaka",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "10356500"
  },
  { "id": 1835848, "name": "Seoul", "country": "KR", "admin1": "Seoul", "pop": "10349312" },
  { "id": 1850147, "name": "Tokyo", "country": "JP", "admin1": "Tokyo", "pop": "9733276" },
  { "id": 1812545, "name": "Dongguan", "country": "CN", "admin1": "Guangdong", "pop": "9644871" },
  { "id": 360630, "name": "Cairo", "country": "EG", "admin1": "Cairo", "pop": "9606916" },
  { "id": 1790630, "name": "Xi’an", "country": "CN", "admin1": "Shaanxi", "pop": "9600000" },
  { "id": 993800, "name": "Johannesburg", "country": "ZA", "admin1": "Gauteng", "pop": "9418183" },
  { "id": 1799962, "name": "Nanjing", "country": "CN", "admin1": "Jiangsu", "pop": "9314685" },
  { "id": 1808926, "name": "Hangzhou", "country": "CN", "admin1": "Zhejiang", "pop": "9236032" },
  { "id": 1811103, "name": "Foshan", "country": "CN", "admin1": "Guangdong", "pop": "9042509" },
  { "id": 2643743, "name": "London", "country": "GB", "admin1": "England", "pop": "8961989" },
  {
    "id": 5128581,
    "name": "New York City",
    "country": "US",
    "admin1": "New York",
    "pop": "8804190"
  },
  { "id": 1642911, "name": "Jakarta", "country": "ID", "admin1": "Jakarta", "pop": "8540121" },
  { "id": 1277333, "name": "Bengaluru", "country": "IN", "admin1": "Karnataka", "pop": "8495492" },
  { "id": 1581130, "name": "Hanoi", "country": "VN", "admin1": "Hanoi", "pop": "8053663" },
  { "id": 1668341, "name": "Taipei", "country": "TW", "admin1": "Taiwan", "pop": "7871900" },
  { "id": 3936456, "name": "Lima", "country": "PE", "admin1": "Lima Province", "pop": "7737002" },
  { "id": 3688689, "name": "Bogotá", "country": "CO", "admin1": "Bogota D.C.", "pop": "7674366" },
  { "id": 1814906, "name": "Chongqing", "country": "CN", "admin1": "Chongqing", "pop": "7457599" },
  { "id": 1819729, "name": "Hong Kong", "country": "HK", "admin1": null, "pop": "7396076" },
  { "id": 98182, "name": "Baghdad", "country": "IQ", "admin1": "Baghdad", "pop": "7216000" },
  { "id": 1797929, "name": "Qingdao", "country": "CN", "admin1": "Shandong", "pop": "7172451" },
  { "id": 112931, "name": "Tehran", "country": "IR", "admin1": "Tehran", "pop": "7153309" },
  { "id": 2034937, "name": "Shenyang", "country": "CN", "admin1": "Liaoning", "pop": "7050000" },
  { "id": 1269843, "name": "Hyderabad", "country": "IN", "admin1": "Telangana", "pop": "6993262" },
  {
    "id": 3451190,
    "name": "Rio de Janeiro",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "6747815"
  },
  { "id": 1886760, "name": "Suzhou", "country": "CN", "admin1": "Jiangsu", "pop": "6715559" },
  { "id": 1279233, "name": "Ahmedabad", "country": "IN", "admin1": "Gujarat", "pop": "6357693" },
  {
    "id": 2293538,
    "name": "Abidjan",
    "country": "CI",
    "admin1": "Abidjan Autonomous District",
    "pop": "6321017"
  },
  { "id": 1880252, "name": "Singapore", "country": "SG", "admin1": null, "pop": "5638700" },
  {
    "id": 2147714,
    "name": "Sydney",
    "country": "AU",
    "admin1": "New South Wales",
    "pop": "5557233"
  },
  {
    "id": 160263,
    "name": "Dar es Salaam",
    "country": "TZ",
    "admin1": "Dar es Salaam Region",
    "pop": "5383728"
  },
  {
    "id": 498817,
    "name": "Saint Petersburg",
    "country": "RU",
    "admin1": "St.-Petersburg",
    "pop": "5351935"
  },
  { "id": 2158177, "name": "Melbourne", "country": "AU", "admin1": "Victoria", "pop": "5350705" },
  { "id": 361058, "name": "Alexandria", "country": "EG", "admin1": "Alexandria", "pop": "5263542" },
  { "id": 2037013, "name": "Harbin", "country": "CN", "admin1": "Heilongjiang", "pop": "5242897" },
  { "id": 1609350, "name": "Bangkok", "country": "TH", "admin1": "Bangkok", "pop": "5104476" },
  { "id": 1808722, "name": "Hefei", "country": "CN", "admin1": "Anhui", "pop": "5050000" },
  { "id": 1814087, "name": "Dalian", "country": "CN", "admin1": "Liaoning", "pop": "4913879" },
  { "id": 2335204, "name": "Kano", "country": "NG", "admin1": "Kano State", "pop": "4910000" },
  {
    "id": 3871336,
    "name": "Santiago",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "4837295"
  },
  {
    "id": 3369157,
    "name": "Cape Town",
    "country": "ZA",
    "admin1": "Western Cape",
    "pop": "4772846"
  },
  {
    "id": 1168197,
    "name": "Peshawar",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "4758762"
  },
  { "id": 2038180, "name": "Changchun", "country": "CN", "admin1": "Jilin", "pop": "4714996" },
  { "id": 105343, "name": "Jeddah", "country": "SA", "admin1": "Mecca Region", "pop": "4697000" },
  { "id": 1264527, "name": "Chennai", "country": "IN", "admin1": "Tamil Nadu", "pop": "4681087" },
  { "id": 1275004, "name": "Kolkata", "country": "IN", "admin1": "West Bengal", "pop": "4631392" },
  { "id": 1790645, "name": "Xiamen", "country": "CN", "admin1": "Fujian", "pop": "4617251" },
  { "id": 1255364, "name": "Surat", "country": "IN", "admin1": "Gujarat", "pop": "4591246" },
  { "id": 1298824, "name": "Yangon", "country": "MM", "admin1": "Yangon", "pop": "4477638" },
  { "id": 13308620, "name": "Bao'an", "country": "CN", "admin1": "Guangdong", "pop": "4476554" },
  { "id": 1138958, "name": "Kabul", "country": "AF", "admin1": "Kabul", "pop": "4434550" },
  {
    "id": 184745,
    "name": "Nairobi",
    "country": "KE",
    "admin1": "Nairobi County",
    "pop": "4397073"
  },
  { "id": 1790923, "name": "Wuxi", "country": "CN", "admin1": "Jiangsu", "pop": "4396835" },
  { "id": 360995, "name": "Giza", "country": "EG", "admin1": "Giza", "pop": "4367343" },
  { "id": 1805753, "name": "Jinan", "country": "CN", "admin1": "Shandong", "pop": "4335989" },
  { "id": 1793511, "name": "Taiyuan", "country": "CN", "admin1": "Shanxi", "pop": "4303673" },
  { "id": 1784658, "name": "Zhengzhou", "country": "CN", "admin1": "Henan", "pop": "4253913" },
  { "id": 2460596, "name": "Bamako", "country": "ML", "admin1": "Bamako", "pop": "4227569" },
  { "id": 108410, "name": "Riyadh", "country": "SA", "admin1": "Riyadh Region", "pop": "4205961" },
  {
    "id": 12908892,
    "name": "New Taipei City",
    "country": "TW",
    "admin1": "Taipei",
    "pop": "4004367"
  },
  { "id": 1795270, "name": "Shijiazhuang", "country": "CN", "admin1": "Hebei", "pop": "3938513" },
  {
    "id": 1205733,
    "name": "Chattogram",
    "country": "BD",
    "admin1": "Chittagong",
    "pop": "3920222"
  },
  {
    "id": 344979,
    "name": "Addis Ababa",
    "country": "ET",
    "admin1": "Addis Ababa",
    "pop": "3860000"
  },
  { "id": 1804651, "name": "Kunming", "country": "CN", "admin1": "Yunnan", "pop": "3855346" },
  { "id": 6986104, "name": "Zhongshan", "country": "CN", "admin1": "Guangdong", "pop": "3841873" },
  { "id": 1799869, "name": "Nanning", "country": "CN", "admin1": "Guangxi", "pop": "3839800" },
  { "id": 1795940, "name": "Shantou", "country": "CN", "admin1": "Guangdong", "pop": "3838900" },
  {
    "id": 5368361,
    "name": "Los Angeles",
    "country": "US",
    "admin1": "California",
    "pop": "3820914"
  },
  { "id": 1179400, "name": "Faisalabad", "country": "PK", "admin1": "Punjab", "pop": "3800193" },
  { "id": 292223, "name": "Dubai", "country": "AE", "admin1": "Dubai", "pop": "3790000" },
  { "id": 1848354, "name": "Yokohama", "country": "JP", "admin1": "Kanagawa", "pop": "3777491" },
  { "id": 1810821, "name": "Fuzhou", "country": "CN", "admin1": "Fujian", "pop": "3740000" },
  { "id": 1799397, "name": "Ningbo", "country": "CN", "admin1": "Zhejiang", "pop": "3731203" },
  {
    "id": 2553604,
    "name": "Casablanca",
    "country": "MA",
    "admin1": "Casablanca-Settat",
    "pop": "3665954"
  },
  { "id": 2339354, "name": "Ibadan", "country": "NG", "admin1": "Oyo State", "pop": "3649000" },
  { "id": 1798425, "name": "Puyang", "country": "CN", "admin1": "Zhejiang", "pop": "3590000" },
  { "id": 323786, "name": "Ankara", "country": "TR", "admin1": "Ankara", "pop": "3517182" },
  { "id": 1794903, "name": "Shiyan", "country": "CN", "admin1": "Hubei", "pop": "3460000" },
  {
    "id": 2950159,
    "name": "Berlin",
    "country": "DE",
    "admin1": "State of Berlin",
    "pop": "3426354"
  },
  { "id": 1793346, "name": "Tangshan", "country": "CN", "admin1": "Hebei", "pop": "3372102" },
  { "id": 1166993, "name": "Rawalpindi", "country": "PK", "admin1": "Punjab", "pop": "3357612" },
  { "id": 13512505, "name": "Lüliang", "country": "CN", "admin1": "Shanxi", "pop": "3346500" },
  { "id": 1838524, "name": "Busan", "country": "KR", "admin1": "Busan", "pop": "3343903" },
  { "id": 1007311, "name": "Durban", "country": "ZA", "admin1": "KwaZulu-Natal", "pop": "3338026" },
  { "id": 1815456, "name": "Changzhou", "country": "CN", "admin1": "Jiangsu", "pop": "3290918" },
  { "id": 3117735, "name": "Madrid", "country": "ES", "admin1": "Madrid", "pop": "3255944" },
  { "id": 1871859, "name": "Pyongyang", "country": "KP", "admin1": "Pyongyang", "pop": "3222000" },
  { "id": 1785286, "name": "Zibo", "country": "CN", "admin1": "Shandong", "pop": "3129228" },
  { "id": 1259229, "name": "Pune", "country": "IN", "admin1": "Maharashtra", "pop": "3124458" },
  { "id": 750269, "name": "Bursa", "country": "TR", "admin1": "Bursa Province", "pop": "3101833" },
  { "id": 1815577, "name": "Changsha", "country": "CN", "admin1": "Hunan", "pop": "3093980" },
  {
    "id": 1692192,
    "name": "Quezon City",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "3084270"
  },
  { "id": 1269515, "name": "Jaipur", "country": "IN", "admin1": "Rajasthan", "pop": "3046163" },
  { "id": 1843564, "name": "Incheon", "country": "KR", "admin1": "Incheon", "pop": "3039450" },
  { "id": 1809461, "name": "Guiyang", "country": "CN", "admin1": "Guizhou", "pop": "3037159" },
  { "id": 1529102, "name": "Ürümqi", "country": "CN", "admin1": "Xinjiang", "pop": "3029372" },
  {
    "id": 3646738,
    "name": "Caracas",
    "country": "VE",
    "admin1": "Distrito Federal",
    "pop": "3000000"
  },
  { "id": 1804430, "name": "Lanzhou", "country": "CN", "admin1": "Gansu", "pop": "3000000" },
  { "id": 311046, "name": "İzmir", "country": "TR", "admin1": "İzmir Province", "pop": "2938292" },
  { "id": 1806776, "name": "Huizhou", "country": "CN", "admin1": "Guangdong", "pop": "2900113" },
  {
    "id": 3435910,
    "name": "Buenos Aires",
    "country": "AR",
    "admin1": "Buenos Aires F.D.",
    "pop": "2891082"
  },
  { "id": 1625822, "name": "Surabaya", "country": "ID", "admin1": "East Java", "pop": "2874314" },
  { "id": 1809078, "name": "Haikou", "country": "CN", "admin1": "Hainan", "pop": "2873358" },
  { "id": 1668399, "name": "Taichung", "country": "TW", "admin1": "Taiwan", "pop": "2850285" },
  { "id": 1267995, "name": "Kanpur", "country": "IN", "admin1": "Uttar Pradesh", "pop": "2823249" },
  { "id": 703448, "name": "Kyiv", "country": "UA", "admin1": "Kyiv City", "pop": "2797553" },
  { "id": 6167865, "name": "Toronto", "country": "CA", "admin1": "Ontario", "pop": "2794356" },
  { "id": 3652462, "name": "Quito", "country": "EC", "admin1": "Pichincha", "pop": "2781641" },
  { "id": 2174003, "name": "Brisbane", "country": "AU", "admin1": "Queensland", "pop": "2780063" },
  { "id": 2240449, "name": "Luanda", "country": "AO", "admin1": "Luanda", "pop": "2776168" },
  { "id": 1853909, "name": "Osaka", "country": "JP", "admin1": "Osaka", "pop": "2753862" },
  { "id": 1803318, "name": "Linyi", "country": "CN", "admin1": "Shandong", "pop": "2743843" },
  { "id": 1816971, "name": "Baoding", "country": "CN", "admin1": "Hebei", "pop": "2739887" },
  { "id": 1673820, "name": "Kaohsiung", "country": "TW", "admin1": "Takao", "pop": "2737660" },
  { "id": 5110302, "name": "Brooklyn", "country": "US", "admin1": "New York", "pop": "2736074" },
  { "id": 3657509, "name": "Guayaquil", "country": "EC", "admin1": "Guayas", "pop": "2723665" },
  {
    "id": 3470127,
    "name": "Belo Horizonte",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "2721564"
  },
  { "id": 3450554, "name": "Salvador", "country": "BR", "admin1": "Bahia", "pop": "2711840" },
  { "id": 2352778, "name": "Abuja", "country": "NG", "admin1": "FCT", "pop": "2690000" },
  {
    "id": 1200109,
    "name": "Gazipur",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "2674697"
  },
  { "id": 4887398, "name": "Chicago", "country": "US", "admin1": "Illinois", "pop": "2664452" },
  { "id": 1791388, "name": "Wenzhou", "country": "CN", "admin1": "Zhejiang", "pop": "2650000" },
  { "id": 2253354, "name": "Dakar", "country": "SN", "admin1": "Dakar", "pop": "2646503" },
  { "id": 1581298, "name": "Haiphong", "country": "VN", "admin1": "Hai Phong", "pop": "2625200" },
  { "id": 1785725, "name": "Yunfu", "country": "CN", "admin1": "Guangdong", "pop": "2612800" },
  { "id": 53654, "name": "Mogadishu", "country": "SO", "admin1": "Banaadir", "pop": "2587183" },
  { "id": 1649378, "name": "Bekasi", "country": "ID", "admin1": "West Java", "pop": "2564940" },
  { "id": 2298890, "name": "Kumasi", "country": "GH", "admin1": "Ashanti", "pop": "2544530" },
  { "id": 1177662, "name": "Gujranwala", "country": "PK", "admin1": "Punjab", "pop": "2511118" },
  { "id": 1797873, "name": "Huai'an", "country": "CN", "admin1": "Jiangsu", "pop": "2494013" },
  {
    "id": 1264733,
    "name": "Lucknow",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "2472011"
  },
  { "id": 1650357, "name": "Bandung", "country": "ID", "admin1": "West Java", "pop": "2444160" },
  { "id": 1214520, "name": "Medan", "country": "ID", "admin1": "North Sumatra", "pop": "2435252" },
  { "id": 2357048, "name": "Ouagadougou", "country": "BF", "admin1": "Centre", "pop": "2415266" },
  { "id": 1262180, "name": "Nagpur", "country": "IN", "admin1": "Maharashtra", "pop": "2405665" },
  { "id": 3399415, "name": "Fortaleza", "country": "BR", "admin1": "Ceará", "pop": "2400000" },
  {
    "id": 3687925,
    "name": "Cali",
    "country": "CO",
    "admin1": "Valle del Cauca Department",
    "pop": "2392877"
  },
  { "id": 1835329, "name": "Daegu", "country": "KR", "admin1": "Daegu", "pop": "2365523" },
  { "id": 2507480, "name": "Algiers", "country": "DZ", "admin1": "Algiers", "pop": "2364230" },
  { "id": 1800163, "name": "Nanchang", "country": "CN", "admin1": "Jiangxi", "pop": "2357839" },
  {
    "id": 2036892,
    "name": "Hohhot",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "2350000"
  },
  { "id": 1856057, "name": "Nagoya", "country": "JP", "admin1": "Aichi", "pop": "2332176" },
  { "id": 3169070, "name": "Rome", "country": "IT", "admin1": "Lazio", "pop": "2318895" },
  { "id": 5133273, "name": "Queens", "country": "US", "admin1": "New York", "pop": "2316841" },
  { "id": 4699066, "name": "Houston", "country": "US", "admin1": "Texas", "pop": "2314157" },
  {
    "id": 2063523,
    "name": "Perth",
    "country": "AU",
    "admin1": "Western Australia",
    "pop": "2309338"
  },
  {
    "id": 124665,
    "name": "Mashhad",
    "country": "IR",
    "admin1": "Razavi Khorasan",
    "pop": "2307177"
  },
  { "id": 1795855, "name": "Shaoxing", "country": "CN", "admin1": "Zhejiang", "pop": "2300000" },
  { "id": 1799722, "name": "Nantong", "country": "CN", "admin1": "Jiangsu", "pop": "2273326" },
  { "id": 1787093, "name": "Yantai", "country": "CN", "admin1": "Shandong", "pop": "2227733" },
  {
    "id": 922704,
    "name": "Lubumbashi",
    "country": "CD",
    "admin1": "Haut-Katanga",
    "pop": "2221925"
  },
  { "id": 3663517, "name": "Manaus", "country": "BR", "admin1": "Amazonas", "pop": "2219580" },
  {
    "id": 909137,
    "name": "Lusaka",
    "country": "ZM",
    "admin1": "Lusaka Province",
    "pop": "2212301"
  },
  {
    "id": 3469058,
    "name": "Brasília",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "2207718"
  },
  { "id": 1790437, "name": "Zhuhai", "country": "CN", "admin1": "Guangdong", "pop": "2207090" },
  {
    "id": 3492908,
    "name": "Santo Domingo",
    "country": "DO",
    "admin1": "Nacional",
    "pop": "2201941"
  },
  { "id": 2365267, "name": "Lomé", "country": "TG", "admin1": "Maritime", "pop": "2188376" },
  { "id": 1169825, "name": "Multan", "country": "PK", "admin1": "Punjab", "pop": "2169915" },
  { "id": 3553478, "name": "Havana", "country": "CU", "admin1": "Havana", "pop": "2163824" },
  {
    "id": 2038432,
    "name": "Baotou",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "2150000"
  },
  { "id": 1645524, "name": "Depok", "country": "ID", "admin1": "West Java", "pop": "2145400" },
  { "id": 2988507, "name": "Paris", "country": "FR", "admin1": "Île-de-France", "pop": "2138551" },
  {
    "id": 1273865,
    "name": "Coimbatore",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "2136916"
  },
  { "id": 314830, "name": "Gaziantep", "country": "TR", "admin1": "Gaziantep", "pop": "2130432" },
  { "id": 12359313, "name": "Qingyang", "country": "CN", "admin1": "Gansu", "pop": "2125400" },
  {
    "id": 2324774,
    "name": "Port Harcourt",
    "country": "NG",
    "admin1": "Rivers State",
    "pop": "2120000"
  },
  { "id": 964137, "name": "Pretoria", "country": "ZA", "admin1": "Gauteng", "pop": "2112693" },
  { "id": 3860259, "name": "Córdoba", "country": "AR", "admin1": "Cordoba", "pop": "2106734" },
  { "id": 209228, "name": "Mbuji-Mayi", "country": "CD", "admin1": "East Kasai", "pop": "2101332" },
  { "id": 170063, "name": "Aleppo", "country": "SY", "admin1": "Aleppo", "pop": "2098210" },
  { "id": 1785623, "name": "Kunshan", "country": "CN", "admin1": "Jiangsu", "pop": "2092496" },
  { "id": 1791681, "name": "Weifang", "country": "CN", "admin1": "Shandong", "pop": "2044028" },
  { "id": 1783621, "name": "Zunyi", "country": "CN", "admin1": "Guizhou", "pop": "2037775" },
  {
    "id": 3911925,
    "name": "La Paz",
    "country": "BO",
    "admin1": "La Paz Department",
    "pop": "2004652"
  },
  { "id": 10859300, "name": "Lianyungang", "country": "CN", "admin1": "Jiangsu", "pop": "2001009" },
  { "id": 3674962, "name": "Medellín", "country": "CO", "admin1": "Antioquia", "pop": "1999979" },
  {
    "id": 1269743,
    "name": "Indore",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "1994397"
  },
  {
    "id": 2260535,
    "name": "Brazzaville",
    "country": "CG",
    "admin1": "Brazzaville",
    "pop": "1982000"
  },
  { "id": 1512569, "name": "Tashkent", "country": "UZ", "admin1": "Tashkent", "pop": "1978028" },
  { "id": 1810638, "name": "Ganzhou", "country": "CN", "admin1": "Jiangxi", "pop": "1977253" },
  { "id": 1526384, "name": "Almaty", "country": "KZ", "admin1": "Almaty", "pop": "1977011" },
  { "id": 379252, "name": "Khartoum", "country": "SD", "admin1": "Khartoum", "pop": "1974647" },
  { "id": 2128295, "name": "Sapporo", "country": "JP", "admin1": "Hokkaido", "pop": "1973832" },
  { "id": 2306104, "name": "Accra", "country": "GH", "admin1": "Greater Accra", "pop": "1963264" },
  { "id": 3464975, "name": "Curitiba", "country": "BR", "admin1": "Paraná", "pop": "1948626" },
  { "id": 8347664, "name": "Ordos", "country": "CN", "admin1": "Inner Mongolia", "pop": "1940653" },
  { "id": 71137, "name": "Sanaa", "country": "YE", "admin1": "Amanat Alasimah", "pop": "1937451" },
  { "id": 2422465, "name": "Conakry", "country": "GN", "admin1": "Conakry", "pop": "1928389" },
  {
    "id": 3981609,
    "name": "Tijuana",
    "country": "MX",
    "admin1": "Baja California",
    "pop": "1922523"
  },
  { "id": 1176734, "name": "Hyderabad", "country": "PK", "admin1": "Sindh", "pop": "1921275" },
  { "id": 276781, "name": "Beirut", "country": "LB", "admin1": "Beyrouth", "pop": "1916100" },
  { "id": 1625084, "name": "Tangerang", "country": "ID", "admin1": "Banten", "pop": "1912679" },
  { "id": 1797121, "name": "Jieyang", "country": "CN", "admin1": "Guangdong", "pop": "1899394" },
  { "id": 2036502, "name": "Jilin", "country": "CN", "admin1": "Jilin", "pop": "1895865" },
  { "id": 683506, "name": "Bucharest", "country": "RO", "admin1": "București", "pop": "1877155" },
  { "id": 2422488, "name": "Camayenne", "country": "GN", "admin1": "Conakry", "pop": "1871242" },
  {
    "id": 195272,
    "name": "Kakamega",
    "country": "KE",
    "admin1": "Kakamega County",
    "pop": "1867579"
  },
  { "id": 1800146, "name": "Nanchong", "country": "CN", "admin1": "Sichuan", "pop": "1858875" },
  { "id": 1668355, "name": "Tainan", "country": "TW", "admin1": "Taiwan", "pop": "1856642" },
  { "id": 2335727, "name": "Kaduna", "country": "NG", "admin1": "Kaduna State", "pop": "1850000" },
  { "id": 2037799, "name": "Datong", "country": "CN", "admin1": "Shanxi", "pop": "1850000" },
  { "id": 365137, "name": "Omdurman", "country": "SD", "admin1": "Khartoum", "pop": "1849659" },
  { "id": 1715348, "name": "Davao", "country": "PH", "admin1": "Davao Region", "pop": "1848947" },
  { "id": 2911298, "name": "Hamburg", "country": "DE", "admin1": "Hamburg", "pop": "1845229" },
  { "id": 1254661, "name": "Thāne", "country": "IN", "admin1": "Maharashtra", "pop": "1841488" },
  {
    "id": 3526683,
    "name": "Iztapalapa",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "1835486"
  },
  {
    "id": 3904906,
    "name": "Santa Cruz de la Sierra",
    "country": "BO",
    "admin1": "Santa Cruz Department",
    "pop": "1831434"
  },
  { "id": 1253573, "name": "Vadodara", "country": "IN", "admin1": "Gujarat", "pop": "1822221" },
  { "id": 325363, "name": "Adana", "country": "TR", "admin1": "Adana", "pop": "1816750" },
  { "id": 1799629, "name": "Nanyang", "country": "CN", "admin1": "Henan", "pop": "1811812" },
  { "id": 292968, "name": "Abu Dhabi", "country": "AE", "admin1": "Abu Dhabi", "pop": "1807000" },
  { "id": 292672, "name": "Sharjah", "country": "AE", "admin1": "Sharjah", "pop": "1800000" },
  {
    "id": 1275841,
    "name": "Bhopal",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "1798218"
  },
  { "id": 1806299, "name": "Jiangmen", "country": "CN", "admin1": "Guangdong", "pop": "1795459" },
  {
    "id": 316541,
    "name": "Diyarbakır",
    "country": "TR",
    "admin1": "Diyarbakır Province",
    "pop": "1791373"
  },
  { "id": 2347283, "name": "Benin City", "country": "NG", "admin1": "Edo State", "pop": "1782000" },
  { "id": 1815251, "name": "Jiangyin", "country": "CN", "admin1": "Jiangsu", "pop": "1779515" },
  { "id": 1810845, "name": "Fuyang", "country": "CN", "admin1": "Anhui", "pop": "1768947" },
  { "id": 6077243, "name": "Montréal", "country": "CA", "admin1": "Quebec", "pop": "1762949" },
  {
    "id": 11838258,
    "name": "Bayan Nur",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "1760000"
  },
  { "id": 3633009, "name": "Maracaibo", "country": "VE", "admin1": "Zulia", "pop": "1752602" },
  { "id": 1815395, "name": "Chaozhou", "country": "CN", "admin1": "Guangdong", "pop": "1750945" },
  { "id": 625144, "name": "Minsk", "country": "BY", "admin1": "Minsk City", "pop": "1742124" },
  { "id": 3054643, "name": "Budapest", "country": "HU", "admin1": "Budapest", "pop": "1741041" },
  { "id": 1797945, "name": "Qingyuan", "country": "CN", "admin1": "Guangdong", "pop": "1738424" },
  { "id": 1793724, "name": "Tai’an", "country": "CN", "admin1": "Shandong", "pop": "1735425" },
  {
    "id": 1258393,
    "name": "Rasapūdipalem",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "1728128"
  },
  {
    "id": 7626690,
    "name": "Pimpri-Chinchwad",
    "country": "IN",
    "admin1": "Maharashtra",
    "pop": "1727692"
  },
  {
    "id": 1720151,
    "name": "Caloocan City",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "1712945"
  },
  { "id": 756135, "name": "Warsaw", "country": "PL", "admin1": "Mazovia", "pop": "1702139" },
  { "id": 953781, "name": "Soweto", "country": "ZA", "admin1": "Gauteng", "pop": "1695047" },
  { "id": 3521081, "name": "Puebla", "country": "MX", "admin1": "Puebla", "pop": "1692181" },
  { "id": 2761369, "name": "Vienna", "country": "AT", "admin1": "Vienna", "pop": "1691468" },
  { "id": 3128760, "name": "Barcelona", "country": "ES", "admin1": "Catalonia", "pop": "1686208" },
  { "id": 1260086, "name": "Patna", "country": "IN", "admin1": "Bihar", "pop": "1684297" },
  { "id": 99072, "name": "Mosul", "country": "IQ", "admin1": "Nineveh", "pop": "1683000" },
  {
    "id": 12165956,
    "name": "Kallakurichi",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "1682687"
  },
  {
    "id": 232422,
    "name": "Kampala",
    "country": "UG",
    "admin1": "Central Region",
    "pop": "1680600"
  },
  { "id": 1788852, "name": "Xining", "country": "CN", "admin1": "Qinghai", "pop": "1677177" },
  { "id": 7283386, "name": "Changshu", "country": "CN", "admin1": "Jiangsu", "pop": "1677050" },
  {
    "id": 1633070,
    "name": "Palembang",
    "country": "ID",
    "admin1": "South Sumatra",
    "pop": "1668848"
  },
  { "id": 1807681, "name": "Huainan", "country": "CN", "admin1": "Anhui", "pop": "1666826" },
  {
    "id": 2538475,
    "name": "Rabat",
    "country": "MA",
    "admin1": "Rabat-Salé-Kénitra",
    "pop": "1655753"
  },
  {
    "id": 1627896,
    "name": "Semarang",
    "country": "ID",
    "admin1": "Central Java",
    "pop": "1653524"
  },
  { "id": 3390760, "name": "Recife", "country": "BR", "admin1": "Pernambuco", "pop": "1653461" },
  { "id": 5308655, "name": "Phoenix", "country": "US", "admin1": "Arizona", "pop": "1650070" },
  { "id": 1793743, "name": "Suzhou", "country": "CN", "admin1": "Anhui", "pop": "1647642" },
  {
    "id": 3529612,
    "name": "Ecatepec de Morelos",
    "country": "MX",
    "admin1": "México",
    "pop": "1645352"
  },
  { "id": 1802206, "name": "Lu’an", "country": "CN", "admin1": "Anhui", "pop": "1644344" },
  { "id": 3625549, "name": "Valencia", "country": "VE", "admin1": "Carabobo", "pop": "1619470" },
  { "id": 1264728, "name": "Ludhiana", "country": "IN", "admin1": "Punjab", "pop": "1618879" },
  { "id": 1787746, "name": "Yancheng", "country": "CN", "admin1": "Jiangsu", "pop": "1615717" },
  {
    "id": 1496747,
    "name": "Novosibirsk",
    "country": "RU",
    "admin1": "Novosibirsk Oblast",
    "pop": "1612833"
  },
  { "id": 95446, "name": "Erbil", "country": "IQ", "admin1": "Erbil", "pop": "1612700" },
  { "id": 1863967, "name": "Fukuoka", "country": "JP", "admin1": "Fukuoka", "pop": "1612392" },
  { "id": 1793505, "name": "Taizhou", "country": "CN", "admin1": "Jiangsu", "pop": "1607108" },
  { "id": 2037860, "name": "Daqing", "country": "CN", "admin1": "Heilongjiang", "pop": "1604027" },
  { "id": 1701668, "name": "Manila", "country": "PH", "admin1": "Metro Manila", "pop": "1600000" },
  { "id": 1791236, "name": "Wuhu", "country": "CN", "admin1": "Anhui", "pop": "1598165" },
  {
    "id": 3991164,
    "name": "Santiago de Querétaro",
    "country": "MX",
    "admin1": "Querétaro",
    "pop": "1594212"
  },
  { "id": 1813325, "name": "Dazhou", "country": "CN", "admin1": "Sichuan", "pop": "1589435" },
  { "id": 1787227, "name": "Yangzhou", "country": "CN", "admin1": "Jiangsu", "pop": "1584237" },
  {
    "id": 3998655,
    "name": "León de los Aldama",
    "country": "MX",
    "admin1": "Guanajuato",
    "pop": "1579803"
  },
  { "id": 104515, "name": "Makkah", "country": "SA", "admin1": "Mecca Region", "pop": "1578722" },
  {
    "id": 4560349,
    "name": "Philadelphia",
    "country": "US",
    "admin1": "Pennsylvania",
    "pop": "1573916"
  },
  {
    "id": 1821306,
    "name": "Phnom Penh",
    "country": "KH",
    "admin1": "Phnom Penh",
    "pop": "1573544"
  },
  { "id": 1809498, "name": "Guilin", "country": "CN", "admin1": "Guangxi", "pop": "1572300" },
  { "id": 170654, "name": "Damascus", "country": "SY", "admin1": "Dimashq", "pop": "1569394" },
  { "id": 1167528, "name": "Quetta", "country": "PK", "admin1": "Balochistan", "pop": "1565546" },
  { "id": 1784853, "name": "Zhaoqing", "country": "CN", "admin1": "Guangdong", "pop": "1553109" },
  { "id": 2326016, "name": "Onitsha", "country": "NG", "admin1": "Anambra", "pop": "1553000" },
  { "id": 1800627, "name": "Mianyang", "country": "CN", "admin1": "Sichuan", "pop": "1550000" },
  { "id": 418863, "name": "Isfahan", "country": "IR", "admin1": "Isfahan", "pop": "1547164" },
  { "id": 12358576, "name": "Wanzhou", "country": "CN", "admin1": "Chongqing", "pop": "1545900" },
  { "id": 890299, "name": "Harare", "country": "ZW", "admin1": "Harare", "pop": "1542813" },
  {
    "id": 2274895,
    "name": "Monrovia",
    "country": "LR",
    "admin1": "Montserrado County",
    "pop": "1542549"
  },
  { "id": 1798449, "name": "Putian", "country": "CN", "admin1": "Fujian", "pop": "1539389" },
  { "id": 1859642, "name": "Kawasaki", "country": "JP", "admin1": "Kanagawa", "pop": "1538262" },
  { "id": 1783934, "name": "Shangqiu", "country": "CN", "admin1": "Henan", "pop": "1536392" },
  { "id": 3462377, "name": "Goiânia", "country": "BR", "admin1": "Goiás", "pop": "1536097" },
  { "id": 2193733, "name": "Auckland", "country": "NZ", "admin1": "Auckland", "pop": "1530500" },
  { "id": 4726206, "name": "San Antonio", "country": "US", "admin1": "Texas", "pop": "1526656" },
  { "id": 1859171, "name": "Kobe", "country": "JP", "admin1": "Hyōgo", "pop": "1525152" },
  { "id": 2673730, "name": "Stockholm", "country": "SE", "admin1": "Stockholm", "pop": "1515017" },
  {
    "id": 4013708,
    "name": "Ciudad Juárez",
    "country": "MX",
    "admin1": "Chihuahua",
    "pop": "1512450"
  },
  { "id": 1586203, "name": "Cần Thơ", "country": "VN", "admin1": "Can Tho City", "pop": "1507187" },
  {
    "id": 1336135,
    "name": "Khulna",
    "country": "BD",
    "admin1": "Khulna Division",
    "pop": "1500689"
  },
  { "id": 3405870, "name": "Belém", "country": "BR", "admin1": "Pará", "pop": "1499641" },
  {
    "id": 1486209,
    "name": "Yekaterinburg",
    "country": "RU",
    "admin1": "Sverdlovsk Oblast",
    "pop": "1495066"
  },
  {
    "id": 3452925,
    "name": "Porto Alegre",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "1488252"
  },
  { "id": 1786657, "name": "Yinchuan", "country": "CN", "admin1": "Ningxia", "pop": "1487579" },
  { "id": 5125771, "name": "Manhattan", "country": "US", "admin1": "New York", "pop": "1487536" },
  { "id": 1261731, "name": "Nashik", "country": "IN", "admin1": "Maharashtra", "pop": "1486053" },
  { "id": 8400694, "name": "Taizhou", "country": "CN", "admin1": "Zhejiang", "pop": "1485502" },
  { "id": 3439389, "name": "Asunción", "country": "PY", "admin1": "Asunción", "pop": "1482200" },
  { "id": 1814870, "name": "Yiwu", "country": "CN", "admin1": "Zhejiang", "pop": "1481384" },
  { "id": 3979770, "name": "Zapopan", "country": "MX", "admin1": "Jalisco", "pop": "1476491" },
  { "id": 1835235, "name": "Daejeon", "country": "KR", "admin1": "Daejeon", "pop": "1470336" },
  {
    "id": 2078025,
    "name": "Adelaide",
    "country": "AU",
    "admin1": "South Australia",
    "pop": "1469163"
  },
  { "id": 1797353, "name": "Quanzhou", "country": "CN", "admin1": "Fujian", "pop": "1469157" },
  { "id": 1264521, "name": "Madurai", "country": "IN", "admin1": "Tamil Nadu", "pop": "1465625" },
  { "id": 1805528, "name": "Jinhua", "country": "CN", "admin1": "Zhejiang", "pop": "1463990" },
  { "id": 1857910, "name": "Kyoto", "country": "JP", "admin1": "Kyoto", "pop": "1463723" },
  { "id": 1806602, "name": "Cixi", "country": "CN", "admin1": "Zhejiang", "pop": "1457510" },
  { "id": 1791121, "name": "Changde", "country": "CN", "admin1": "Hunan", "pop": "1457419" },
  {
    "id": 1735161,
    "name": "Kuala Lumpur",
    "country": "MY",
    "admin1": "Kuala Lumpur",
    "pop": "1453975"
  },
  { "id": 1804879, "name": "Kaifeng", "country": "CN", "admin1": "Henan", "pop": "1451741" },
  { "id": 2038632, "name": "Anshan", "country": "CN", "admin1": "Liaoning", "pop": "1450000" },
  { "id": 128747, "name": "Karaj", "country": "IR", "admin1": "Alborz Province", "pop": "1448075" },
  {
    "id": 1283240,
    "name": "Kathmandu",
    "country": "NP",
    "admin1": "Bagmati Province",
    "pop": "1442271"
  },
  { "id": 10942359, "name": "Baoji", "country": "CN", "admin1": "Shaanxi", "pop": "1437802" },
  { "id": 1793771, "name": "Suqian", "country": "CN", "admin1": "Jiangsu", "pop": "1437685" },
  { "id": 1803300, "name": "Liuzhou", "country": "CN", "admin1": "Guangxi", "pop": "1436599" },
  {
    "id": 1254361,
    "name": "Tirunelveli",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "1435844"
  },
  { "id": 308464, "name": "Kayseri", "country": "TR", "admin1": "Kayseri", "pop": "1434357" },
  {
    "id": 706483,
    "name": "Kharkiv",
    "country": "UA",
    "admin1": "Kharkivs’ka Oblast’",
    "pop": "1433886"
  },
  { "id": 306571, "name": "Konya", "country": "TR", "admin1": "Konya", "pop": "1433861" },
  { "id": 1787331, "name": "Zhangjiagang", "country": "CN", "admin1": "Jiangsu", "pop": "1432044" },
  { "id": 1279259, "name": "Agra", "country": "IN", "admin1": "Uttar Pradesh", "pop": "1430055" },
  {
    "id": 113646,
    "name": "Tabriz",
    "country": "IR",
    "admin1": "East Azerbaijan",
    "pop": "1424641"
  },
  {
    "id": 1622786,
    "name": "Makassar",
    "country": "ID",
    "admin1": "South Sulawesi",
    "pop": "1423877"
  },
  { "id": 1797658, "name": "Jinjiang", "country": "CN", "admin1": "Fujian", "pop": "1416151" },
  { "id": 1271951, "name": "Faridabad", "country": "IN", "admin1": "Haryana", "pop": "1414050" },
  { "id": 1816234, "name": "Bozhou", "country": "CN", "admin1": "Anhui", "pop": "1409436" },
  { "id": 1797318, "name": "Qujing", "country": "CN", "admin1": "Yunnan", "pop": "1408500" },
  {
    "id": 8581443,
    "name": "South Tangerang",
    "country": "ID",
    "admin1": "Banten",
    "pop": "1404785"
  },
  { "id": 5391811, "name": "San Diego", "country": "US", "admin1": "California", "pop": "1404452" },
  { "id": 1784990, "name": "Zhanjiang", "country": "CN", "admin1": "Guangdong", "pop": "1400709" },
  { "id": 2037355, "name": "Fushun", "country": "CN", "admin1": "Liaoning", "pop": "1400646" },
  { "id": 1841811, "name": "Gwangju", "country": "KR", "admin1": "Gwangju", "pop": "1398538" },
  { "id": 1258847, "name": "Rājkot", "country": "IN", "admin1": "Gujarat", "pop": "1390640" },
  { "id": 1801792, "name": "Luoyang", "country": "CN", "admin1": "Henan", "pop": "1390581" },
  { "id": 4005539, "name": "Guadalajara", "country": "MX", "admin1": "Jalisco", "pop": "1385629" },
  { "id": 5110266, "name": "The Bronx", "country": "US", "admin1": "New York", "pop": "1385108" },
  { "id": 1802875, "name": "Guankou", "country": "CN", "admin1": "Hunan", "pop": "1380000" },
  {
    "id": 1580240,
    "name": "Huế",
    "country": "VN",
    "admin1": "Thừa Thiên Huế Province",
    "pop": "1380000"
  },
  { "id": 3173435, "name": "Milan", "country": "IT", "admin1": "Lombardy", "pop": "1371498" },
  { "id": 1262111, "name": "Najafgarh", "country": "IN", "admin1": "Delhi", "pop": "1365000" },
  { "id": 2427123, "name": "N'Djamena", "country": "TD", "admin1": "N’Djaména", "pop": "1359526" },
  { "id": 1808963, "name": "Handan", "country": "CN", "admin1": "Hebei", "pop": "1358318" },
  {
    "id": 1183460,
    "name": "Bannu",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "1357890"
  },
  { "id": 1786764, "name": "Yichang", "country": "CN", "admin1": "Hubei", "pop": "1350150" },
  {
    "id": 1070940,
    "name": "Antananarivo",
    "country": "MG",
    "admin1": "Analamanga",
    "pop": "1349501"
  },
  { "id": 1808198, "name": "Heze", "country": "CN", "admin1": "Shandong", "pop": "1346717" },
  { "id": 323777, "name": "Antalya", "country": "TR", "admin1": "Antalya", "pop": "1344000" },
  {
    "id": 2293521,
    "name": "Abobo",
    "country": "CI",
    "admin1": "Abidjan Autonomous District",
    "pop": "1340083"
  },
  { "id": 1269300, "name": "Jamshedpur", "country": "IN", "admin1": "Jharkhand", "pop": "1339438" },
  { "id": 2232593, "name": "Douala", "country": "CM", "admin1": "Littoral", "pop": "1338082" },
  { "id": 99532, "name": "Basrah", "country": "IQ", "admin1": "Basra", "pop": "1326564" },
  { "id": 4684888, "name": "Dallas", "country": "US", "admin1": "Texas", "pop": "1326087" },
  { "id": 6940394, "name": "Saitama", "country": "JP", "admin1": "Saitama", "pop": "1324854" },
  { "id": 1270926, "name": "Gorakhpur", "country": "IN", "admin1": "Haryana", "pop": "1324570" },
  { "id": 2440485, "name": "Niamey", "country": "NE", "admin1": "Niamey", "pop": "1323691" },
  { "id": 8533133, "name": "Liupanshui", "country": "CN", "admin1": "Guizhou", "pop": "1320825" },
  { "id": 1684308, "name": "Taguig", "country": "PH", "admin1": "Metro Manila", "pop": "1308085" },
  { "id": 1801180, "name": "Maoming", "country": "CN", "admin1": "Guangdong", "pop": "1307802" },
  { "id": 5913490, "name": "Calgary", "country": "CA", "admin1": "Alberta", "pop": "1306784" },
  { "id": 2210247, "name": "Tripoli", "country": "LY", "admin1": "Tripoli", "pop": "1302947" },
  { "id": 3946083, "name": "Callao", "country": "PE", "admin1": "Callao", "pop": "1300000" },
  { "id": 109223, "name": "Madinah", "country": "SA", "admin1": "Medina Region", "pop": "1300000" },
  { "id": 2220957, "name": "Yaoundé", "country": "CM", "admin1": "Centre", "pop": "1299369" },
  { "id": 1797551, "name": "Qinzhou", "country": "CN", "admin1": "Guangxi", "pop": "1296300" },
  { "id": 1801934, "name": "Luohe", "country": "CN", "admin1": "Henan", "pop": "1294974" },
  { "id": 1790587, "name": "Xiangyang", "country": "CN", "admin1": "Hubei", "pop": "1294733" },
  { "id": 1806408, "name": "Yangjiang", "country": "CN", "admin1": "Guangdong", "pop": "1292987" },
  { "id": 1786760, "name": "Yixing", "country": "CN", "admin1": "Jiangsu", "pop": "1285785" },
  { "id": 1259652, "name": "Pimpri", "country": "IN", "admin1": "Maharashtra", "pop": "1284606" },
  { "id": 1583992, "name": "Da Nang", "country": "VN", "admin1": "Da Nang City", "pop": "1276000" },
  { "id": 250441, "name": "Amman", "country": "JO", "admin1": "Amman", "pop": "1275857" },
  {
    "id": 1723510,
    "name": "Budta",
    "country": "PH",
    "admin1": "Autonomous Region in Muslim Mindanao",
    "pop": "1273715"
  },
  {
    "id": 792680,
    "name": "Belgrade",
    "country": "RS",
    "admin1": "Central Serbia",
    "pop": "1273651"
  },
  { "id": 1587923, "name": "Biên Hòa", "country": "VN", "admin1": "Dong Nai", "pop": "1272235" },
  {
    "id": 3441575,
    "name": "Montevideo",
    "country": "UY",
    "admin1": "Montevideo Department",
    "pop": "1270737"
  },
  { "id": 1788046, "name": "Xuchang", "country": "CN", "admin1": "Henan", "pop": "1265536" },
  { "id": 1268295, "name": "Kalyān", "country": "IN", "admin1": "Maharashtra", "pop": "1262255" },
  { "id": 1783745, "name": "Zigong", "country": "CN", "admin1": "Sichuan", "pop": "1262064" },
  { "id": 2867714, "name": "Munich", "country": "DE", "admin1": "Bavaria", "pop": "1260391" },
  {
    "id": 520555,
    "name": "Nizhniy Novgorod",
    "country": "RU",
    "admin1": "Nizhny Novgorod Oblast",
    "pop": "1259013"
  },
  { "id": 1642548, "name": "Jepara", "country": "ID", "admin1": "Central Java", "pop": "1257912" },
  { "id": 1040652, "name": "Maputo", "country": "MZ", "admin1": "Maputo City", "pop": "1254837" },
  { "id": 10630003, "name": "Xuzhou", "country": "CN", "admin1": "Jiangsu", "pop": "1253991" },
  {
    "id": 110336,
    "name": "Dammam",
    "country": "SA",
    "admin1": "Eastern Province",
    "pop": "1252523"
  },
  { "id": 1799491, "name": "Neijiang", "country": "CN", "admin1": "Sichuan", "pop": "1251095" },
  { "id": 115019, "name": "Shiraz", "country": "IR", "admin1": "Fars", "pop": "1249942" },
  { "id": 1808316, "name": "Heshan", "country": "CN", "admin1": "Hunan", "pop": "1249807" },
  {
    "id": 1272423,
    "name": "Dombivali",
    "country": "IN",
    "admin1": "Maharashtra",
    "pop": "1247327"
  },
  { "id": 214481, "name": "Kananga", "country": "CD", "admin1": "Kasai-Central", "pop": "1247168" },
  {
    "id": 551487,
    "name": "Kazan",
    "country": "RU",
    "admin1": "Tatarstan Republic",
    "pop": "1243500"
  },
  { "id": 1805518, "name": "Jining", "country": "CN", "admin1": "Shandong", "pop": "1241012" },
  { "id": 3648522, "name": "Barquisimeto", "country": "VE", "admin1": "Lara", "pop": "1240714" },
  {
    "id": 349076,
    "name": "Shubrā al Khaymah",
    "country": "EG",
    "admin1": "Qalyubia",
    "pop": "1240289"
  },
  { "id": 3718426, "name": "Port-au-Prince", "country": "HT", "admin1": "Ouest", "pop": "1234742" },
  { "id": 1788534, "name": "Xinyang", "country": "CN", "admin1": "Henan", "pop": "1230042" },
  { "id": 1803834, "name": "Liaocheng", "country": "CN", "admin1": "Shandong", "pop": "1229768" },
  { "id": 10942283, "name": "Jinzhong", "country": "CN", "admin1": "Shanxi", "pop": "1226617" },
  { "id": 1263214, "name": "Meerut", "country": "IN", "admin1": "Uttar Pradesh", "pop": "1223184" },
  { "id": 1253133, "name": "Virār", "country": "IN", "admin1": "Maharashtra", "pop": "1222390" },
  { "id": 1261162, "name": "Nowrangapur", "country": "IN", "admin1": "Odisha", "pop": "1220946" },
  { "id": 94824, "name": "Karbala", "country": "IQ", "admin1": "Karbalāʼ", "pop": "1218732" },
  { "id": 1808956, "name": "Changzhi", "country": "CN", "admin1": "Shanxi", "pop": "1214940" },
  { "id": 1792892, "name": "Tianshui", "country": "CN", "admin1": "Gansu", "pop": "1212791" },
  {
    "id": 186301,
    "name": "Mombasa",
    "country": "KE",
    "admin1": "Mombasa County",
    "pop": "1208333"
  },
  {
    "id": 1311874,
    "name": "Mandalay",
    "country": "MM",
    "admin1": "Mandalay Region",
    "pop": "1208099"
  },
  {
    "id": 1255634,
    "name": "Srinagar",
    "country": "IN",
    "admin1": "Jammu and Kashmir",
    "pop": "1206419"
  },
  {
    "id": 3689147,
    "name": "Barranquilla",
    "country": "CO",
    "admin1": "Atlántico",
    "pop": "1206319"
  },
  {
    "id": 1508291,
    "name": "Chelyabinsk",
    "country": "RU",
    "admin1": "Chelyabinsk",
    "pop": "1202371"
  },
  { "id": 3523349, "name": "Mérida", "country": "MX", "admin1": "Yucatán", "pop": "1201000" },
  { "id": 1862415, "name": "Hiroshima", "country": "JP", "admin1": "Hiroshima", "pop": "1200754" },
  {
    "id": 3492914,
    "name": "Santiago de los Caballeros",
    "country": "DO",
    "admin1": "Santiago Province",
    "pop": "1200000"
  },
  { "id": 1518980, "name": "Shymkent", "country": "KZ", "admin1": "Shymkent", "pop": "1200000" },
  { "id": 1791636, "name": "Weinan", "country": "CN", "admin1": "Shaanxi", "pop": "1199290" },
  {
    "id": 1271308,
    "name": "Ghāziābād",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "1199191"
  },
  {
    "id": 1039854,
    "name": "Matola",
    "country": "MZ",
    "admin1": "Maputo Province",
    "pop": "1198988"
  },
  { "id": 1272979, "name": "Dhanbad", "country": "IN", "admin1": "Jharkhand", "pop": "1196214" },
  { "id": 2548885, "name": "Fes", "country": "MA", "admin1": "Fès-Meknès", "pop": "1191905" },
  { "id": 1835553, "name": "Suwon", "country": "KR", "admin1": "Gyeonggi-do", "pop": "1191063" },
  {
    "id": 3514674,
    "name": "Gustavo Adolfo Madero",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "1185772"
  },
  { "id": 2377450, "name": "Nouakchott", "country": "MR", "admin1": null, "pop": "1184530" },
  { "id": 212730, "name": "Kisangani", "country": "CD", "admin1": "Tshopo", "pop": "1181788" },
  { "id": 1805953, "name": "Jiaxing", "country": "CN", "admin1": "Zhejiang", "pop": "1180000" },
  {
    "id": 1278149,
    "name": "Aurangabad",
    "country": "IN",
    "admin1": "Maharashtra",
    "pop": "1175116"
  },
  { "id": 1496153, "name": "Omsk", "country": "RU", "admin1": "Omsk Oblast", "pop": "1172070" },
  { "id": 3461786, "name": "Guarulhos", "country": "BR", "admin1": "São Paulo", "pop": "1169577" },
  {
    "id": 1624917,
    "name": "Bandar Lampung",
    "country": "ID",
    "admin1": "Lampung",
    "pop": "1166066"
  },
  { "id": 3067696, "name": "Prague", "country": "CZ", "admin1": "Prague", "pop": "1165581" },
  {
    "id": 1253405,
    "name": "Varanasi",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "1164404"
  },
  { "id": 6295587, "name": "Batam", "country": "ID", "admin1": "Riau", "pop": "1164352" },
  { "id": 1805179, "name": "Jiujiang", "country": "CN", "admin1": "Jiangxi", "pop": "1164268" },
  { "id": 499099, "name": "Samara", "country": "RU", "admin1": "Samara Oblast", "pop": "1163399" },
  { "id": 2353151, "name": "Aba", "country": "NG", "admin1": "Abia State", "pop": "1160000" },
  { "id": 1278710, "name": "Amritsar", "country": "IN", "admin1": "Punjab", "pop": "1159227" },
  { "id": 2655603, "name": "Birmingham", "country": "GB", "admin1": "England", "pop": "1157603" },
  {
    "id": 2618425,
    "name": "Copenhagen",
    "country": "DK",
    "admin1": "Capital Region",
    "pop": "1153615"
  },
  { "id": 727011, "name": "Sofia", "country": "BG", "admin1": "Sofia-Capital", "pop": "1152556" },
  { "id": 1785294, "name": "Anyang", "country": "CN", "admin1": "Henan", "pop": "1146839" },
  {
    "id": 1253184,
    "name": "Vijayawada",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "1143232"
  },
  { "id": 616052, "name": "Yerevan", "country": "AM", "admin1": "Yerevan", "pop": "1141100" },
  { "id": 1816373, "name": "Bijie", "country": "CN", "admin1": "Guizhou", "pop": "1137383" },
  { "id": 3995465, "name": "Monterrey", "country": "MX", "admin1": "Nuevo León", "pop": "1135512" },
  { "id": 202061, "name": "Kigali", "country": "RW", "admin1": "Kigali", "pop": "1132686" },
  { "id": 501175, "name": "Rostov-na-Donu", "country": "RU", "admin1": "Rostov", "pop": "1130305" },
  { "id": 1783763, "name": "Zhuzhou", "country": "CN", "admin1": "Hunan", "pop": "1129687" },
  { "id": 1648473, "name": "Bogor", "country": "ID", "admin1": "West Java", "pop": "1127408" },
  {
    "id": 1978681,
    "name": "Malingao",
    "country": "PH",
    "admin1": "Soccsksargen",
    "pop": "1121974"
  },
  {
    "id": 2244322,
    "name": "Touba",
    "country": "SN",
    "admin1": "Diourbel Region",
    "pop": "1120824"
  },
  {
    "id": 479561,
    "name": "Ufa",
    "country": "RU",
    "admin1": "Bashkortostan Republic",
    "pop": "1120547"
  },
  { "id": 1258526, "name": "Ranchi", "country": "IN", "admin1": "Jharkhand", "pop": "1120374" },
  { "id": 587084, "name": "Baku", "country": "AZ", "admin1": "Baki", "pop": "1116513" },
  { "id": 1787858, "name": "Shangrao", "country": "CN", "admin1": "Jiangxi", "pop": "1116486" },
  {
    "id": 927967,
    "name": "Lilongwe",
    "country": "MW",
    "admin1": "Central Region",
    "pop": "1115815"
  },
  { "id": 1807700, "name": "Huaibei", "country": "CN", "admin1": "Anhui", "pop": "1113321" },
  {
    "id": 2331447,
    "name": "Maiduguri",
    "country": "NG",
    "admin1": "Borno State",
    "pop": "1110000"
  },
  { "id": 1800818, "name": "Meishan", "country": "CN", "admin1": "Sichuan", "pop": "1107742" },
  { "id": 152224, "name": "Mwanza", "country": "TZ", "admin1": "Mwanza", "pop": "1104521" },
  { "id": 2111149, "name": "Sendai", "country": "JP", "admin1": "Miyagi", "pop": "1096704" },
  { "id": 1833747, "name": "Ulsan", "country": "KR", "admin1": "Ulsan", "pop": "1095014" },
  {
    "id": 1502026,
    "name": "Krasnoyarsk",
    "country": "RU",
    "admin1": "Krasnoyarsk Krai",
    "pop": "1090811"
  },
  { "id": 1810820, "name": "Fuzhou", "country": "CN", "admin1": "Jiangxi", "pop": "1089888" },
  { "id": 1809532, "name": "Guigang", "country": "CN", "admin1": "Guangxi", "pop": "1086327" },
  { "id": 1631761, "name": "Pekanbaru", "country": "ID", "admin1": "Riau", "pop": "1085000" },
  { "id": 3143244, "name": "Oslo", "country": "NO", "admin1": "Oslo", "pop": "1082575" },
  {
    "id": 1269633,
    "name": "Jabalpur",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "1081677"
  },
  { "id": 2337639, "name": "Ilorin", "country": "NG", "admin1": "Kwara State", "pop": "1080000" },
  { "id": 415189, "name": "Aden", "country": "YE", "admin1": "Aden", "pop": "1079670" },
  {
    "id": 3530589,
    "name": "Ciudad Nezahualcoyotl",
    "country": "MX",
    "admin1": "México",
    "pop": "1077208"
  },
  { "id": 1808370, "name": "Hengyang", "country": "CN", "admin1": "Hunan", "pop": "1075516" },
  {
    "id": 1278994,
    "name": "Prayagraj",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "1073438"
  },
  {
    "id": 1253102,
    "name": "Visakhapatnam",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "1063178"
  },
  {
    "id": 1842485,
    "name": "Goyang-si",
    "country": "KR",
    "admin1": "Gyeonggi-do",
    "pop": "1061752"
  },
  { "id": 1785781, "name": "Yulin", "country": "CN", "admin1": "Guangxi", "pop": "1056743" },
  { "id": 1268865, "name": "Jodhpur", "country": "IN", "admin1": "Rajasthan", "pop": "1056191" },
  {
    "id": 1270583,
    "name": "Gwalior",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "1054420"
  },
  { "id": 1805540, "name": "Jingzhou", "country": "CN", "admin1": "Hubei", "pop": "1052282" },
  {
    "id": 964420,
    "name": "Port Elizabeth",
    "country": "ZA",
    "admin1": "Eastern Cape",
    "pop": "1050078"
  },
  { "id": 611717, "name": "Tbilisi", "country": "GE", "admin1": "Tbilisi", "pop": "1049498" },
  {
    "id": 472045,
    "name": "Voronezh",
    "country": "RU",
    "admin1": "Voronezh Oblast",
    "pop": "1047549"
  },
  { "id": 1788572, "name": "Xinxiang", "country": "CN", "admin1": "Henan", "pop": "1047088" },
  { "id": 1786746, "name": "Yichun", "country": "CN", "admin1": "Jiangxi", "pop": "1045952" },
  { "id": 2335953, "name": "Jos", "country": "NG", "admin1": "Plateau State", "pop": "1040000" },
  { "id": 2322911, "name": "Sokoto", "country": "NG", "admin1": "Sokoto", "pop": "1040000" },
  {
    "id": 2530335,
    "name": "Tangier",
    "country": "MA",
    "admin1": "Tanger-Tetouan-Al Hoceima",
    "pop": "1035141"
  },
  { "id": 1790353, "name": "Xianyang", "country": "CN", "admin1": "Shaanxi", "pop": "1034081" },
  {
    "id": 3996069,
    "name": "Mexicali",
    "country": "MX",
    "admin1": "Baja California",
    "pop": "1032686"
  },
  {
    "id": 2255414,
    "name": "Pointe-Noire",
    "country": "CG",
    "admin1": "Pointe-Noire",
    "pop": "1032000"
  },
  { "id": 3395981, "name": "Maceió", "country": "BR", "admin1": "Alagoas", "pop": "1031597" },
  { "id": 3467865, "name": "Campinas", "country": "BR", "admin1": "São Paulo", "pop": "1031554" },
  { "id": 1796556, "name": "Sanya", "country": "CN", "admin1": "Hainan", "pop": "1031396" },
  {
    "id": 1185188,
    "name": "Rangpur",
    "country": "BD",
    "admin1": "Rangpur Division",
    "pop": "1031388"
  },
  { "id": 94787, "name": "Kirkuk", "country": "IQ", "admin1": "Kirkuk", "pop": "1031000" },
  { "id": 1185186, "name": "Comilla", "country": "BD", "admin1": "Chittagong", "pop": "1030000" },
  { "id": 1795874, "name": "Shaoguan", "country": "CN", "admin1": "Guangdong", "pop": "1028460" },
  { "id": 1270396, "name": "Howrah", "country": "IN", "admin1": "West Bengal", "pop": "1027672" },
  { "id": 1258980, "name": "Raipur", "country": "IN", "admin1": "Chhattisgarh", "pop": "1027264" },
  {
    "id": 1846326,
    "name": "Changwon",
    "country": "KR",
    "admin1": "Gyeongsangnam-do",
    "pop": "1025702"
  },
  { "id": 1802276, "name": "Longyan", "country": "CN", "admin1": "Fujian", "pop": "1025087" },
  { "id": 2964574, "name": "Dublin", "country": "IE", "admin1": "Leinster", "pop": "1024027" },
  {
    "id": 1254388,
    "name": "Tiruchirappalli",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "1022518"
  },
  { "id": 1786217, "name": "Yongzhou", "country": "CN", "admin1": "Hunan", "pop": "1020715" },
  {
    "id": 2800866,
    "name": "Brussels",
    "country": "BE",
    "admin1": "Brussels Capital",
    "pop": "1019022"
  },
  {
    "id": 1679432,
    "name": "Zamboanga",
    "country": "PH",
    "admin1": "Zamboanga Peninsula",
    "pop": "1018849"
  },
  { "id": 6094817, "name": "Ottawa", "country": "CA", "admin1": "Ontario", "pop": "1017449" },
  { "id": 1806535, "name": "Huzhou", "country": "CN", "admin1": "Zhejiang", "pop": "1015937" },
  { "id": 698740, "name": "Odesa", "country": "UA", "admin1": "Odessa", "pop": "1015826" },
  {
    "id": 472757,
    "name": "Volgograd",
    "country": "RU",
    "admin1": "Volgograd Oblast",
    "pop": "1013533"
  },
  {
    "id": 379251,
    "name": "Khartoum North",
    "country": "SD",
    "admin1": "Khartoum",
    "pop": "1012211"
  },
  { "id": 5946768, "name": "Edmonton", "country": "CA", "admin1": "Alberta", "pop": "1010899" },
  { "id": 1803936, "name": "Wuwei", "country": "CN", "admin1": "Gansu", "pop": "1010295" },
  { "id": 4160021, "name": "Jacksonville", "country": "US", "admin1": "Florida", "pop": "1009833" },
  { "id": 3947322, "name": "Arequipa", "country": "PE", "admin1": "Arequipa", "pop": "1008290" },
  { "id": 4691930, "name": "Fort Worth", "country": "US", "admin1": "Texas", "pop": "1008106" },
  { "id": 1808857, "name": "Hanzhong", "country": "CN", "admin1": "Shaanxi", "pop": "1006557" },
  { "id": 7576887, "name": "Hezhou", "country": "CN", "admin1": "Guangxi", "pop": "1005490" },
  { "id": 1266049, "name": "Kota", "country": "IN", "admin1": "Rajasthan", "pop": "1001694" },
  {
    "id": 7602670,
    "name": "Zhu Cheng City",
    "country": "CN",
    "admin1": "Shandong",
    "pop": "1000000"
  },
  { "id": 1812101, "name": "Dongying", "country": "CN", "admin1": "Shandong", "pop": "998968" },
  { "id": 1801640, "name": "Luzhou", "country": "CN", "admin1": "Sichuan", "pop": "998900" },
  { "id": 5392171, "name": "San Jose", "country": "US", "admin1": "California", "pop": "997368" },
  { "id": 1256436, "name": "Sholapur", "country": "IN", "admin1": "Maharashtra", "pop": "997281" },
  {
    "id": 2542997,
    "name": "Marrakesh",
    "country": "MA",
    "admin1": "Marrakesh-Safi",
    "pop": "995871"
  },
  {
    "id": 3598132,
    "name": "Guatemala City",
    "country": "GT",
    "admin1": "Guatemala",
    "pop": "994938"
  },
  { "id": 1800779, "name": "Meizhou", "country": "CN", "admin1": "Guangdong", "pop": "992351" },
  { "id": 1927639, "name": "Yueyang", "country": "CN", "admin1": "Hunan", "pop": "991465" },
  { "id": 1804591, "name": "Laiwu", "country": "CN", "admin1": "Shandong", "pop": "989535" },
  { "id": 2038300, "name": "Benxi", "country": "CN", "admin1": "Liaoning", "pop": "987717" },
  { "id": 511196, "name": "Perm", "country": "RU", "admin1": "Perm Krai", "pop": "982419" },
  { "id": 2317765, "name": "Zaria", "country": "NG", "admin1": "Kaduna State", "pop": "980000" },
  { "id": 2113015, "name": "Chiba", "country": "JP", "admin1": "Chiba", "pop": "979768" },
  { "id": 1798827, "name": "Pingdingshan", "country": "CN", "admin1": "Henan", "pop": "979130" },
  {
    "id": 3645528,
    "name": "Ciudad Guayana",
    "country": "VE",
    "admin1": "Bolívar",
    "pop": "978202"
  },
  { "id": 1166000, "name": "Sargodha", "country": "PK", "admin1": "Punjab", "pop": "975886" },
  { "id": 4671654, "name": "Austin", "country": "US", "admin1": "Texas", "pop": "974447" },
  {
    "id": 3617763,
    "name": "Managua",
    "country": "NI",
    "admin1": "Managua Department",
    "pop": "973087"
  },
  { "id": 1816440, "name": "Bengbu", "country": "CN", "admin1": "Anhui", "pop": "972784" },
  {
    "id": 2537763,
    "name": "Salé",
    "country": "MA",
    "admin1": "Rabat-Salé-Kénitra",
    "pop": "972299"
  },
  { "id": 281184, "name": "Jerusalem", "country": "IL", "admin1": "Jerusalem", "pop": "971800" },
  { "id": 1274746, "name": "Chandigarh", "country": "IN", "admin1": "Chandigarh", "pop": "970602" },
  { "id": 709930, "name": "Dnipro", "country": "UA", "admin1": "Dnipropetrovsk", "pop": "968502" },
  {
    "id": 1717512,
    "name": "Cebu City",
    "country": "PH",
    "admin1": "Central Visayas",
    "pop": "965332"
  },
  {
    "id": 2886242,
    "name": "Köln",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "963395"
  },
  { "id": 1254348, "name": "Tiruppur", "country": "IN", "admin1": "Tamil Nadu", "pop": "963173" },
  { "id": 1271476, "name": "Guwahati", "country": "IN", "admin1": "Assam", "pop": "962334" },
  { "id": 1790492, "name": "Xiangtan", "country": "CN", "admin1": "Hunan", "pop": "959303" },
  { "id": 1803567, "name": "Linfen", "country": "CN", "admin1": "Shanxi", "pop": "959198" },
  {
    "id": 1931681,
    "name": "Victoria",
    "country": "HK",
    "admin1": "Central and Western",
    "pop": "956800"
  },
  { "id": 1784642, "name": "Zhenjiang", "country": "CN", "admin1": "Jiangsu", "pop": "950516" },
  { "id": 2343279, "name": "Enugu", "country": "NG", "admin1": "Enugu State", "pop": "950000" },
  { "id": 3838583, "name": "Rosario", "country": "AR", "admin1": "Santa Fe", "pop": "948312" },
  { "id": 101760, "name": "Sulţānah", "country": "SA", "admin1": "Medina Region", "pop": "946697" },
  { "id": 2036662, "name": "Huludao", "country": "CN", "admin1": "Liaoning", "pop": "944495" },
  { "id": 1269920, "name": "Hubballi", "country": "IN", "admin1": "Karnataka", "pop": "943788" },
  { "id": 1859307, "name": "Kitakyushu", "country": "JP", "admin1": "Fukuoka", "pop": "940978" },
  { "id": 70225, "name": "Taiz", "country": "YE", "admin1": "Ta‘izz", "pop": "940600" },
  { "id": 3489854, "name": "Kingston", "country": "JM", "admin1": "Kingston", "pop": "937700" },
  { "id": 1281673, "name": "Baoshan", "country": "CN", "admin1": "Yunnan", "pop": "935618" },
  { "id": 1797063, "name": "Rui’an", "country": "CN", "admin1": "Zhejiang", "pop": "927383" },
  { "id": 4014338, "name": "Chihuahua", "country": "MX", "admin1": "Chihuahua", "pop": "925762" },
  {
    "id": 6611854,
    "name": "Nay Pyi Taw",
    "country": "MM",
    "admin1": "Nay Pyi Taw",
    "pop": "925000"
  },
  { "id": 1262321, "name": "Mysuru", "country": "IN", "admin1": "Karnataka", "pop": "920550" },
  { "id": 3691175, "name": "Trujillo", "country": "PE", "admin1": "La Libertad", "pop": "919899" },
  { "id": 1257629, "name": "Salem", "country": "IN", "admin1": "Tamil Nadu", "pop": "917414" },
  { "id": 3388368, "name": "São Luís", "country": "BR", "admin1": "Maranhão", "pop": "917237" },
  {
    "id": 1897000,
    "name": "Seongnam-si",
    "country": "KR",
    "admin1": "Gyeonggi-do",
    "pop": "914832"
  },
  { "id": 3687238, "name": "Cartagena", "country": "CO", "admin1": "Bolívar", "pop": "914552" },
  { "id": 1730501, "name": "Antipolo", "country": "PH", "admin1": "Calabarzon", "pop": "913712" },
  { "id": 4509177, "name": "Columbus", "country": "US", "admin1": "Ohio", "pop": "913175" },
  { "id": 1164909, "name": "Sialkot", "country": "PK", "admin1": "Punjab", "pop": "911817" },
  {
    "id": 4460243,
    "name": "Charlotte",
    "country": "US",
    "admin1": "North Carolina",
    "pop": "911311"
  },
  { "id": 1804609, "name": "Laibin", "country": "CN", "admin1": "Guangxi", "pop": "910282" },
  { "id": 2319133, "name": "Warri", "country": "NG", "admin1": "Delta", "pop": "910000" },
  { "id": 3172394, "name": "Naples", "country": "IT", "admin1": "Campania", "pop": "909048" },
  { "id": 1633419, "name": "Padang", "country": "ID", "admin1": "West Sumatra", "pop": "909040" },
  { "id": 1790254, "name": "Xiaogan", "country": "CN", "admin1": "Hubei", "pop": "908266" },
  {
    "id": 3467747,
    "name": "Campo Grande",
    "country": "BR",
    "admin1": "Mato Grosso do Sul",
    "pop": "906092"
  },
  { "id": 1783683, "name": "Ziyang", "country": "CN", "admin1": "Sichuan", "pop": "905729" },
  {
    "id": 2362344,
    "name": "Bobo-Dioulasso",
    "country": "BF",
    "admin1": "Hauts-Bassins",
    "pop": "904920"
  },
  { "id": 1183880, "name": "Bahawalpur", "country": "PK", "admin1": "Punjab", "pop": "903795" },
  { "id": 1797264, "name": "Quzhou", "country": "CN", "admin1": "Zhejiang", "pop": "902767" },
  {
    "id": 931755,
    "name": "Blantyre",
    "country": "MW",
    "admin1": "Southern Region",
    "pop": "902588"
  },
  { "id": 709717, "name": "Donetsk", "country": "UA", "admin1": "Donetsk", "pop": "901645" },
  { "id": 1528675, "name": "Bishkek", "country": "KG", "admin1": "Bishkek", "pop": "900000" },
  { "id": 119208, "name": "Qom", "country": "IR", "admin1": "Qom Province", "pop": "900000" },
  { "id": 100077, "name": "Abū Ghurayb", "country": "IQ", "admin1": "Baghdad", "pop": "900000" },
  { "id": 1785453, "name": "Zaozhuang", "country": "CN", "admin1": "Shandong", "pop": "899753" },
  {
    "id": 542420,
    "name": "Krasnodar",
    "country": "RU",
    "admin1": "Krasnodar Krai",
    "pop": "899541"
  },
  {
    "id": 3394023,
    "name": "Natal",
    "country": "BR",
    "admin1": "Rio Grande do Norte",
    "pop": "896708"
  },
  { "id": 1798654, "name": "Pingxiang", "country": "CN", "admin1": "Jiangxi", "pop": "893550" },
  { "id": 3531673, "name": "Cancún", "country": "MX", "admin1": "Quintana Roo", "pop": "888797" },
  { "id": 4259418, "name": "Indianapolis", "country": "US", "admin1": "Indiana", "pop": "887642" },
  { "id": 1270642, "name": "Gurugram", "country": "IN", "admin1": "Haryana", "pop": "886519" },
  { "id": 1275817, "name": "Bhubaneswar", "country": "IN", "admin1": "Odisha", "pop": "885363" },
  { "id": 1886762, "name": "Zhoushan", "country": "CN", "admin1": "Zhejiang", "pop": "882932" },
  { "id": 2035265, "name": "Qiqihar", "country": "CN", "admin1": "Heilongjiang", "pop": "882364" },
  {
    "id": 98463,
    "name": "As Sulaymānīyah",
    "country": "IQ",
    "admin1": "Sulaymaniyah",
    "pop": "878146"
  },
  { "id": 1802940, "name": "Puning", "country": "CN", "admin1": "Guangdong", "pop": "874954" },
  { "id": 2246678, "name": "Pikine", "country": "SN", "admin1": "Dakar", "pop": "874062" },
  { "id": 1275901, "name": "Bhiwandi", "country": "IN", "admin1": "Maharashtra", "pop": "874032" },
  { "id": 954013, "name": "Soshanguve", "country": "ZA", "admin1": "Gauteng", "pop": "872309" },
  { "id": 3386496, "name": "Teresina", "country": "BR", "admin1": "Piauí", "pop": "871126" },
  {
    "id": 2995469,
    "name": "Marseille",
    "country": "FR",
    "admin1": "Provence-Alpes-Côte d'Azur",
    "pop": "870731"
  },
  { "id": 1789065, "name": "Ankang", "country": "CN", "admin1": "Shaanxi", "pop": "870126" },
  { "id": 1268782, "name": "Jalandhar", "country": "IN", "admin1": "Punjab", "pop": "868929" },
  {
    "id": 2747891,
    "name": "Rotterdam",
    "country": "NL",
    "admin1": "South Holland",
    "pop": "868135"
  },
  { "id": 1804540, "name": "Langfang", "country": "CN", "admin1": "Hebei", "pop": "868066" },
  { "id": 1805987, "name": "Jiaozuo", "country": "CN", "admin1": "Henan", "pop": "865413" },
  { "id": 1791748, "name": "Wanxian", "country": "CN", "admin1": "Chongqing", "pop": "859662" },
  { "id": 1799194, "name": "Guang’an", "country": "CN", "admin1": "Sichuan", "pop": "858159" },
  { "id": 1732752, "name": "Johor Bahru", "country": "MY", "admin1": "Johor", "pop": "858118" },
  {
    "id": 1845604,
    "name": "Cheongju-si",
    "country": "KR",
    "admin1": "North Chungcheong",
    "pop": "853938"
  },
  {
    "id": 7290466,
    "name": "Pasig City",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "853050"
  },
  { "id": 12501153, "name": "Kanayannur", "country": "IN", "admin1": "Kerala", "pop": "851406" },
  {
    "id": 3600949,
    "name": "Tegucigalpa",
    "country": "HN",
    "admin1": "Francisco Morazán Department",
    "pop": "850848"
  },
  {
    "id": 1838716,
    "name": "Bucheon-si",
    "country": "KR",
    "admin1": "Gyeonggi-do",
    "pop": "850731"
  },
  {
    "id": 1566166,
    "name": "Thanh Hóa",
    "country": "VN",
    "admin1": "Thanh Hóa Province",
    "pop": "850000"
  },
  { "id": 3165524, "name": "Turin", "country": "IT", "admin1": "Piedmont", "pop": "847287" },
  { "id": 1636722, "name": "Malang", "country": "ID", "admin1": "East Java", "pop": "847182" },
  { "id": 292913, "name": "Al Ain City", "country": "AE", "admin1": "Abu Dhabi", "pop": "846747" },
  { "id": 2399697, "name": "Libreville", "country": "GA", "admin1": "Estuaire", "pop": "846090" },
  { "id": 498677, "name": "Saratov", "country": "RU", "admin1": "Saratov Oblast", "pop": "844858" },
  {
    "id": 2028462,
    "name": "Ulan Bator",
    "country": "MN",
    "admin1": "Ulaanbaatar",
    "pop": "844818"
  },
  { "id": 1791673, "name": "Weihai", "country": "CN", "admin1": "Shandong", "pop": "844310" },
  { "id": 1821940, "name": "Takeo", "country": "KH", "admin1": "Takeo", "pop": "843931" },
  { "id": 3919968, "name": "Cochabamba", "country": "BO", "admin1": "Cochabamba", "pop": "841276" },
  { "id": 144448, "name": "Ahvaz", "country": "IR", "admin1": "Khuzestan", "pop": "841145" },
  { "id": 1788508, "name": "Xinyu", "country": "CN", "admin1": "Jiangxi", "pop": "839488" },
  {
    "id": 965301,
    "name": "Pietermaritzburg",
    "country": "ZA",
    "admin1": "KwaZulu-Natal",
    "pop": "839327"
  },
  { "id": 1786770, "name": "Yibin", "country": "CN", "admin1": "Sichuan", "pop": "836340" },
  {
    "id": 3522790,
    "name": "Naucalpan de Juárez",
    "country": "MX",
    "admin1": "México",
    "pop": "834434"
  },
  {
    "id": 1771023,
    "name": "Kampung Baru Subang",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "833571"
  },
  {
    "id": 2290956,
    "name": "Bouaké",
    "country": "CI",
    "admin1": "Vallée du Bandama District",
    "pop": "832371"
  },
  {
    "id": 1629001,
    "name": "Samarinda",
    "country": "ID",
    "admin1": "East Kalimantan",
    "pop": "831460"
  },
  { "id": 1793703, "name": "Taicang", "country": "CN", "admin1": "Jiangsu", "pop": "831113" },
  {
    "id": 5391959,
    "name": "San Francisco",
    "country": "US",
    "admin1": "California",
    "pop": "827526"
  },
  { "id": 1853195, "name": "Sakai", "country": "JP", "admin1": "Osaka", "pop": "826161" },
  { "id": 2509954, "name": "Valencia", "country": "ES", "admin1": "Valencia", "pop": "824340" },
  {
    "id": 3456160,
    "name": "Nova Iguaçu",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "823302"
  },
  { "id": 1815059, "name": "Chenzhou", "country": "CN", "admin1": "Hunan", "pop": "822534" },
  {
    "id": 3464374,
    "name": "Duque de Caxias",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "818329"
  },
  { "id": 3397277, "name": "João Pessoa", "country": "BR", "admin1": "Paraíba", "pop": "817511" },
  { "id": 217831, "name": "Bukavu", "country": "CD", "admin1": "South Kivu", "pop": "816811" },
  { "id": 3648559, "name": "Barcelona", "country": "VE", "admin1": "Anzoátegui", "pop": "815141" },
  { "id": 2389853, "name": "Bangui", "country": "CF", "admin1": "Bangui", "pop": "812407" },
  { "id": 4004898, "name": "Hermosillo", "country": "MX", "admin1": "Sonora", "pop": "812229" },
  { "id": 1276014, "name": "Bhayandar", "country": "IN", "admin1": "Maharashtra", "pop": "809378" },
  { "id": 4012176, "name": "Culiacán", "country": "MX", "admin1": "Sinaloa", "pop": "808416" },
  {
    "id": 1735158,
    "name": "Petaling Jaya",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "807879"
  },
  { "id": 304922, "name": "Malatya", "country": "TR", "admin1": "Malatya", "pop": "806156" },
  { "id": 1817993, "name": "Anqing", "country": "CN", "admin1": "Anhui", "pop": "804493" },
  { "id": 2485926, "name": "Oran", "country": "DZ", "admin1": "Oran", "pop": "803329" },
  { "id": 2409306, "name": "Freetown", "country": "SL", "admin1": "Western Area", "pop": "802639" },
  {
    "id": 3601782,
    "name": "San Pedro Sula",
    "country": "HN",
    "admin1": "Cortés Department",
    "pop": "801259"
  },
  { "id": 1261809, "name": "Narela", "country": "IN", "admin1": "Delhi", "pop": "800000" },
  { "id": 1788927, "name": "Xingtai", "country": "CN", "admin1": "Hebei", "pop": "798770" },
  { "id": 1855431, "name": "Niigata", "country": "JP", "admin1": "Niigata", "pop": "797591" },
  { "id": 287286, "name": "Muscat", "country": "OM", "admin1": "Muscat", "pop": "797000" },
  { "id": 250090, "name": "Zarqa", "country": "JO", "admin1": "Zarqa", "pop": "792665" },
  { "id": 6955677, "name": "Çankaya", "country": "TR", "admin1": "Ankara", "pop": "792189" },
  { "id": 1863289, "name": "Hamamatsu", "country": "JP", "admin1": "Shizuoka", "pop": "791707" },
  { "id": 922773, "name": "Kolwezi", "country": "CD", "admin1": "Lualaba", "pop": "790248" },
  { "id": 1562798, "name": "Vinh", "country": "VN", "admin1": "Nghệ An Province", "pop": "790000" },
  { "id": 315202, "name": "Eskişehir", "country": "TR", "admin1": "Eskişehir", "pop": "789023" },
  {
    "id": 1254163,
    "name": "Thiruvananthapuram",
    "country": "IN",
    "admin1": "Kerala",
    "pop": "788271"
  },
  {
    "id": 10630176,
    "name": "Pasragad Branch",
    "country": "IR",
    "admin1": "Hamadan Province",
    "pop": "787878"
  },
  { "id": 1784841, "name": "Zhaotong", "country": "CN", "admin1": "Yunnan", "pop": "787845" },
  { "id": 6929460, "name": "Panzhihua", "country": "CN", "admin1": "Sichuan", "pop": "787177" },
  { "id": 1814757, "name": "Chuzhou", "country": "CN", "admin1": "Anhui", "pop": "782671" },
  { "id": 5809844, "name": "Seattle", "country": "US", "admin1": "Washington", "pop": "780995" },
  { "id": 358619, "name": "Port Said", "country": "EG", "admin1": "Port Said", "pop": "780515" },
  {
    "id": 3685533,
    "name": "Cúcuta",
    "country": "CO",
    "admin1": "Norte de Santander Department",
    "pop": "777106"
  },
  { "id": 169577, "name": "Homs", "country": "SY", "admin1": "Homs", "pop": "775404" },
  { "id": 1788081, "name": "Xuancheng", "country": "CN", "admin1": "Anhui", "pop": "774332" },
  { "id": 74477, "name": "Ibb", "country": "YE", "admin1": "Ibb Governorate", "pop": "771514" },
  { "id": 1033356, "name": "Nampula", "country": "MZ", "admin1": "Nampula", "pop": "770379" },
  { "id": 1817720, "name": "Shangyu", "country": "CN", "admin1": "Zhejiang", "pop": "770000" },
  {
    "id": 425378,
    "name": "Bujumbura",
    "country": "BI",
    "admin1": "Bujumbura Mairie",
    "pop": "769317"
  },
  { "id": 3093133, "name": "Łódź", "country": "PL", "admin1": "Łódź Voivodeship", "pop": "768755" },
  { "id": 1488754, "name": "Tyumen", "country": "RU", "admin1": "Tyumen Oblast", "pop": "768358" },
  { "id": 315368, "name": "Erzurum", "country": "TR", "admin1": "Erzurum", "pop": "767848" },
  { "id": 1817968, "name": "Anshun", "country": "CN", "admin1": "Guizhou", "pop": "765313" },
  { "id": 160196, "name": "Dodoma", "country": "TZ", "admin1": "Dodoma", "pop": "765179" },
  {
    "id": 1185128,
    "name": "Rajshahi",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "763580"
  },
  {
    "id": 1180281,
    "name": "Dera Ismail Khan",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "763195"
  },
  { "id": 1790840, "name": "Wuzhou", "country": "CN", "admin1": "Guangxi", "pop": "761948" },
  { "id": 1734634, "name": "Ipoh", "country": "MY", "admin1": "Perak", "pop": "759952" },
  { "id": 1797595, "name": "Qinhuangdao", "country": "CN", "admin1": "Hebei", "pop": "759718" },
  { "id": 88319, "name": "Benghazi", "country": "LY", "admin1": "Banghāzī", "pop": "757490" },
  { "id": 3094802, "name": "Kraków", "country": "PL", "admin1": "Lesser Poland", "pop": "755050" },
  { "id": 1279017, "name": "Alīgarh", "country": "IN", "admin1": "Uttar Pradesh", "pop": "753207" },
  { "id": 1816920, "name": "Shaoyang", "country": "CN", "admin1": "Hunan", "pop": "753194" },
  { "id": 6183235, "name": "Winnipeg", "country": "CA", "admin1": "Manitoba", "pop": "749607" },
  { "id": 751324, "name": "Bağcılar", "country": "TR", "admin1": "Istanbul", "pop": "749024" },
  { "id": 8469289, "name": "Ōta", "country": "JP", "admin1": "Tokyo", "pop": "748081" },
  {
    "id": 1514588,
    "name": "Andijon",
    "country": "UZ",
    "admin1": "Andijan Region",
    "pop": "747800"
  },
  {
    "id": 1277013,
    "name": "Bareilly",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "745435"
  },
  {
    "id": 107304,
    "name": "Buraydah",
    "country": "SA",
    "admin1": "Al-Qassim Region",
    "pop": "745353"
  },
  {
    "id": 3449344,
    "name": "São Bernardo do Campo",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "743372"
  },
  { "id": 2036986, "name": "Hegang", "country": "CN", "admin1": "Heilongjiang", "pop": "743307" },
  { "id": 3995402, "name": "Morelia", "country": "MX", "admin1": "Michoacán", "pop": "743275" },
  { "id": 456172, "name": "Riga", "country": "LV", "admin1": "Riga", "pop": "742572" },
  { "id": 1624647, "name": "Tasikmalaya", "country": "ID", "admin1": "West Java", "pop": "741760" },
  {
    "id": 2759794,
    "name": "Amsterdam",
    "country": "NL",
    "admin1": "North Holland",
    "pop": "741636"
  },
  {
    "id": 1721080,
    "name": "Cagayan de Oro",
    "country": "PH",
    "admin1": "Northern Mindanao",
    "pop": "741617"
  },
  { "id": 1801620, "name": "Ma’anshan", "country": "CN", "admin1": "Anhui", "pop": "741531" },
  { "id": 1732903, "name": "Shah Alam", "country": "MY", "admin1": "Selangor", "pop": "740750" },
  { "id": 12324556, "name": "Shizuishan", "country": "CN", "admin1": "Ningxia", "pop": "739400" },
  { "id": 1858421, "name": "Kumamoto", "country": "JP", "admin1": "Kumamoto", "pop": "738907" },
  { "id": 2325200, "name": "Oyo", "country": "NG", "admin1": "Oyo State", "pop": "736072" },
  { "id": 3981254, "name": "Torreón", "country": "MX", "admin1": "Coahuila", "pop": "735340" },
  { "id": 1812961, "name": "Deyang", "country": "CN", "admin1": "Sichuan", "pop": "735070" },
  { "id": 2352947, "name": "Abeokuta", "country": "NG", "admin1": "Ogun State", "pop": "735000" },
  { "id": 79415, "name": "Al Ḩudaydah", "country": "YE", "admin1": "Al Hudaydah", "pop": "734699" },
  { "id": 1787351, "name": "Yangquan", "country": "CN", "admin1": "Shanxi", "pop": "731228" },
  { "id": 2350841, "name": "Akure", "country": "NG", "admin1": "Ondo State", "pop": "730000" },
  {
    "id": 3448636,
    "name": "São José dos Campos",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "729737"
  },
  { "id": 5419384, "name": "Denver", "country": "US", "admin1": "Colorado", "pop": "729019" },
  { "id": 3455775, "name": "Osasco", "country": "BR", "admin1": "São Paulo", "pop": "728615" },
  { "id": 162183, "name": "Ashgabat", "country": "TM", "admin1": "Ashgabat", "pop": "727700" },
  { "id": 1865689, "name": "Aihara", "country": "JP", "admin1": "Kanagawa", "pop": "725493" },
  { "id": 1004866, "name": "Evaton", "country": "ZA", "admin1": "Gauteng", "pop": "725468" },
  { "id": 1645528, "name": "Denpasar", "country": "ID", "admin1": "Bali", "pop": "725314" },
  {
    "id": 1680102,
    "name": "Valenzuela",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "725173"
  },
  {
    "id": 1169607,
    "name": "Muzaffarābād",
    "country": "PK",
    "admin1": "Azad Kashmir",
    "pop": "725000"
  },
  { "id": 1854383, "name": "Okayama", "country": "JP", "admin1": "Okayama", "pop": "724691" },
  {
    "id": 3985606,
    "name": "San Luis Potosí",
    "country": "MX",
    "admin1": "San Luis Potosí",
    "pop": "722772"
  },
  {
    "id": 4019233,
    "name": "Aguascalientes",
    "country": "MX",
    "admin1": "Aguascalientes",
    "pop": "722250"
  },
  {
    "id": 1713022,
    "name": "General Santos",
    "country": "PH",
    "admin1": "Soccsksargen",
    "pop": "722059"
  },
  { "id": 1783873, "name": "Zhumadian", "country": "CN", "admin1": "Henan", "pop": "721670" },
  {
    "id": 1262801,
    "name": "Morādābād",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "721139"
  },
  { "id": 11611609, "name": "Sagamihara", "country": "JP", "admin1": "Kanagawa", "pop": "720780" },
  { "id": 6075357, "name": "Mississauga", "country": "CA", "admin1": "Ontario", "pop": "717961" },
  { "id": 702550, "name": "Lviv", "country": "UA", "admin1": "Lviv", "pop": "717273" },
  { "id": 1513157, "name": "Namangan", "country": "UZ", "admin1": "Namangan", "pop": "713220" },
  {
    "id": 3451328,
    "name": "Ribeirão Preto",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "711825"
  },
  {
    "id": 687700,
    "name": "Zaporizhzhya",
    "country": "UA",
    "admin1": "Zaporizhzhia",
    "pop": "710052"
  },
  {
    "id": 148730,
    "name": "Zanzibar",
    "country": "TZ",
    "admin1": "Zanzibar Urban/West",
    "pop": "709809"
  },
  { "id": 3988086, "name": "Saltillo", "country": "MX", "admin1": "Coahuila", "pop": "709671" },
  { "id": 173576, "name": "Latakia", "country": "SY", "admin1": "Latakia", "pop": "709000" },
  { "id": 1252948, "name": "Warangal", "country": "IN", "admin1": "Telangana", "pop": "704570" },
  {
    "id": 1694781,
    "name": "Paranaque City",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "703245"
  },
  { "id": 482283, "name": "Tolyatti", "country": "RU", "admin1": "Samara Oblast", "pop": "702879" },
  { "id": 3397838, "name": "Jaboatão", "country": "BR", "admin1": "Pernambuco", "pop": "702621" },
  {
    "id": 7874116,
    "name": "Santo Domingo Oeste",
    "country": "DO",
    "admin1": "Santo Domingo Province",
    "pop": "701269"
  },
  {
    "id": 8601412,
    "name": "Santo Domingo Este",
    "country": "DO",
    "admin1": "Santo Domingo Province",
    "pop": "700000"
  },
  {
    "id": 1183105,
    "name": "Battagram",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "700000"
  },
  { "id": 359796, "name": "Suez", "country": "EG", "admin1": "Suez", "pop": "699541" },
  { "id": 1815463, "name": "Changzhi", "country": "CN", "admin1": "Shanxi", "pop": "699514" },
  { "id": 2561668, "name": "Agadir", "country": "MA", "admin1": "Souss-Massa", "pop": "698310" },
  {
    "id": 3191281,
    "name": "Sarajevo",
    "country": "BA",
    "admin1": "Federation of B&H",
    "pop": "696731"
  },
  {
    "id": 1650527,
    "name": "Balikpapan",
    "country": "ID",
    "admin1": "East Kalimantan",
    "pop": "695287"
  },
  { "id": 2347470, "name": "Bauchi", "country": "NG", "admin1": "Bauchi", "pop": "693700" },
  { "id": 1851717, "name": "Shizuoka", "country": "JP", "admin1": "Shizuoka", "pop": "693389" },
  {
    "id": 2464470,
    "name": "Tunis",
    "country": "TN",
    "admin1": "Tunis Governorate",
    "pop": "693210"
  },
  { "id": 2033196, "name": "Zhangjiakou", "country": "CN", "admin1": "Hebei", "pop": "692602" },
  { "id": 1627549, "name": "Serang", "country": "ID", "admin1": "Banten", "pop": "692101" },
  {
    "id": 4140963,
    "name": "Washington",
    "country": "US",
    "admin1": "District of Columbia",
    "pop": "689545"
  },
  { "id": 4644585, "name": "Nashville", "country": "US", "admin1": "Tennessee", "pop": "689447" },
  { "id": 2037346, "name": "Fuxin", "country": "CN", "admin1": "Liaoning", "pop": "689050" },
  { "id": 107968, "name": "Ta’if", "country": "SA", "admin1": "Mecca Region", "pop": "688693" },
  { "id": 1796989, "name": "Changsha", "country": "CN", "admin1": "Guangdong", "pop": "688242" },
  { "id": 1807234, "name": "Huangshi", "country": "CN", "admin1": "Hubei", "pop": "688090" },
  { "id": 2036113, "name": "Liaoyang", "country": "CN", "admin1": "Liaoning", "pop": "687890" },
  { "id": 1052373, "name": "Beira", "country": "MZ", "admin1": "Sofala", "pop": "687764" },
  { "id": 3447399, "name": "Sorocaba", "country": "BR", "admin1": "São Paulo", "pop": "687357" },
  { "id": 3104324, "name": "Zaragoza", "country": "ES", "admin1": "Aragon", "pop": "686986" },
  { "id": 2510911, "name": "Sevilla", "country": "ES", "admin1": "Andalusia", "pop": "686741" },
  { "id": 1816269, "name": "Baise", "country": "CN", "admin1": "Guangxi", "pop": "686078" },
  { "id": 1626801, "name": "Situbondo", "country": "ID", "admin1": "East Java", "pop": "685967" },
  { "id": 1816336, "name": "Binzhou", "country": "CN", "admin1": "Shandong", "pop": "682717" },
  {
    "id": 4544349,
    "name": "Oklahoma City",
    "country": "US",
    "admin1": "Oklahoma",
    "pop": "681054"
  },
  { "id": 1785738, "name": "Yuncheng", "country": "CN", "admin1": "Shanxi", "pop": "680036" },
  { "id": 1812955, "name": "Dezhou", "country": "CN", "admin1": "Shandong", "pop": "679535" },
  { "id": 1221874, "name": "Dushanbe", "country": "TJ", "admin1": "Dushanbe", "pop": "679400" },
  { "id": 2394819, "name": "Cotonou", "country": "BJ", "admin1": "Littoral", "pop": "679012" },
  { "id": 5520993, "name": "El Paso", "country": "US", "admin1": "Texas", "pop": "678815" },
  {
    "id": 1270927,
    "name": "Gorakhpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "674246"
  },
  { "id": 4005492, "name": "Guadalupe", "country": "MX", "admin1": "Nuevo León", "pop": "673616" },
  { "id": 1270668, "name": "Guntur", "country": "IN", "admin1": "Andhra Pradesh", "pop": "670073" },
  { "id": 2334802, "name": "Katsina", "country": "NG", "admin1": "Katsina State", "pop": "670000" },
  { "id": 1796669, "name": "Sanmenxia", "country": "CN", "admin1": "Henan", "pop": "669307" },
  { "id": 6642286, "name": "E’zhou", "country": "CN", "admin1": "Hubei", "pop": "668727" },
  { "id": 101628, "name": "Tabuk", "country": "SA", "admin1": "Tabuk Region", "pop": "667000" },
  { "id": 911148, "name": "Kitwe", "country": "ZM", "admin1": "Copperbelt", "pop": "665961" },
  { "id": 894701, "name": "Bulawayo", "country": "ZW", "admin1": "Bulawayo", "pop": "665952" },
  {
    "id": 2035715,
    "name": "Mudanjiang",
    "country": "CN",
    "admin1": "Heilongjiang",
    "pop": "665915"
  },
  { "id": 3471872, "name": "Aracaju", "country": "BR", "admin1": "Sergipe", "pop": "664908" },
  { "id": 264371, "name": "Athens", "country": "GR", "admin1": "Attica", "pop": "664046" },
  { "id": 3186886, "name": "Zagreb", "country": "HR", "admin1": "Zagreb", "pop": "663592" },
  { "id": 1804153, "name": "Leshan", "country": "CN", "admin1": "Sichuan", "pop": "662814" },
  { "id": 3449701, "name": "Santo André", "country": "BR", "admin1": "São Paulo", "pop": "662373" },
  {
    "id": 6173331,
    "name": "Vancouver",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "662248"
  },
  { "id": 9072919, "name": "Rizhao", "country": "CN", "admin1": "Shandong", "pop": "661943" },
  { "id": 658225, "name": "Helsinki", "country": "FI", "admin1": "Uusimaa", "pop": "658864" },
  {
    "id": 1845759,
    "name": "Cheonan",
    "country": "KR",
    "admin1": "Chungcheongnam-do",
    "pop": "658831"
  },
  {
    "id": 1630789,
    "name": "Pontianak",
    "country": "ID",
    "admin1": "West Kalimantan",
    "pop": "658685"
  },
  {
    "id": 3533462,
    "name": "Acapulco de Juárez",
    "country": "MX",
    "admin1": "Guerrero",
    "pop": "658609"
  },
  {
    "id": 1650213,
    "name": "Banjarmasin",
    "country": "ID",
    "admin1": "South Kalimantan",
    "pop": "657663"
  },
  { "id": 1259425, "name": "Puducherry", "country": "IN", "admin1": "Puducherry", "pop": "657209" },
  { "id": 1793900, "name": "Suining", "country": "CN", "admin1": "Sichuan", "pop": "656760" },
  { "id": 5907364, "name": "Brampton", "country": "CA", "admin1": "Ontario", "pop": "656480" },
  { "id": 9181182, "name": "Puyang", "country": "CN", "admin1": "Henan", "pop": "655674" },
  { "id": 3667905, "name": "Soacha", "country": "CO", "admin1": "Cundinamarca", "pop": "655025" },
  { "id": 4930956, "name": "Boston", "country": "US", "admin1": "Massachusetts", "pop": "653833" },
  { "id": 3515431, "name": "Tlalnepantla", "country": "MX", "admin1": "México", "pop": "653410" },
  { "id": 5746545, "name": "Portland", "country": "US", "admin1": "Oregon", "pop": "652503" },
  { "id": 3981461, "name": "Tlaquepaque", "country": "MX", "admin1": "Jalisco", "pop": "650123" },
  {
    "id": 2925533,
    "name": "Frankfurt am Main",
    "country": "DE",
    "admin1": "Hesse",
    "pop": "650000"
  },
  { "id": 1821274, "name": "Macau", "country": "MO", "admin1": null, "pop": "649335" },
  { "id": 2523920, "name": "Palermo", "country": "IT", "admin1": "Sicily", "pop": "648260" },
  {
    "id": 554840,
    "name": "Izhevsk",
    "country": "RU",
    "admin1": "Udmurtiya Republic",
    "pop": "648213"
  },
  {
    "id": 1248991,
    "name": "Colombo",
    "country": "LK",
    "admin1": "Western Province",
    "pop": "648034"
  },
  { "id": 3778045, "name": "Maturín", "country": "VE", "admin1": "Monagas", "pop": "647459" },
  { "id": 1278718, "name": "Amravati", "country": "IN", "admin1": "Maharashtra", "pop": "647057" },
  { "id": 4990729, "name": "Detroit", "country": "US", "admin1": "Michigan", "pop": "645705" },
  { "id": 2325590, "name": "Osogbo", "country": "NG", "admin1": "Osun State", "pop": "645000" },
  { "id": 1275665, "name": "Bikaner", "country": "IN", "admin1": "Rajasthan", "pop": "644406" },
  {
    "id": 6317344,
    "name": "Jaboatão dos Guararapes",
    "country": "BR",
    "admin1": "Pernambuco",
    "pop": "644037"
  },
  { "id": 5506956, "name": "Las Vegas", "country": "US", "admin1": "Nevada", "pop": "641903" },
  {
    "id": 1843847,
    "name": "Hwaseong-si",
    "country": "KR",
    "admin1": "Gyeonggi-do",
    "pop": "640890"
  },
  { "id": 2165087, "name": "Gold Coast", "country": "AU", "admin1": "Queensland", "pop": "640778" },
  { "id": 285839, "name": "Al Aḩmadī", "country": "KW", "admin1": "Al Aḩmadī", "pop": "637411" },
  { "id": 3658666, "name": "Cuenca", "country": "EC", "admin1": "Azuay", "pop": "636996" },
  {
    "id": 618426,
    "name": "Chisinau",
    "country": "MD",
    "admin1": "Chișinău Municipality",
    "pop": "635994"
  },
  { "id": 922741, "name": "Likasi", "country": "CD", "admin1": "Haut-Katanga", "pop": "635768" },
  { "id": 3081368, "name": "Wrocław", "country": "PL", "admin1": "Lower Silesia", "pop": "634893" },
  { "id": 1808770, "name": "Hebi", "country": "CN", "admin1": "Henan", "pop": "634721" },
  { "id": 204953, "name": "Tshikapa", "country": "CD", "admin1": "Kasai", "pop": "634529" },
  { "id": 1273874, "name": "Kochi", "country": "IN", "admin1": "Kerala", "pop": "633553" },
  { "id": 4641239, "name": "Memphis", "country": "US", "admin1": "Tennessee", "pop": "633104" },
  { "id": 1805611, "name": "Jingmen", "country": "CN", "admin1": "Hubei", "pop": "632954" },
  { "id": 1510853, "name": "Barnaul", "country": "RU", "admin1": "Altai Krai", "pop": "632372" },
  { "id": 2037886, "name": "Dandong", "country": "CN", "admin1": "Liaoning", "pop": "631973" },
  {
    "id": 2825297,
    "name": "Stuttgart",
    "country": "DE",
    "admin1": "Baden-Wurttemberg",
    "pop": "630305"
  },
  { "id": 1845457, "name": "Jeonju", "country": "KR", "admin1": "Jeollabuk-do", "pop": "629618" },
  { "id": 1275971, "name": "Bhilai", "country": "IN", "admin1": "Chhattisgarh", "pop": "627734" },
  { "id": 901344, "name": "Ndola", "country": "ZM", "admin1": "Copperbelt", "pop": "627503" },
  { "id": 3465624, "name": "Contagem", "country": "BR", "admin1": "Minas Gerais", "pop": "627123" },
  { "id": 479123, "name": "Ulyanovsk", "country": "RU", "admin1": "Ulyanovsk", "pop": "626540" },
  { "id": 223817, "name": "Djibouti", "country": "DJ", "admin1": "Djibouti", "pop": "626512" },
  { "id": 2648579, "name": "Glasgow", "country": "GB", "admin1": "Scotland", "pop": "626410" },
  { "id": 2035513, "name": "Panshan", "country": "CN", "admin1": "Liaoning", "pop": "625040" },
  { "id": 4299276, "name": "Louisville", "country": "US", "admin1": "Kentucky", "pop": "624444" },
  {
    "id": 2023469,
    "name": "Irkutsk",
    "country": "RU",
    "admin1": "Irkutsk Oblast",
    "pop": "623869"
  },
  { "id": 1846918, "name": "Ansan-si", "country": "KR", "admin1": "Gyeonggi-do", "pop": "623256" },
  { "id": 360761, "name": "Al Mansurah", "country": "EG", "admin1": "Dakahlia", "pop": "621953" },
  {
    "id": 128226,
    "name": "Kermanshah",
    "country": "IR",
    "admin1": "Kermanshah Province",
    "pop": "621100"
  },
  {
    "id": 2934246,
    "name": "Düsseldorf",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "620523"
  },
  {
    "id": 3463478,
    "name": "Feira de Santana",
    "country": "BR",
    "admin1": "Bahia",
    "pop": "619609"
  },
  { "id": 1806096, "name": "Jiaozhou", "country": "CN", "admin1": "Shandong", "pop": "619266" },
  { "id": 1793879, "name": "Suizhou", "country": "CN", "admin1": "Hubei", "pop": "618582" },
  { "id": 3587902, "name": "Villa Nueva", "country": "GT", "admin1": "Guatemala", "pop": "618397" },
  { "id": 2022890, "name": "Khabarovsk", "country": "RU", "admin1": "Khabarovsk", "pop": "618150" },
  { "id": 3465038, "name": "Cuiabá", "country": "BR", "admin1": "Mato Grosso", "pop": "618124" },
  { "id": 161325, "name": "Arusha", "country": "TZ", "admin1": "Arusha", "pop": "617631" },
  {
    "id": 1707174,
    "name": "Las Piñas",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "615549"
  },
  { "id": 1814934, "name": "Chizhou", "country": "CN", "admin1": "Anhui", "pop": "615274" },
  { "id": 3530139, "name": "Coyoacán", "country": "MX", "admin1": "Mexico City", "pop": "614447" },
  { "id": 1787816, "name": "Ya'an", "country": "CN", "admin1": "Sichuan", "pop": "612056" },
  { "id": 1273780, "name": "Cuttack", "country": "IN", "admin1": "Odisha", "pop": "610189" },
  { "id": 1275248, "name": "Borivli", "country": "IN", "admin1": "Maharashtra", "pop": "609617" },
  {
    "id": 468902,
    "name": "Yaroslavl",
    "country": "RU",
    "admin1": "Yaroslavl Oblast",
    "pop": "608722"
  },
  {
    "id": 2711537,
    "name": "Göteborg",
    "country": "SE",
    "admin1": "Västra Götaland",
    "pop": "608462"
  },
  { "id": 1859730, "name": "Kawaguchi", "country": "JP", "admin1": "Saitama", "pop": "607373" },
  {
    "id": 13118225,
    "name": "Bukit Rahman Putra",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "607000"
  },
  { "id": 1642858, "name": "Jambi City", "country": "ID", "admin1": "Jambi", "pop": "606200" },
  { "id": 106281, "name": "Ha'il", "country": "SA", "admin1": "Ha'il Region", "pop": "605930" },
  { "id": 1276032, "name": "Bhavnagar", "country": "IN", "admin1": "Gujarat", "pop": "605882" },
  { "id": 1020098, "name": "Benoni", "country": "ZA", "admin1": "Gauteng", "pop": "605344" },
  { "id": 2013348, "name": "Vladivostok", "country": "RU", "admin1": "Primorye", "pop": "604901" },
  { "id": 2036427, "name": "Jinzhou", "country": "CN", "admin1": "Liaoning", "pop": "604269" },
  { "id": 3515001, "name": "Tuxtla", "country": "MX", "admin1": "Chiapas", "pop": "604147" },
  {
    "id": 703845,
    "name": "Kryvyy Rih",
    "country": "UA",
    "admin1": "Dnipropetrovsk",
    "pop": "603904"
  },
  { "id": 1796663, "name": "Sanming", "country": "CN", "admin1": "Fujian", "pop": "602166" },
  { "id": 1176615, "name": "Islamabad", "country": "PK", "admin1": "Islamabad", "pop": "601600" },
  { "id": 1257416, "name": "Sāngli", "country": "IN", "admin1": "Maharashtra", "pop": "601214" },
  { "id": 1269317, "name": "Jamnagar", "country": "IN", "admin1": "Gujarat", "pop": "600943" },
  { "id": 3347762, "name": "Lubango", "country": "AO", "admin1": "Huíla", "pop": "600751" },
  {
    "id": 2034786,
    "name": "Shuangyashan",
    "country": "CN",
    "admin1": "Heilongjiang",
    "pop": "600000"
  },
  { "id": 1282898, "name": "Pokhara", "country": "NP", "admin1": "Province 4", "pop": "599504" },
  { "id": 64021, "name": "Borama", "country": "SO", "admin1": "Awdal", "pop": "597842" },
  { "id": 1802204, "name": "Luancheng", "country": "CN", "admin1": "Hebei", "pop": "597130" },
  { "id": 532096, "name": "Makhachkala", "country": "RU", "admin1": "Dagestan", "pop": "596356" },
  { "id": 1846898, "name": "Anyang-si", "country": "KR", "admin1": "Gyeonggi-do", "pop": "595644" },
  { "id": 3348313, "name": "Huambo", "country": "AO", "admin1": "Huambo", "pop": "595304" },
  {
    "id": 1216265,
    "name": "Samarkand",
    "country": "UZ",
    "admin1": "Samarqand Region",
    "pop": "595200"
  },
  { "id": 13512502, "name": "Mengzi", "country": "CN", "admin1": "Yunnan", "pop": "595100" },
  { "id": 1860827, "name": "Kagoshima", "country": "JP", "admin1": "Kagoshima", "pop": "595049" },
  {
    "id": 78754,
    "name": "Mukalla",
    "country": "YE",
    "admin1": "Muhafazat Hadramaout",
    "pop": "594951"
  },
  { "id": 118743, "name": "Rasht", "country": "IR", "admin1": "Gilan Province", "pop": "594590" },
  {
    "id": 3430863,
    "name": "Mar del Plata",
    "country": "AR",
    "admin1": "Buenos Aires",
    "pop": "593337"
  },
  {
    "id": 2928810,
    "name": "Essen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "593085"
  },
  {
    "id": 360829,
    "name": "Al Maḩallah al Kubrá",
    "country": "EG",
    "admin1": "Gharbia",
    "pop": "592573"
  },
  { "id": 2514256, "name": "Málaga", "country": "ES", "admin1": "Andalusia", "pop": "591637" },
  { "id": 1165221, "name": "Shekhupura", "country": "PK", "admin1": "Punjab", "pop": "591424" },
  { "id": 2033370, "name": "Yingkou", "country": "CN", "admin1": "Liaoning", "pop": "591159" },
  { "id": 1646448, "name": "Cimahi", "country": "ID", "admin1": "West Java", "pop": "590782" },
  { "id": 1785018, "name": "Zhangzhou", "country": "CN", "admin1": "Fujian", "pop": "589831" },
  { "id": 3520339, "name": "Reynosa", "country": "MX", "admin1": "Tamaulipas", "pop": "589466" },
  {
    "id": 12382296,
    "name": "Thuận An",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "588616"
  },
  {
    "id": 2935517,
    "name": "Dortmund",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "588462"
  },
  { "id": 3458449, "name": "Londrina", "country": "BR", "admin1": "Paraná", "pop": "588125" },
  { "id": 4347778, "name": "Baltimore", "country": "US", "admin1": "Maryland", "pop": "585708" },
  { "id": 1732747, "name": "Pelentong", "country": "MY", "admin1": "Johor", "pop": "583640" },
  {
    "id": 3688465,
    "name": "Bucaramanga",
    "country": "CO",
    "admin1": "Santander Department",
    "pop": "581130"
  },
  { "id": 3176219, "name": "Genoa", "country": "IT", "admin1": "Liguria", "pop": "580097" },
  { "id": 1863440, "name": "Hachiōji", "country": "JP", "admin1": "Tokyo", "pop": "579355" },
  { "id": 1734759, "name": "Malacca", "country": "MY", "admin1": "Melaka", "pop": "579000" },
  { "id": 1572151, "name": "Nha Trang", "country": "VN", "admin1": "Khanh Hoa", "pop": "579000" },
  { "id": 128234, "name": "Kerman", "country": "IR", "admin1": "Kerman", "pop": "577514" },
  {
    "id": 121801,
    "name": "Orūmīyeh",
    "country": "IR",
    "admin1": "West Azerbaijan",
    "pop": "577307"
  },
  { "id": 7627067, "name": "Bahçelievler", "country": "TR", "admin1": "Istanbul", "pop": "576799" },
  { "id": 347497, "name": "Tanta", "country": "EG", "admin1": "Gharbia", "pop": "576648" },
  {
    "id": 1269321,
    "name": "Jammu",
    "country": "IN",
    "admin1": "Jammu and Kashmir",
    "pop": "576198"
  },
  {
    "id": 10063567,
    "name": "Iskandar Puteri",
    "country": "MY",
    "admin1": "Johor",
    "pop": "575977"
  },
  { "id": 1720681, "name": "Calamba", "country": "PH", "admin1": "Calabarzon", "pop": "575046" },
  { "id": 3515428, "name": "Tlalpan", "country": "MX", "admin1": "Mexico City", "pop": "574577" },
  { "id": 1140026, "name": "Herāt", "country": "AF", "admin1": "Herat", "pop": "574300" },
  { "id": 1177654, "name": "Gujrat", "country": "PK", "admin1": "Punjab", "pop": "574240" },
  { "id": 1489425, "name": "Tomsk", "country": "RU", "admin1": "Tomsk Oblast", "pop": "574002" },
  {
    "id": 3459505,
    "name": "Juiz de Fora",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "573285"
  },
  { "id": 738377, "name": "Umraniye", "country": "TR", "admin1": "Istanbul", "pop": "573265" },
  { "id": 1529195, "name": "Shihezi", "country": "CN", "admin1": "Xinjiang", "pop": "572772" },
  { "id": 184622, "name": "Nakuru", "country": "KE", "admin1": "Nakuru County", "pop": "570674" },
  { "id": 3088171, "name": "Poznań", "country": "PL", "admin1": "Greater Poland", "pop": "570352" },
  { "id": 5969782, "name": "Hamilton", "country": "CA", "admin1": "Ontario", "pop": "569353" },
  { "id": 248946, "name": "Irbid", "country": "JO", "admin1": "Irbid", "pop": "569068" },
  { "id": 2643123, "name": "Manchester", "country": "GB", "admin1": "England", "pop": "568996" },
  { "id": 1736376, "name": "Kota Bharu", "country": "MY", "admin1": "Kelantan", "pop": "568900" },
  {
    "id": 6159905,
    "name": "Surrey",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "568322"
  },
  { "id": 2542715, "name": "Meknes", "country": "MA", "admin1": "Fès-Meknès", "pop": "568295" },
  {
    "id": 3875024,
    "name": "Puente Alto",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "568106"
  },
  { "id": 369004, "name": "Nyala", "country": "SD", "admin1": "Southern Darfur", "pop": "565734" },
  {
    "id": 515003,
    "name": "Orenburg",
    "country": "RU",
    "admin1": "Orenburg Oblast",
    "pop": "564773"
  },
  {
    "id": 5454711,
    "name": "Albuquerque",
    "country": "US",
    "admin1": "New Mexico",
    "pop": "564559"
  },
  { "id": 1275362, "name": "Bokāro", "country": "IN", "admin1": "Jharkhand", "pop": "564319" },
  { "id": 343300, "name": "Asmara", "country": "ER", "admin1": "Maekel", "pop": "563930" },
  { "id": 1164408, "name": "Sukkur", "country": "PK", "admin1": "Sindh", "pop": "563851" },
  {
    "id": 3445831,
    "name": "Uberlândia",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "563536"
  },
  { "id": 5263045, "name": "Milwaukee", "country": "US", "admin1": "Wisconsin", "pop": "563531" },
  { "id": 1791544, "name": "Wenchang", "country": "CN", "admin1": "Hainan", "pop": "560894" },
  { "id": 2340451, "name": "Gombe", "country": "NG", "admin1": "Gombe State", "pop": "560000" },
  { "id": 2338900, "name": "Ile-Ife", "country": "NG", "admin1": "Osun State", "pop": "560000" },
  {
    "id": 1877449,
    "name": "Hamhŭng",
    "country": "KP",
    "admin1": "South Hamgyong",
    "pop": "559056"
  },
  { "id": 1503901, "name": "Kemerovo", "country": "RU", "admin1": "Kuzbass", "pop": "558973" },
  { "id": 98854, "name": "Nasiriyah", "country": "IQ", "admin1": "Dhi Qar", "pop": "558400" },
  {
    "id": 1018725,
    "name": "Bloemfontein",
    "country": "ZA",
    "admin1": "Free State",
    "pop": "556637"
  },
  { "id": 2638077, "name": "Sheffield", "country": "GB", "admin1": "England", "pop": "556500" },
  { "id": 2935022, "name": "Dresden", "country": "DE", "admin1": "Saxony", "pop": "556227" },
  {
    "id": 3536729,
    "name": "Santiago de Cuba",
    "country": "CU",
    "admin1": "Santiago de Cuba Province",
    "pop": "555865"
  },
  { "id": 2034714, "name": "Siping", "country": "CN", "admin1": "Jilin", "pop": "555609" },
  {
    "id": 3515807,
    "name": "Cuautitlán Izcalli",
    "country": "MX",
    "admin1": "México",
    "pop": "555163"
  },
  { "id": 3351663, "name": "Benguela", "country": "AO", "admin1": "Benguela", "pop": "555124" },
  { "id": 1814760, "name": "Chuxiong", "country": "CN", "admin1": "Yunnan", "pop": "555081" },
  { "id": 1807689, "name": "Huaihua", "country": "CN", "admin1": "Hunan", "pop": "552622" },
  { "id": 3698350, "name": "Chiclayo", "country": "PE", "admin1": "Lambayeque", "pop": "552508" },
  {
    "id": 1904564,
    "name": "Bình Thạnh",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "552164"
  },
  {
    "id": 1159301,
    "name": "Zahedan",
    "country": "IR",
    "admin1": "Sistan and Baluchestan",
    "pop": "551980"
  },
  { "id": 1670029, "name": "Banqiao", "country": "TW", "admin1": "Taipei", "pop": "551221" },
  { "id": 1261977, "name": "Nanded", "country": "IN", "admin1": "Maharashtra", "pop": "550564" },
  { "id": 1265873, "name": "Kozhikode", "country": "IN", "admin1": "Kerala", "pop": "550440" },
  {
    "id": 8335361,
    "name": "Ulanqab",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "550231"
  },
  { "id": 2566636, "name": "Ajegunle", "country": "NG", "admin1": "Lagos", "pop": "550000" },
  { "id": 2243271, "name": "Cabinda", "country": "AO", "admin1": "Cabinda", "pop": "550000" },
  { "id": 786714, "name": "Pristina", "country": "XK", "admin1": "Pristina", "pop": "550000" },
  { "id": 2036581, "name": "Jiamusi", "country": "CN", "admin1": "Heilongjiang", "pop": "549549" },
  { "id": 1529376, "name": "Korla", "country": "CN", "admin1": "Xinjiang", "pop": "549324" },
  { "id": 1266285, "name": "Kolhāpur", "country": "IN", "admin1": "Maharashtra", "pop": "549236" },
  { "id": 3662762, "name": "Porto Velho", "country": "BR", "admin1": "Rondônia", "pop": "548952" },
  {
    "id": 3836873,
    "name": "San Miguel de Tucumán",
    "country": "AR",
    "admin1": "Tucuman",
    "pop": "548866"
  },
  { "id": 1735227, "name": "Kuantan", "country": "MY", "admin1": "Pahang", "pop": "548014" },
  {
    "id": 694423,
    "name": "Sevastopol",
    "country": "UA",
    "admin1": "Sevastopol City",
    "pop": "547820"
  },
  {
    "id": 1261529,
    "name": "Nellore",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "547621"
  },
  {
    "id": 2944388,
    "name": "Bremen",
    "country": "DE",
    "admin1": "City state Bremen",
    "pop": "546501"
  },
  { "id": 1791779, "name": "Wanning", "country": "CN", "admin1": "Hainan", "pop": "545992" },
  { "id": 2325330, "name": "Owerri", "country": "NG", "admin1": "Imo State", "pop": "545000" },
  { "id": 6847550, "name": "Kota Kuala Muda", "country": "MY", "admin1": "Kedah", "pop": "544984" },
  { "id": 1735498, "name": "Sungai Petani", "country": "MY", "admin1": "Kedah", "pop": "544851" },
  { "id": 1788450, "name": "Xinzhou", "country": "CN", "admin1": "Shanxi", "pop": "544683" },
  { "id": 11209896, "name": "Kotō", "country": "JP", "admin1": "Kumamoto", "pop": "543730" },
  { "id": 1270752, "name": "Kalaburagi", "country": "IN", "admin1": "Karnataka", "pop": "543147" },
  { "id": 5318313, "name": "Tucson", "country": "US", "admin1": "Arizona", "pop": "542629" },
  {
    "id": 7795834,
    "name": "Selayang Baru Utara",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "542409"
  },
  { "id": 593116, "name": "Vilnius", "country": "LT", "admin1": "Vilnius", "pop": "542366" },
  { "id": 1279159, "name": "Ajmer", "country": "IN", "admin1": "Rajasthan", "pop": "542321" },
  { "id": 1798821, "name": "Pingdu", "country": "CN", "admin1": "Shandong", "pop": "542234" },
  { "id": 5350937, "name": "Fresno", "country": "US", "admin1": "California", "pop": "542107" },
  { "id": 154380, "name": "Mbeya", "country": "TZ", "admin1": "Mbeya", "pop": "541603" },
  {
    "id": 2346229,
    "name": "Calabar",
    "country": "NG",
    "admin1": "Cross River State",
    "pop": "540000"
  },
  { "id": 2540483, "name": "Oujda", "country": "MA", "admin1": "Oriental", "pop": "539711" },
  { "id": 1496990, "name": "Novokuznetsk", "country": "RU", "admin1": "Kuzbass", "pop": "539616" },
  { "id": 500096, "name": "Ryazan’", "country": "RU", "admin1": "Ryazan Oblast", "pop": "538962" },
  { "id": 1806445, "name": "Ji’an", "country": "CN", "admin1": "Jiangxi", "pop": "538699" },
  { "id": 1166548, "name": "Sahiwal", "country": "PK", "admin1": "Punjab", "pop": "538344" },
  { "id": 304531, "name": "Mersin", "country": "TR", "admin1": "Mersin", "pop": "537842" },
  { "id": 2644688, "name": "Leeds", "country": "GB", "admin1": "England", "pop": "536280" },
  { "id": 1809412, "name": "Guli", "country": "CN", "admin1": "Zhejiang", "pop": "536000" },
  { "id": 1529660, "name": "Aqsu", "country": "CN", "admin1": "Xinjiang", "pop": "535657" },
  { "id": 2344082, "name": "Ebute Ikorodu", "country": "NG", "admin1": "Lagos", "pop": "535619" },
  { "id": 1793424, "name": "Tanggu", "country": "CN", "admin1": "Tianjin", "pop": "535298" },
  { "id": 1732722, "name": "Pasir Gudang", "country": "MY", "admin1": "Johor", "pop": "534659" },
  {
    "id": 580497,
    "name": "Astrakhan",
    "country": "RU",
    "admin1": "Astrakhan Oblast",
    "pop": "533925"
  },
  { "id": 1168718, "name": "Okara", "country": "PK", "admin1": "Punjab", "pop": "533693" },
  {
    "id": 10943053,
    "name": "Nansana",
    "country": "UG",
    "admin1": "Central Region",
    "pop": "532800"
  },
  {
    "id": 1842943,
    "name": "Kimhae",
    "country": "KR",
    "admin1": "Gyeongsangnam-do",
    "pop": "531966"
  },
  { "id": 172955, "name": "Ar Raqqah", "country": "SY", "admin1": "Ar-Raqqah", "pop": "531952" },
  { "id": 6325494, "name": "Québec", "country": "CA", "admin1": "Quebec", "pop": "531902" },
  {
    "id": 3827409,
    "name": "Cuauhtémoc",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "531831"
  },
  { "id": 1796068, "name": "Shangluo", "country": "CN", "admin1": "Shaanxi", "pop": "531696" },
  { "id": 1862627, "name": "Himeji", "country": "JP", "admin1": "Hyōgo", "pop": "530495" },
  {
    "id": 3680656,
    "name": "Ibagué",
    "country": "CO",
    "admin1": "Tolima Department",
    "pop": "529635"
  },
  { "id": 2803138, "name": "Antwerpen", "country": "BE", "admin1": "Flanders", "pop": "529247" },
  { "id": 359783, "name": "Assiut", "country": "EG", "admin1": "Asyut", "pop": "528669" },
  {
    "id": 132144,
    "name": "Hamadān",
    "country": "IR",
    "admin1": "Hamadan Province",
    "pop": "528256"
  },
  { "id": 1806488, "name": "Qionghai", "country": "CN", "admin1": "Hainan", "pop": "528238" },
  { "id": 1816080, "name": "Cangzhou", "country": "CN", "admin1": "Hebei", "pop": "527681" },
  {
    "id": 1194041,
    "name": "Mohāmmadpur",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "527571"
  },
  {
    "id": 1625812,
    "name": "Surakarta",
    "country": "ID",
    "admin1": "Central Java",
    "pop": "526870"
  },
  {
    "id": 3583361,
    "name": "San Salvador",
    "country": "SV",
    "admin1": "San Salvador Department",
    "pop": "525990"
  },
  { "id": 1816705, "name": "Beihai", "country": "CN", "admin1": "Guangxi", "pop": "525329" },
  { "id": 298117, "name": "Van", "country": "TR", "admin1": "Van", "pop": "525016" },
  { "id": 5389489, "name": "Sacramento", "country": "US", "admin1": "California", "pop": "524943" },
  {
    "id": 1565019,
    "name": "Thủ Đức",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "524670"
  },
  { "id": 738329, "name": "Üsküdar", "country": "TR", "admin1": "Istanbul", "pop": "524452" },
  { "id": 511565, "name": "Penza", "country": "RU", "admin1": "Penza Oblast", "pop": "523553" },
  { "id": 1138336, "name": "Kandahār", "country": "AF", "admin1": "Kandahar", "pop": "523300" },
  { "id": 1133616, "name": "Mazār-e Sharīf", "country": "AF", "admin1": "Balkh", "pop": "523300" },
  { "id": 2996944, "name": "Lyon", "country": "FR", "admin1": "Rhône-Alpes", "pop": "522969" },
  { "id": 1808392, "name": "Hengshui", "country": "CN", "admin1": "Hebei", "pop": "522147" },
  { "id": 1273313, "name": "Dehra Dūn", "country": "IN", "admin1": "Uttarakhand", "pop": "522081" },
  { "id": 1272013, "name": "Erode", "country": "IN", "admin1": "Tamil Nadu", "pop": "521891" },
  { "id": 3838233, "name": "Salta", "country": "AR", "admin1": "Salta", "pop": "520683" },
  { "id": 3447779, "name": "Serra", "country": "BR", "admin1": "Espírito Santo", "pop": "520653" },
  { "id": 747340, "name": "Esenler", "country": "TR", "admin1": "Istanbul", "pop": "520235" },
  { "id": 1568574, "name": "Qui Nhon", "country": "VN", "admin1": "Gia Lai", "pop": "519208" },
  { "id": 361320, "name": "Al Fayyum", "country": "EG", "admin1": "Faiyum", "pop": "519047" },
  { "id": 1272175, "name": "Durgapur", "country": "IN", "admin1": "West Bengal", "pop": "518872" },
  { "id": 1849053, "name": "Utsunomiya", "country": "JP", "admin1": "Tochigi", "pop": "518757" },
  {
    "id": 4011743,
    "name": "Victoria de Durango",
    "country": "MX",
    "admin1": "Durango",
    "pop": "518709"
  },
  { "id": 2267057, "name": "Lisbon", "country": "PT", "admin1": "Lisbon", "pop": "517802" },
  { "id": 1167460, "name": "Rahim Yar Khan", "country": "PK", "admin1": "Punjab", "pop": "517000" },
  {
    "id": 1253894,
    "name": "Ulhasnagar",
    "country": "IN",
    "admin1": "Maharashtra",
    "pop": "516584"
  },
  { "id": 1806466, "name": "Guangyuan", "country": "CN", "admin1": "Sichuan", "pop": "516424" },
  { "id": 1264773, "name": "Loni", "country": "IN", "admin1": "Uttar Pradesh", "pop": "516082" },
  { "id": 1256525, "name": "Siliguri", "country": "IN", "admin1": "West Bengal", "pop": "515574" },
  { "id": 2861650, "name": "Nürnberg", "country": "DE", "admin1": "Bavaria", "pop": "515543" },
  { "id": 1253914, "name": "Ujjain", "country": "IN", "admin1": "Madhya Pradesh", "pop": "515215" },
  { "id": 2910831, "name": "Hannover", "country": "DE", "admin1": "Lower Saxony", "pop": "515140" },
  { "id": 2650225, "name": "Edinburgh", "country": "GB", "admin1": "Scotland", "pop": "514990" },
  {
    "id": 14256,
    "name": "Āzādshahr",
    "country": "IR",
    "admin1": "Hamadan Province",
    "pop": "514102"
  },
  { "id": 3396016, "name": "Macapá", "country": "BR", "admin1": "Amapá", "pop": "512902" },
  { "id": 1790396, "name": "Xianning", "country": "CN", "admin1": "Hubei", "pop": "512517" },
  { "id": 949880, "name": "Thembisa", "country": "ZA", "admin1": "Gauteng", "pop": "511655" },
  { "id": 1926099, "name": "Matsuyama", "country": "JP", "admin1": "Ehime", "pop": "511192" },
  {
    "id": 3467693,
    "name": "Campos dos Goytacazes",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "511168"
  },
  { "id": 1275610, "name": "Bilimora", "country": "IN", "admin1": "Gujarat", "pop": "510879" },
  { "id": 1174625, "name": "Kasur", "country": "PK", "admin1": "Punjab", "pop": "510875" },
  { "id": 4180439, "name": "Atlanta", "country": "US", "admin1": "Georgia", "pop": "510823" },
  {
    "id": 6316406,
    "name": "Aparecida de Goiânia",
    "country": "BR",
    "admin1": "Goiás",
    "pop": "510770"
  },
  {
    "id": 3523466,
    "name": "Heroica Matamoros",
    "country": "MX",
    "admin1": "Tamaulipas",
    "pop": "510739"
  },
  {
    "id": 1703417,
    "name": "Makati City",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "510383"
  },
  {
    "id": 12492662,
    "name": "Mianzhu, Deyang, Sichuan",
    "country": "CN",
    "admin1": "Sichuan",
    "pop": "510000"
  },
  { "id": 2034414, "name": "Tonghua", "country": "CN", "admin1": "Jilin", "pop": "510000" },
  {
    "id": 523750,
    "name": "Naberezhnyye Chelny",
    "country": "RU",
    "admin1": "Tatarstan Republic",
    "pop": "509870"
  },
  { "id": 535121, "name": "Lipetsk", "country": "RU", "admin1": "Lipetsk Oblast", "pop": "509735" },
  { "id": 2314705, "name": "Kikwit", "country": "CD", "admin1": "Kwilu", "pop": "509367" },
  {
    "id": 3463237,
    "name": "Florianópolis",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "508826"
  },
  { "id": 1909733, "name": "Banan", "country": "CN", "admin1": "Chongqing", "pop": "508703" },
  {
    "id": 2155472,
    "name": "Newcastle",
    "country": "AU",
    "admin1": "New South Wales",
    "pop": "508437"
  },
  { "id": 1818446, "name": "Tuen Mun", "country": "HK", "admin1": "Tuen Mun", "pop": "507900" },
  { "id": 1785036, "name": "Zhangye", "country": "CN", "admin1": "Gansu", "pop": "507433" },
  { "id": 548408, "name": "Kirov", "country": "RU", "admin1": "Kirov Oblast", "pop": "507155" },
  { "id": 1280849, "name": "Kashgar", "country": "CN", "admin1": "Xinjiang", "pop": "506640" },
  { "id": 12750654, "name": "Mukim Pulai", "country": "MY", "admin1": "Johor", "pop": "505661" },
  { "id": 103630, "name": "Najrān", "country": "SA", "admin1": "Najran Region", "pop": "505652" },
  { "id": 1784130, "name": "Zhoukou", "country": "CN", "admin1": "Henan", "pop": "505171" },
  { "id": 2879139, "name": "Leipzig", "country": "DE", "admin1": "Saxony", "pop": "504971" },
  { "id": 1798760, "name": "Pingliang", "country": "CN", "admin1": "Gansu", "pop": "504848" },
  {
    "id": 2934691,
    "name": "Duisburg",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "504358"
  },
  { "id": 1278314, "name": "Āsansol", "country": "IN", "admin1": "West Bengal", "pop": "504271" },
  { "id": 143127, "name": "Arāk", "country": "IR", "admin1": "Markazi", "pop": "503647" },
  {
    "id": 3880980,
    "name": "Maipú",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "503635"
  },
  { "id": 627907, "name": "Homyel'", "country": "BY", "admin1": "Gomel Oblast", "pop": "501102" },
  {
    "id": 610611,
    "name": "Aktobe",
    "country": "KZ",
    "admin1": "Aktyubinskaya Oblast’",
    "pop": "500757"
  },
  { "id": 1733432, "name": "Kota Kinabalu", "country": "MY", "admin1": "Sabah", "pop": "500421" },
  {
    "id": 12514556,
    "name": "Kota Damansara",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "500000"
  },
  {
    "id": 1732724,
    "name": "Kampung Larkin Lama",
    "country": "MY",
    "admin1": "Johor",
    "pop": "500000"
  },
  { "id": 1263780, "name": "Mangaluru", "country": "IN", "admin1": "Karnataka", "pop": "499487" },
  { "id": 1783988, "name": "Zhucheng", "country": "CN", "admin1": "Shandong", "pop": "499285" },
  {
    "id": 3668605,
    "name": "Santa Marta",
    "country": "CO",
    "admin1": "Magdalena Department",
    "pop": "499192"
  },
  { "id": 1857553, "name": "Matsudo", "country": "JP", "admin1": "Chiba", "pop": "498575" },
  { "id": 1462674, "name": "Hāthazāri", "country": "BD", "admin1": "Chittagong", "pop": "498179" },
  {
    "id": 1707267,
    "name": "Lapu-Lapu City",
    "country": "PH",
    "admin1": "Central Visayas",
    "pop": "497813"
  },
  { "id": 609655, "name": "Karagandy", "country": "KZ", "admin1": "Karaganda", "pop": "497777" },
  { "id": 1802238, "name": "Loudi", "country": "CN", "admin1": "Hunan", "pop": "497171" },
  { "id": 2644210, "name": "Liverpool", "country": "GB", "admin1": "England", "pop": "496770" },
  { "id": 1185270, "name": "Bāndarban", "country": "BD", "admin1": "Chittagong", "pop": "495272" },
  { "id": 1818920, "name": "Sha Tin", "country": "HK", "admin1": "Sha Tin", "pop": "495200" },
  {
    "id": 1180289,
    "name": "Dera Ghazi Khan",
    "country": "PK",
    "admin1": "Punjab",
    "pop": "494464"
  },
  { "id": 1862752, "name": "Higashiosaka", "country": "JP", "admin1": "Osaka", "pop": "493940" },
  { "id": 2972315, "name": "Toulouse", "country": "FR", "admin1": "Occitanie", "pop": "493465" },
  {
    "id": 569696,
    "name": "Cheboksary",
    "country": "RU",
    "admin1": "Chuvash Republic",
    "pop": "492331"
  },
  {
    "id": 1839071,
    "name": "Pohang",
    "country": "KR",
    "admin1": "Gyeongsangbuk-do",
    "pop": "492041"
  },
  { "id": 1795928, "name": "Shanwei", "country": "CN", "admin1": "Guangdong", "pop": "491766" },
  { "id": 3674453, "name": "Montería", "country": "CO", "admin1": "Córdoba", "pop": "490935" },
  { "id": 181032, "name": "Ruiru", "country": "KE", "admin1": "Kiambu County", "pop": "490120" },
  {
    "id": 3666304,
    "name": "Valledupar",
    "country": "CO",
    "admin1": "Cesar Department",
    "pop": "490075"
  },
  { "id": 1276533, "name": "Belagavi", "country": "IN", "admin1": "Karnataka", "pop": "490045" },
  { "id": 292932, "name": "Ajman City", "country": "AE", "admin1": "Ajman", "pop": "490035" },
  { "id": 9931406, "name": "Jianshui", "country": "CN", "admin1": "Yunnan", "pop": "490000" },
  { "id": 377039, "name": "Port Sudan", "country": "SD", "admin1": "Red Sea", "pop": "489725" },
  { "id": 3515302, "name": "Toluca", "country": "MX", "admin1": "México", "pop": "489333" },
  {
    "id": 3532624,
    "name": "Ciudad López Mateos",
    "country": "MX",
    "admin1": "México",
    "pop": "489160"
  },
  { "id": 360890, "name": "Al Khuşūş", "country": "EG", "admin1": "Qalyubia", "pop": "488904" },
  { "id": 1846266, "name": "Jeju City", "country": "KR", "admin1": "Jeju-do", "pop": "488844" },
  { "id": 4164138, "name": "Miami", "country": "US", "admin1": "Florida", "pop": "487014" },
  { "id": 5074472, "name": "Omaha", "country": "US", "admin1": "Nebraska", "pop": "486051" },
  { "id": 1855207, "name": "Nishinomiya", "country": "JP", "admin1": "Hyōgo", "pop": "485587" },
  { "id": 2593460, "name": "Masina", "country": "CD", "admin1": "Kinshasa", "pop": "485167" },
  {
    "id": 1257806,
    "name": "Sahāranpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "484873"
  },
  { "id": 1253286, "name": "Vellore", "country": "IN", "admin1": "Tamil Nadu", "pop": "484690" },
  { "id": 3693528, "name": "Piura", "country": "PE", "admin1": "Piura", "pop": "484475" },
  { "id": 1858311, "name": "Kurashiki", "country": "JP", "admin1": "Okayama", "pop": "483576" },
  {
    "id": 1730737,
    "name": "Angeles City",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "483452"
  },
  { "id": 1276058, "name": "Bhātpāra", "country": "IN", "admin1": "West Bengal", "pop": "483129" },
  { "id": 333795, "name": "Jijiga", "country": "ET", "admin1": "Somali", "pop": "483000" },
  { "id": 480562, "name": "Tula", "country": "RU", "admin1": "Tula Oblast", "pop": "482873" },
  { "id": 98860, "name": "Najaf", "country": "IQ", "admin1": "An Najaf", "pop": "482576" },
  {
    "id": 4487042,
    "name": "Raleigh",
    "country": "US",
    "admin1": "North Carolina",
    "pop": "482295"
  },
  { "id": 1710914, "name": "Imus", "country": "PH", "admin1": "Calabarzon", "pop": "481949" },
  { "id": 1789647, "name": "Xichang", "country": "CN", "admin1": "Sichuan", "pop": "481796" },
  { "id": 1264115, "name": "Malegaon", "country": "IN", "admin1": "Maharashtra", "pop": "481228" },
  {
    "id": 3448639,
    "name": "São José do Rio Preto",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "480393"
  },
  { "id": 2327220, "name": "Okene", "country": "NG", "admin1": "Kogi State", "pop": "479178" },
  {
    "id": 1833788,
    "name": "Uijeongbu-si",
    "country": "KR",
    "admin1": "Gyeonggi-do",
    "pop": "479141"
  },
  { "id": 2654675, "name": "Bristol", "country": "GB", "admin1": "England", "pop": "479024" },
  {
    "id": 1006984,
    "name": "East London",
    "country": "ZA",
    "admin1": "Eastern Cape",
    "pop": "478676"
  },
  { "id": 13527052, "name": "Chéngguān Qū", "country": "CN", "admin1": "Tibet", "pop": "478275" },
  { "id": 111822, "name": "Yazd", "country": "IR", "admin1": "Yazd Province", "pop": "477905" },
  {
    "id": 57289,
    "name": "Hargeysa",
    "country": "SO",
    "admin1": "Woqooyi Galbeed",
    "pop": "477876"
  },
  { "id": 1854487, "name": "Ōita", "country": "JP", "admin1": "Oita", "pop": "477715" },
  { "id": 3457381, "name": "Mauá", "country": "BR", "admin1": "São Paulo", "pop": "477552" },
  { "id": 1805741, "name": "Jincheng", "country": "CN", "admin1": "Shanxi", "pop": "476945" },
  { "id": 1667905, "name": "Taoyuan", "country": "TW", "admin1": "Taiwan", "pop": "475798" },
  {
    "id": 198629,
    "name": "Eldoret",
    "country": "KE",
    "admin1": "Uasin Gishu County",
    "pop": "475716"
  },
  { "id": 4393217, "name": "Kansas City", "country": "US", "admin1": "Missouri", "pop": "475378" },
  { "id": 1787765, "name": "Yan’an", "country": "CN", "admin1": "Shaanxi", "pop": "475234" },
  {
    "id": 554234,
    "name": "Kaliningrad",
    "country": "RU",
    "admin1": "Kaliningrad Oblast",
    "pop": "475056"
  },
  { "id": 785842, "name": "Skopje", "country": "MK", "admin1": "Grad Skopje", "pop": "474889" },
  { "id": 944385, "name": "Vereeniging", "country": "ZA", "admin1": "Gauteng", "pop": "474681" },
  {
    "id": 2747373,
    "name": "The Hague",
    "country": "NL",
    "admin1": "South Holland",
    "pop": "474292"
  },
  { "id": 5367929, "name": "Long Beach", "country": "US", "admin1": "California", "pop": "474140" },
  { "id": 1271439, "name": "Gaya", "country": "IN", "admin1": "Bihar", "pop": "474093" },
  {
    "id": 1711005,
    "name": "Iloilo",
    "country": "PH",
    "admin1": "Western Visayas",
    "pop": "473728"
  },
  { "id": 1794794, "name": "Shouguang", "country": "CN", "admin1": "Shandong", "pop": "473620" },
  { "id": 1805680, "name": "Jingdezhen", "country": "CN", "admin1": "Jiangxi", "pop": "473561" },
  { "id": 2513416, "name": "Murcia", "country": "ES", "admin1": "Murcia", "pop": "471982" },
  { "id": 5304391, "name": "Mesa", "country": "US", "admin1": "Arizona", "pop": "471825" },
  { "id": 6324729, "name": "Halifax", "country": "CA", "admin1": "Nova Scotia", "pop": "471559" },
  { "id": 153220, "name": "Morogoro", "country": "TZ", "admin1": "Morogoro", "pop": "471409" },
  {
    "id": 1700925,
    "name": "Marikina City",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "471323"
  },
  {
    "id": 2544571,
    "name": "Kenitra",
    "country": "MA",
    "admin1": "Rabat-Salé-Kénitra",
    "pop": "470949"
  },
  { "id": 288967, "name": "Seeb", "country": "OM", "admin1": "Muscat", "pop": "470878" },
  { "id": 700569, "name": "Mykolayiv", "country": "UA", "admin1": "Mykolaiv", "pop": "470011" },
  { "id": 1863917, "name": "Fukuyama", "country": "JP", "admin1": "Hiroshima", "pop": "468812" },
  {
    "id": 5139568,
    "name": "Staten Island",
    "country": "US",
    "admin1": "New York",
    "pop": "468730"
  },
  { "id": 1799846, "name": "Nanping", "country": "CN", "admin1": "Fujian", "pop": "467875" },
  {
    "id": 3672486,
    "name": "Pereira",
    "country": "CO",
    "admin1": "Risaralda Department",
    "pop": "467269"
  },
  {
    "id": 4018390,
    "name": "Ciudad Apodaca",
    "country": "MX",
    "admin1": "Nuevo León",
    "pop": "467157"
  },
  {
    "id": 3448877,
    "name": "São João de Meriti",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "466536"
  },
  { "id": 1278840, "name": "Ambattur", "country": "IN", "admin1": "Tamil Nadu", "pop": "466205" },
  {
    "id": 3470142,
    "name": "Belford Roxo",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "466096"
  },
  { "id": 1860243, "name": "Kanazawa", "country": "JP", "admin1": "Ishikawa", "pop": "466029" },
  { "id": 336014, "name": "Gonder", "country": "ET", "admin1": "Amhara", "pop": "466000" },
  {
    "id": 1701966,
    "name": "Mandaluyong City",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "465902"
  },
  { "id": 3592519, "name": "Mixco", "country": "GT", "admin1": "Guatemala", "pop": "465773" },
  { "id": 2036109, "name": "Longshan", "country": "CN", "admin1": "Jilin", "pop": "465249" },
  { "id": 2338325, "name": "Ikare", "country": "NG", "admin1": "Ondo State", "pop": "465000" },
  {
    "id": 1562414,
    "name": "Vũng Tàu",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "464860"
  },
  { "id": 3632998, "name": "Maracay", "country": "VE", "admin1": "Aragua", "pop": "464700" },
  { "id": 2294877, "name": "Tamale", "country": "GH", "admin1": "Northern", "pop": "464316" },
  { "id": 1786112, "name": "Heyuan", "country": "CN", "admin1": "Guangdong", "pop": "463907" },
  {
    "id": 1583518,
    "name": "Dĩ An",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "463023"
  },
  { "id": 231165, "name": "Kira", "country": "UG", "admin1": "Central Region", "pop": "462900" },
  { "id": 3099434, "name": "Gdańsk", "country": "PL", "admin1": "Pomerania", "pop": "461865" },
  {
    "id": 3459712,
    "name": "Joinville",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "461304"
  },
  { "id": 1792359, "name": "Huangshan", "country": "CN", "admin1": "Anhui", "pop": "460786" },
  { "id": 170017, "name": "Ḩamāh", "country": "SY", "admin1": "Hama", "pop": "460602" },
  { "id": 1269407, "name": "Jalgaon", "country": "IN", "admin1": "Maharashtra", "pop": "460228" },
  {
    "id": 1265491,
    "name": "Kurnool",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "460184"
  },
  { "id": 2318044, "name": "Yola", "country": "NG", "admin1": "Adamawa", "pop": "460000" },
  { "id": 1568510, "name": "Rạch Giá", "country": "VN", "admin1": "An Giang", "pop": "459860" },
  { "id": 1865387, "name": "Amagasaki", "country": "JP", "admin1": "Hyōgo", "pop": "459593" },
  {
    "id": 3651297,
    "name": "Santo Domingo de los Colorados",
    "country": "EC",
    "admin1": "Santo Domingo de los Tsáchilas",
    "pop": "458580"
  },
  { "id": 163345, "name": "Ţarţūs", "country": "SY", "admin1": "Tartus", "pop": "458327" },
  {
    "id": 7701384,
    "name": "Karabağlar",
    "country": "TR",
    "admin1": "İzmir Province",
    "pop": "458000"
  },
  { "id": 331180, "name": "Mek'ele", "country": "ET", "admin1": "Tigray", "pop": "457900" },
  { "id": 330186, "name": "Nazrēt", "country": "ET", "admin1": "Oromiya", "pop": "456900" },
  {
    "id": 5417598,
    "name": "Colorado Springs",
    "country": "US",
    "admin1": "Colorado",
    "pop": "456568"
  },
  {
    "id": 3456283,
    "name": "Niterói",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "456456"
  },
  { "id": 3939459, "name": "Huancayo", "country": "PE", "admin1": "Junin", "pop": "456250" },
  { "id": 99347, "name": "Al Ḩillah", "country": "IQ", "admin1": "Bābil", "pop": "455700" },
  { "id": 2312895, "name": "Mbandaka", "country": "CD", "admin1": "Équateur", "pop": "455011" },
  { "id": 2239862, "name": "Malanje", "country": "AO", "admin1": "Malanje", "pop": "455000" },
  { "id": 1873757, "name": "Namp’o", "country": "KP", "admin1": "Nampo", "pop": "455000" },
  {
    "id": 4005867,
    "name": "Ciudad General Escobedo",
    "country": "MX",
    "admin1": "Nuevo León",
    "pop": "454967"
  },
  {
    "id": 1729564,
    "name": "Bacolod City",
    "country": "PH",
    "admin1": "Western Visayas",
    "pop": "454898"
  },
  {
    "id": 4791259,
    "name": "Virginia Beach",
    "country": "US",
    "admin1": "Virginia",
    "pop": "454808"
  },
  {
    "id": 1701500,
    "name": "Mansilingan",
    "country": "PH",
    "admin1": "Western Visayas",
    "pop": "454150"
  },
  { "id": 158597, "name": "Kahama", "country": "TZ", "admin1": "Shinyanga", "pop": "453654" },
  { "id": 1675151, "name": "Hsinchu", "country": "TW", "admin1": "Taiwan", "pop": "453536" },
  { "id": 8469284, "name": "Katsushika", "country": "JP", "admin1": "Tokyo", "pop": "453093" },
  { "id": 1258662, "name": "Rāmgundam", "country": "IN", "admin1": "Telangana", "pop": "452261" },
  { "id": 321836, "name": "Batman", "country": "TR", "admin1": "Batman", "pop": "452157" },
  { "id": 1636544, "name": "Manado", "country": "ID", "admin1": "North Sulawesi", "pop": "451916" },
  { "id": 1803245, "name": "Lishui", "country": "CN", "admin1": "Zhejiang", "pop": "451418" },
  { "id": 1253986, "name": "Udaipur", "country": "IN", "admin1": "Rajasthan", "pop": "451100" },
  { "id": 1646511, "name": "Cilegon", "country": "ID", "admin1": "Banten", "pop": "450271" },
  { "id": 8505006, "name": "Wenshan City", "country": "CN", "admin1": "Yunnan", "pop": "450000" },
  { "id": 8074174, "name": "Muratpaşa", "country": "TR", "admin1": "Antalya", "pop": "450000" },
  { "id": 1591527, "name": "Bắc Giang", "country": "VN", "admin1": "Bac Ninh", "pop": "450000" },
  { "id": 449504, "name": "Eslamshahr", "country": "IR", "admin1": "Tehran", "pop": "450000" },
  { "id": 373303, "name": "Juba", "country": "SS", "admin1": "Central Equatoria", "pop": "450000" },
  { "id": 298333, "name": "Şanlıurfa", "country": "TR", "admin1": "Şanlıurfa", "pop": "449549" },
  { "id": 2038087, "name": "Chengde", "country": "CN", "admin1": "Hebei", "pop": "449325" },
  { "id": 538560, "name": "Kursk", "country": "RU", "admin1": "Kursk Oblast", "pop": "448733" },
  {
    "id": 1348843,
    "name": "Maheshtala",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "448317"
  },
  { "id": 1573517, "name": "Nam Định", "country": "VN", "admin1": "Ninh Binh", "pop": "448225" },
  {
    "id": 2501152,
    "name": "Constantine",
    "country": "DZ",
    "admin1": "Constantine",
    "pop": "448028"
  },
  { "id": 1260107, "name": "Patiāla", "country": "IN", "admin1": "Punjab", "pop": "446246" },
  { "id": 1017780, "name": "Boksburg", "country": "ZA", "admin1": "Gauteng", "pop": "445168" },
  { "id": 1816858, "name": "Basuo", "country": "CN", "admin1": "Hainan", "pop": "444458" },
  {
    "id": 4006702,
    "name": "Ensenada",
    "country": "MX",
    "admin1": "Baja California",
    "pop": "443807"
  },
  { "id": 315808, "name": "Elazığ", "country": "TR", "admin1": "Elazığ", "pop": "443363" },
  { "id": 3459462, "name": "Jundiaí", "country": "BR", "admin1": "São Paulo", "pop": "443221" },
  {
    "id": 2057087,
    "name": "Kupang",
    "country": "ID",
    "admin1": "East Nusa Tenggara",
    "pop": "442758"
  },
  {
    "id": 3514450,
    "name": "Xochimilco",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "442178"
  },
  {
    "id": 1256409,
    "name": "Shyamnagar",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "441956"
  },
  { "id": 1715430, "name": "Dasmariñas", "country": "PH", "admin1": "Calabarzon", "pop": "441876" },
  { "id": 1813171, "name": "Zhangjiajie", "country": "CN", "admin1": "Hunan", "pop": "441804" },
  {
    "id": 2286304,
    "name": "Korhogo",
    "country": "CI",
    "admin1": "Savanes District",
    "pop": "440926"
  },
  { "id": 1864092, "name": "Fujisawa", "country": "JP", "admin1": "Kanagawa", "pop": "439728" },
  { "id": 2374775, "name": "Bissau", "country": "GW", "admin1": "Bissau", "pop": "439704" },
  { "id": 1734052, "name": "Sandakan", "country": "MY", "admin1": "Sabah", "pop": "439050" },
  { "id": 1308465, "name": "Mawlamyine", "country": "MM", "admin1": "Mon", "pop": "438861" },
  { "id": 6050610, "name": "Laval", "country": "CA", "admin1": "Quebec", "pop": "438366" },
  {
    "id": 2512989,
    "name": "Palma",
    "country": "ES",
    "admin1": "Balearic Islands",
    "pop": "438234"
  },
  {
    "id": 1869012,
    "name": "Sunch’ŏn",
    "country": "KP",
    "admin1": "South Pyongan",
    "pop": "437000"
  },
  { "id": 7628416, "name": "Sultangazi", "country": "TR", "admin1": "Istanbul", "pop": "436935" },
  { "id": 2319480, "name": "Uyo", "country": "NG", "admin1": "Akwa Ibom State", "pop": "436606" },
  { "id": 2038365, "name": "Bei’an", "country": "CN", "admin1": "Heilongjiang", "pop": "436444" },
  { "id": 1273368, "name": "Davangere", "country": "IN", "admin1": "Karnataka", "pop": "435128" },
  { "id": 2352379, "name": "Ado-Ekiti", "country": "NG", "admin1": "Ekiti State", "pop": "435000" },
  {
    "id": 3675443,
    "name": "Manizales",
    "country": "CO",
    "admin1": "Caldas Department",
    "pop": "434403"
  },
  { "id": 1841246, "name": "Masan", "country": "KR", "admin1": "Gwangju", "pop": "434371" },
  { "id": 1586896, "name": "Buôn Ma Thuột", "country": "VN", "admin1": "Dak Lak", "pop": "434256" },
  { "id": 3407669, "name": "Ananindeua", "country": "BR", "admin1": "Pará", "pop": "433956" },
  {
    "id": 487846,
    "name": "Stavropol’",
    "country": "RU",
    "admin1": "Stavropol Kray",
    "pop": "433931"
  },
  { "id": 3449433, "name": "Santos", "country": "BR", "admin1": "São Paulo", "pop": "433656" },
  { "id": 1859924, "name": "Kashiwa", "country": "JP", "admin1": "Chiba", "pop": "433436" },
  { "id": 2327735, "name": "Ogbomoso", "country": "NG", "admin1": "Oyo State", "pop": "433030" },
  { "id": 293397, "name": "Tel Aviv", "country": "IL", "admin1": "Tel Aviv", "pop": "432892" },
  { "id": 216281, "name": "Goma", "country": "CD", "admin1": "North Kivu", "pop": "432587" },
  {
    "id": 3688452,
    "name": "Buenaventura",
    "country": "CO",
    "admin1": "Valle del Cauca Department",
    "pop": "432385"
  },
  { "id": 940909, "name": "Welkom", "country": "ZA", "admin1": "Free State", "pop": "431944" },
  {
    "id": 1818953,
    "name": "Sham Shui Po",
    "country": "HK",
    "admin1": "Sham Shui Po District",
    "pop": "431090"
  },
  { "id": 1857871, "name": "Machida", "country": "JP", "admin1": "Tokyo", "pop": "431079" },
  { "id": 359493, "name": "Zagazig", "country": "EG", "admin1": "Sharqia", "pop": "430445" },
  {
    "id": 1635882,
    "name": "Mataram",
    "country": "ID",
    "admin1": "West Nusa Tenggara",
    "pop": "429651"
  },
  { "id": 361055, "name": "Ismailia", "country": "EG", "admin1": "Ismailia", "pop": "429465" },
  { "id": 1806097, "name": "Ningde", "country": "CN", "admin1": "Fujian", "pop": "429260" },
  { "id": 1279105, "name": "Akola", "country": "IN", "admin1": "Maharashtra", "pop": "428857" },
  {
    "id": 3941584,
    "name": "Cusco",
    "country": "PE",
    "admin1": "Cuzco Department",
    "pop": "428450"
  },
  { "id": 1279945, "name": "Jiuquan", "country": "CN", "admin1": "Gansu", "pop": "428346" },
  { "id": 3514783, "name": "Veracruz", "country": "MX", "admin1": "Veracruz", "pop": "428323" },
  { "id": 571476, "name": "Bryansk", "country": "RU", "admin1": "Bryansk Oblast", "pop": "427236" },
  { "id": 741763, "name": "Maltepe", "country": "TR", "admin1": "Istanbul", "pop": "427040" },
  {
    "id": 1734705,
    "name": "Kuala Terengganu",
    "country": "MY",
    "admin1": "Terengganu",
    "pop": "426500"
  },
  { "id": 1849814, "name": "Toyota", "country": "JP", "admin1": "Aichi", "pop": "426162" },
  { "id": 2313002, "name": "Matadi", "country": "CD", "admin1": "Bas-Congo", "pop": "425662" },
  { "id": 109353, "name": "Al Kharj", "country": "SA", "admin1": "Riyadh Region", "pop": "425300" },
  {
    "id": 1818304,
    "name": "Wong Tai Sin",
    "country": "HK",
    "admin1": "Wong Tai Sin District",
    "pop": "425235"
  },
  {
    "id": 13118244,
    "name": "Mandaluyong",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "425000"
  },
  { "id": 2330100, "name": "Minna", "country": "NG", "admin1": "Niger State", "pop": "425000" },
  {
    "id": 3526617,
    "name": "Xalapa de Enríquez",
    "country": "MX",
    "admin1": "Veracruz",
    "pop": "424755"
  },
  {
    "id": 1255783,
    "name": "Rajpur Sonarpur",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "424368"
  },
  {
    "id": 3060972,
    "name": "Bratislava",
    "country": "SK",
    "admin1": "Bratislava Region",
    "pop": "423737"
  },
  {
    "id": 12557764,
    "name": "Taman Petaling",
    "country": "MY",
    "admin1": "Kuala Lumpur",
    "pop": "423062"
  },
  { "id": 1852139, "name": "Shinagawa", "country": "JP", "admin1": "Ehime", "pop": "422488" },
  { "id": 173811, "name": "Al Ḩasakah", "country": "SY", "admin1": "Al-Hasakah", "pop": "422445" },
  { "id": 360502, "name": "Luxor", "country": "EG", "admin1": "Luxor", "pop": "422407" },
  { "id": 6058560, "name": "London", "country": "CA", "admin1": "Ontario", "pop": "422324" },
  { "id": 343137, "name": "Awasa", "country": "ET", "admin1": "Sidama Region", "pop": "422200" },
  { "id": 1049261, "name": "Chimoio", "country": "MZ", "admin1": "Manica", "pop": "422046" },
  { "id": 1163965, "name": "Tando Allahyar", "country": "PK", "admin1": "Sindh", "pop": "421923" },
  {
    "id": 2290486,
    "name": "Daloa",
    "country": "CI",
    "admin1": "Sassandra-Marahoué",
    "pop": "421871"
  },
  { "id": 1812749, "name": "Dingxi", "country": "CN", "admin1": "Gansu", "pop": "420614" },
  { "id": 2234974, "name": "Bamenda", "country": "CM", "admin1": "North-West", "pop": "420445" },
  { "id": 480060, "name": "Tver", "country": "RU", "admin1": "Tver Oblast", "pop": "420065" },
  {
    "id": 1566319,
    "name": "Thái Nguyên",
    "country": "VN",
    "admin1": "Thai Nguyen",
    "pop": "420000"
  },
  { "id": 3664980, "name": "Boa Vista", "country": "BR", "admin1": "Roraima", "pop": "419652" },
  { "id": 3662574, "name": "Rio Branco", "country": "BR", "admin1": "Acre", "pop": "419452" },
  { "id": 5378538, "name": "Oakland", "country": "US", "admin1": "California", "pop": "419267" },
  { "id": 1266122, "name": "Korba", "country": "IN", "admin1": "Chhattisgarh", "pop": "419146" },
  { "id": 1851100, "name": "Takamatsu", "country": "JP", "admin1": "Kagawa", "pop": "418994" },
  {
    "id": 1819607,
    "name": "Kowloon City",
    "country": "HK",
    "admin1": "Kowloon City",
    "pop": "418732"
  },
  { "id": 3183875, "name": "Tirana", "country": "AL", "admin1": "Tirana", "pop": "418495" },
  { "id": 4568127, "name": "San Juan", "country": "PR", "admin1": "San Juan", "pop": "418140" },
  { "id": 1736309, "name": "Alor Setar", "country": "MY", "admin1": "Kedah", "pop": "417800" },
  { "id": 7064006, "name": "Tongchuan", "country": "CN", "admin1": "Shaanxi", "pop": "417740" },
  { "id": 1694611, "name": "Pasay", "country": "PH", "admin1": "Metro Manila", "pop": "416522" },
  {
    "id": 3522551,
    "name": "Nuevo Laredo",
    "country": "MX",
    "admin1": "Tamaulipas",
    "pop": "416055"
  },
  { "id": 1849876, "name": "Toyama", "country": "JP", "admin1": "Toyama", "pop": "415844" },
  {
    "id": 2528910,
    "name": "Tétouan",
    "country": "MA",
    "admin1": "Tanger-Tetouan-Al Hoceima",
    "pop": "415810"
  },
  { "id": 2657896, "name": "Zürich", "country": "CH", "admin1": "Zurich", "pop": "415367" },
  { "id": 1562820, "name": "Việt Trì", "country": "VN", "admin1": "Phu Tho", "pop": "415280" },
  {
    "id": 3532497,
    "name": "Azcapotzalco",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "414711"
  },
  { "id": 4174757, "name": "Tampa", "country": "US", "admin1": "Florida", "pop": "414547" },
  {
    "id": 3456814,
    "name": "Montes Claros",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "414240"
  },
  {
    "id": 234179,
    "name": "Bunamwaya",
    "country": "UG",
    "admin1": "Central Region",
    "pop": "413400"
  },
  {
    "id": 532288,
    "name": "Magnitogorsk",
    "country": "RU",
    "admin1": "Chelyabinsk",
    "pop": "413351"
  },
  { "id": 4553433, "name": "Tulsa", "country": "US", "admin1": "Oklahoma", "pop": "413066" },
  { "id": 1269006, "name": "Jhānsi", "country": "IN", "admin1": "Uttar Pradesh", "pop": "412927" },
  {
    "id": 1818506,
    "name": "Tseung Kwan O",
    "country": "HK",
    "admin1": "Sai Kung District",
    "pop": "412900"
  },
  {
    "id": 3645532,
    "name": "Ciudad Bolívar",
    "country": "VE",
    "admin1": "Bolívar",
    "pop": "412619"
  },
  {
    "id": 1762110,
    "name": "Kampung Kangkar Teberau",
    "country": "MY",
    "admin1": "Johor",
    "pop": "412373"
  },
  {
    "id": 2285853,
    "name": "Koumassi",
    "country": "CI",
    "admin1": "Abidjan Autonomous District",
    "pop": "412282"
  },
  {
    "id": 3985241,
    "name": "San Nicolás de los Garza",
    "country": "MX",
    "admin1": "Nuevo León",
    "pop": "412199"
  },
  {
    "id": 2192362,
    "name": "Christchurch",
    "country": "NZ",
    "admin1": "Canterbury",
    "pop": "412000"
  },
  { "id": 1809152, "name": "Guyuan", "country": "CN", "admin1": "Ningxia", "pop": "411854" },
  { "id": 5037649, "name": "Minneapolis", "country": "US", "admin1": "Minnesota", "pop": "410939" },
  {
    "id": 8629640,
    "name": "Thoothukudi",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "410760"
  },
  {
    "id": 143083,
    "name": "Ardabīl",
    "country": "IR",
    "admin1": "Ardabil Province",
    "pop": "410753"
  },
  { "id": 1276509, "name": "Ballari", "country": "IN", "admin1": "Karnataka", "pop": "410445" },
  { "id": 2038120, "name": "Chaoyang", "country": "CN", "admin1": "Liaoning", "pop": "410005" },
  { "id": 281133, "name": "Gaza", "country": "PS", "admin1": "Gaza Strip", "pop": "410000" },
  { "id": 1848313, "name": "Yokosuka", "country": "JP", "admin1": "Kanagawa", "pop": "409478" },
  { "id": 1856177, "name": "Nagasaki", "country": "JP", "admin1": "Nagasaki", "pop": "409118" },
  { "id": 1281019, "name": "Gujangbagh", "country": "CN", "admin1": "Xinjiang", "pop": "408894" },
  { "id": 3981369, "name": "Tonalá", "country": "MX", "admin1": "Jalisco", "pop": "408759" },
  { "id": 3703443, "name": "Panamá", "country": "PA", "admin1": "Panamá", "pop": "408168" },
  {
    "id": 3083829,
    "name": "Szczecin",
    "country": "PL",
    "admin1": "West Pomerania",
    "pop": "407811"
  },
  { "id": 3453643, "name": "Piracicaba", "country": "BR", "admin1": "São Paulo", "pop": "407252" },
  { "id": 204405, "name": "Uvira", "country": "CD", "admin1": "South Kivu", "pop": "407092" },
  { "id": 1862540, "name": "Hirakata", "country": "JP", "admin1": "Osaka", "pop": "406331" },
  { "id": 555312, "name": "Ivanovo", "country": "RU", "admin1": "Ivanovo Oblast", "pop": "406113" },
  { "id": 3644768, "name": "Cumaná", "country": "VE", "admin1": "Sucre", "pop": "405626" },
  {
    "id": 971421,
    "name": "Newcastle",
    "country": "ZA",
    "admin1": "KwaZulu-Natal",
    "pop": "404838"
  },
  { "id": 1842225, "name": "Gumi", "country": "KR", "admin1": "Gyeongsangbuk-do", "pop": "404691" },
  { "id": 2082600, "name": "Jayapura", "country": "ID", "admin1": "Papua", "pop": "404004" },
  { "id": 2036389, "name": "Jixi", "country": "CN", "admin1": "Heilongjiang", "pop": "403759" },
  { "id": 1735634, "name": "Kuching", "country": "MY", "admin1": "Sarawak", "pop": "402738" },
  { "id": 1863641, "name": "Gifu", "country": "JP", "admin1": "Gifu", "pop": "402557" },
  { "id": 3402655, "name": "Caruaru", "country": "BR", "admin1": "Pernambuco", "pop": "402290" },
  { "id": 1792621, "name": "Tongling", "country": "CN", "admin1": "Anhui", "pop": "402062" },
  { "id": 6696918, "name": "Taoyuan City", "country": "TW", "admin1": "Taiwan", "pop": "402014" },
  {
    "id": 1682812,
    "name": "Tarlac City",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "401892"
  },
  { "id": 1849837, "name": "Toyonaka", "country": "JP", "admin1": "Osaka", "pop": "401558" },
  { "id": 372753, "name": "Kassala", "country": "SD", "admin1": "Kassala", "pop": "401477" },
  { "id": 1856717, "name": "Miyazaki", "country": "JP", "admin1": "Miyazaki", "pop": "401339" },
  { "id": 2332121, "name": "Lekki", "country": "NG", "admin1": "Lagos", "pop": "401272" },
  {
    "id": 3899539,
    "name": "Antofagasta",
    "country": "CL",
    "admin1": "Antofagasta",
    "pop": "401096"
  },
  { "id": 1276300, "name": "Bhāgalpur", "country": "IN", "admin1": "Bihar", "pop": "400146" },
  { "id": 1279290, "name": "Agartala", "country": "IN", "admin1": "Tripura", "pop": "400004" },
  { "id": 2347209, "name": "Bida", "country": "NG", "admin1": "Niger State", "pop": "400000" },
  { "id": 217695, "name": "Bunia", "country": "CD", "admin1": "Ituri", "pop": "399282" },
  {
    "id": 9645085,
    "name": "Quận Mười",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "399000"
  },
  { "id": 191245, "name": "Kisumu", "country": "KE", "admin1": "Kisumu County", "pop": "397957" },
  { "id": 702658, "name": "Luhansk", "country": "UA", "admin1": "Luhansk", "pop": "397677" },
  { "id": 3648546, "name": "Barinas", "country": "VE", "admin1": "Barinas", "pop": "397279" },
  { "id": 4281730, "name": "Wichita", "country": "US", "admin1": "Kansas", "pop": "396119" },
  {
    "id": 2558545,
    "name": "Al Hoceïma",
    "country": "MA",
    "admin1": "Tanger-Tetouan-Al Hoceima",
    "pop": "395644"
  },
  {
    "id": 3445026,
    "name": "Vila Velha",
    "country": "BR",
    "admin1": "Espírito Santo",
    "pop": "394930"
  },
  {
    "id": 3181928,
    "name": "Bologna",
    "country": "IT",
    "admin1": "Emilia-Romagna",
    "pop": "394843"
  },
  { "id": 11523293, "name": "Sejong", "country": "KR", "admin1": "Sejong-si", "pop": "394630" },
  { "id": 740264, "name": "Samsun", "country": "TR", "admin1": "Samsun", "pop": "394050" },
  { "id": 588409, "name": "Tallinn", "country": "EE", "admin1": "Harjumaa", "pop": "394024" },
  { "id": 149606, "name": "Tanga", "country": "TZ", "admin1": "Tanga", "pop": "393429" },
  {
    "id": 379003,
    "name": "El Obeid",
    "country": "SD",
    "admin1": "North Kordofan",
    "pop": "393311"
  },
  { "id": 3464739, "name": "Diadema", "country": "BR", "admin1": "São Paulo", "pop": "393237" },
  { "id": 145531, "name": "Saurimo", "country": "AO", "admin1": "Lunda Sul", "pop": "393000" },
  { "id": 3688928, "name": "Bello", "country": "CO", "admin1": "Antioquia", "pop": "392939" },
  { "id": 3672778, "name": "Pasto", "country": "CO", "admin1": "Nariño", "pop": "392930" },
  { "id": 1810458, "name": "Gaomi", "country": "CN", "admin1": "Shandong", "pop": "391986" },
  { "id": 3836277, "name": "Santa Fe", "country": "AR", "admin1": "Santa Fe", "pop": "391164" },
  {
    "id": 2282006,
    "name": "San-Pédro",
    "country": "CI",
    "admin1": "Bas-Sassandra District",
    "pop": "390654"
  },
  { "id": 2331140, "name": "Makurdi", "country": "NG", "admin1": "Benue State", "pop": "390000" },
  { "id": 2294915, "name": "Takoradi", "country": "GH", "admin1": "Western", "pop": "389114" },
  {
    "id": 1606590,
    "name": "Samut Prakan",
    "country": "TH",
    "admin1": "Samut Prakan",
    "pop": "388920"
  },
  { "id": 4671240, "name": "Arlington", "country": "US", "admin1": "Texas", "pop": "388125" },
  {
    "id": 105072,
    "name": "Khamis Mushait",
    "country": "SA",
    "admin1": "'Asir Region",
    "pop": "387553"
  },
  {
    "id": 3660689,
    "name": "Ambato",
    "country": "EC",
    "admin1": "Tungurahua Province",
    "pop": "387309"
  },
  { "id": 3466998, "name": "Carapicuíba", "country": "BR", "admin1": "São Paulo", "pop": "386984" },
  { "id": 3392242, "name": "Petrolina", "country": "BR", "admin1": "Pernambuco", "pop": "386791" },
  { "id": 3827598, "name": "Ojo de Agua", "country": "MX", "admin1": "México", "pop": "386290" },
  {
    "id": 3352136,
    "name": "Windhoek",
    "country": "NA",
    "admin1": "Khomas Region",
    "pop": "386219"
  },
  {
    "id": 2395914,
    "name": "Abomey-Calavi",
    "country": "BJ",
    "admin1": "Atlantique",
    "pop": "385755"
  },
  {
    "id": 2947416,
    "name": "Bochum",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "385729"
  },
  { "id": 1851483, "name": "Suita", "country": "JP", "admin1": "Osaka", "pop": "385567" },
  {
    "id": 310859,
    "name": "Kahramanmaraş",
    "country": "TR",
    "admin1": "Kahramanmaraş",
    "pop": "384953"
  },
  { "id": 12159964, "name": "Chongzuo", "country": "CN", "admin1": "Guangxi", "pop": "384905" },
  { "id": 1854376, "name": "Okazaki", "country": "JP", "admin1": "Aichi", "pop": "384654" },
  { "id": 3514519, "name": "Xico", "country": "MX", "admin1": "México", "pop": "384327" },
  { "id": 3526700, "name": "Iztacalco", "country": "MX", "admin1": "Mexico City", "pop": "384326" },
  {
    "id": 1268561,
    "name": "Kākināda",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "384182"
  },
  { "id": 3470044, "name": "Betim", "country": "BR", "admin1": "Minas Gerais", "pop": "384000" },
  {
    "id": 2515270,
    "name": "Las Palmas de Gran Canaria",
    "country": "ES",
    "admin1": "Canary Islands",
    "pop": "383516"
  },
  {
    "id": 1716771,
    "name": "Cotabato",
    "country": "PH",
    "admin1": "Autonomous Region in Muslim Mindanao",
    "pop": "383383"
  },
  { "id": 288764, "name": "Bawshar", "country": "OM", "admin1": "Muscat", "pop": "383257" },
  { "id": 1265014, "name": "Latur", "country": "IN", "admin1": "Maharashtra", "pop": "382940" },
  { "id": 3726786, "name": "Delmas", "country": "HT", "admin1": "Ouest", "pop": "382920" },
  { "id": 1913154, "name": "Tanzhou", "country": "CN", "admin1": "Guangdong", "pop": "382445" },
  {
    "id": 2179537,
    "name": "Wellington",
    "country": "NZ",
    "admin1": "Wellington Region",
    "pop": "381900"
  },
  { "id": 3996322, "name": "Mazatlán", "country": "MX", "admin1": "Sinaloa", "pop": "381583" },
  {
    "id": 3466537,
    "name": "Caxias do Sul",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "381270"
  },
  {
    "id": 520494,
    "name": "Nizhny Tagil",
    "country": "RU",
    "admin1": "Sverdlovsk Oblast",
    "pop": "381116"
  },
  { "id": 4004330, "name": "Irapuato", "country": "MX", "admin1": "Guanajuato", "pop": "380941" },
  { "id": 1861949, "name": "Ichinomiya", "country": "JP", "admin1": "Aichi", "pop": "380073" },
  { "id": 359792, "name": "Aswān", "country": "EG", "admin1": "Aswan", "pop": "379774" },
  { "id": 3078610, "name": "Brno", "country": "CZ", "admin1": "South Moravian", "pop": "379466" },
  { "id": 3470279, "name": "Bauru", "country": "BR", "admin1": "São Paulo", "pop": "379297" },
  { "id": 675810, "name": "Iaşi", "country": "RO", "admin1": "Iași County", "pop": "378954" },
  { "id": 986822, "name": "Krugersdorp", "country": "ZA", "admin1": "Gauteng", "pop": "378821" },
  { "id": 1260482, "name": "Pānihāti", "country": "IN", "admin1": "West Bengal", "pop": "378705" },
  {
    "id": 1185107,
    "name": "Shibganj",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "378701"
  },
  { "id": 3696183, "name": "Iquitos", "country": "PE", "admin1": "Loreto", "pop": "377609" },
  { "id": 1849846, "name": "Toyohashi", "country": "JP", "admin1": "Aichi", "pop": "377453" },
  { "id": 1808212, "name": "Hechuan", "country": "CN", "admin1": "Chongqing", "pop": "377213" },
  { "id": 2745912, "name": "Utrecht", "country": "NL", "admin1": "Utrecht", "pop": "376435" },
  {
    "id": 1258932,
    "name": "Rajamahendravaram",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "376333"
  },
  { "id": 1272691, "name": "Dhule", "country": "IN", "admin1": "Maharashtra", "pop": "375559" },
  { "id": 1852383, "name": "Minato", "country": "JP", "admin1": "Wakayama", "pop": "375339" },
  { "id": 1749822, "name": "Puchong", "country": "MY", "admin1": "Selangor", "pop": "375181" },
  { "id": 2326171, "name": "Ondo", "country": "NG", "admin1": "Ondo State", "pop": "375000" },
  { "id": 1258076, "name": "Rohtak", "country": "IN", "admin1": "Haryana", "pop": "374292" },
  { "id": 958724, "name": "Rustenburg", "country": "ZA", "admin1": "North West", "pop": "373695" },
  {
    "id": 5325738,
    "name": "Bakersfield",
    "country": "US",
    "admin1": "California",
    "pop": "373640"
  },
  { "id": 1649150, "name": "Bengkulu", "country": "ID", "admin1": "Bengkulu", "pop": "373591" },
  { "id": 1621177, "name": "Yogyakarta", "country": "ID", "admin1": "Yogyakarta", "pop": "373589" },
  { "id": 2033574, "name": "Xuanhua", "country": "CN", "admin1": "Hebei", "pop": "373422" },
  { "id": 939270, "name": "Emalahleni", "country": "ZA", "admin1": "Mpumalanga", "pop": "373403" },
  { "id": 2235189, "name": "Bafoussam", "country": "CM", "admin1": "West", "pop": "373268" },
  { "id": 1633034, "name": "Palu", "country": "ID", "admin1": "Central Sulawesi", "pop": "373218" },
  {
    "id": 1565022,
    "name": "Thủ Dầu Một",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "373105"
  },
  { "id": 1851002, "name": "Takasaki", "country": "JP", "admin1": "Gunma", "pop": "372973" },
  {
    "id": 1734810,
    "name": "Seremban",
    "country": "MY",
    "admin1": "Negeri Sembilan",
    "pop": "372917"
  },
  {
    "id": 3827408,
    "name": "Miguel Hidalgo",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "372889"
  },
  { "id": 1856215, "name": "Nagano", "country": "JP", "admin1": "Nagano", "pop": "372760" },
  { "id": 1734199, "name": "Tawau", "country": "MY", "admin1": "Sabah", "pop": "372615" },
  { "id": 2653822, "name": "Cardiff", "country": "GB", "admin1": "Wales", "pop": "372089" },
  { "id": 1106542, "name": "Chitungwiza", "country": "ZW", "admin1": "Harare", "pop": "371246" },
  { "id": 145459, "name": "Abadan", "country": "IR", "admin1": "Khuzestan", "pop": "370180" },
  { "id": 7304020, "name": "Fenghuang", "country": "CN", "admin1": "Hunan", "pop": "370000" },
  {
    "id": 3629672,
    "name": "Puerto La Cruz",
    "country": "VE",
    "admin1": "Anzoátegui",
    "pop": "370000"
  },
  { "id": 2320576, "name": "Umuahia", "country": "NG", "admin1": "Abia State", "pop": "370000" },
  { "id": 689558, "name": "Vinnytsya", "country": "UA", "admin1": "Vinnytsia", "pop": "369839" },
  { "id": 298299, "name": "Uşak", "country": "TR", "admin1": "Uşak", "pop": "369433" },
  {
    "id": 1283613,
    "name": "Bharatpur",
    "country": "NP",
    "admin1": "Bagmati Province",
    "pop": "369377"
  },
  {
    "id": 3460644,
    "name": "Itaquaquecetuba",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "369275"
  },
  {
    "id": 7483813,
    "name": "Natore",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "369138"
  },
  {
    "id": 353219,
    "name": "6th of October City",
    "country": "EG",
    "admin1": "Giza",
    "pop": "368650"
  },
  { "id": 2644668, "name": "Leicester", "country": "GB", "admin1": "England", "pop": "368600" },
  {
    "id": 2172517,
    "name": "Canberra",
    "country": "AU",
    "admin1": "Australian Capital Territory",
    "pop": "367752"
  },
  { "id": 1855612, "name": "Nara-shi", "country": "JP", "admin1": "Nara", "pop": "367353" },
  { "id": 3176959, "name": "Florence", "country": "IT", "admin1": "Tuscany", "pop": "367150" },
  {
    "id": 1279228,
    "name": "Ahilyanagar",
    "country": "IN",
    "admin1": "Maharashtra",
    "pop": "367140"
  },
  { "id": 1259091, "name": "Kollam", "country": "IN", "admin1": "Kerala", "pop": "367107" },
  { "id": 8537264, "name": "Huanggang", "country": "CN", "admin1": "Hubei", "pop": "366769" },
  { "id": 3393536, "name": "Olinda", "country": "BR", "admin1": "Pernambuco", "pop": "366754" },
  {
    "id": 3102014,
    "name": "Bydgoszcz",
    "country": "PL",
    "admin1": "Kujawsko-Pomorskie",
    "pop": "366452"
  },
  { "id": 2654993, "name": "Bradford", "country": "GB", "admin1": "England", "pop": "366187" },
  { "id": 1275637, "name": "Bilāspur", "country": "IN", "admin1": "Chhattisgarh", "pop": "365579" },
  { "id": 1703320, "name": "Malabon", "country": "PH", "admin1": "Metro Manila", "pop": "365525" },
  { "id": 5150529, "name": "Cleveland", "country": "US", "admin1": "Ohio", "pop": "365379" },
  { "id": 2337181, "name": "Iseyin", "country": "NG", "admin1": "Oyo State", "pop": "365300" },
  { "id": 5950268, "name": "Etobicoke", "country": "CA", "admin1": "Ontario", "pop": "365000" },
  { "id": 2341374, "name": "Gboko", "country": "NG", "admin1": "Benue State", "pop": "365000" },
  { "id": 2318123, "name": "Yenagoa", "country": "NG", "admin1": "Bayelsa State", "pop": "365000" },
  {
    "id": 1838343,
    "name": "Pyeongtaek",
    "country": "KR",
    "admin1": "Gyeonggi-do",
    "pop": "364694"
  },
  { "id": 3630297, "name": "Petare", "country": "VE", "admin1": "Miranda", "pop": "364684" },
  {
    "id": 1588060,
    "name": "Bến Cát",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "364578"
  },
  { "id": 1817990, "name": "Anqiu", "country": "CN", "admin1": "Shandong", "pop": "364208" },
  { "id": 324190, "name": "Alanya", "country": "TR", "admin1": "Antalya", "pop": "364180" },
  { "id": 1172128, "name": "Larkana", "country": "PK", "admin1": "Sindh", "pop": "364033" },
  { "id": 379062, "name": "Al Qadarif", "country": "SD", "admin1": "Al Qaḑārif", "pop": "363945" },
  { "id": 1647003, "name": "Cibinong", "country": "ID", "admin1": "West Java", "pop": "363424" },
  { "id": 1169116, "name": "Nawabshah", "country": "PK", "admin1": "Sindh", "pop": "363138" },
  { "id": 4335045, "name": "New Orleans", "country": "US", "admin1": "Louisiana", "pop": "362701" },
  { "id": 1678228, "name": "Keelung", "country": "TW", "admin1": "Taiwan", "pop": "362487" },
  { "id": 2692969, "name": "Malmö", "country": "SE", "admin1": "Skåne", "pop": "362133" },
  { "id": 1805029, "name": "Jizhou", "country": "CN", "admin1": "Hebei", "pop": "362013" },
  { "id": 2187404, "name": "Manukau City", "country": "NZ", "admin1": "Auckland", "pop": "362000" },
  {
    "id": 3469968,
    "name": "Blumenau",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "361855"
  },
  { "id": 2441291, "name": "Maradi", "country": "NE", "admin1": "Maradi Region", "pop": "361702" },
  { "id": 6947637, "name": "Ataşehir", "country": "TR", "admin1": "Istanbul", "pop": "361615" },
  { "id": 627904, "name": "Hrodna", "country": "BY", "admin1": "Grodnenskaya", "pop": "361115" },
  {
    "id": 2805753,
    "name": "Wuppertal",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "360797"
  },
  { "id": 1626381, "name": "Sukabumi", "country": "ID", "admin1": "West Java", "pop": "360644" },
  {
    "id": 2014407,
    "name": "Ulan-Ude",
    "country": "RU",
    "admin1": "Buryatiya Republic",
    "pop": "360278"
  },
  { "id": 765876, "name": "Lublin", "country": "PL", "admin1": "Lublin", "pop": "360044" },
  { "id": 11694038, "name": "Huocheng", "country": "CN", "admin1": "Xinjiang", "pop": "360000" },
  { "id": 2338400, "name": "Ijebu Ode", "country": "NG", "admin1": "Ogun State", "pop": "360000" },
  { "id": 932505, "name": "Maseru", "country": "LS", "admin1": "Maseru District", "pop": "359753" },
  { "id": 1275960, "name": "Bhilwara", "country": "IN", "admin1": "Rajasthan", "pop": "359483" },
  { "id": 5412347, "name": "Aurora", "country": "US", "admin1": "Colorado", "pop": "359407" },
  { "id": 584923, "name": "Sumqayıt", "country": "AZ", "admin1": "Sumqayit", "pop": "358675" },
  { "id": 3463011, "name": "Franca", "country": "BR", "admin1": "São Paulo", "pop": "358539" },
  { "id": 620127, "name": "Vitebsk", "country": "BY", "admin1": "Vitebsk", "pop": "358395" },
  { "id": 1516905, "name": "Taraz", "country": "KZ", "admin1": "Zhambyl", "pop": "358153" },
  {
    "id": 1832828,
    "name": "Yangsan",
    "country": "KR",
    "admin1": "Gyeongsangnam-do",
    "pop": "358074"
  },
  { "id": 3347939, "name": "Lobito", "country": "AO", "admin1": "Benguela", "pop": "357950" },
  {
    "id": 1689395,
    "name": "San Jose del Monte",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "357828"
  },
  {
    "id": 1948005,
    "name": "Gwangmyeong",
    "country": "KR",
    "admin1": "Gyeonggi-do",
    "pop": "357545"
  },
  { "id": 111453, "name": "Zanjan", "country": "IR", "admin1": "Zanjan", "pop": "357471" },
  {
    "id": 3673899,
    "name": "Neiva",
    "country": "CO",
    "admin1": "Huila Department",
    "pop": "357392"
  },
  { "id": 2112539, "name": "Iwaki", "country": "JP", "admin1": "Fukushima", "pop": "357309" },
  {
    "id": 473247,
    "name": "Vladimir",
    "country": "RU",
    "admin1": "Vladimir Oblast",
    "pop": "357024"
  },
  { "id": 1026014, "name": "Tete", "country": "MZ", "admin1": "Tete", "pop": "357000" },
  { "id": 1729524, "name": "Bacoor", "country": "PH", "admin1": "Calabarzon", "pop": "356974" },
  { "id": 1926004, "name": "Wakayama", "country": "JP", "admin1": "Wakayama", "pop": "356729" },
  { "id": 1275198, "name": "Brahmapur", "country": "IN", "admin1": "Odisha", "pop": "356598" },
  { "id": 1673816, "name": "Fengshan", "country": "TW", "admin1": "Takao", "pop": "356463" },
  { "id": 3402429, "name": "Caucaia", "country": "BR", "admin1": "Ceará", "pop": "355679" },
  { "id": 2214846, "name": "Misratah", "country": "LY", "admin1": "Mişrātah", "pop": "355657" },
  { "id": 3348078, "name": "Cuíto", "country": "AO", "admin1": "Bíe", "pop": "355423" },
  {
    "id": 3827406,
    "name": "Benito Juarez",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "355017"
  },
  { "id": 1519922, "name": "Kyzylorda", "country": "KZ", "admin1": "Qyzylorda", "pop": "354800" },
  { "id": 1859740, "name": "Kawagoe", "country": "JP", "admin1": "Saitama", "pop": "354571" },
  { "id": 1850910, "name": "Takatsuki", "country": "JP", "admin1": "Osaka", "pop": "354468" },
  { "id": 1262330, "name": "Muzaffarpur", "country": "IN", "admin1": "Bihar", "pop": "354462" },
  { "id": 3516266, "name": "Tapachula", "country": "MX", "admin1": "Chiapas", "pop": "353706" },
  { "id": 8067345, "name": "Lhoka", "country": "CN", "admin1": "Tibet", "pop": "353700" },
  { "id": 3514670, "name": "Villahermosa", "country": "MX", "admin1": "Tabasco", "pop": "353577" },
  {
    "id": 3466954,
    "name": "Cariacica",
    "country": "BR",
    "admin1": "Espírito Santo",
    "pop": "353491"
  },
  { "id": 1735162, "name": "Setapak", "country": "MY", "admin1": "Selangor", "pop": "353268" },
  { "id": 625665, "name": "Mahilyow", "country": "BY", "admin1": "Mogilev", "pop": "353110" },
  { "id": 141681, "name": "Bandar Abbas", "country": "IR", "admin1": "Hormozgan", "pop": "352173" },
  {
    "id": 291074,
    "name": "Ras Al Khaimah City",
    "country": "AE",
    "admin1": "Raʼs al Khaymah",
    "pop": "351943"
  },
  { "id": 3647651, "name": "Cabimas", "country": "VE", "admin1": "Zulia", "pop": "351736" },
  { "id": 5856195, "name": "Honolulu", "country": "US", "admin1": "Hawaii", "pop": "350964" },
  { "id": 5323810, "name": "Anaheim", "country": "US", "admin1": "California", "pop": "350742" },
  { "id": 299817, "name": "Tarsus", "country": "TR", "admin1": "Mersin", "pop": "350732" },
  { "id": 1798900, "name": "Pengze", "country": "CN", "admin1": "Jiangxi", "pop": "350000" },
  { "id": 1259239, "name": "Punāsa", "country": "IN", "admin1": "Madhya Pradesh", "pop": "350000" },
  { "id": 342884, "name": "Bahir Dar", "country": "ET", "admin1": "Amhara", "pop": "350000" },
  { "id": 99100, "name": "Al Maḩmūdīyah", "country": "IQ", "admin1": "Baghdad", "pop": "350000" },
  {
    "id": 8054802,
    "name": "Xilinhot",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "349953"
  },
  {
    "id": 3452465,
    "name": "Praia Grande",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "349935"
  },
  {
    "id": 1028434,
    "name": "Quelimane",
    "country": "MZ",
    "admin1": "Zambezia Province",
    "pop": "349842"
  },
  {
    "id": 581049,
    "name": "Arkhangel’sk",
    "country": "RU",
    "admin1": "Arkhangelskaya",
    "pop": "349742"
  },
  {
    "id": 1262332,
    "name": "Muzaffarnagar",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "349706"
  },
  {
    "id": 12548253,
    "name": "Hulunbuir",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "349400"
  },
  { "id": 2451185, "name": "Sikasso", "country": "ML", "admin1": "Sikasso", "pop": "349324" },
  {
    "id": 117574,
    "name": "Sanandaj",
    "country": "IR",
    "admin1": "Kurdistan Province",
    "pop": "349176"
  },
  {
    "id": 2025339,
    "name": "Chita",
    "country": "RU",
    "admin1": "Zabaykalskiy (Transbaikal) Kray",
    "pop": "349005"
  },
  { "id": 1688749, "name": "San Pedro", "country": "PH", "admin1": "Calabarzon", "pop": "348968" },
  {
    "id": 3403642,
    "name": "Campina Grande",
    "country": "BR",
    "admin1": "Paraíba",
    "pop": "348936"
  },
  { "id": 2521978, "name": "Alicante", "country": "ES", "admin1": "Valencia", "pop": "348901" },
  { "id": 2388873, "name": "Bimbo", "country": "CF", "admin1": "Ombella-M'Poko", "pop": "348802" },
  {
    "id": 1321218,
    "name": "Kalemyo",
    "country": "MM",
    "admin1": "Sagaing Region",
    "pop": "348573"
  },
  {
    "id": 2655984,
    "name": "Belfast",
    "country": "GB",
    "admin1": "Northern Ireland",
    "pop": "348005"
  },
  { "id": 1564064, "name": "Long Bien", "country": "VN", "admin1": "Hanoi", "pop": "347829" },
  { "id": 3566067, "name": "Camagüey", "country": "CU", "admin1": "Camagüey", "pop": "347562" },
  { "id": 1813206, "name": "Daye", "country": "CN", "admin1": "Hubei", "pop": "347406" },
  { "id": 3128026, "name": "Bilbao", "country": "ES", "admin1": "Basque Country", "pop": "347342" },
  { "id": 1651531, "name": "Ambon", "country": "ID", "admin1": "Maluku", "pop": "347288" },
  { "id": 728193, "name": "Plovdiv", "country": "BG", "admin1": "Plovdiv", "pop": "346893" },
  {
    "id": 2038067,
    "name": "Chifeng",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "346654"
  },
  {
    "id": 10630449,
    "name": "Sunshine Coast",
    "country": "AU",
    "admin1": "Queensland",
    "pop": "346522"
  },
  { "id": 3435217, "name": "Corrientes", "country": "AR", "admin1": "Corrientes", "pop": "346334" },
  {
    "id": 1877030,
    "name": "Hŭngnam",
    "country": "KP",
    "admin1": "South Hamgyong",
    "pop": "346082"
  },
  { "id": 1278130, "name": "Avadi", "country": "IN", "admin1": "Tamil Nadu", "pop": "345996" },
  { "id": 1526273, "name": "Astana", "country": "KZ", "admin1": "Astana", "pop": "345604" },
  { "id": 12277239, "name": "Yunlong", "country": "CN", "admin1": "Jiangsu", "pop": "345393" },
  { "id": 1858729, "name": "Koshigaya", "country": "JP", "admin1": "Saitama", "pop": "345353" },
  { "id": 2652221, "name": "Coventry", "country": "GB", "admin1": "England", "pop": "345324" },
  {
    "id": 578072,
    "name": "Belgorod",
    "country": "RU",
    "admin1": "Belgorod Oblast",
    "pop": "345289"
  },
  {
    "id": 1640344,
    "name": "Kendari",
    "country": "ID",
    "admin1": "Southeast Sulawesi",
    "pop": "345107"
  },
  { "id": 1053384, "name": "Toamasina", "country": "MG", "admin1": "Atsinanana", "pop": "345107" },
  { "id": 1853574, "name": "Ōtsu", "country": "JP", "admin1": "Shiga", "pop": "345070" },
  { "id": 371760, "name": "Kosti", "country": "SD", "admin1": "White Nile", "pop": "345068" },
  { "id": 2035261, "name": "Qitaihe", "country": "CN", "admin1": "Heilongjiang", "pop": "345033" },
  {
    "id": 290030,
    "name": "Doha",
    "country": "QA",
    "admin1": "Baladīyat ad Dawḩah",
    "pop": "344939"
  },
  { "id": 1273800, "name": "Kadapa", "country": "IN", "admin1": "Andhra Pradesh", "pop": "344893" },
  { "id": 8715035, "name": "Nakano", "country": "JP", "admin1": "Tokyo", "pop": "344880" },
  { "id": 3625829, "name": "Turmero", "country": "VE", "admin1": "Aragua", "pop": "344700" },
  { "id": 629634, "name": "Brest", "country": "BY", "admin1": "Brest", "pop": "344470" },
  { "id": 1850181, "name": "Tokorozawa", "country": "JP", "admin1": "Saitama", "pop": "344194" },
  {
    "id": 1721906,
    "name": "Cabanatuan City",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "343672"
  },
  { "id": 1785716, "name": "Pizhou", "country": "CN", "admin1": "Jiangsu", "pop": "343421" },
  { "id": 338832, "name": "Dire Dawa", "country": "ET", "admin1": "Dire Dawa", "pop": "343000" },
  { "id": 2506999, "name": "Annaba", "country": "DZ", "admin1": "Annaba", "pop": "342703" },
  {
    "id": 2990440,
    "name": "Nice",
    "country": "FR",
    "admin1": "Provence-Alpes-Côte d'Azur",
    "pop": "342669"
  },
  {
    "id": 1711084,
    "name": "Iligan",
    "country": "PH",
    "admin1": "Northern Mindanao",
    "pop": "342618"
  },
  { "id": 3667849, "name": "Soledad", "country": "CO", "admin1": "Atlántico", "pop": "342556" },
  {
    "id": 2529013,
    "name": "Temara",
    "country": "MA",
    "admin1": "Rabat-Salé-Kénitra",
    "pop": "342345"
  },
  { "id": 3392740, "name": "Paulista", "country": "BR", "admin1": "Pernambuco", "pop": "342167" },
  { "id": 2566633, "name": "Obalende", "country": "NG", "admin1": "Lagos", "pop": "342000" },
  { "id": 1646170, "name": "Cirebon", "country": "ID", "admin1": "West Java", "pop": "341980" },
  { "id": 1265767, "name": "Kukatpally", "country": "IN", "admin1": "Telangana", "pop": "341709" },
  { "id": 1794479, "name": "Laixi", "country": "CN", "admin1": "Shandong", "pop": "341470" },
  { "id": 1175892, "name": "Jhang Sadr", "country": "PK", "admin1": "Punjab", "pop": "341210" },
  { "id": 96994, "name": "Dihok", "country": "IQ", "admin1": "Duhok", "pop": "340900" },
  { "id": 553915, "name": "Kaluga", "country": "RU", "admin1": "Kaluga Oblast", "pop": "340851" },
  { "id": 13405933, "name": "Bắc Từ Liêm", "country": "VN", "admin1": "Hanoi", "pop": "340605" },
  { "id": 4014875, "name": "Celaya", "country": "MX", "admin1": "Guanajuato", "pop": "340387" },
  { "id": 2411989, "name": "Serekunda", "country": "GM", "admin1": "Banjul", "pop": "340000" },
  { "id": 1199503, "name": "Kāfrul", "country": "BD", "admin1": "Dhaka Division", "pop": "339734" },
  { "id": 702320, "name": "Makiivka", "country": "UA", "admin1": "Donetsk", "pop": "338968" },
  { "id": 3529947, "name": "Cuernavaca", "country": "MX", "admin1": "Morelos", "pop": "338650" },
  { "id": 6066513, "name": "Markham", "country": "CA", "admin1": "Ontario", "pop": "338503" },
  { "id": 1876373, "name": "Kaesŏng", "country": "KP", "admin1": "Kaesong", "pop": "338155" },
  { "id": 3445839, "name": "Uberaba", "country": "BR", "admin1": "Minas Gerais", "pop": "337836" },
  { "id": 1185098, "name": "Tungi", "country": "BD", "admin1": "Dhaka Division", "pop": "337579" },
  { "id": 963241, "name": "Randburg", "country": "ZA", "admin1": "Gauteng", "pop": "337053" },
  { "id": 2537881, "name": "Safi", "country": "MA", "admin1": "Marrakesh-Safi", "pop": "336883" },
  { "id": 693805, "name": "Simferopol", "country": "UA", "admin1": "Crimea", "pop": "336460" },
  { "id": 586523, "name": "Ganja", "country": "AZ", "admin1": "Gǝncǝ", "pop": "335600" },
  { "id": 3621849, "name": "San José", "country": "CR", "admin1": "San José", "pop": "335007" },
  { "id": 4167147, "name": "Orlando", "country": "US", "admin1": "Florida", "pop": "334854" },
  { "id": 2034439, "name": "Tieling", "country": "CN", "admin1": "Liaoning", "pop": "333907" },
  { "id": 119505, "name": "Qazvin", "country": "IR", "admin1": "Qazvin Province", "pop": "333635" },
  { "id": 2130629, "name": "Asahikawa", "country": "JP", "admin1": "Hokkaido", "pop": "333530" },
  { "id": 1268257, "name": "Kāmārhāti", "country": "IN", "admin1": "West Bengal", "pop": "332965" },
  { "id": 3981941, "name": "Tepic", "country": "MX", "admin1": "Nayarit", "pop": "332863" },
  { "id": 1833105, "name": "Wŏnju", "country": "KR", "admin1": "Gangwon-do", "pop": "332849" },
  { "id": 364103, "name": "Wad Medani", "country": "SD", "admin1": "Al Jazīrah", "pop": "332714" },
  {
    "id": 9645084,
    "name": "Quận Mười Một",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "332536"
  },
  { "id": 601294, "name": "Nukus", "country": "UZ", "admin1": "Karakalpakstan", "pop": "332500" },
  { "id": 1857843, "name": "Maebashi", "country": "JP", "admin1": "Gunma", "pop": "332149" },
  { "id": 8469285, "name": "Kita", "country": "JP", "admin1": "Tokyo", "pop": "332140" },
  {
    "id": 3530580,
    "name": "Ciudad Victoria",
    "country": "MX",
    "admin1": "Tamaulipas",
    "pop": "332100"
  },
  {
    "id": 3982912,
    "name": "Soledad de Graciano Sánchez",
    "country": "MX",
    "admin1": "San Luis Potosí",
    "pop": "332072"
  },
  { "id": 1859146, "name": "Kochi", "country": "JP", "admin1": "Kochi", "pop": "332059" },
  {
    "id": 2949186,
    "name": "Bielefeld",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "331906"
  },
  { "id": 1645133, "name": "Dumai", "country": "ID", "admin1": "Riau", "pop": "331832" },
  { "id": 2503769, "name": "Blida", "country": "DZ", "admin1": "Blida", "pop": "331779" },
  {
    "id": 1819595,
    "name": "Kwai Chung",
    "country": "HK",
    "admin1": "Kwai Tsing District",
    "pop": "331600"
  },
  {
    "id": 1701947,
    "name": "Mandaue City",
    "country": "PH",
    "admin1": "Central Visayas",
    "pop": "331320"
  },
  { "id": 127319, "name": "Khorramshahr", "country": "IR", "admin1": "Khuzestan", "pop": "330606" },
  {
    "id": 2946447,
    "name": "Bonn",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "330579"
  },
  { "id": 1263364, "name": "Mathura", "country": "IN", "admin1": "Uttar Pradesh", "pop": "330511" },
  { "id": 12358476, "name": "Hechi", "country": "CN", "admin1": "Guangxi", "pop": "330131" },
  {
    "id": 491687,
    "name": "Smolensk",
    "country": "RU",
    "admin1": "Smolensk Oblast",
    "pop": "330025"
  },
  { "id": 608668, "name": "Oral", "country": "KZ", "admin1": "Batys Qazaqstan", "pop": "330000" },
  { "id": 3448136, "name": "São Vicente", "country": "BR", "admin1": "São Paulo", "pop": "329911" },
  {
    "id": 127349,
    "name": "Khorramabad",
    "country": "IR",
    "admin1": "Lorestan Province",
    "pop": "329825"
  },
  {
    "id": 3451353,
    "name": "Ribeirão das Neves",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "329794"
  },
  {
    "id": 3583096,
    "name": "Soyapango",
    "country": "SV",
    "admin1": "San Salvador Department",
    "pop": "329708"
  },
  { "id": 1787824, "name": "Tongshan", "country": "CN", "admin1": "Jiangsu", "pop": "329661" },
  { "id": 2595778, "name": "Guédiawaye", "country": "SN", "admin1": "Dakar", "pop": "329659" },
  {
    "id": 3448632,
    "name": "São José dos Pinhais",
    "country": "BR",
    "admin1": "Paraná",
    "pop": "329628"
  },
  { "id": 4013704, "name": "Ciudad Obregón", "country": "MX", "admin1": "Sonora", "pop": "329404" },
  { "id": 1866923, "name": "Wŏnsan", "country": "KP", "admin1": "Kangwŏn-do", "pop": "329207" },
  {
    "id": 1520240,
    "name": "Pavlodar",
    "country": "KZ",
    "admin1": "Pavlodar Region",
    "pop": "329002"
  },
  { "id": 1274693, "name": "Chānda", "country": "IN", "admin1": "Maharashtra", "pop": "328351" },
  {
    "id": 3467467,
    "name": "Canoas",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "328291"
  },
  { "id": 2112141, "name": "Kōriyama", "country": "JP", "admin1": "Fukushima", "pop": "327692" },
  { "id": 491422, "name": "Sochi", "country": "RU", "admin1": "Krasnodar Krai", "pop": "327608" },
  { "id": 1275701, "name": "Vijayapura", "country": "IN", "admin1": "Karnataka", "pop": "327427" },
  {
    "id": 918702,
    "name": "Chipata",
    "country": "ZM",
    "admin1": "Eastern Province",
    "pop": "327059"
  },
  {
    "id": 2044757,
    "name": "Chongjin",
    "country": "KP",
    "admin1": "North Hamgyong",
    "pop": "327000"
  },
  { "id": 2033467, "name": "Yanji", "country": "CN", "admin1": "Jilin", "pop": "326957" },
  { "id": 7281838, "name": "Logan City", "country": "AU", "admin1": "Queensland", "pop": "326615" },
  { "id": 936374, "name": "Roodepoort", "country": "ZA", "admin1": "Gauteng", "pop": "326416" },
  { "id": 3693345, "name": "Pucallpa", "country": "PE", "admin1": "Ucayali", "pop": "326040" },
  {
    "id": 3457001,
    "name": "Mogi das Cruzes",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "325746"
  },
  { "id": 2519240, "name": "Córdoba", "country": "ES", "admin1": "Andalusia", "pop": "325708" },
  { "id": 2655613, "name": "Birkenhead", "country": "GB", "admin1": "England", "pop": "325264" },
  { "id": 2337704, "name": "Ilesa", "country": "NG", "admin1": "Osun State", "pop": "325000" },
  {
    "id": 1209106,
    "name": "Bhātāra",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "324300"
  },
  { "id": 192126, "name": "Kikuyu", "country": "KE", "admin1": "Kiambu County", "pop": "323881" },
  { "id": 1732811, "name": "Kluang", "country": "MY", "admin1": "Johor", "pop": "323762" },
  { "id": 1803590, "name": "Lincang", "country": "CN", "admin1": "Yunnan", "pop": "323708" },
  { "id": 2641170, "name": "Nottingham", "country": "GB", "admin1": "England", "pop": "323632" },
  { "id": 99608, "name": "Al ‘Amārah", "country": "IQ", "admin1": "Maysan", "pop": "323302" },
  {
    "id": 472231,
    "name": "Volzhsky",
    "country": "RU",
    "admin1": "Volgograd Oblast",
    "pop": "323293"
  },
  { "id": 6173577, "name": "Vaughan", "country": "CA", "admin1": "Ontario", "pop": "323103" },
  { "id": 1807566, "name": "Xingyi", "country": "CN", "admin1": "Guizhou", "pop": "322890" },
  { "id": 3461789, "name": "Guarujá", "country": "BR", "admin1": "São Paulo", "pop": "322750" },
  { "id": 1256515, "name": "Shivamogga", "country": "IN", "admin1": "Karnataka", "pop": "322650" },
  { "id": 1278946, "name": "Alwar", "country": "IN", "admin1": "Rajasthan", "pop": "322568" },
  { "id": 2236568, "name": "Uíge", "country": "AO", "admin1": "Uíge", "pop": "322531" },
  { "id": 3526682, "name": "Ixtapaluca", "country": "MX", "admin1": "México", "pop": "322271" },
  { "id": 1527534, "name": "Osh", "country": "KG", "admin1": "Osh Region", "pop": "322164" },
  { "id": 3652941, "name": "Portoviejo", "country": "EC", "admin1": "Manabí", "pop": "321800" },
  {
    "id": 3665900,
    "name": "Villavicencio",
    "country": "CO",
    "admin1": "Meta Department",
    "pop": "321717"
  },
  {
    "id": 1874533,
    "name": "Man’gyŏngdae-ri",
    "country": "KP",
    "admin1": "Pyongyang",
    "pop": "321690"
  },
  { "id": 3701329, "name": "San Miguelito", "country": "PA", "admin1": "Panamá", "pop": "321501" },
  {
    "id": 3454244,
    "name": "Pelotas",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "320674"
  },
  {
    "id": 1256728,
    "name": "Shāhjānpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "320434"
  },
  { "id": 4297983, "name": "Lexington", "country": "US", "admin1": "Kentucky", "pop": "320347" },
  { "id": 6958518, "name": "Tantou", "country": "CN", "admin1": "Guangdong", "pop": "320304" },
  { "id": 3472287, "name": "Anápolis", "country": "BR", "admin1": "Goiás", "pop": "319587" },
  {
    "id": 1876401,
    "name": "Kaech’ŏn",
    "country": "KP",
    "admin1": "South Pyongan",
    "pop": "319554"
  },
  { "id": 1268773, "name": "Jūnāgadh", "country": "IN", "admin1": "Gujarat", "pop": "319462" },
  { "id": 2646003, "name": "Islington", "country": "GB", "admin1": "England", "pop": "319143" },
  {
    "id": 3556969,
    "name": "Holguín",
    "country": "CU",
    "admin1": "Holguín Province",
    "pop": "319102"
  },
  {
    "id": 1520316,
    "name": "Ust-Kamenogorsk",
    "country": "KZ",
    "admin1": "East Kazakhstan",
    "pop": "319067"
  },
  { "id": 1818209, "name": "Tsuen Wan", "country": "HK", "admin1": "Tsuen Wan", "pop": "318916" },
  { "id": 2437798, "name": "Zinder", "country": "NE", "admin1": "Zinder Region", "pop": "318874" },
  {
    "id": 498698,
    "name": "Saransk",
    "country": "RU",
    "admin1": "Mordoviya Republic",
    "pop": "318841"
  },
  {
    "id": 2990969,
    "name": "Nantes",
    "country": "FR",
    "admin1": "Pays de la Loire",
    "pop": "318808"
  },
  {
    "id": 99762,
    "name": "Ad Dīwānīyah",
    "country": "IQ",
    "admin1": "Al Qādisīyah",
    "pop": "318801"
  },
  { "id": 1177384, "name": "Hafizabad", "country": "PK", "admin1": "Punjab", "pop": "318621" },
  {
    "id": 12278193,
    "name": "Marne La Vallée",
    "country": "FR",
    "admin1": "Île-de-France",
    "pop": "318325"
  },
  { "id": 358448, "name": "Damanhur", "country": "EG", "admin1": "Beheira", "pop": "318207" },
  { "id": 1181096, "name": "Chiniot", "country": "PK", "admin1": "Punjab", "pop": "318165" },
  {
    "id": 3671916,
    "name": "Popayán",
    "country": "CO",
    "admin1": "Cauca Department",
    "pop": "318059"
  },
  { "id": 2639577, "name": "Reading", "country": "GB", "admin1": "England", "pop": "318014" },
  { "id": 159908, "name": "Geita", "country": "TZ", "admin1": "Geita", "pop": "318006" },
  { "id": 3446682, "name": "Taubaté", "country": "BR", "admin1": "São Paulo", "pop": "317915" },
  {
    "id": 680963,
    "name": "Constanţa",
    "country": "RO",
    "admin1": "Constanța County",
    "pop": "317832"
  },
  { "id": 1261481, "name": "New Delhi", "country": "IN", "admin1": "Delhi", "pop": "317797" },
  {
    "id": 734077,
    "name": "Thessaloníki",
    "country": "GR",
    "admin1": "Central Macedonia",
    "pop": "317778"
  },
  { "id": 2244802, "name": "Thiès", "country": "SN", "admin1": "Thiès", "pop": "317763" },
  { "id": 1856035, "name": "Naha", "country": "JP", "admin1": "Okinawa", "pop": "317625" },
  {
    "id": 1631766,
    "name": "Pekalongan",
    "country": "ID",
    "admin1": "Central Java",
    "pop": "317524"
  },
  { "id": 3096472, "name": "Katowice", "country": "PL", "admin1": "Silesia", "pop": "317316" },
  { "id": 8519916, "name": "Obolon", "country": "UA", "admin1": "Kyiv City", "pop": "317300" },
  { "id": 5387877, "name": "Riverside", "country": "US", "admin1": "California", "pop": "317261" },
  { "id": 2038569, "name": "Baicheng", "country": "CN", "admin1": "Jilin", "pop": "316970" },
  { "id": 3698304, "name": "Chimbote", "country": "PE", "admin1": "Ancash", "pop": "316966" },
  { "id": 3182351, "name": "Bari", "country": "IT", "admin1": "Apulia", "pop": "316491" },
  { "id": 3470353, "name": "Barueri", "country": "BR", "admin1": "São Paulo", "pop": "316473" },
  { "id": 4683416, "name": "Corpus Christi", "country": "US", "admin1": "Texas", "pop": "316239" },
  { "id": 1254187, "name": "Thrissur", "country": "IN", "admin1": "Kerala", "pop": "315957" },
  {
    "id": 569223,
    "name": "Cherepovets",
    "country": "RU",
    "admin1": "Vologda Oblast",
    "pop": "315738"
  },
  { "id": 3658192, "name": "Eloy Alfaro", "country": "EC", "admin1": "Guayas", "pop": "315724" },
  { "id": 99131, "name": "Al Kūt", "country": "IQ", "admin1": "Wāsiţ", "pop": "315162" },
  { "id": 1732869, "name": "Muar", "country": "MY", "admin1": "Johor", "pop": "314776" },
  { "id": 739549, "name": "Şişli", "country": "TR", "admin1": "Istanbul", "pop": "314684" },
  {
    "id": 3445451,
    "name": "Várzea Grande",
    "country": "BR",
    "admin1": "Mato Grosso",
    "pop": "314627"
  },
  {
    "id": 4297999,
    "name": "Lexington-Fayette",
    "country": "US",
    "admin1": "Kentucky",
    "pop": "314488"
  },
  { "id": 2228373, "name": "Maroua", "country": "CM", "admin1": "Far North", "pop": "314122" },
  {
    "id": 2645425,
    "name": "Kingston upon Hull",
    "country": "GB",
    "admin1": "England",
    "pop": "314018"
  },
  { "id": 2639912, "name": "Preston", "country": "GB", "admin1": "England", "pop": "313332" },
  { "id": 2036434, "name": "Lianshan", "country": "CN", "admin1": "Liaoning", "pop": "313247" },
  { "id": 317109, "name": "Denizli", "country": "TR", "admin1": "Denizli", "pop": "313238" },
  { "id": 2338313, "name": "Ikeja", "country": "NG", "admin1": "Lagos", "pop": "313196" },
  { "id": 7799991, "name": "New Cairo", "country": "EG", "admin1": "Cairo", "pop": "313139" },
  { "id": 726050, "name": "Varna", "country": "BG", "admin1": "Varna", "pop": "312770" },
  {
    "id": 3444924,
    "name": "Vitória",
    "country": "BR",
    "admin1": "Espírito Santo",
    "pop": "312656"
  },
  {
    "id": 3673164,
    "name": "Palmira",
    "country": "CO",
    "admin1": "Valle del Cauca Department",
    "pop": "312519"
  },
  { "id": 472459, "name": "Vologda", "country": "RU", "admin1": "Vologda Oblast", "pop": "312420" },
  {
    "id": 1711082,
    "name": "Iligan City",
    "country": "PH",
    "admin1": "Soccsksargen",
    "pop": "312323"
  },
  { "id": 3457671, "name": "Maringá", "country": "BR", "admin1": "Paraná", "pop": "311724" },
  { "id": 2525068, "name": "Catania", "country": "IT", "admin1": "Sicily", "pop": "311584" },
  { "id": 1261258, "name": "Nizāmābād", "country": "IN", "admin1": "Telangana", "pop": "311152" },
  { "id": 4508722, "name": "Cincinnati", "country": "US", "admin1": "Ohio", "pop": "311097" },
  { "id": 1214189, "name": "Percut", "country": "ID", "admin1": "North Sumatra", "pop": "311063" },
  {
    "id": 3530517,
    "name": "Coatzacoalcos",
    "country": "MX",
    "admin1": "Veracruz",
    "pop": "310698"
  },
  { "id": 5392900, "name": "Santa Ana", "country": "US", "admin1": "California", "pop": "310227" },
  {
    "id": 1870883,
    "name": "Sariwŏn-si",
    "country": "KP",
    "admin1": "North Hwanghae",
    "pop": "310100"
  },
  { "id": 1016670, "name": "Botshabelo", "country": "ZA", "admin1": "Free State", "pop": "309714" },
  { "id": 1722186, "name": "Butuan", "country": "PH", "admin1": "Caraga", "pop": "309709" },
  { "id": 120292, "name": "Shahr-e Qods", "country": "IR", "admin1": "Tehran", "pop": "309605" },
  { "id": 9871722, "name": "Gia Lâm", "country": "VN", "admin1": "Hanoi", "pop": "309353" },
  { "id": 1501321, "name": "Kurgan", "country": "RU", "admin1": "Kurgan Oblast", "pop": "309285" },
  { "id": 3516355, "name": "Tampico", "country": "MX", "admin1": "Tamaulipas", "pop": "309003" },
  { "id": 2566696, "name": "Akowonjo", "country": "NG", "admin1": "Lagos", "pop": "308900" },
  { "id": 1721281, "name": "Cabuyao", "country": "PH", "admin1": "Calabarzon", "pop": "308745" },
  { "id": 149658, "name": "Tabora", "country": "TZ", "admin1": "Tabora", "pop": "308741" },
  { "id": 1859891, "name": "Kasugai", "country": "JP", "admin1": "Aichi", "pop": "308681" },
  { "id": 1594308, "name": "An Nhơn", "country": "VN", "admin1": "Gia Lai", "pop": "308396" },
  { "id": 2566676, "name": "Alimosho", "country": "NG", "admin1": "Lagos", "pop": "308290" },
  {
    "id": 4003757,
    "name": "Ciudad Benito Juárez",
    "country": "MX",
    "admin1": "Nuevo León",
    "pop": "308285"
  },
  {
    "id": 2873891,
    "name": "Mannheim",
    "country": "DE",
    "admin1": "Baden-Wurttemberg",
    "pop": "307960"
  },
  { "id": 2113126, "name": "Akita", "country": "JP", "admin1": "Akita", "pop": "307672" },
  { "id": 3447212, "name": "Suzano", "country": "BR", "admin1": "São Paulo", "pop": "307429" },
  { "id": 1254089, "name": "Tumkūr", "country": "IN", "admin1": "Karnataka", "pop": "307359" },
  {
    "id": 1846052,
    "name": "Chinju",
    "country": "KR",
    "admin1": "Gyeongsangnam-do",
    "pop": "307242"
  },
  { "id": 1260341, "name": "Parbhani", "country": "IN", "admin1": "Maharashtra", "pop": "307170" },
  { "id": 1270022, "name": "Hisar", "country": "IN", "admin1": "Haryana", "pop": "307024" },
  { "id": 1843491, "name": "Iksan", "country": "KR", "admin1": "Jeollabuk-do", "pop": "307000" },
  {
    "id": 1271885,
    "name": "Fīrozābād",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "306409"
  },
  { "id": 3474574, "name": "Palmas", "country": "BR", "admin1": "Tocantins", "pop": "306296" },
  {
    "id": 473249,
    "name": "Vladikavkaz",
    "country": "RU",
    "admin1": "North Ossetia–Alania",
    "pop": "306258"
  },
  {
    "id": 3718420,
    "name": "Port-de-Paix",
    "country": "HT",
    "admin1": "Nord-Ouest",
    "pop": "306217"
  },
  { "id": 358048, "name": "Damietta", "country": "EG", "admin1": "Damietta", "pop": "305920" },
  { "id": 3429886, "name": "Posadas", "country": "AR", "admin1": "Misiones", "pop": "305874" },
  { "id": 1016181, "name": "Brakpan", "country": "ZA", "admin1": "Gauteng", "pop": "305692" },
  { "id": 5399020, "name": "Stockton", "country": "US", "admin1": "California", "pop": "305658" },
  { "id": 1848373, "name": "Yokkaichi", "country": "JP", "admin1": "Mie", "pop": "305424" },
  { "id": 1265711, "name": "Kulti", "country": "IN", "admin1": "West Bengal", "pop": "305405" },
  { "id": 3515463, "name": "Tláhuac", "country": "MX", "admin1": "Mexico City", "pop": "305076" },
  { "id": 2323675, "name": "Sapele", "country": "NG", "admin1": "Delta", "pop": "305000" },
  {
    "id": 5206379,
    "name": "Pittsburgh",
    "country": "US",
    "admin1": "Pennsylvania",
    "pop": "304391"
  },
  {
    "id": 3689560,
    "name": "Armenia",
    "country": "CO",
    "admin1": "Quindío Department",
    "pop": "304314"
  },
  {
    "id": 3984583,
    "name": "Santa Catarina",
    "country": "MX",
    "admin1": "Nuevo León",
    "pop": "304052"
  },
  { "id": 149703, "name": "Sumbawanga", "country": "TZ", "admin1": "Rukwa", "pop": "303986" },
  { "id": 515012, "name": "Orël", "country": "RU", "admin1": "Oryol oblast", "pop": "303696" },
  { "id": 1847966, "name": "Akashi", "country": "JP", "admin1": "Hyōgo", "pop": "303601" },
  { "id": 8616127, "name": "Hai Bà Trưng", "country": "VN", "admin1": "Hanoi", "pop": "303586" },
  { "id": 1858088, "name": "Kurume", "country": "JP", "admin1": "Fukuoka", "pop": "303579" },
  { "id": 2778067, "name": "Graz", "country": "AT", "admin1": "Styria", "pop": "303270" },
  { "id": 5045360, "name": "Saint Paul", "country": "US", "admin1": "Minnesota", "pop": "303176" },
  {
    "id": 1572532,
    "name": "Nghi Sơn",
    "country": "VN",
    "admin1": "Thanh Hóa Province",
    "pop": "302210"
  },
  { "id": 1267708, "name": "Karnāl", "country": "IN", "admin1": "Haryana", "pop": "302140" },
  { "id": 1815482, "name": "Changyi", "country": "CN", "admin1": "Shandong", "pop": "302072" },
  {
    "id": 3439101,
    "name": "Ciudad del Este",
    "country": "PY",
    "admin1": "Alto Paraná Department",
    "pop": "301815"
  },
  {
    "id": 1277029,
    "name": "Barddhamān",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "301725"
  },
  { "id": 897045, "name": "Solwezi", "country": "ZM", "admin1": "North-Western", "pop": "301370" },
  {
    "id": 3106672,
    "name": "Valladolid",
    "country": "ES",
    "admin1": "Castille and León",
    "pop": "300618"
  },
  { "id": 1738050, "name": "Miri", "country": "MY", "admin1": "Sarawak", "pop": "300543" },
  { "id": 1789262, "name": "Xinyi", "country": "CN", "admin1": "Jiangsu", "pop": "300511" },
  {
    "id": 1170880,
    "name": "Mardan",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "300424"
  },
  { "id": 1490624, "name": "Surgut", "country": "RU", "admin1": "Khanty-Mansia", "pop": "300367" },
  { "id": 2636432, "name": "Swansea", "country": "GB", "admin1": "Wales", "pop": "300352" },
  { "id": 1688830, "name": "San Pablo", "country": "PH", "admin1": "Calabarzon", "pop": "300166" },
  {
    "id": 2641673,
    "name": "Newcastle upon Tyne",
    "country": "GB",
    "admin1": "England",
    "pop": "300125"
  },
  {
    "id": 11679708,
    "name": "Gundupālaiyam",
    "country": "IN",
    "admin1": "Puducherry",
    "pop": "300104"
  },
  { "id": 5959974, "name": "Gatineau", "country": "CA", "admin1": "Quebec", "pop": "300045" },
  { "id": 3632308, "name": "Mérida", "country": "VE", "admin1": "Mérida", "pop": "300000" },
  { "id": 1787323, "name": "Yangshuo", "country": "CN", "admin1": "Guangxi", "pop": "300000" },
  { "id": 1725115, "name": "Biñan", "country": "PH", "admin1": "Calabarzon", "pop": "300000" },
  {
    "id": 363807,
    "name": "Winejok",
    "country": "SS",
    "admin1": "Northern Bahr al Ghazal",
    "pop": "300000"
  },
  { "id": 1803364, "name": "Linqu", "country": "CN", "admin1": "Shandong", "pop": "299646" },
  { "id": 3980760, "name": "Uruapan", "country": "MX", "admin1": "Michoacán", "pop": "299523" },
  {
    "id": 1282931,
    "name": "Pātan",
    "country": "NP",
    "admin1": "Bagmati Province",
    "pop": "299283"
  },
  { "id": 1514019, "name": "Fergana", "country": "UZ", "admin1": "Fergana", "pop": "299200" },
  {
    "id": 3865086,
    "name": "Bahía Blanca",
    "country": "AR",
    "admin1": "Buenos Aires",
    "pop": "299101"
  },
  { "id": 1687687, "name": "Santol", "country": "PH", "admin1": "Central Luzon", "pop": "298976" },
  { "id": 2250805, "name": "Kaolack", "country": "SN", "admin1": "Kaolack", "pop": "298904" },
  { "id": 1642588, "name": "Jember", "country": "ID", "admin1": "East Java", "pop": "298585" },
  { "id": 2130658, "name": "Aomori", "country": "JP", "admin1": "Aomori", "pop": "298394" },
  { "id": 1277065, "name": "Bārāsat", "country": "IN", "admin1": "West Bengal", "pop": "298127" },
  { "id": 12165955, "name": "Mulugu", "country": "IN", "admin1": "Telangana", "pop": "297671" },
  { "id": 1275716, "name": "Bihār Sharīf", "country": "IN", "admin1": "Bihar", "pop": "297268" },
  { "id": 558418, "name": "Grozny", "country": "RU", "admin1": "Chechnya", "pop": "297137" },
  { "id": 2316702, "name": "Boma", "country": "CD", "admin1": "Bas-Congo", "pop": "297009" },
  { "id": 1277539, "name": "Bāli", "country": "IN", "admin1": "West Bengal", "pop": "296973" },
  { "id": 1794209, "name": "Simao", "country": "CN", "admin1": "Yunnan", "pop": "296565" },
  { "id": 1258599, "name": "Rāmpur", "country": "IN", "admin1": "Uttar Pradesh", "pop": "296418" },
  { "id": 1273491, "name": "Darbhanga", "country": "IN", "admin1": "Bihar", "pop": "296039" },
  { "id": 1260476, "name": "Panipat", "country": "IN", "admin1": "Haryana", "pop": "295970" },
  { "id": 8461573, "name": "Mwene", "country": "CD", "admin1": "Lualaba", "pop": "295683" },
  { "id": 2246512, "name": "Rufisque", "country": "SN", "admin1": "Dakar", "pop": "295459" },
  { "id": 524305, "name": "Murmansk", "country": "RU", "admin1": "Murmansk", "pop": "295374" },
  {
    "id": 1254360,
    "name": "Tirupati",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "295323"
  },
  {
    "id": 2637433,
    "name": "Southend-on-Sea",
    "country": "GB",
    "admin1": "England",
    "pop": "295310"
  },
  { "id": 5072006, "name": "Lincoln", "country": "US", "admin1": "Nebraska", "pop": "294757" },
  {
    "id": 3868121,
    "name": "Viña del Mar",
    "country": "CL",
    "admin1": "Valparaíso",
    "pop": "294551"
  },
  { "id": 8531735, "name": "Phu Quoc", "country": "VN", "admin1": "An Giang", "pop": "294419" },
  { "id": 1817240, "name": "Baiyin", "country": "CN", "admin1": "Gansu", "pop": "294400" },
  { "id": 2112923, "name": "Fukushima", "country": "JP", "admin1": "Fukushima", "pop": "294237" },
  { "id": 3161732, "name": "Bergen", "country": "NO", "admin1": "Vestland", "pop": "294029" },
  { "id": 7279746, "name": "Noida", "country": "IN", "admin1": "Uttar Pradesh", "pop": "293908" },
  {
    "id": 6954929,
    "name": "Greater Noida",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "293908"
  },
  { "id": 484646, "name": "Tambov", "country": "RU", "admin1": "Tambov Oblast", "pop": "293661" },
  { "id": 3105976, "name": "Vigo", "country": "ES", "admin1": "Galicia", "pop": "293642" },
  {
    "id": 1633118,
    "name": "Palangkaraya",
    "country": "ID",
    "admin1": "Central Kalimantan",
    "pop": "293500"
  },
  { "id": 1279186, "name": "Aizawl", "country": "IN", "admin1": "Mizoram", "pop": "293416" },
  { "id": 8616118, "name": "Thanh Xuân", "country": "VN", "admin1": "Hanoi", "pop": "293292" },
  {
    "id": 109571,
    "name": "Al Hufūf",
    "country": "SA",
    "admin1": "Eastern Province",
    "pop": "293179"
  },
  { "id": 3530757, "name": "Cholula", "country": "MX", "admin1": "Puebla", "pop": "292881" },
  { "id": 1271715, "name": "Gandhinagar", "country": "IN", "admin1": "Gujarat", "pop": "292797" },
  { "id": 1519422, "name": "Semey", "country": "KZ", "admin1": "Abai Region", "pop": "292780" },
  { "id": 8616113, "name": "Cầu Giấy", "country": "VN", "admin1": "Hanoi", "pop": "292536" },
  { "id": 1272543, "name": "Dindigul", "country": "IN", "admin1": "Tamil Nadu", "pop": "292512" },
  { "id": 3453186, "name": "Ponta Grossa", "country": "BR", "admin1": "Paraná", "pop": "292177" },
  { "id": 1810295, "name": "Gaozhou", "country": "CN", "admin1": "Guangdong", "pop": "292164" },
  { "id": 3458575, "name": "Limeira", "country": "BR", "admin1": "São Paulo", "pop": "291869" },
  { "id": 776069, "name": "Białystok", "country": "PL", "admin1": "Podlasie", "pop": "291855" },
  { "id": 1254649, "name": "Thanjavur", "country": "IN", "admin1": "Tamil Nadu", "pop": "291067" },
  { "id": 946877, "name": "Kariega", "country": "ZA", "admin1": "Eastern Cape", "pop": "291052" },
  {
    "id": 109101,
    "name": "Al Mubarraz",
    "country": "SA",
    "admin1": "Eastern Province",
    "pop": "290802"
  },
  { "id": 3429577, "name": "Resistencia", "country": "AR", "admin1": "Chaco", "pop": "290793" },
  { "id": 2111834, "name": "Morioka", "country": "JP", "admin1": "Iwate", "pop": "290700" },
  { "id": 610529, "name": "Atyrau", "country": "KZ", "admin1": "Atyrau Oblisi", "pop": "290700" },
  { "id": 1788245, "name": "Xiuying", "country": "CN", "admin1": "Hainan", "pop": "290000" },
  { "id": 3628473, "name": "San Cristóbal", "country": "VE", "admin1": "Táchira", "pop": "289852" },
  { "id": 1267755, "name": "Karīmnagar", "country": "IN", "admin1": "Telangana", "pop": "289821" },
  {
    "id": 6174041,
    "name": "Victoria",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "289625"
  },
  { "id": 5879400, "name": "Anchorage", "country": "US", "admin1": "Alaska", "pop": "289600" },
  { "id": 1273066, "name": "Dewas", "country": "IN", "admin1": "Madhya Pradesh", "pop": "289550" },
  { "id": 2505572, "name": "Batna City", "country": "DZ", "admin1": "Batna", "pop": "289504" },
  { "id": 598316, "name": "Kaunas", "country": "LT", "admin1": "Kaunas", "pop": "289380" },
  { "id": 1255744, "name": "Sonīpat", "country": "IN", "admin1": "Haryana", "pop": "289333" },
  { "id": 3654533, "name": "Machala", "country": "EC", "admin1": "El Oro", "pop": "289141" },
  { "id": 737071, "name": "Zeytinburnu", "country": "TR", "admin1": "Istanbul", "pop": "288743" },
  { "id": 4300488, "name": "Meads", "country": "US", "admin1": "Kentucky", "pop": "288649" },
  { "id": 4295940, "name": "Ironville", "country": "US", "admin1": "Kentucky", "pop": "288649" },
  { "id": 916095, "name": "Kabwe", "country": "ZM", "admin1": "Central Province", "pop": "288598" },
  { "id": 1646494, "name": "Cileungsir", "country": "ID", "admin1": "West Java", "pop": "288347" },
  {
    "id": 2040893,
    "name": "Sinŭiju",
    "country": "KP",
    "admin1": "P'yŏngan-bukto",
    "pop": "288112"
  },
  { "id": 1862033, "name": "Ibaraki", "country": "JP", "admin1": "Osaka", "pop": "287730" },
  { "id": 1591449, "name": "Bắc Ninh", "country": "VN", "admin1": "Bac Ninh", "pop": "287658" },
  {
    "id": 1269834,
    "name": "Ichalkaranji",
    "country": "IN",
    "admin1": "Maharashtra",
    "pop": "287353"
  },
  {
    "id": 1570357,
    "name": "Phú Mỹ",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "287055"
  },
  {
    "id": 3466489,
    "name": "Ceilândia",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "287023"
  },
  { "id": 752850, "name": "Adapazarı", "country": "TR", "admin1": "Sakarya", "pop": "286787" },
  { "id": 7628419, "name": "Sultanbeyli", "country": "TR", "admin1": "Istanbul", "pop": "286622" },
  {
    "id": 681290,
    "name": "Cluj-Napoca",
    "country": "RO",
    "admin1": "Cluj County",
    "pop": "286598"
  },
  { "id": 1842030, "name": "Gunpo", "country": "KR", "admin1": "Gyeonggi-do", "pop": "286485" },
  { "id": 877401, "name": "Songea", "country": "TZ", "admin1": "Ruvuma", "pop": "286285" },
  { "id": 217562, "name": "Butembo", "country": "CD", "admin1": "North Kivu", "pop": "286242" },
  { "id": 3928128, "name": "Tacna", "country": "PE", "admin1": "Tacna", "pop": "286240" },
  { "id": 3447259, "name": "Sumaré", "country": "BR", "admin1": "São Paulo", "pop": "286211" },
  { "id": 1575627, "name": "Long Xuyên", "country": "VN", "admin1": "An Giang", "pop": "286140" },
  { "id": 1845136, "name": "Chuncheon", "country": "KR", "admin1": "Gangwon-do", "pop": "286124" },
  { "id": 98993, "name": "Al Qurnah", "country": "IQ", "admin1": "Basra", "pop": "286073" },
  { "id": 1349452, "name": "Savar", "country": "BD", "admin1": "Dhaka Division", "pop": "286008" },
  { "id": 1276070, "name": "Bathinda", "country": "IN", "admin1": "Punjab", "pop": "285788" },
  { "id": 5505411, "name": "Henderson", "country": "US", "admin1": "Nevada", "pop": "285667" },
  { "id": 1269395, "name": "Jālna", "country": "IN", "admin1": "Maharashtra", "pop": "285577" },
  { "id": 11808941, "name": "Sekondi", "country": "GH", "admin1": "Western", "pop": "285506" },
  {
    "id": 10858926,
    "name": "Kyengera",
    "country": "UG",
    "admin1": "Central Region",
    "pop": "285400"
  },
  {
    "id": 4469146,
    "name": "Greensboro",
    "country": "US",
    "admin1": "North Carolina",
    "pop": "285342"
  },
  { "id": 294801, "name": "Haifa", "country": "IL", "admin1": "Haifa", "pop": "285316" },
  { "id": 2624652, "name": "Århus", "country": "DK", "admin1": "Central Jutland", "pop": "285273" },
  {
    "id": 3445156,
    "name": "Viamão",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "285269"
  },
  { "id": 710735, "name": "Chernihiv", "country": "UA", "admin1": "Chernihiv", "pop": "285234" },
  { "id": 1812990, "name": "Dengzhou", "country": "CN", "admin1": "Henan", "pop": "285032" },
  { "id": 1281743, "name": "Artux", "country": "CN", "admin1": "Xinjiang", "pop": "285000" },
  { "id": 3487903, "name": "Alto Barinas", "country": "VE", "admin1": "Barinas", "pop": "284289" },
  { "id": 2248477, "name": "Mbour", "country": "SN", "admin1": "Thiès", "pop": "284189" },
  {
    "id": 2892794,
    "name": "Karlsruhe",
    "country": "DE",
    "admin1": "Baden-Wurttemberg",
    "pop": "283799"
  },
  {
    "id": 2088122,
    "name": "Port Moresby",
    "country": "PG",
    "admin1": "National Capital",
    "pop": "283733"
  },
  {
    "id": 3450083,
    "name": "Santa Maria",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "283677"
  },
  { "id": 706448, "name": "Kherson", "country": "UA", "admin1": "Kherson", "pop": "283649" },
  { "id": 360686, "name": "Minya", "country": "EG", "admin1": "Minya", "pop": "283605" },
  { "id": 4719457, "name": "Plano", "country": "US", "admin1": "Texas", "pop": "283558" },
  { "id": 2112664, "name": "Ichihara", "country": "JP", "admin1": "Chiba", "pop": "283531" },
  { "id": 696643, "name": "Poltava", "country": "UA", "admin1": "Poltava", "pop": "283402" },
  {
    "id": 10263153,
    "name": "Kirāri Sulemānnagar",
    "country": "IN",
    "admin1": "Delhi",
    "pop": "283211"
  },
  { "id": 1720840, "name": "Cainta", "country": "PH", "admin1": "Calabarzon", "pop": "283172" },
  { "id": 3719028, "name": "Pétionville", "country": "HT", "admin1": "Ouest", "pop": "283052" },
  { "id": 1257022, "name": "Satna", "country": "IN", "admin1": "Madhya Pradesh", "pop": "282977" },
  { "id": 1624494, "name": "Tegal", "country": "ID", "admin1": "Central Java", "pop": "282781" },
  { "id": 1529046, "name": "Xinyuan", "country": "CN", "admin1": "Xinjiang", "pop": "282718" },
  { "id": 3868626, "name": "Valparaíso", "country": "CL", "admin1": "Valparaíso", "pop": "282448" },
  { "id": 3938527, "name": "Ica", "country": "PE", "admin1": "Ica", "pop": "282407" },
  {
    "id": 1818558,
    "name": "Tin Shui Wai",
    "country": "HK",
    "admin1": "Yuen Long",
    "pop": "282400"
  },
  { "id": 1259166, "name": "Purnia", "country": "IN", "admin1": "Bihar", "pop": "282248" },
  { "id": 5101798, "name": "Newark", "country": "US", "admin1": "New Jersey", "pop": "281944" },
  { "id": 3680450, "name": "Itagüí", "country": "CO", "admin1": "Antioquia", "pop": "281853" },
  { "id": 3522732, "name": "Nicolás Romero", "country": "MX", "admin1": "México", "pop": "281799" },
  { "id": 747014, "name": "Gebze", "country": "TR", "admin1": "Kocaeli", "pop": "281436" },
  {
    "id": 1043893,
    "name": "Lichinga",
    "country": "MZ",
    "admin1": "Niassa Province",
    "pop": "281341"
  },
  {
    "id": 1185117,
    "name": "Narsingdi",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "281080"
  },
  { "id": 2467454, "name": "Sfax", "country": "TN", "admin1": "Sfax Governorate", "pop": "280566" },
  { "id": 3513966, "name": "Zumpango", "country": "MX", "admin1": "México", "pop": "280455" },
  { "id": 11238838, "name": "Merkezefendi", "country": "TR", "admin1": "Denizli", "pop": "280341" },
  { "id": 5261457, "name": "Madison", "country": "US", "admin1": "Wisconsin", "pop": "280305" },
  { "id": 1217662, "name": "Bukhara", "country": "UZ", "admin1": "Bukhara", "pop": "280187" },
  {
    "id": 2171507,
    "name": "Wollongong",
    "country": "AU",
    "admin1": "New South Wales",
    "pop": "280153"
  },
  {
    "id": 1170395,
    "name": "Mingora",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "279914"
  },
  {
    "id": 3444876,
    "name": "Volta Redonda",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "279898"
  },
  {
    "id": 3068799,
    "name": "Ostrava",
    "country": "CZ",
    "admin1": "Moravskoslezský",
    "pop": "279791"
  },
  { "id": 4407066, "name": "St. Louis", "country": "US", "admin1": "Missouri", "pop": "279695" },
  {
    "id": 2343983,
    "name": "Efon-Alaaye",
    "country": "NG",
    "admin1": "Ekiti State",
    "pop": "279319"
  },
  { "id": 1215355, "name": "Binjai", "country": "ID", "admin1": "North Sumatra", "pop": "279302" },
  { "id": 509820, "name": "Petrozavodsk", "country": "RU", "admin1": "Karelia", "pop": "279190" },
  { "id": 1811720, "name": "Enshi", "country": "CN", "admin1": "Hubei", "pop": "279185" },
  { "id": 484907, "name": "Taganrog", "country": "RU", "admin1": "Rostov", "pop": "279056" },
  {
    "id": 3627047,
    "name": "Santa Teresa del Tuy",
    "country": "VE",
    "admin1": "Miranda",
    "pop": "278890"
  },
  { "id": 2809346, "name": "Wiesbaden", "country": "DE", "admin1": "Hesse", "pop": "278609" },
  { "id": 1568770, "name": "Quảng Ngãi", "country": "VN", "admin1": "Quang Ngai", "pop": "278496" },
  { "id": 1216311, "name": "Qarshi", "country": "UZ", "admin1": "Qashqadaryo", "pop": "278300" },
  { "id": 1793419, "name": "Binhe", "country": "CN", "admin1": "Henan", "pop": "278055" },
  { "id": 3530569, "name": "Coacalco", "country": "MX", "admin1": "México", "pop": "277959" },
  {
    "id": 3667983,
    "name": "Sincelejo",
    "country": "CO",
    "admin1": "Sucre Department",
    "pop": "277773"
  },
  { "id": 1783633, "name": "Zoucheng", "country": "CN", "admin1": "Shandong", "pop": "277400" },
  { "id": 418710, "name": "Khomeynī Shahr", "country": "IR", "admin1": "Isfahan", "pop": "277334" },
  {
    "id": 543878,
    "name": "Kostroma",
    "country": "RU",
    "admin1": "Kostroma Oblast",
    "pop": "277280"
  },
  { "id": 1269771, "name": "Imphal", "country": "IN", "admin1": "Manipur", "pop": "277196" },
  { "id": 2654710, "name": "Brighton", "country": "GB", "admin1": "England", "pop": "277103" },
  { "id": 2288829, "name": "Gagnoa", "country": "CI", "admin1": "Gôh-Djiboua", "pop": "277044" },
  { "id": 1884382, "name": "Bedok New Town", "country": "SG", "admin1": null, "pop": "276990" },
  { "id": 1880159, "name": "Ulu Bedok", "country": "SG", "admin1": null, "pop": "276990" },
  { "id": 2325314, "name": "Owo", "country": "NG", "admin1": "Ondo State", "pop": "276574" },
  { "id": 1835648, "name": "Suncheon", "country": "KR", "admin1": "Jeollanam-do", "pop": "276375" },
  {
    "id": 12269572,
    "name": "Fangchenggang",
    "country": "CN",
    "admin1": "Guangxi",
    "pop": "276315"
  },
  {
    "id": 2021851,
    "name": "Komsomolsk-on-Amur",
    "country": "RU",
    "admin1": "Khabarovsk",
    "pop": "275908"
  },
  {
    "id": 1185056,
    "name": "Abbottabad",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "275890"
  },
  { "id": 1804866, "name": "Kaili", "country": "CN", "admin1": "Guizhou", "pop": "275745" },
  { "id": 2130188, "name": "Hakodate", "country": "JP", "admin1": "Hokkaido", "pop": "275730" },
  {
    "id": 2279755,
    "name": "Yamoussoukro",
    "country": "CI",
    "admin1": "Lacs District",
    "pop": "275686"
  },
  { "id": 2505854, "name": "Bab Ezzouar", "country": "DZ", "admin1": "Algiers", "pop": "275630" },
  { "id": 2973783, "name": "Strasbourg", "country": "FR", "admin1": "Grand Est", "pop": "274845" },
  {
    "id": 1214204,
    "name": "Pematangsiantar",
    "country": "ID",
    "admin1": "North Sumatra",
    "pop": "274838"
  },
  {
    "id": 706369,
    "name": "Khmelnytskyi",
    "country": "UA",
    "admin1": "Khmelnytskyi",
    "pop": "274582"
  },
  { "id": 1257845, "name": "Saugor", "country": "IN", "admin1": "Madhya Pradesh", "pop": "274556" },
  { "id": 1671467, "name": "Neihu", "country": "TW", "admin1": "Taiwan", "pop": "274538" },
  { "id": 1849796, "name": "Tsu", "country": "JP", "admin1": "Mie", "pop": "274537" },
  { "id": 8594670, "name": "Xingning", "country": "CN", "admin1": "Guangdong", "pop": "274499" },
  {
    "id": 1803331,
    "name": "Linxia Chengguanzhen",
    "country": "CN",
    "admin1": "Gansu",
    "pop": "274466"
  },
  {
    "id": 12032137,
    "name": "Kushinagar",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "274403"
  },
  { "id": 3654667, "name": "Loja", "country": "EC", "admin1": "Loja", "pop": "274112" },
  { "id": 1818673, "name": "Tai Po", "country": "HK", "admin1": "Tai Po", "pop": "274100" },
  { "id": 1514896, "name": "Isfara", "country": "TJ", "admin1": "Sughd", "pop": "274000" },
  { "id": 3347719, "name": "Luena", "country": "AO", "admin1": "Moxico", "pop": "273675" },
  { "id": 1632228, "name": "Pasarkemis", "country": "ID", "admin1": "West Java", "pop": "273659" },
  {
    "id": 3447186,
    "name": "Taboão da Serra",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "273542"
  },
  { "id": 1220253, "name": "Istaravshan", "country": "TJ", "admin1": "Sughd", "pop": "273500" },
  { "id": 1529114, "name": "Turpan", "country": "CN", "admin1": "Xinjiang", "pop": "273385" },
  { "id": 1258315, "name": "Rourkela", "country": "IN", "admin1": "Odisha", "pop": "273317" },
  { "id": 1848522, "name": "Yao", "country": "JP", "admin1": "Osaka", "pop": "273213" },
  {
    "id": 359173,
    "name": "Banī Suwayf",
    "country": "EG",
    "admin1": "Beni Suweif",
    "pop": "273151"
  },
  {
    "id": 1193745,
    "name": "Nagar Naluākot",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "273000"
  },
  {
    "id": 3557689,
    "name": "Guantánamo",
    "country": "CU",
    "admin1": "Guantánamo Province",
    "pop": "272801"
  },
  { "id": 1728930, "name": "Baguio", "country": "PH", "admin1": "Cordillera", "pop": "272714" },
  {
    "id": 3454031,
    "name": "Petrópolis",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "272691"
  },
  { "id": 710791, "name": "Cherkasy", "country": "UA", "admin1": "Cherkasy", "pop": "272651" },
  {
    "id": 289888,
    "name": "Ar Rayyān",
    "country": "QA",
    "admin1": "Baladīyat ar Rayyān",
    "pop": "272465"
  },
  { "id": 965289, "name": "Polokwane", "country": "ZA", "admin1": "Limpopo", "pop": "272461" },
  { "id": 3196359, "name": "Ljubljana", "country": "SI", "admin1": "Ljubljana", "pop": "272220" },
  { "id": 1139715, "name": "Jalālābād", "country": "AF", "admin1": "Nangarhar", "pop": "271900" },
  {
    "id": 170794,
    "name": "Deir ez-Zor",
    "country": "SY",
    "admin1": "Deir ez-Zor",
    "pop": "271800"
  },
  { "id": 3121424, "name": "Gijón", "country": "ES", "admin1": "Asturias", "pop": "271780" },
  {
    "id": 106297,
    "name": "Hafar Al-Batin",
    "country": "SA",
    "admin1": "Eastern Province",
    "pop": "271642"
  },
  {
    "id": 1860704,
    "name": "Kakogawachō-honmachi",
    "country": "JP",
    "admin1": "Hyōgo",
    "pop": "271634"
  },
  {
    "id": 9645072,
    "name": "Quận Sáu",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "271050"
  },
  { "id": 1574023, "name": "Mỹ Tho", "country": "VN", "admin1": "Dong Thap", "pop": "270700" },
  { "id": 2111901, "name": "Mito", "country": "JP", "admin1": "Ibaraki", "pop": "270685" },
  { "id": 2651347, "name": "Derby", "country": "GB", "admin1": "England", "pop": "270468" },
  { "id": 339219, "name": "Dessie", "country": "ET", "admin1": "Amhara", "pop": "270400" },
  {
    "id": 3448744,
    "name": "São José",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "270299"
  },
  {
    "id": 2867543,
    "name": "Münster",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "270184"
  },
  { "id": 1580410, "name": "Hạ Long", "country": "VN", "admin1": "Quảng Ninh", "pop": "270054" },
  {
    "id": 2921466,
    "name": "Gelsenkirchen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "270028"
  },
  {
    "id": 12492660,
    "name": "Longling County",
    "country": "CN",
    "admin1": "Yunnan",
    "pop": "270000"
  },
  { "id": 1702540, "name": "Malolos", "country": "PH", "admin1": "Central Luzon", "pop": "269809" },
  { "id": 2637487, "name": "Southampton", "country": "GB", "admin1": "England", "pop": "269781" },
  { "id": 1732901, "name": "Kapar", "country": "MY", "admin1": "Selangor", "pop": "269627" },
  { "id": 748879, "name": "Çorum", "country": "TR", "admin1": "Çorum", "pop": "269595" },
  { "id": 1529435, "name": "Ghulja", "country": "CN", "admin1": "Xinjiang", "pop": "269158" },
  { "id": 2165798, "name": "Geelong", "country": "AU", "admin1": "Victoria", "pop": "268984" },
  { "id": 3430697, "name": "Merlo", "country": "AR", "admin1": "Buenos Aires", "pop": "268961" },
  { "id": 1884138, "name": "Yeosu", "country": "KR", "admin1": "Jeollanam-do", "pop": "268823" },
  { "id": 1272181, "name": "Durg", "country": "IN", "admin1": "Chhattisgarh", "pop": "268806" },
  { "id": 1810979, "name": "Fuling", "country": "CN", "admin1": "Chongqing", "pop": "268658" },
  { "id": 1841066, "name": "Mokpo", "country": "KR", "admin1": "Jeollanam-do", "pop": "268402" },
  { "id": 1283581, "name": "Birgañj", "country": "NP", "admin1": "Madhesh", "pop": "268273" },
  {
    "id": 466806,
    "name": "Yoshkar-Ola",
    "country": "RU",
    "admin1": "Mariy-El Republic",
    "pop": "268272"
  },
  { "id": 7838895, "name": "Russeifa", "country": "JO", "admin1": "Zarqa", "pop": "268237" },
  { "id": 349158, "name": "Shibīn al Kawm", "country": "EG", "admin1": "Monufia", "pop": "267945" },
  { "id": 6317872, "name": "Parauapebas", "country": "BR", "admin1": "Pará", "pop": "267836" },
  { "id": 1170295, "name": "Mirpur Khas", "country": "PK", "admin1": "Sindh", "pop": "267833" },
  {
    "id": 3682385,
    "name": "Floridablanca",
    "country": "CO",
    "admin1": "Santander Department",
    "pop": "267591"
  },
  { "id": 1850158, "name": "Tokushima", "country": "JP", "admin1": "Tokushima", "pop": "267345" },
  {
    "id": 487495,
    "name": "Sterlitamak",
    "country": "RU",
    "admin1": "Bashkortostan Republic",
    "pop": "267231"
  },
  {
    "id": 1278672,
    "name": "Anantapur",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "267161"
  },
  {
    "id": 325330,
    "name": "Adıyaman",
    "country": "TR",
    "admin1": "Adıyaman Province",
    "pop": "267131"
  },
  {
    "id": 3392998,
    "name": "Parnamirim",
    "country": "BR",
    "admin1": "Rio Grande do Norte",
    "pop": "267036"
  },
  {
    "id": 1841598,
    "name": "Gyeongsan-si",
    "country": "KR",
    "admin1": "Gyeongsangbuk-do",
    "pop": "266951"
  },
  { "id": 347796, "name": "Sohag", "country": "EG", "admin1": "Sohag", "pop": "266944" },
  { "id": 1856199, "name": "Nagaoka", "country": "JP", "admin1": "Niigata", "pop": "266936" },
  {
    "id": 1185281,
    "name": "Bagerhat",
    "country": "BD",
    "admin1": "Khulna Division",
    "pop": "266388"
  },
  {
    "id": 6141256,
    "name": "Saskatoon",
    "country": "CA",
    "admin1": "Saskatchewan",
    "pop": "266141"
  },
  { "id": 1786640, "name": "Chengzhong", "country": "CN", "admin1": "Hubei", "pop": "265886" },
  { "id": 2500017, "name": "Djelfa", "country": "DZ", "admin1": "Djelfa", "pop": "265833" },
  {
    "id": 5336899,
    "name": "Chula Vista",
    "country": "US",
    "admin1": "California",
    "pop": "265757"
  },
  { "id": 1852225, "name": "Shimonoseki", "country": "JP", "admin1": "Yamaguchi", "pop": "265684" },
  { "id": 5174035, "name": "Toledo", "country": "US", "admin1": "Ohio", "pop": "265638" },
  { "id": 710719, "name": "Chernivtsi", "country": "UA", "admin1": "Chernivtsi", "pop": "265471" },
  { "id": 158027, "name": "Kibaha", "country": "TZ", "admin1": "Pwani", "pop": "265360" },
  {
    "id": 2036670,
    "name": "Hulan Ergi",
    "country": "CN",
    "admin1": "Heilongjiang",
    "pop": "265344"
  },
  {
    "id": 3247449,
    "name": "Aachen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "265208"
  },
  { "id": 2797656, "name": "Gent", "country": "BE", "admin1": "Flanders", "pop": "265086" },
  {
    "id": 3462089,
    "name": "Gravataí",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "265074"
  },
  {
    "id": 1701472,
    "name": "Mantampay",
    "country": "PH",
    "admin1": "Northern Mindanao",
    "pop": "265032"
  },
  { "id": 1258342, "name": "Ratlām", "country": "IN", "admin1": "Madhya Pradesh", "pop": "264914" },
  { "id": 4004886, "name": "Nogales", "country": "MX", "admin1": "Sonora", "pop": "264782" },
  {
    "id": 380148,
    "name": "El Daein",
    "country": "SD",
    "admin1": "Eastern Darfur",
    "pop": "264734"
  },
  { "id": 1812521, "name": "Donghai", "country": "CN", "admin1": "Guangdong", "pop": "264709" },
  { "id": 1842025, "name": "Gunsan", "country": "KR", "admin1": "Jeollabuk-do", "pop": "264656" },
  {
    "id": 3394682,
    "name": "Mossoró",
    "country": "BR",
    "admin1": "Rio Grande do Norte",
    "pop": "264577"
  },
  { "id": 1258451, "name": "Rānipet", "country": "IN", "admin1": "Tamil Nadu", "pop": "264330" },
  {
    "id": 1336142,
    "name": "Brāhmanbāria",
    "country": "BD",
    "admin1": "Chittagong",
    "pop": "264326"
  },
  { "id": 2392087, "name": "Porto-Novo", "country": "BJ", "admin1": "Ouémé", "pop": "264320" },
  {
    "id": 5099836,
    "name": "Jersey City",
    "country": "US",
    "admin1": "New Jersey",
    "pop": "264290"
  },
  { "id": 3654410, "name": "Manta", "country": "EC", "admin1": "Manabí", "pop": "264281" },
  { "id": 5511077, "name": "Reno", "country": "US", "admin1": "Nevada", "pop": "264165" },
  { "id": 2389422, "name": "Bégoua", "country": "CF", "admin1": "Ombella-M'Poko", "pop": "264067" },
  {
    "id": 3652350,
    "name": "Riobamba",
    "country": "EC",
    "admin1": "Chimborazo Province",
    "pop": "264048"
  },
  { "id": 300619, "name": "Sivas", "country": "TR", "admin1": "Sivas", "pop": "264022" },
  { "id": 2633691, "name": "Wolverhampton", "country": "GB", "admin1": "England", "pop": "263700" },
  {
    "id": 1819873,
    "name": "Fanling",
    "country": "HK",
    "admin1": "North District",
    "pop": "263200"
  },
  { "id": 1678836, "name": "Chiayi City", "country": "TW", "admin1": "Taiwan", "pop": "263188" },
  { "id": 1812228, "name": "Dongtai", "country": "CN", "admin1": "Jiangsu", "pop": "262873" },
  { "id": 11611632, "name": "Fuchū", "country": "JP", "admin1": "Tokyo", "pop": "262790" },
  { "id": 1881953, "name": "Jurong Town", "country": "SG", "admin1": null, "pop": "262730" },
  {
    "id": 124878,
    "name": "Marāgheh",
    "country": "IR",
    "admin1": "Razavi Khorasan",
    "pop": "262604"
  },
  {
    "id": 124877,
    "name": "Marāgheh",
    "country": "IR",
    "admin1": "East Azerbaijan",
    "pop": "262604"
  },
  { "id": 3429652, "name": "Quilmes", "country": "AR", "admin1": "Buenos Aires", "pop": "262379" },
  { "id": 1863985, "name": "Fukui-shi", "country": "JP", "admin1": "Fukui", "pop": "262328" },
  {
    "id": 7302826,
    "name": "Lal Bahadur Nagar",
    "country": "IN",
    "admin1": "Telangana",
    "pop": "261987"
  },
  {
    "id": 2869894,
    "name": "Mönchengladbach",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "261742"
  },
  {
    "id": 13060482,
    "name": "Bagong Silang",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "261729"
  },
  { "id": 686967, "name": "Zhytomyr", "country": "UA", "admin1": "Zhytomyr", "pop": "261624" },
  { "id": 1529401, "name": "Karamay", "country": "CN", "admin1": "Xinjiang", "pop": "261445" },
  { "id": 1278483, "name": "Arrah", "country": "IN", "admin1": "Bihar", "pop": "261430" },
  {
    "id": 2034400,
    "name": "Tongliao",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "261110"
  },
  {
    "id": 3031582,
    "name": "Bordeaux",
    "country": "FR",
    "admin1": "Nouvelle-Aquitaine",
    "pop": "260958"
  },
  { "id": 161218, "name": "Bariadi", "country": "TZ", "admin1": "Simiyu", "pop": "260927" },
  {
    "id": 1069166,
    "name": "Antsirabe",
    "country": "MG",
    "admin1": "Vakinankaratra",
    "pop": "260907"
  },
  { "id": 5289282, "name": "Chandler", "country": "US", "admin1": "Arizona", "pop": "260828" },
  { "id": 363619, "name": "Yei", "country": "SS", "admin1": "Central Equatoria", "pop": "260720" },
  { "id": 1062663, "name": "Mahajanga", "country": "MG", "admin1": "Boeny", "pop": "260556" },
  { "id": 13353696, "name": "Minato City", "country": "JP", "admin1": "Tokyo", "pop": "260486" },
  { "id": 4920423, "name": "Fort Wayne", "country": "US", "admin1": "Indiana", "pop": "260326" },
  { "id": 2640194, "name": "Plymouth", "country": "GB", "admin1": "England", "pop": "260203" },
  { "id": 1799471, "name": "Nianbo", "country": "CN", "admin1": "Qinghai", "pop": "260184" },
  { "id": 1529641, "name": "Aral", "country": "CN", "admin1": "Xinjiang", "pop": "260000" },
  {
    "id": 1164709,
    "name": "Skardu",
    "country": "PK",
    "admin1": "Gilgit-Baltistan",
    "pop": "260000"
  },
  {
    "id": 1701053,
    "name": "Marawi City",
    "country": "PH",
    "admin1": "Autonomous Region in Muslim Mindanao",
    "pop": "259993"
  },
  { "id": 1512979, "name": "Qo‘qon", "country": "UZ", "admin1": "Fergana", "pop": "259700" },
  { "id": 692194, "name": "Sumy", "country": "UA", "admin1": "Sumy", "pop": "259660" },
  {
    "id": 1684712,
    "name": "Tacloban",
    "country": "PH",
    "admin1": "Eastern Visayas",
    "pop": "259353"
  },
  { "id": 2954172, "name": "Augsburg", "country": "DE", "admin1": "Bavaria", "pop": "259196" },
  {
    "id": 3450909,
    "name": "Rondonópolis",
    "country": "BR",
    "admin1": "Mato Grosso",
    "pop": "259167"
  },
  { "id": 1815669, "name": "Changle", "country": "CN", "admin1": "Shandong", "pop": "259161" },
  {
    "id": 7302833,
    "name": "Gajuwaka",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "258944"
  },
  { "id": 2036458, "name": "Jining", "country": "CN", "admin1": "Inner Mongolia", "pop": "258757" },
  {
    "id": 293703,
    "name": "Rishon LeTsiyyon",
    "country": "IL",
    "admin1": "Central District",
    "pop": "258535"
  },
  { "id": 1862462, "name": "Hiratsuka", "country": "JP", "admin1": "Kanagawa", "pop": "258422" },
  {
    "id": 2636841,
    "name": "Stoke-on-Trent",
    "country": "GB",
    "admin1": "England",
    "pop": "258366"
  },
  { "id": 3463030, "name": "Foz do Iguaçu", "country": "BR", "admin1": "Paraná", "pop": "258248" },
  { "id": 5110629, "name": "Buffalo", "country": "US", "admin1": "New York", "pop": "258071" },
  { "id": 3164527, "name": "Verona", "country": "IT", "admin1": "Veneto", "pop": "258031" },
  { "id": 1584071, "name": "Ðà Lạt", "country": "VN", "admin1": "Lam Dong", "pop": "258014" },
  {
    "id": 3836564,
    "name": "San Salvador de Jujuy",
    "country": "AR",
    "admin1": "Jujuy",
    "pop": "257970"
  },
  { "id": 4464368, "name": "Durham", "country": "US", "admin1": "North Carolina", "pop": "257636" },
  { "id": 1881955, "name": "Jurong West", "country": "SG", "admin1": null, "pop": "257470" },
  { "id": 1271987, "name": "Etāwah", "country": "IN", "admin1": "Uttar Pradesh", "pop": "257448" },
  {
    "id": 3104499,
    "name": "Gasteiz / Vitoria",
    "country": "ES",
    "admin1": "Basque Country",
    "pop": "257407"
  },
  { "id": 10942183, "name": "Rugao", "country": "CN", "admin1": "Jiangsu", "pop": "257400" },
  { "id": 4005775, "name": "Gómez Palacio", "country": "MX", "admin1": "Durango", "pop": "257352" },
  { "id": 3466779, "name": "Cascavel", "country": "BR", "admin1": "Paraná", "pop": "257172" },
  {
    "id": 4171563,
    "name": "St. Petersburg",
    "country": "US",
    "admin1": "Florida",
    "pop": "257083"
  },
  {
    "id": 3120619,
    "name": "L'Hospitalet de Llobregat",
    "country": "ES",
    "admin1": "Catalonia",
    "pop": "257038"
  },
  { "id": 3099424, "name": "Gdynia", "country": "PL", "admin1": "Pomerania", "pop": "257000" },
  { "id": 1646559, "name": "Cilacap", "country": "ID", "admin1": "Central Java", "pop": "256996" },
  { "id": 5359777, "name": "Irvine", "country": "US", "admin1": "California", "pop": "256927" },
  { "id": 5992996, "name": "Kitchener", "country": "CA", "admin1": "Ontario", "pop": "256885" },
  { "id": 660158, "name": "Espoo", "country": "FI", "admin1": "Uusimaa", "pop": "256760" },
  { "id": 1793899, "name": "Suicheng", "country": "CN", "admin1": "Jiangsu", "pop": "256665" },
  { "id": 1800234, "name": "Nada", "country": "CN", "admin1": "Hainan", "pop": "256652" },
  { "id": 3997479, "name": "Los Mochis", "country": "MX", "admin1": "Sinaloa", "pop": "256613" },
  { "id": 2051523, "name": "Bratsk", "country": "RU", "admin1": "Irkutsk Oblast", "pop": "256600" },
  {
    "id": 3522210,
    "name": "Pachuca de Soto",
    "country": "MX",
    "admin1": "Hidalgo",
    "pop": "256584"
  },
  { "id": 919009, "name": "Chingola", "country": "ZM", "admin1": "Copperbelt", "pop": "256560" },
  { "id": 2642465, "name": "Milton Keynes", "country": "GB", "admin1": "England", "pop": "256385" },
  { "id": 3461311, "name": "Indaiatuba", "country": "BR", "admin1": "São Paulo", "pop": "256223" },
  { "id": 4705349, "name": "Laredo", "country": "US", "admin1": "Texas", "pop": "256153" },
  { "id": 2392204, "name": "Parakou", "country": "BJ", "admin1": "Borgou", "pop": "255478" },
  { "id": 215771, "name": "Isiro", "country": "CD", "admin1": "Haut-Uele", "pop": "255409" },
  { "id": 116996, "name": "Sari", "country": "IR", "admin1": "Māzandarān", "pop": "255396" },
  { "id": 1882316, "name": "Woodlands", "country": "SG", "admin1": null, "pop": "255180" },
  { "id": 3522507, "name": "Oaxaca", "country": "MX", "admin1": "Oaxaca", "pop": "255029" },
  { "id": 1215502, "name": "Banda Aceh", "country": "ID", "admin1": "Aceh", "pop": "255029" },
  { "id": 3347019, "name": "Mossamedes", "country": "AO", "admin1": "Namibe", "pop": "255000" },
  { "id": 99106, "name": "Al Madīnah", "country": "IQ", "admin1": "Basra", "pop": "255000" },
  {
    "id": 2338106,
    "name": "Ikot Ekpene",
    "country": "NG",
    "admin1": "Akwa Ibom State",
    "pop": "254806"
  },
  { "id": 1787031, "name": "Yanzhou", "country": "CN", "admin1": "Shandong", "pop": "254788" },
  { "id": 1897007, "name": "Hanam", "country": "KR", "admin1": "Gyeonggi-do", "pop": "254415" },
  {
    "id": 1608133,
    "name": "Mueang Nonthaburi",
    "country": "TH",
    "admin1": "Nonthaburi",
    "pop": "254375"
  },
  {
    "id": 1626542,
    "name": "Sorong",
    "country": "ID",
    "admin1": "Southwest Papua",
    "pop": "254294"
  },
  {
    "id": 2246452,
    "name": "Saint-Louis",
    "country": "SN",
    "admin1": "Saint-Louis",
    "pop": "254171"
  },
  { "id": 1735166, "name": "Batu Caves", "country": "MY", "admin1": "Selangor", "pop": "254083" },
  {
    "id": 3456068,
    "name": "Novo Hamburgo",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "253841"
  },
  {
    "id": 1336134,
    "name": "Cox’s Bāzār",
    "country": "BD",
    "admin1": "Chittagong",
    "pop": "253788"
  },
  { "id": 3465284, "name": "Cotia", "country": "BR", "admin1": "São Paulo", "pop": "253608" },
  {
    "id": 293918,
    "name": "Petaẖ Tiqva",
    "country": "IL",
    "admin1": "Central District",
    "pop": "253529"
  },
  { "id": 1513243, "name": "Marg‘ilon", "country": "UZ", "admin1": "Fergana", "pop": "253500" },
  { "id": 1278903, "name": "Ambarnath", "country": "IN", "admin1": "Maharashtra", "pop": "253475" },
  { "id": 2394092, "name": "Godomè", "country": "BJ", "admin1": "Atlantique", "pop": "253262" },
  { "id": 1262131, "name": "Naihāti", "country": "IN", "admin1": "West Bengal", "pop": "253221" },
  { "id": 683844, "name": "Braşov", "country": "RO", "admin1": "Brașov County", "pop": "253200" },
  { "id": 1560565, "name": "Xuân Lộc", "country": "VN", "admin1": "Dong Nai", "pop": "253140" },
  {
    "id": 3444914,
    "name": "Vitória da Conquista",
    "country": "BR",
    "admin1": "Bahia",
    "pop": "253137"
  },
  { "id": 1804386, "name": "Laohekou", "country": "CN", "admin1": "Hubei", "pop": "253112" },
  { "id": 3870282, "name": "Talcahuano", "country": "CL", "admin1": "Biobío", "pop": "252968" },
  {
    "id": 962367,
    "name": "Richards Bay",
    "country": "ZA",
    "admin1": "KwaZulu-Natal",
    "pop": "252968"
  },
  { "id": 350550, "name": "Qina", "country": "EG", "admin1": "Qena", "pop": "252883" },
  { "id": 1276128, "name": "Bharatpur", "country": "IN", "admin1": "Rajasthan", "pop": "252838" },
  { "id": 2163355, "name": "Hobart", "country": "AU", "admin1": "Tasmania", "pop": "252639" },
  {
    "id": 379555,
    "name": "El Fasher",
    "country": "SD",
    "admin1": "Northern Darfur",
    "pop": "252609"
  },
  { "id": 2244799, "name": "Thiès Nones", "country": "SN", "admin1": "Thiès", "pop": "252320" },
  { "id": 2034655, "name": "Suihua", "country": "CN", "admin1": "Heilongjiang", "pop": "252245" },
  { "id": 3633622, "name": "Los Teques", "country": "VE", "admin1": "Miranda", "pop": "252242" },
  {
    "id": 3835869,
    "name": "Santiago del Estero",
    "country": "AR",
    "admin1": "Santiago del Estero",
    "pop": "252192"
  },
  { "id": 2481700, "name": "Sétif", "country": "DZ", "admin1": "Sétif", "pop": "252127" },
  { "id": 1276609, "name": "Begusarai", "country": "IN", "admin1": "Bihar", "pop": "252008" },
  {
    "id": 140044,
    "name": "Borūjerd",
    "country": "IR",
    "admin1": "Lorestan Province",
    "pop": "251958"
  },
  { "id": 32767, "name": "Qarchak", "country": "IR", "admin1": "Tehran", "pop": "251834" },
  {
    "id": 325303,
    "name": "Afyonkarahisar",
    "country": "TR",
    "admin1": "Afyonkarahisar Province",
    "pop": "251799"
  },
  { "id": 311111, "name": "İskenderun", "country": "TR", "admin1": "Hatay", "pop": "251682" },
  { "id": 179330, "name": "Thika", "country": "KE", "admin1": "Nairobi County", "pop": "251407" },
  {
    "id": 1690039,
    "name": "San Fernando",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "251248"
  },
  {
    "id": 3347353,
    "name": "Menongue",
    "country": "AO",
    "admin1": "Cuando Cobango",
    "pop": "251178"
  },
  { "id": 333772, "name": "Jimma", "country": "ET", "admin1": "Oromiya", "pop": "250900" },
  {
    "id": 3462315,
    "name": "Governador Valadares",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "250878"
  },
  { "id": 665087, "name": "Timişoara", "country": "RO", "admin1": "Timiș County", "pop": "250849" },
  {
    "id": 3464305,
    "name": "Embu das Artes",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "250691"
  },
  { "id": 1792260, "name": "Wafangdian", "country": "CN", "admin1": "Liaoning", "pop": "250591" },
  {
    "id": 3537906,
    "name": "Santa Clara",
    "country": "CU",
    "admin1": "Villa Clara Province",
    "pop": "250512"
  },
  { "id": 2336905, "name": "Iwo", "country": "NG", "admin1": "Osun State", "pop": "250443" },
  { "id": 3119841, "name": "A Coruña", "country": "ES", "admin1": "Galicia", "pop": "250438" },
  { "id": 1706684, "name": "Libertad", "country": "PH", "admin1": "Caraga", "pop": "250353" },
  {
    "id": 4000900,
    "name": "La Paz",
    "country": "MX",
    "admin1": "Baja California Sur",
    "pop": "250141"
  },
  { "id": 787657, "name": "Niš", "country": "RS", "admin1": "Central Serbia", "pop": "250000" },
  { "id": 366847, "name": "Singa", "country": "SD", "admin1": "Sinnār", "pop": "250000" },
  { "id": 95005, "name": "Kelar", "country": "IQ", "admin1": "Sulaymaniyah", "pop": "250000" },
  {
    "id": 1624725,
    "name": "Tarakan",
    "country": "ID",
    "admin1": "North Kalimantan",
    "pop": "249960"
  },
  {
    "id": 3872348,
    "name": "San Bernardo",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "249858"
  },
  { "id": 1851604, "name": "Sōka", "country": "JP", "admin1": "Saitama", "pop": "249645" },
  { "id": 2735943, "name": "Porto", "country": "PT", "admin1": "Porto", "pop": "249633" },
  { "id": 925475, "name": "Mzuzu", "country": "MW", "admin1": "Northern Region", "pop": "249564" },
  { "id": 1697846, "name": "Navotas", "country": "PH", "admin1": "Metro Manila", "pop": "249463" },
  {
    "id": 1254320,
    "name": "Tiruvottiyūr",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "249446"
  },
  {
    "id": 5911606,
    "name": "Burnaby",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "249125"
  },
  { "id": 5525577, "name": "Lubbock", "country": "US", "admin1": "Texas", "pop": "249042" },
  {
    "id": 1582497,
    "name": "Thị Trấn Đông Triều",
    "country": "VN",
    "admin1": "Quảng Ninh",
    "pop": "248896"
  },
  { "id": 2110556, "name": "Yamagata", "country": "JP", "admin1": "Yamagata", "pop": "248772" },
  { "id": 3516109, "name": "Tehuacán", "country": "MX", "admin1": "Puebla", "pop": "248716" },
  { "id": 3640049, "name": "Guarenas", "country": "VE", "admin1": "Miranda", "pop": "248588" },
  { "id": 2992166, "name": "Montpellier", "country": "FR", "admin1": "Occitanie", "pop": "248252" },
  { "id": 2336056, "name": "Jimeta", "country": "NG", "admin1": "Adamawa", "pop": "248148" },
  { "id": 3100946, "name": "Częstochowa", "country": "PL", "admin1": "Silesia", "pop": "248125" },
  { "id": 1271717, "name": "Gāndhīdhām", "country": "IN", "admin1": "Gujarat", "pop": "247992" },
  { "id": 1816790, "name": "Beibei", "country": "CN", "admin1": "Chongqing", "pop": "247702" },
  { "id": 1321937, "name": "Insein", "country": "MM", "admin1": "Yangon", "pop": "247675" },
  {
    "id": 2634341,
    "name": "City of Westminster",
    "country": "GB",
    "admin1": "England",
    "pop": "247614"
  },
  { "id": 5295903, "name": "Gilbert", "country": "US", "admin1": "Arizona", "pop": "247542" },
  { "id": 2940132, "name": "Chemnitz", "country": "DE", "admin1": "Saxony", "pop": "247220" },
  { "id": 324496, "name": "Aksaray", "country": "TR", "admin1": "Aksaray", "pop": "247147" },
  { "id": 3841956, "name": "Paraná", "country": "AR", "admin1": "Entre Rios", "pop": "247139" },
  {
    "id": 3583446,
    "name": "San Miguel",
    "country": "SV",
    "admin1": "San Miguel Department",
    "pop": "247126"
  },
  { "id": 1630634, "name": "Probolinggo", "country": "ID", "admin1": "East Java", "pop": "246980" },
  { "id": 145778, "name": "Chitato", "country": "AO", "admin1": "Luanda Norte", "pop": "246880" },
  { "id": 514734, "name": "Orsk", "country": "RU", "admin1": "Orenburg Oblast", "pop": "246836" },
  { "id": 944986, "name": "Vanderbijlpark", "country": "ZA", "admin1": "Gauteng", "pop": "246754" },
  { "id": 3645213, "name": "Coro", "country": "VE", "admin1": "Falcón", "pop": "246657" },
  { "id": 3472343, "name": "Americana", "country": "BR", "admin1": "São Paulo", "pop": "246655" },
  {
    "id": 2891122,
    "name": "Kiel",
    "country": "DE",
    "admin1": "Schleswig-Holstein",
    "pop": "246601"
  },
  { "id": 3465927, "name": "Colombo", "country": "BR", "admin1": "Paraná", "pop": "246540" },
  { "id": 1529484, "name": "Hami", "country": "CN", "admin1": "Xinjiang", "pop": "246373" },
  { "id": 933773, "name": "Gaborone", "country": "BW", "admin1": "Gaborone", "pop": "246325" },
  {
    "id": 353229,
    "name": "Al ‘Āshir min Ramaḑān",
    "country": "EG",
    "admin1": "Sharqia",
    "pop": "246148"
  },
  {
    "id": 1626916,
    "name": "Singkawang",
    "country": "ID",
    "admin1": "West Kalimantan",
    "pop": "246112"
  },
  {
    "id": 11810635,
    "name": "Kyain Seikgyi Township",
    "country": "MM",
    "admin1": "Kayin State",
    "pop": "246065"
  },
  { "id": 1263311, "name": "Mau", "country": "IN", "admin1": "Uttar Pradesh", "pop": "246050" },
  {
    "id": 3874960,
    "name": "Puerto Montt",
    "country": "CL",
    "admin1": "Los Lagos Region",
    "pop": "245902"
  },
  { "id": 2641430, "name": "Northampton", "country": "GB", "admin1": "England", "pop": "245899" },
  { "id": 3937513, "name": "Juliaca", "country": "PE", "admin1": "Puno", "pop": "245675" },
  { "id": 1864134, "name": "Fuji", "country": "JP", "admin1": "Shizuoka", "pop": "245392" },
  {
    "id": 1841603,
    "name": "Gyeongju",
    "country": "KR",
    "admin1": "Gyeongsangbuk-do",
    "pop": "245365"
  },
  { "id": 695594, "name": "Rivne", "country": "UA", "admin1": "Rivne", "pop": "245289" },
  {
    "id": 2281606,
    "name": "Sinfra",
    "country": "CI",
    "admin1": "Zanzan District",
    "pop": "245226"
  },
  { "id": 485239, "name": "Syktyvkar", "country": "RU", "admin1": "Komi", "pop": "245083" },
  {
    "id": 1497543,
    "name": "Nizhnevartovsk",
    "country": "RU",
    "admin1": "Khanty-Mansia",
    "pop": "244937"
  },
  { "id": 132892, "name": "Gorgān", "country": "IR", "admin1": "Golestan", "pop": "244937" },
  { "id": 2755251, "name": "Groningen", "country": "NL", "admin1": "Groningen", "pop": "244807" },
  { "id": 1283582, "name": "Biratnagar", "country": "NP", "admin1": "Koshi", "pop": "244750" },
  {
    "id": 2945024,
    "name": "Braunschweig",
    "country": "DE",
    "admin1": "Lower Saxony",
    "pop": "244715"
  },
  { "id": 3625542, "name": "Valera", "country": "VE", "admin1": "Trujillo", "pop": "244708" },
  { "id": 7289760, "name": "Sengkang New Town", "country": "SG", "admin1": null, "pop": "244600" },
  {
    "id": 3388441,
    "name": "São José de Ribamar",
    "country": "BR",
    "admin1": "Maranhão",
    "pop": "244579"
  },
  { "id": 1256320, "name": "Sīkar", "country": "IN", "admin1": "Rajasthan", "pop": "244497" },
  { "id": 1300466, "name": "Bago", "country": "MM", "admin1": "Bago Region", "pop": "244376" },
  { "id": 634963, "name": "Tampere", "country": "FI", "admin1": "Pirkanmaa", "pop": "244315" },
  { "id": 3648439, "name": "Baruta", "country": "VE", "admin1": "Miranda", "pop": "244216" },
  { "id": 3458142, "name": "Magé", "country": "BR", "admin1": "Rio de Janeiro", "pop": "244092" },
  { "id": 738648, "name": "Trabzon", "country": "TR", "admin1": "Trabzon", "pop": "244083" },
  { "id": 7289169, "name": "Tri-Cities", "country": "US", "admin1": "Washington", "pop": "244036" },
  {
    "id": 1336140,
    "name": "Jessore",
    "country": "BD",
    "admin1": "Khulna Division",
    "pop": "243987"
  },
  { "id": 304827, "name": "Manisa", "country": "TR", "admin1": "Manisa", "pop": "243971" },
  { "id": 3407327, "name": "Arapiraca", "country": "BR", "admin1": "Alagoas", "pop": "243661" },
  { "id": 12042053, "name": "Musaffah", "country": "AE", "admin1": "Abu Dhabi", "pop": "243341" },
  { "id": 1852899, "name": "Sasebo", "country": "JP", "admin1": "Nagasaki", "pop": "243223" },
  {
    "id": 2027667,
    "name": "Angarsk",
    "country": "RU",
    "admin1": "Irkutsk Oblast",
    "pop": "243158"
  },
  { "id": 8347656, "name": "Ramagundam", "country": "IN", "admin1": "Telangana", "pop": "242979" },
  { "id": 1270393, "name": "Hāpur", "country": "IN", "admin1": "Uttar Pradesh", "pop": "242920" },
  { "id": 1864624, "name": "Chigasaki", "country": "JP", "admin1": "Kanagawa", "pop": "242798" },
  { "id": 1864518, "name": "Chōfu", "country": "JP", "admin1": "Tokyo", "pop": "242614" },
  { "id": 1806988, "name": "Huayin", "country": "CN", "admin1": "Shaanxi", "pop": "242488" },
  { "id": 64435, "name": "Berbera", "country": "SO", "admin1": "Woqooyi Galbeed", "pop": "242344" },
  { "id": 1805012, "name": "Jiyuan", "country": "CN", "admin1": "Henan", "pop": "242143" },
  { "id": 11611478, "name": "Yamato", "country": "JP", "admin1": "Kanagawa", "pop": "242065" },
  { "id": 2284647, "name": "Man", "country": "CI", "admin1": "Montagnes", "pop": "241969" },
  { "id": 1183883, "name": "Bahawalnagar", "country": "PK", "admin1": "Punjab", "pop": "241873" },
  {
    "id": 518255,
    "name": "Novorossiysk",
    "country": "RU",
    "admin1": "Krasnodar Krai",
    "pop": "241856"
  },
  { "id": 2110681, "name": "Tsukuba", "country": "JP", "admin1": "Ibaraki", "pop": "241656" },
  {
    "id": 3899361,
    "name": "Arica",
    "country": "CL",
    "admin1": "Arica y Parinacota Region",
    "pop": "241653"
  },
  {
    "id": 3876682,
    "name": "Peñalolén",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "241599"
  },
  { "id": 1581326, "name": "Hải Dương", "country": "VN", "admin1": "Hai Phong", "pop": "241373" },
  {
    "id": 4499612,
    "name": "Winston-Salem",
    "country": "US",
    "admin1": "North Carolina",
    "pop": "241218"
  },
  {
    "id": 1271942,
    "name": "Farrukhābād",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "241152"
  },
  { "id": 1857519, "name": "Matsumoto", "country": "JP", "admin1": "Nagano", "pop": "241145" },
  { "id": 7628420, "name": "Sancaktepe", "country": "TR", "admin1": "Istanbul", "pop": "241000" },
  { "id": 1278985, "name": "Alappuzha", "country": "IN", "admin1": "Kerala", "pop": "240991" },
  { "id": 3460718, "name": "Itapevi", "country": "BR", "admin1": "São Paulo", "pop": "240961" },
  { "id": 1267480, "name": "Katihar", "country": "IN", "admin1": "Bihar", "pop": "240838" },
  { "id": 3457692, "name": "Marília", "country": "BR", "admin1": "São Paulo", "pop": "240590" },
  {
    "id": 3688451,
    "name": "Buenaventura",
    "country": "CO",
    "admin1": "Valle del Cauca Department",
    "pop": "240387"
  },
  { "id": 147622, "name": "Lankaran", "country": "AZ", "admin1": "Lənkəran", "pop": "240300" },
  { "id": 3645527, "name": "Ciudad Ojeda", "country": "VE", "admin1": "Zulia", "pop": "240283" },
  { "id": 5295985, "name": "Glendale", "country": "US", "admin1": "Arizona", "pop": "240126" },
  {
    "id": 3460950,
    "name": "Itaboraí",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "240040"
  },
  { "id": 1732905, "name": "Klang", "country": "MY", "admin1": "Selangor", "pop": "240016" },
  { "id": 32900, "name": "Golestān", "country": "IR", "admin1": "Tehran", "pop": "240000" },
  { "id": 550280, "name": "Khimki", "country": "RU", "admin1": "Moscow Oblast", "pop": "239967" },
  { "id": 707753, "name": "Horlivka", "country": "UA", "admin1": "Donetsk", "pop": "239828" },
  { "id": 1035025, "name": "Nacala", "country": "MZ", "admin1": "Nampula", "pop": "239808" },
  { "id": 1790371, "name": "Xiantao", "country": "CN", "admin1": "Hubei", "pop": "239406" },
  {
    "id": 523523,
    "name": "Nalchik",
    "country": "RU",
    "admin1": "Kabardino-Balkariya Republic",
    "pop": "239300"
  },
  { "id": 2130203, "name": "Hachinohe", "country": "JP", "admin1": "Aomori", "pop": "239046" },
  { "id": 1839652, "name": "Osan", "country": "KR", "admin1": "Gyeonggi-do", "pop": "238788" },
  { "id": 6697563, "name": "Neyagawa", "country": "JP", "admin1": "Osaka", "pop": "238549" },
  { "id": 1697018, "name": "Ormoc", "country": "PH", "admin1": "Eastern Visayas", "pop": "238545" },
  {
    "id": 3523760,
    "name": "Magdalena Contreras",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "238431"
  },
  {
    "id": 1185159,
    "name": "Nāgarpur",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "238422"
  },
  { "id": 158214, "name": "Kasulu", "country": "TZ", "admin1": "Kigoma", "pop": "238321" },
  { "id": 2224827, "name": "Ngaoundéré", "country": "CM", "admin1": "Adamaoua", "pop": "238196" },
  {
    "id": 707471,
    "name": "Ivano-Frankivsk",
    "country": "UA",
    "admin1": "Ivano-Frankivsk",
    "pop": "238196"
  },
  {
    "id": 3468615,
    "name": "Cabo Frio",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "238166"
  },
  { "id": 322165, "name": "Balıkesir", "country": "TR", "admin1": "Balıkesir", "pop": "238151" },
  { "id": 3870011, "name": "Temuco", "country": "CL", "admin1": "Araucanía", "pop": "238129" },
  { "id": 4776222, "name": "Norfolk", "country": "US", "admin1": "Virginia", "pop": "238005" },
  {
    "id": 2884509,
    "name": "Krefeld",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "237984"
  },
  {
    "id": 2911522,
    "name": "Halle (Saale)",
    "country": "DE",
    "admin1": "Saxony-Anhalt",
    "pop": "237865"
  },
  { "id": 3397154, "name": "Juazeiro", "country": "BR", "admin1": "Bahia", "pop": "237821" },
  {
    "id": 1271685,
    "name": "Sri Ganganagar",
    "country": "IN",
    "admin1": "Rajasthan",
    "pop": "237780"
  },
  {
    "id": 1329221,
    "name": "Amarapura",
    "country": "MM",
    "admin1": "Mandalay Region",
    "pop": "237618"
  },
  { "id": 1726280, "name": "Batangas", "country": "PH", "admin1": "Calabarzon", "pop": "237370" },
  {
    "id": 109435,
    "name": "Al Jubayl",
    "country": "SA",
    "admin1": "Eastern Province",
    "pop": "237274"
  },
  {
    "id": 1868144,
    "name": "Tŏkch’ŏn",
    "country": "KP",
    "admin1": "South Pyongan",
    "pop": "237133"
  },
  { "id": 2641022, "name": "Oldham", "country": "GB", "admin1": "England", "pop": "237110" },
  { "id": 1328421, "name": "Pathein", "country": "MM", "admin1": "Ayeyarwady", "pop": "237089" },
  { "id": 4158476, "name": "Hialeah", "country": "US", "admin1": "Florida", "pop": "237069" },
  {
    "id": 1185099,
    "name": "Sylhet",
    "country": "BD",
    "admin1": "Sylhet Division",
    "pop": "237000"
  },
  { "id": 3363094, "name": "Paarl", "country": "ZA", "admin1": "Western Cape", "pop": "236910" },
  { "id": 4693003, "name": "Garland", "country": "US", "admin1": "Texas", "pop": "236897" },
  { "id": 3193044, "name": "Podgorica", "country": "ME", "admin1": "Podgorica", "pop": "236852" },
  { "id": 5313457, "name": "Scottsdale", "country": "US", "admin1": "Arizona", "pop": "236839" },
  { "id": 4700168, "name": "Irving", "country": "US", "admin1": "Texas", "pop": "236607" },
  { "id": 1105777, "name": "Centurion", "country": "ZA", "admin1": "Gauteng", "pop": "236580" },
  { "id": 1786731, "name": "Qingzhou", "country": "CN", "admin1": "Shandong", "pop": "236406" },
  { "id": 10941913, "name": "Kajang", "country": "MY", "admin1": "Selangor", "pop": "236240" },
  {
    "id": 1214369,
    "name": "Padangsidempuan",
    "country": "ID",
    "admin1": "North Sumatra",
    "pop": "236217"
  },
  {
    "id": 2874545,
    "name": "Magdeburg",
    "country": "DE",
    "admin1": "Saxony-Anhalt",
    "pop": "235775"
  },
  {
    "id": 2756253,
    "name": "Eindhoven",
    "country": "NL",
    "admin1": "North Brabant",
    "pop": "235691"
  },
  { "id": 5586437, "name": "Boise", "country": "US", "admin1": "Idaho", "pop": "235684" },
  { "id": 1258182, "name": "Rewa", "country": "IN", "admin1": "Madhya Pradesh", "pop": "235654" },
  { "id": 2013159, "name": "Yakutsk", "country": "RU", "admin1": "Sakha", "pop": "235600" },
  { "id": 8521718, "name": "Bole", "country": "CN", "admin1": "Xinjiang", "pop": "235585" },
  { "id": 1169605, "name": "Muzaffargarh", "country": "PK", "admin1": "Punjab", "pop": "235541" },
  { "id": 4752186, "name": "Chesapeake", "country": "US", "admin1": "Virginia", "pop": "235429" },
  { "id": 1253880, "name": "Uluberiya", "country": "IN", "admin1": "West Bengal", "pop": "235345" },
  { "id": 1814093, "name": "Dali", "country": "CN", "admin1": "Yunnan", "pop": "235305" },
  {
    "id": 8594709,
    "name": "Thành Phố Bà Rịa",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "235192"
  },
  { "id": 1640660, "name": "Kediri", "country": "ID", "admin1": "East Java", "pop": "235143" },
  {
    "id": 3378644,
    "name": "Georgetown",
    "country": "GY",
    "admin1": "Demerara-Mahaica",
    "pop": "235017"
  },
  { "id": 55671, "name": "Kismayo", "country": "SO", "admin1": "Lower Juba", "pop": "234852" },
  { "id": 1219649, "name": "Türkmenabat", "country": "TM", "admin1": "Lebap", "pop": "234817" },
  {
    "id": 5509403,
    "name": "North Las Vegas",
    "country": "US",
    "admin1": "Nevada",
    "pop": "234807"
  },
  { "id": 2518559, "name": "Elche", "country": "ES", "admin1": "Valencia", "pop": "234765" },
  { "id": 1255947, "name": "Sivakasi", "country": "IN", "admin1": "Tamil Nadu", "pop": "234704" },
  { "id": 212902, "name": "Kindu", "country": "CD", "admin1": "Maniema", "pop": "234651" },
  { "id": 3395473, "name": "Maracanaú", "country": "BR", "admin1": "Ceará", "pop": "234509" },
  { "id": 2998324, "name": "Lille", "country": "FR", "admin1": "Hauts-de-France", "pop": "234475" },
  { "id": 2982652, "name": "Rouen", "country": "FR", "admin1": "Normandy", "pop": "234475" },
  {
    "id": 521118,
    "name": "Nizhnekamsk",
    "country": "RU",
    "admin1": "Tatarstan Republic",
    "pop": "234297"
  },
  { "id": 3461655, "name": "Hortolândia", "country": "BR", "admin1": "São Paulo", "pop": "234259" },
  { "id": 1267648, "name": "Karur", "country": "IN", "admin1": "Tamil Nadu", "pop": "234191" },
  {
    "id": 1637158,
    "name": "Lubuklinggau",
    "country": "ID",
    "admin1": "South Sumatra",
    "pop": "234166"
  },
  { "id": 680332, "name": "Craiova", "country": "RO", "admin1": "Dolj", "pop": "234140" },
  { "id": 1259012, "name": "Rāichūr", "country": "IN", "admin1": "Karnataka", "pop": "234073" },
  { "id": 1260692, "name": "Pallāvaram", "country": "IN", "admin1": "Tamil Nadu", "pop": "233984" },
  { "id": 1665221, "name": "Yongkang", "country": "TW", "admin1": "Taiwan", "pop": "233730" },
  { "id": 2517117, "name": "Granada", "country": "ES", "admin1": "Andalusia", "pop": "233532" },
  { "id": 1253993, "name": "Ooty", "country": "IN", "admin1": "Tamil Nadu", "pop": "233426" },
  { "id": 1853303, "name": "Saga", "country": "JP", "admin1": "Saga", "pop": "233301" },
  {
    "id": 1684269,
    "name": "Magugpo Poblacion",
    "country": "PH",
    "admin1": "Davao Region",
    "pop": "233254"
  },
  {
    "id": 563708,
    "name": "Dzerzhinsk",
    "country": "RU",
    "admin1": "Nizhny Novgorod Oblast",
    "pop": "233126"
  },
  {
    "id": 1028918,
    "name": "Pemba",
    "country": "MZ",
    "admin1": "Cabo Delgado Province",
    "pop": "232932"
  },
  { "id": 1735459, "name": "Teluk Intan", "country": "MY", "admin1": "Perak", "pop": "232800" },
  { "id": 149879, "name": "Singida", "country": "TZ", "admin1": "Singida", "pop": "232459" },
  { "id": 157738, "name": "Kigoma", "country": "TZ", "admin1": "Kigoma", "pop": "232388" },
  { "id": 5350734, "name": "Fremont", "country": "US", "admin1": "California", "pop": "232206" },
  { "id": 1280957, "name": "Jiayuguan", "country": "CN", "admin1": "Gansu", "pop": "231853" },
  { "id": 1682598, "name": "Taytay", "country": "PH", "admin1": "Calabarzon", "pop": "231460" },
  { "id": 3843123, "name": "Neuquén", "country": "AR", "admin1": "Neuquen", "pop": "231198" },
  {
    "id": 3464688,
    "name": "Divinópolis",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "231091"
  },
  { "id": 1567621, "name": "Sơn Tây", "country": "VN", "admin1": "Hanoi", "pop": "230577" },
  { "id": 1571951, "name": "Ninh Hòa", "country": "VN", "admin1": "Khanh Hoa", "pop": "230566" },
  { "id": 1736372, "name": "Pasir Mas", "country": "MY", "admin1": "Kelantan", "pop": "230424" },
  {
    "id": 1630328,
    "name": "Purwokerto",
    "country": "ID",
    "admin1": "Central Java",
    "pop": "230235"
  },
  {
    "id": 12076997,
    "name": "José C. Paz",
    "country": "AR",
    "admin1": "Buenos Aires",
    "pop": "230208"
  },
  { "id": 54225, "name": "Marka", "country": "SO", "admin1": "Lower Shabeelle", "pop": "230100" },
  { "id": 1260716, "name": "Pāli", "country": "IN", "admin1": "Rajasthan", "pop": "230075" },
  { "id": 2349019, "name": "Atani", "country": "NG", "admin1": "Anambra", "pop": "230000" },
  { "id": 355795, "name": "Ḩalwān", "country": "EG", "admin1": "Cairo", "pop": "230000" },
  { "id": 7843638, "name": "Changzheng", "country": "CN", "admin1": "Shanghai", "pop": "229925" },
  { "id": 1859884, "name": "Kasukabe", "country": "JP", "admin1": "Saitama", "pop": "229792" },
  { "id": 6182962, "name": "Windsor", "country": "CA", "admin1": "Ontario", "pop": "229660" },
  { "id": 1269934, "name": "Hosūr", "country": "IN", "admin1": "Tamil Nadu", "pop": "229528" },
  { "id": 5811696, "name": "Spokane", "country": "US", "admin1": "Washington", "pop": "229447" },
  { "id": 266826, "name": "Tripoli", "country": "LB", "admin1": "Liban-Nord", "pop": "229398" },
  { "id": 6059891, "name": "Longueuil", "country": "CA", "admin1": "Quebec", "pop": "229330" },
  { "id": 741100, "name": "Ordu", "country": "TR", "admin1": "Ordu", "pop": "229214" },
  {
    "id": 3805673,
    "name": "San Fernando de Apure",
    "country": "VE",
    "admin1": "Apure",
    "pop": "229197"
  },
  {
    "id": 3727135,
    "name": "Croix-des-Bouquets",
    "country": "HT",
    "admin1": "Ouest",
    "pop": "229127"
  },
  { "id": 1705357, "name": "Lucena", "country": "PH", "admin1": "Calabarzon", "pop": "228758" },
  { "id": 3461144, "name": "Ipatinga", "country": "BR", "admin1": "Minas Gerais", "pop": "228746" },
  {
    "id": 1253084,
    "name": "Vizianagaram",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "228720"
  },
  { "id": 1805733, "name": "Jinchang", "country": "CN", "admin1": "Gansu", "pop": "228561" },
  { "id": 1571058, "name": "Phan Thiết", "country": "VN", "admin1": "Lam Dong", "pop": "228536" },
  {
    "id": 294071,
    "name": "Netanya",
    "country": "IL",
    "admin1": "Central District",
    "pop": "228204"
  },
  { "id": 3124964, "name": "Ciudad Lineal", "country": "ES", "admin1": "Madrid", "pop": "228171" },
  {
    "id": 1699802,
    "name": "Meycauayan",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "228023"
  },
  { "id": 2655775, "name": "Bexley", "country": "GB", "admin1": "England", "pop": "228000" },
  { "id": 2350434, "name": "Aliayabiagba", "country": "NG", "admin1": "Lagos", "pop": "228000" },
  { "id": 3571824, "name": "Nassau", "country": "BS", "admin1": "New Providence", "pop": "227940" },
  {
    "id": 3437056,
    "name": "San Lorenzo",
    "country": "PY",
    "admin1": "Central Department",
    "pop": "227876"
  },
  {
    "id": 2542051,
    "name": "Mohammedia",
    "country": "MA",
    "admin1": "Casablanca-Settat",
    "pop": "227799"
  },
  { "id": 3639898, "name": "Guatire", "country": "VE", "admin1": "Miranda", "pop": "227666" },
  {
    "id": 1624863,
    "name": "Tanjung Pinang",
    "country": "ID",
    "admin1": "Riau Islands",
    "pop": "227663"
  },
  { "id": 4315588, "name": "Baton Rouge", "country": "US", "admin1": "Louisiana", "pop": "227470" },
  {
    "id": 3447624,
    "name": "Sete Lagoas",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "227397"
  },
  { "id": 3085128, "name": "Sosnowiec", "country": "PL", "admin1": "Silesia", "pop": "227295" },
  { "id": 1517945, "name": "Turkestan", "country": "KZ", "admin1": "Turkistan", "pop": "227098" },
  { "id": 989921, "name": "Klerksdorp", "country": "ZA", "admin1": "North West", "pop": "227039" },
  {
    "id": 487928,
    "name": "Staryy Oskol",
    "country": "RU",
    "admin1": "Belgorod Oblast",
    "pop": "226977"
  },
  { "id": 1865714, "name": "Ageo", "country": "JP", "admin1": "Saitama", "pop": "226940" },
  { "id": 2339937, "name": "Gusau", "country": "NG", "admin1": "Zamfara State", "pop": "226857" },
  {
    "id": 709932,
    "name": "Kamyanske",
    "country": "UA",
    "admin1": "Dnipropetrovsk",
    "pop": "226845"
  },
  {
    "id": 295629,
    "name": "Ashdod",
    "country": "IL",
    "admin1": "Southern District",
    "pop": "226838"
  },
  { "id": 760778, "name": "Radom", "country": "PL", "admin1": "Mazovia", "pop": "226794" },
  { "id": 13100478, "name": "Paya Terubong", "country": "MY", "admin1": "Penang", "pop": "226712" },
  { "id": 4781708, "name": "Richmond", "country": "US", "admin1": "Virginia", "pop": "226610" },
  { "id": 1993459, "name": "Changhua", "country": "TW", "admin1": "Taiwan", "pop": "226564" },
  { "id": 1679136, "name": "Chang-hua", "country": "TW", "admin1": "Taiwan", "pop": "226564" },
  { "id": 1583478, "name": "Điện Bàn", "country": "VN", "admin1": "Da Nang City", "pop": "226564" },
  { "id": 1851012, "name": "Takarazuka", "country": "JP", "admin1": "Hyōgo", "pop": "226432" },
  {
    "id": 2416969,
    "name": "Nzérékoré",
    "country": "GN",
    "admin1": "Nzérékoré Region",
    "pop": "226426"
  },
  { "id": 6119109, "name": "Regina", "country": "CA", "admin1": "Saskatchewan", "pop": "226404" },
  { "id": 1586443, "name": "Cà Mau", "country": "VN", "admin1": "Ca Mau", "pop": "226372" },
  {
    "id": 1256422,
    "name": "Shrīrāmpur",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "226317"
  },
  {
    "id": 118063,
    "name": "Sabzevar",
    "country": "IR",
    "admin1": "Razavi Khorasan",
    "pop": "226183"
  },
  { "id": 1807508, "name": "Huanggang", "country": "CN", "admin1": "Guangdong", "pop": "225956" },
  {
    "id": 7302845,
    "name": "Quthbullapur",
    "country": "IN",
    "admin1": "Telangana",
    "pop": "225816"
  },
  { "id": 2329821, "name": "Mubi", "country": "NG", "admin1": "Adamawa", "pop": "225705" },
  { "id": 3451055, "name": "Rio Verde", "country": "BR", "admin1": "Goiás", "pop": "225696" },
  {
    "id": 6316328,
    "name": "Águas Lindas de Goiás",
    "country": "BR",
    "admin1": "Goiás",
    "pop": "225693"
  },
  {
    "id": 3452324,
    "name": "Presidente Prudente",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "225668"
  },
  {
    "id": 6951112,
    "name": "Somerset West",
    "country": "ZA",
    "admin1": "Western Cape",
    "pop": "225289"
  },
  { "id": 2643339, "name": "Luton", "country": "GB", "admin1": "England", "pop": "225262" },
  { "id": 691650, "name": "Ternopil", "country": "UA", "admin1": "Ternopil", "pop": "225238" },
  {
    "id": 3397147,
    "name": "Juazeiro do Norte",
    "country": "BR",
    "admin1": "Ceará",
    "pop": "225230"
  },
  { "id": 1648637, "name": "Bitung", "country": "ID", "admin1": "North Sulawesi", "pop": "225134" },
  {
    "id": 1185162,
    "name": "Mymensingh",
    "country": "BD",
    "admin1": "Mymensingh Division",
    "pop": "225126"
  },
  {
    "id": 2026609,
    "name": "Blagoveshchensk",
    "country": "RU",
    "admin1": "Amur Oblast",
    "pop": "225091"
  },
  { "id": 1262292, "name": "Nadiād", "country": "IN", "admin1": "Gujarat", "pop": "225071" },
  { "id": 2229752, "name": "Kumba", "country": "CM", "admin1": "South-West", "pop": "225046" },
  { "id": 724443, "name": "Košice", "country": "SK", "admin1": "Košice Region", "pop": "225044" },
  { "id": 1805618, "name": "Jingling", "country": "CN", "admin1": "Hubei", "pop": "224871" },
  { "id": 1262204, "name": "Nāgercoil", "country": "IN", "admin1": "Tamil Nadu", "pop": "224849" },
  {
    "id": 3903987,
    "name": "Sucre",
    "country": "BO",
    "admin1": "Chuquisaca Department",
    "pop": "224838"
  },
  { "id": 884979, "name": "Mutare", "country": "ZW", "admin1": "Manicaland", "pop": "224802" },
  { "id": 1853677, "name": "Ōta", "country": "JP", "admin1": "Gunma", "pop": "224358" },
  {
    "id": 3991328,
    "name": "Puerto Vallarta",
    "country": "MX",
    "admin1": "Jalisco",
    "pop": "224166"
  },
  { "id": 1857144, "name": "Minamirinkan", "country": "JP", "admin1": "Kanagawa", "pop": "224015" },
  { "id": 1847963, "name": "Atsugi", "country": "JP", "admin1": "Kanagawa", "pop": "223960" },
  { "id": 2036973, "name": "Heihe", "country": "CN", "admin1": "Heilongjiang", "pop": "223832" },
  { "id": 13353441, "name": "Mango", "country": "IN", "admin1": "Jharkhand", "pop": "223805" },
  {
    "id": 3383330,
    "name": "Paramaribo",
    "country": "SR",
    "admin1": "Paramaribo District",
    "pop": "223757"
  },
  {
    "id": 1185155,
    "name": "Nārāyanganj",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "223622"
  },
  {
    "id": 1680116,
    "name": "NIA Valencia",
    "country": "PH",
    "admin1": "Northern Mindanao",
    "pop": "223620"
  },
  { "id": 1795196, "name": "Tongchuanshi", "country": "CN", "admin1": "Shaanxi", "pop": "223603" },
  { "id": 3893894, "name": "Concepción", "country": "CL", "admin1": "Biobío", "pop": "223574" },
  { "id": 98717, "name": "Ramadi", "country": "IQ", "admin1": "Al Anbar", "pop": "223500" },
  { "id": 418606, "name": "Najafābād", "country": "IR", "admin1": "Isfahan", "pop": "223450" },
  { "id": 5509952, "name": "Paradise", "country": "US", "admin1": "Nevada", "pop": "223167" },
  { "id": 5812944, "name": "Tacoma", "country": "US", "admin1": "Washington", "pop": "222906" },
  {
    "id": 519336,
    "name": "Velikiy Novgorod",
    "country": "RU",
    "admin1": "Novgorod Oblast",
    "pop": "222868"
  },
  { "id": 1735153, "name": "Sungai Buloh", "country": "MY", "admin1": "Selangor", "pop": "222858" },
  { "id": 1270896, "name": "Gosāba", "country": "IN", "admin1": "West Bengal", "pop": "222764" },
  {
    "id": 1692685,
    "name": "Puerto Princesa",
    "country": "PH",
    "admin1": "Mimaropa",
    "pop": "222673"
  },
  { "id": 1788618, "name": "Xintai", "country": "CN", "admin1": "Shandong", "pop": "222459" },
  { "id": 3641351, "name": "El Tigre", "country": "VE", "admin1": "Anzoátegui", "pop": "222450" },
  { "id": 1877615, "name": "Haeju", "country": "KP", "admin1": "South Hwanghae", "pop": "222396" },
  { "id": 3433899, "name": "Formosa", "country": "AR", "admin1": "Formosa", "pop": "222226" },
  { "id": 2338273, "name": "Ikire", "country": "NG", "admin1": "Osun State", "pop": "222160" },
  {
    "id": 3608248,
    "name": "La Ceiba",
    "country": "HN",
    "admin1": "Atlántida Department",
    "pop": "222055"
  },
  { "id": 2746301, "name": "Tilburg", "country": "NL", "admin1": "North Brabant", "pop": "221947" },
  { "id": 7289846, "name": "Ba Dinh", "country": "VN", "admin1": "Hanoi", "pop": "221893" },
  {
    "id": 1262395,
    "name": "Murwāra",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "221883"
  },
  { "id": 153209, "name": "Moshi", "country": "TZ", "admin1": "Kilimanjaro", "pop": "221733" },
  {
    "id": 2464915,
    "name": "Sousse",
    "country": "TN",
    "admin1": "Sousse Governorate",
    "pop": "221715"
  },
  {
    "id": 1268159,
    "name": "Kanchipuram",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "221715"
  },
  { "id": 1649824, "name": "Batu", "country": "ID", "admin1": "East Java", "pop": "221714" },
  {
    "id": 3666645,
    "name": "Tuluá",
    "country": "CO",
    "admin1": "Valle del Cauca Department",
    "pop": "221684"
  },
  { "id": 1882155, "name": "Yishun New Town", "country": "SG", "admin1": null, "pop": "221610" },
  {
    "id": 1567788,
    "name": "Sóc Trăng",
    "country": "VN",
    "admin1": "Can Tho City",
    "pop": "221430"
  },
  { "id": 2419992, "name": "Kankan", "country": "GN", "admin1": "Kankan Region", "pop": "221428" },
  { "id": 496015, "name": "Shakhty", "country": "RU", "admin1": "Rostov", "pop": "221312" },
  { "id": 229268, "name": "Mbarara", "country": "UG", "admin1": "Western Region", "pop": "221300" },
  {
    "id": 1697175,
    "name": "Olongapo",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "221178"
  },
  { "id": 3655673, "name": "Ibarra", "country": "EC", "admin1": "Imbabura", "pop": "221149" },
  { "id": 3204541, "name": "Banja Luka", "country": "BA", "admin1": "Srpska", "pop": "221106" },
  {
    "id": 122285,
    "name": "Neyshābūr",
    "country": "IR",
    "admin1": "Razavi Khorasan",
    "pop": "220929"
  },
  { "id": 1790894, "name": "Wuxue", "country": "CN", "admin1": "Hubei", "pop": "220661" },
  { "id": 2983990, "name": "Rennes", "country": "FR", "admin1": "Brittany", "pop": "220488" },
  { "id": 1585489, "name": "Chí Linh", "country": "VN", "admin1": "Hai Phong", "pop": "220421" },
  { "id": 3531732, "name": "Campeche", "country": "MX", "admin1": "Campeche", "pop": "220389" },
  {
    "id": 9645086,
    "name": "Quận Ba",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "220375"
  },
  {
    "id": 7279754,
    "name": "Singrauli",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "220257"
  },
  {
    "id": 1262995,
    "name": "Mirzāpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "220029"
  },
  { "id": 3114711, "name": "Oviedo", "country": "ES", "admin1": "Asturias", "pop": "220027" },
  {
    "id": 13118272,
    "name": "Bandar Seri Alam",
    "country": "MY",
    "admin1": "Johor",
    "pop": "220000"
  },
  { "id": 2524170, "name": "Messina", "country": "IT", "admin1": "Sicily", "pop": "219948" },
  {
    "id": 1234569,
    "name": "Dehiwala-Mount Lavinia",
    "country": "LK",
    "admin1": "Western Province",
    "pop": "219827"
  },
  {
    "id": 705812,
    "name": "Kropyvnytskyy",
    "country": "UA",
    "admin1": "Kirovohrad",
    "pop": "219676"
  },
  { "id": 1266976, "name": "Kharagpur", "country": "IN", "admin1": "West Bengal", "pop": "219665" },
  { "id": 215527, "name": "Kabinda", "country": "CD", "admin1": "Lomami", "pop": "219396" },
  { "id": 1176515, "name": "Jacobabad", "country": "PK", "admin1": "Sindh", "pop": "219315" },
  { "id": 149402, "name": "Tunduma", "country": "TZ", "admin1": "Songwe", "pop": "219309" },
  { "id": 1725094, "name": "Binangonan", "country": "PH", "admin1": "Calabarzon", "pop": "219204" },
  {
    "id": 2860410,
    "name": "Oberhausen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "219176"
  },
  { "id": 1611110, "name": "Chon Buri", "country": "TH", "admin1": "Chon Buri", "pop": "219164" },
  {
    "id": 3450144,
    "name": "Santa Luzia",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "219132"
  },
  { "id": 1494114, "name": "Prokop’yevsk", "country": "RU", "admin1": "Kuzbass", "pop": "219000" },
  {
    "id": 12432979,
    "name": "Samambaia",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "218840"
  },
  { "id": 3657990, "name": "Esmeraldas", "country": "EC", "admin1": "Esmeraldas", "pop": "218727" },
  { "id": 3108286, "name": "Terrassa", "country": "ES", "admin1": "Catalonia", "pop": "218535" },
  { "id": 1791249, "name": "Wuhai", "country": "CN", "admin1": "Inner Mongolia", "pop": "218427" },
  { "id": 3398269, "name": "Imperatriz", "country": "BR", "admin1": "Maranhão", "pop": "218106" },
  { "id": 2454268, "name": "Koutiala", "country": "ML", "admin1": "Sikasso", "pop": "218031" },
  { "id": 1272051, "name": "Eluru", "country": "IN", "admin1": "Andhra Pradesh", "pop": "218020" },
  {
    "id": 3493032,
    "name": "San Pedro de Macorís",
    "country": "DO",
    "admin1": "San Pedro de Macorís",
    "pop": "217899"
  },
  { "id": 677697, "name": "Galaţi", "country": "RO", "admin1": "Galați County", "pop": "217851" },
  { "id": 3129028, "name": "Badalona", "country": "ES", "admin1": "Catalonia", "pop": "217741" },
  { "id": 704147, "name": "Kremenchuk", "country": "UA", "admin1": "Poltava", "pop": "217710" },
  { "id": 764484, "name": "Mokotów", "country": "PL", "admin1": "Mazovia", "pop": "217683" },
  { "id": 1734586, "name": "Taiping", "country": "MY", "admin1": "Perak", "pop": "217647" },
  { "id": 12358616, "name": "Yintai", "country": "CN", "admin1": "Shaanxi", "pop": "217509" },
  { "id": 2874225, "name": "Mainz", "country": "DE", "admin1": "Rheinland-Pfalz", "pop": "217123" },
  { "id": 1252797, "name": "Yamuna Nagar", "country": "IN", "admin1": "Haryana", "pop": "217071" },
  {
    "id": 3404545,
    "name": "Cabo de Santo Agostinho",
    "country": "BR",
    "admin1": "Pernambuco",
    "pop": "216969"
  },
  {
    "id": 1632654,
    "name": "Pangkalpinang",
    "country": "ID",
    "admin1": "Bangka–Belitung Islands",
    "pop": "216893"
  },
  { "id": 3827606, "name": "Buenavista", "country": "MX", "admin1": "México", "pop": "216776" },
  {
    "id": 1178338,
    "name": "Gilgit",
    "country": "PK",
    "admin1": "Gilgit-Baltistan",
    "pop": "216760"
  },
  {
    "id": 500004,
    "name": "Rybinsk",
    "country": "RU",
    "admin1": "Yaroslavl Oblast",
    "pop": "216724"
  },
  { "id": 1687894, "name": "Santa Rosa", "country": "PH", "admin1": "Calabarzon", "pop": "216650" },
  { "id": 3133880, "name": "Trondheim", "country": "NO", "admin1": "Trøndelag", "pop": "216518" },
  {
    "id": 13308246,
    "name": "Raurkela Industrial Township",
    "country": "IN",
    "admin1": "Odisha",
    "pop": "216410"
  },
  {
    "id": 3629965,
    "name": "Porlamar",
    "country": "VE",
    "admin1": "Nueva Esparta",
    "pop": "216234"
  },
  {
    "id": 5391710,
    "name": "San Bernardino",
    "country": "US",
    "admin1": "California",
    "pop": "216108"
  },
  { "id": 4013728, "name": "Ciudad Acuña", "country": "MX", "admin1": "Coahuila", "pop": "216099" },
  { "id": 6318696, "name": "Sinop", "country": "BR", "admin1": "Mato Grosso", "pop": "216029" },
  { "id": 1275738, "name": "Bidar", "country": "IN", "admin1": "Karnataka", "pop": "216020" },
  { "id": 702569, "name": "Lutsk", "country": "UA", "admin1": "Volyn", "pop": "215986" },
  {
    "id": 2925177,
    "name": "Freiburg",
    "country": "DE",
    "admin1": "Baden-Wurttemberg",
    "pop": "215966"
  },
  {
    "id": 3519537,
    "name": "San Cristóbal de las Casas",
    "country": "MX",
    "admin1": "Chiapas",
    "pop": "215874"
  },
  { "id": 463829, "name": "Zelenograd", "country": "RU", "admin1": "Moscow", "pop": "215727" },
  { "id": 11777624, "name": "Archway", "country": "GB", "admin1": "England", "pop": "215667" },
  {
    "id": 12750606,
    "name": "Wangsa Maju",
    "country": "MY",
    "admin1": "Kuala Lumpur",
    "pop": "215600"
  },
  { "id": 5780993, "name": "Salt Lake City", "country": "US", "admin1": "Utah", "pop": "215548" },
  { "id": 1510018, "name": "Biysk", "country": "RU", "admin1": "Altai Krai", "pop": "215430" },
  { "id": 3194360, "name": "Novi Sad", "country": "RS", "admin1": "Vojvodina", "pop": "215400" },
  { "id": 1805298, "name": "Jinzhou", "country": "CN", "admin1": "Liaoning", "pop": "215386" },
  { "id": 3526485, "name": "Jiutepec", "country": "MX", "admin1": "Morelos", "pop": "215357" },
  { "id": 3995523, "name": "Monclova", "country": "MX", "admin1": "Coahuila", "pop": "215271" },
  { "id": 1567069, "name": "Tân An", "country": "VN", "admin1": "Tay Ninh", "pop": "215250" },
  { "id": 1819400, "name": "Ma On Shan", "country": "HK", "admin1": "Sha Tin", "pop": "215200" },
  { "id": 4068590, "name": "Huntsville", "country": "US", "admin1": "Alabama", "pop": "215006" },
  { "id": 2243940, "name": "Ziguinchor", "country": "SN", "admin1": "Ziguinchor", "pop": "214874" },
  {
    "id": 1221194,
    "name": "Kŭlob",
    "country": "TJ",
    "admin1": "Khatlon Province",
    "pop": "214700"
  },
  { "id": 1646034, "name": "Citeureup", "country": "ID", "admin1": "West Java", "pop": "214668" },
  { "id": 1568212, "name": "Sa Dec", "country": "VN", "admin1": "Dong Thap", "pop": "214610" },
  { "id": 1858296, "name": "Kure", "country": "JP", "admin1": "Hiroshima", "pop": "214592" },
  { "id": 2323411, "name": "Shagamu", "country": "NG", "admin1": "Ogun State", "pop": "214558" },
  { "id": 295514, "name": "Bnei Brak", "country": "IL", "admin1": "Tel Aviv", "pop": "214444" },
  {
    "id": 2544248,
    "name": "Khouribga",
    "country": "MA",
    "admin1": "Béni Mellal-Khénifra",
    "pop": "214241"
  },
  { "id": 1786577, "name": "Yingtan", "country": "CN", "admin1": "Jiangxi", "pop": "214229" },
  { "id": 4853828, "name": "Des Moines", "country": "US", "admin1": "Iowa", "pop": "214133" },
  {
    "id": 2595323,
    "name": "Marcory",
    "country": "CI",
    "admin1": "Abidjan Autonomous District",
    "pop": "214061"
  },
  { "id": 2520058, "name": "Cartagena", "country": "ES", "admin1": "Murcia", "pop": "213943" },
  { "id": 3652567, "name": "Quevedo", "country": "EC", "admin1": "Los Ríos", "pop": "213842" },
  { "id": 6092122, "name": "Oakville", "country": "CA", "admin1": "Ontario", "pop": "213759" },
  { "id": 2929670, "name": "Erfurt", "country": "DE", "admin1": "Thuringia", "pop": "213692" },
  {
    "id": 122438,
    "name": "Naz̧arābād",
    "country": "IR",
    "admin1": "Alborz Province",
    "pop": "213388"
  },
  { "id": 139889, "name": "Būkān", "country": "IR", "admin1": "West Azerbaijan", "pop": "213331" },
  { "id": 1262482, "name": "Munger", "country": "IN", "admin1": "Bihar", "pop": "213303" },
  { "id": 3460370, "name": "Jacareí", "country": "BR", "admin1": "São Paulo", "pop": "213110" },
  {
    "id": 2516326,
    "name": "Jerez de la Frontera",
    "country": "ES",
    "admin1": "Andalusia",
    "pop": "212879"
  },
  {
    "id": 2550078,
    "name": "El Jadida",
    "country": "MA",
    "admin1": "Casablanca-Settat",
    "pop": "212863"
  },
  { "id": 1783700, "name": "Zitong", "country": "CN", "admin1": "Chongqing", "pop": "212819" },
  {
    "id": 1637510,
    "name": "Loa Janan",
    "country": "ID",
    "admin1": "East Kalimantan",
    "pop": "212816"
  },
  {
    "id": 665004,
    "name": "Târgu Mureş",
    "country": "RO",
    "admin1": "Mureș County",
    "pop": "212752"
  },
  { "id": 5349755, "name": "Fontana", "country": "US", "admin1": "California", "pop": "212704" },
  {
    "id": 3873775,
    "name": "Rancagua",
    "country": "CL",
    "admin1": "O'Higgins Region",
    "pop": "212695"
  },
  { "id": 1677112, "name": "Zhubei", "country": "TW", "admin1": "Taiwan", "pop": "212695" },
  { "id": 352951, "name": "Mallawī", "country": "EG", "admin1": "Minya", "pop": "212628" },
  { "id": 1632033, "name": "Pasuruan", "country": "ID", "admin1": "East Java", "pop": "212466" },
  { "id": 2302357, "name": "Cape Coast", "country": "GH", "admin1": "Central", "pop": "212426" },
  { "id": 1735079, "name": "Bukit Mertajam", "country": "MY", "admin1": "Penang", "pop": "212329" },
  { "id": 1706090, "name": "Lipa City", "country": "PH", "admin1": "Calabarzon", "pop": "212287" },
  {
    "id": 2875601,
    "name": "Lübeck",
    "country": "DE",
    "admin1": "Schleswig-Holstein",
    "pop": "212207"
  },
  { "id": 1801909, "name": "Luojiang", "country": "CN", "admin1": "Sichuan", "pop": "212186" },
  { "id": 1734821, "name": "Sepang", "country": "MY", "admin1": "Selangor", "pop": "212050" },
  { "id": 3598119, "name": "Cobán", "country": "GT", "admin1": "Alta Verapaz", "pop": "212047" },
  { "id": 3457708, "name": "Maricá", "country": "BR", "admin1": "Rio de Janeiro", "pop": "211986" },
  { "id": 1586151, "name": "Cao Lãnh", "country": "VN", "admin1": "Dong Thap", "pop": "211912" },
  { "id": 1861436, "name": "Isesaki", "country": "JP", "admin1": "Gunma", "pop": "211850" },
  { "id": 3111199, "name": "Sabadell", "country": "ES", "admin1": "Catalonia", "pop": "211734" },
  {
    "id": 1261927,
    "name": "Nandyāl",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "211424"
  },
  {
    "id": 2511174,
    "name": "Santa Cruz de Tenerife",
    "country": "ES",
    "admin1": "Canary Islands",
    "pop": "211359"
  },
  { "id": 6690108, "name": "Panchkula", "country": "IN", "admin1": "Haryana", "pop": "211355" },
  { "id": 747323, "name": "Esenyurt", "country": "TR", "admin1": "Istanbul", "pop": "211330" },
  { "id": 5373900, "name": "Modesto", "country": "US", "admin1": "California", "pop": "211266" },
  { "id": 1695804, "name": "Panabo", "country": "PH", "admin1": "Davao Region", "pop": "211242" },
  { "id": 1813253, "name": "Lijiang", "country": "CN", "admin1": "Yunnan", "pop": "211151" },
  { "id": 1514891, "name": "Konibodom", "country": "TJ", "admin1": "Sughd", "pop": "211100" },
  { "id": 2037078, "name": "Hailar", "country": "CN", "admin1": "Inner Mongolia", "pop": "211066" },
  {
    "id": 1709968,
    "name": "Kabankalan",
    "country": "PH",
    "admin1": "Western Visayas",
    "pop": "210893"
  },
  {
    "id": 1275068,
    "name": "Burhānpur",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "210886"
  },
  { "id": 110690, "name": "Abha", "country": "SA", "admin1": "'Asir Region", "pop": "210886" },
  { "id": 504341, "name": "Pskov", "country": "RU", "admin1": "Pskov Oblast", "pop": "210501" },
  { "id": 1262775, "name": "Morvi", "country": "IN", "admin1": "Gujarat", "pop": "210451" },
  { "id": 1814082, "name": "Daliang", "country": "CN", "admin1": "Guangdong", "pop": "210411" },
  {
    "id": 3874212,
    "name": "Quilicura",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "210410"
  },
  {
    "id": 2555745,
    "name": "Beni Mellal",
    "country": "MA",
    "admin1": "Béni Mellal-Khénifra",
    "pop": "210397"
  },
  {
    "id": 2481007,
    "name": "Sidi Bel Abbes",
    "country": "DZ",
    "admin1": "Sidi Bel Abbès",
    "pop": "210146"
  },
  { "id": 3568342, "name": "Arroyo Naranjo", "country": "CU", "admin1": "Havana", "pop": "210053" },
  { "id": 11524601, "name": "Jebel Ali", "country": "AE", "admin1": "Dubai", "pop": "210000" },
  { "id": 1519928, "name": "Kostanay", "country": "KZ", "admin1": "Qostanay", "pop": "210000" },
  {
    "id": 1337233,
    "name": "Bogra",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "210000"
  },
  { "id": 323779, "name": "Antakya", "country": "TR", "admin1": "Hatay", "pop": "210000" },
  {
    "id": 6122085,
    "name": "Richmond",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "209937"
  },
  { "id": 5134086, "name": "Rochester", "country": "US", "admin1": "New York", "pop": "209802" },
  {
    "id": 643492,
    "name": "Oulu",
    "country": "FI",
    "admin1": "North Ostrobothnia",
    "pop": "209648"
  },
  { "id": 2043572, "name": "Kanggye", "country": "KP", "admin1": "Chagang", "pop": "209530" },
  {
    "id": 1845033,
    "name": "Chungju",
    "country": "KR",
    "admin1": "North Chungcheong",
    "pop": "209483"
  },
  { "id": 1278685, "name": "Anand", "country": "IN", "admin1": "Gujarat", "pop": "209410" },
  {
    "id": 3448622,
    "name": "São Leopoldo",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "209229"
  },
  { "id": 1670909, "name": "Bade", "country": "TW", "admin1": "Taiwan", "pop": "209148" },
  { "id": 3458329, "name": "Luziânia", "country": "BR", "admin1": "Goiás", "pop": "209129" },
  { "id": 3909234, "name": "Oruro", "country": "BO", "admin1": "Oruro", "pop": "208684" },
  { "id": 769250, "name": "Kielce", "country": "PL", "admin1": "Świętokrzyskie", "pop": "208598" },
  { "id": 1817848, "name": "Bachuan", "country": "CN", "admin1": "Chongqing", "pop": "208520" },
  { "id": 3500957, "name": "La Romana", "country": "DO", "admin1": "La Romana", "pop": "208437" },
  { "id": 328689, "name": "Shashamane", "country": "ET", "admin1": "Oromiya", "pop": "208400" },
  { "id": 1808931, "name": "Hangu", "country": "CN", "admin1": "Tianjin", "pop": "208369" },
  { "id": 1261045, "name": "Ongole", "country": "IN", "admin1": "Andhra Pradesh", "pop": "208344" },
  { "id": 3114472, "name": "Pamplona", "country": "ES", "admin1": "Navarre", "pop": "208243" },
  { "id": 1843137, "name": "Gangneung", "country": "KR", "admin1": "Gangwon-do", "pop": "208161" },
  { "id": 2639996, "name": "Portsmouth", "country": "GB", "admin1": "England", "pop": "208100" },
  { "id": 216449, "name": "Gandajika", "country": "CD", "admin1": "Lomami", "pop": "208051" },
  { "id": 1809380, "name": "Gunan", "country": "CN", "admin1": "Chongqing", "pop": "208010" },
  {
    "id": 1571067,
    "name": "Phan Rang-Tháp Chàm",
    "country": "VN",
    "admin1": "Khanh Hoa",
    "pop": "207998"
  },
  { "id": 1646194, "name": "Ciputat", "country": "ID", "admin1": "West Java", "pop": "207858" },
  {
    "id": 232110,
    "name": "Kasangati",
    "country": "UG",
    "admin1": "Central Region",
    "pop": "207800"
  },
  { "id": 114259, "name": "Sirjan", "country": "IR", "admin1": "Kerman", "pop": "207645" },
  { "id": 4744709, "name": "Arlington", "country": "US", "admin1": "Virginia", "pop": "207627" },
  { "id": 339666, "name": "Bishoftu", "country": "ET", "admin1": "Oromiya", "pop": "207400" },
  { "id": 1850692, "name": "Nishi-Tokyo-shi", "country": "JP", "admin1": "Tokyo", "pop": "207388" },
  { "id": 630468, "name": "Bobruysk", "country": "BY", "admin1": "Mogilev", "pop": "207351" },
  {
    "id": 2045220,
    "name": "Changam-ch’on",
    "country": "KP",
    "admin1": "South Hamgyong",
    "pop": "207299"
  },
  { "id": 712165, "name": "Bila Tserkva", "country": "UA", "admin1": "Kiev", "pop": "207273" },
  { "id": 5380184, "name": "Oxnard", "country": "US", "admin1": "California", "pop": "207254" },
  { "id": 1647383, "name": "Ciampea", "country": "ID", "admin1": "West Java", "pop": "207212" },
  { "id": 361291, "name": "Hurghada", "country": "EG", "admin1": "Red Sea", "pop": "207132" },
  { "id": 3116025, "name": "Móstoles", "country": "ES", "admin1": "Madrid", "pop": "207095" },
  { "id": 4188985, "name": "Columbus", "country": "US", "admin1": "Georgia", "pop": "206922" },
  {
    "id": 3685095,
    "name": "Dosquebradas",
    "country": "CO",
    "admin1": "Risaralda Department",
    "pop": "206693"
  },
  {
    "id": 1681602,
    "name": "Toledo",
    "country": "PH",
    "admin1": "Central Visayas",
    "pop": "206692"
  },
  {
    "id": 4956184,
    "name": "Worcester",
    "country": "US",
    "admin1": "Massachusetts",
    "pop": "206518"
  },
  {
    "id": 1696710,
    "name": "Pagadian",
    "country": "PH",
    "admin1": "Zamboanga Peninsula",
    "pop": "206483"
  },
  { "id": 3628423, "name": "San Felipe", "country": "VE", "admin1": "Yaracuy", "pop": "206270" },
  {
    "id": 1203891,
    "name": "Dinajpur",
    "country": "BD",
    "admin1": "Rangpur Division",
    "pop": "206234"
  },
  { "id": 1269935, "name": "Hosapete", "country": "IN", "admin1": "Karnataka", "pop": "206167" },
  { "id": 1562818, "name": "Việt Yên", "country": "VN", "admin1": "Bac Ninh", "pop": "205900" },
  { "id": 159492, "name": "Ifakara", "country": "TZ", "admin1": "Morogoro", "pop": "205843" },
  { "id": 3346015, "name": "Sumbe", "country": "AO", "admin1": "Kwanza Sul", "pop": "205832" },
  { "id": 2451478, "name": "Ségou", "country": "ML", "admin1": "Ségou", "pop": "205787" },
  { "id": 1578500, "name": "Kon Tum", "country": "VN", "admin1": "Quang Ngai", "pop": "205762" },
  { "id": 3460949, "name": "Itabuna", "country": "BR", "admin1": "Bahia", "pop": "205660" },
  { "id": 3654870, "name": "Latacunga", "country": "EC", "admin1": "Cotopaxi", "pop": "205624" },
  { "id": 1261913, "name": "Nāngloi Jāt", "country": "IN", "admin1": "Delhi", "pop": "205596" },
  { "id": 1859383, "name": "Kishiwada", "country": "JP", "admin1": "Osaka", "pop": "205561" },
  { "id": 1785710, "name": "Jinghong", "country": "CN", "admin1": "Yunnan", "pop": "205523" },
  { "id": 977432, "name": "Mdantsane", "country": "ZA", "admin1": "Eastern Cape", "pop": "205504" },
  { "id": 3449319, "name": "São Carlos", "country": "BR", "admin1": "São Paulo", "pop": "205035" },
  { "id": 1165108, "name": "Shikarpur", "country": "PK", "admin1": "Sindh", "pop": "204938" },
  { "id": 1624041, "name": "Ternate", "country": "ID", "admin1": "North Maluku", "pop": "204920" },
  { "id": 6958503, "name": "Gongheyong", "country": "CN", "admin1": "Guangdong", "pop": "204881" },
  { "id": 2772400, "name": "Linz", "country": "AT", "admin1": "Upper Austria", "pop": "204846" },
  {
    "id": 1283467,
    "name": "Dhangaḍhi̇̄",
    "country": "NP",
    "admin1": "Sudurpashchim Pradesh",
    "pop": "204788"
  },
  { "id": 8544703, "name": "Nanchuan", "country": "CN", "admin1": "Chongqing", "pop": "204775" },
  { "id": 3530240, "name": "Córdoba", "country": "MX", "admin1": "Veracruz", "pop": "204721" },
  { "id": 1816329, "name": "Bishan", "country": "CN", "admin1": "Chongqing", "pop": "204702" },
  { "id": 2503826, "name": "Biskra", "country": "DZ", "admin1": "Biskra", "pop": "204661" },
  { "id": 1675393, "name": "Xizhi", "country": "TW", "admin1": "Taipei", "pop": "204619" },
  { "id": 1810437, "name": "Gaoping", "country": "CN", "admin1": "Sichuan", "pop": "204368" },
  {
    "id": 3165185,
    "name": "Trieste",
    "country": "IT",
    "admin1": "Friuli Venezia Giulia",
    "pop": "204338"
  },
  { "id": 153176, "name": "Mpanda", "country": "TZ", "admin1": "Katavi", "pop": "204338" },
  {
    "id": 5374732,
    "name": "Moreno Valley",
    "country": "US",
    "admin1": "California",
    "pop": "204198"
  },
  {
    "id": 1256922,
    "name": "Secunderabad",
    "country": "IN",
    "admin1": "Telangana",
    "pop": "204182"
  },
  {
    "id": 7910079,
    "name": "Sodo",
    "country": "ET",
    "admin1": "South Ethiopia Regional State",
    "pop": "204100"
  },
  { "id": 2208485, "name": "Zliten", "country": "LY", "admin1": "Mişrātah", "pop": "203790" },
  { "id": 3171728, "name": "Padova", "country": "IT", "admin1": "Veneto", "pop": "203725" },
  { "id": 8299875, "name": "Karnaphuli", "country": "BD", "admin1": "Chittagong", "pop": "203697" },
  {
    "id": 3550598,
    "name": "Las Tunas",
    "country": "CU",
    "admin1": "Las Tunas Province",
    "pop": "203684"
  },
  { "id": 1857550, "name": "Matsue", "country": "JP", "admin1": "Shimane", "pop": "203616" },
  { "id": 4562831, "name": "Bayamón", "country": "PR", "admin1": "Bayamón", "pop": "203499" },
  {
    "id": 6317464,
    "name": "Lauro de Freitas",
    "country": "BR",
    "admin1": "Bahia",
    "pop": "203331"
  },
  { "id": 1273241, "name": "Deoghar", "country": "IN", "admin1": "Jharkhand", "pop": "203123" },
  {
    "id": 1064890,
    "name": "Fianarantsoa",
    "country": "MG",
    "admin1": "Upper Matsiatra",
    "pop": "203105"
  },
  { "id": 3387296, "name": "Sobral", "country": "BR", "admin1": "Ceará", "pop": "203023" },
  { "id": 1207337, "name": "Chāndpur", "country": "BD", "admin1": "Chittagong", "pop": "203000" },
  {
    "id": 2306079,
    "name": "Atsiaman",
    "country": "GH",
    "admin1": "Greater Accra",
    "pop": "202932"
  },
  {
    "id": 2317397,
    "name": "Bandundu Province",
    "country": "CD",
    "admin1": "Kwilu",
    "pop": "202904"
  },
  { "id": 303195, "name": "Osmaniye", "country": "TR", "admin1": "Osmaniye", "pop": "202837" },
  { "id": 142363, "name": "Bābol", "country": "IR", "admin1": "Māzandarān", "pop": "202796" },
  {
    "id": 3985710,
    "name": "Cabo San Lucas",
    "country": "MX",
    "admin1": "Baja California Sur",
    "pop": "202694"
  },
  { "id": 4119403, "name": "Little Rock", "country": "US", "admin1": "Arkansas", "pop": "202591" },
  { "id": 748893, "name": "Çorlu", "country": "TR", "admin1": "Tekirdağ", "pop": "202578" },
  { "id": 1636930, "name": "Madiun", "country": "ID", "admin1": "East Java", "pop": "202544" },
  { "id": 159071, "name": "Iringa", "country": "TZ", "admin1": "Iringa", "pop": "202490" },
  { "id": 721472, "name": "Debrecen", "country": "HU", "admin1": "Hajdú-Bihar", "pop": "202402" },
  { "id": 1274353, "name": "Chāpra", "country": "IN", "admin1": "Bihar", "pop": "202352" },
  {
    "id": 1336137,
    "name": "Barishal",
    "country": "BD",
    "admin1": "Barisal Division",
    "pop": "202242"
  },
  { "id": 6122091, "name": "Richmond Hill", "country": "CA", "admin1": "Ontario", "pop": "202022" },
  {
    "id": 4466033,
    "name": "Fayetteville",
    "country": "US",
    "admin1": "North Carolina",
    "pop": "201963"
  },
  { "id": 2219905, "name": "Al Khums", "country": "LY", "admin1": "Al Marqab", "pop": "201943" },
  {
    "id": 5358705,
    "name": "Huntington Beach",
    "country": "US",
    "admin1": "California",
    "pop": "201899"
  },
  {
    "id": 1708522,
    "name": "Koronadal",
    "country": "PH",
    "admin1": "Soccsksargen",
    "pop": "201844"
  },
  { "id": 2660646, "name": "Genève", "country": "CH", "admin1": "Geneva", "pop": "201741" },
  { "id": 4174715, "name": "Tallahassee", "country": "US", "admin1": "Florida", "pop": "201731" },
  { "id": 2636389, "name": "Swindon", "country": "GB", "admin1": "England", "pop": "201669" },
  {
    "id": 1629710,
    "name": "Rengasdengklok",
    "country": "ID",
    "admin1": "West Java",
    "pop": "201463"
  },
  { "id": 3451234, "name": "Rio Claro", "country": "BR", "admin1": "São Paulo", "pop": "201418" },
  { "id": 1629131, "name": "Salatiga", "country": "ID", "admin1": "Central Java", "pop": "201369" },
  {
    "id": 3699088,
    "name": "Cajamarca",
    "country": "PE",
    "admin1": "Cajamarca Department",
    "pop": "201329"
  },
  {
    "id": 7281017,
    "name": "La Pintana",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "201178"
  },
  { "id": 5145215, "name": "Yonkers", "country": "US", "admin1": "New York", "pop": "201116" },
  { "id": 5352423, "name": "Glendale", "country": "US", "admin1": "California", "pop": "201020" },
  { "id": 1180809, "name": "Dadu", "country": "PK", "admin1": "Sindh", "pop": "201017" },
  {
    "id": 343663,
    "name": "Arba Minch",
    "country": "ET",
    "admin1": "South Ethiopia Regional State",
    "pop": "201000"
  },
  { "id": 1650234, "name": "Banjar", "country": "ID", "admin1": "West Java", "pop": "200970" },
  { "id": 2236967, "name": "Soyo", "country": "AO", "admin1": "Zaire", "pop": "200920" },
  {
    "id": 1520172,
    "name": "Petropavl",
    "country": "KZ",
    "admin1": "North Kazakhstan",
    "pop": "200920"
  },
  { "id": 4684724, "name": "Cypress", "country": "US", "admin1": "Texas", "pop": "200839" },
  {
    "id": 1267031,
    "name": "Khandwa",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "200738"
  },
  { "id": 4883817, "name": "Aurora", "country": "US", "admin1": "Illinois", "pop": "200661" },
  { "id": 1259184, "name": "Puri", "country": "IN", "admin1": "Odisha", "pop": "200564" },
  { "id": 1262771, "name": "Morena", "country": "IN", "admin1": "Madhya Pradesh", "pop": "200482" },
  { "id": 146268, "name": "Nicosia", "country": "CY", "admin1": "Nicosia", "pop": "200452" },
  { "id": 3181554, "name": "Brescia", "country": "IT", "admin1": "Lombardy", "pop": "200423" },
  { "id": 13405749, "name": "Nasimshahr", "country": "IR", "admin1": "Tehran", "pop": "200393" },
  {
    "id": 2320831,
    "name": "Ugep",
    "country": "NG",
    "admin1": "Cross River State",
    "pop": "200276"
  },
  { "id": 214614, "name": "Kamina", "country": "CD", "admin1": "Haut-Lomami", "pop": "200184" },
  { "id": 100425, "name": "Yanbu", "country": "SA", "admin1": "Medina Region", "pop": "200161" },
  { "id": 1856184, "name": "Nagareyama", "country": "JP", "admin1": "Chiba", "pop": "200136" },
  { "id": 2800481, "name": "Charleroi", "country": "BE", "admin1": "Wallonia", "pop": "200132" },
  {
    "id": 1576633,
    "name": "Lạng Sơn",
    "country": "VN",
    "admin1": "Lạng Sơn Province",
    "pop": "200108"
  },
  { "id": 13512708, "name": "Nyingchi", "country": "CN", "admin1": "Tibet", "pop": "200000" },
  {
    "id": 13118362,
    "name": "Bukit Jalil",
    "country": "MY",
    "admin1": "Kuala Lumpur",
    "pop": "200000"
  },
  {
    "id": 13118277,
    "name": "Bandar Utama",
    "country": "MY",
    "admin1": "Kuala Lumpur",
    "pop": "200000"
  },
  {
    "id": 12129605,
    "name": "Chakwama",
    "country": "NG",
    "admin1": "Jigawa State",
    "pop": "200000"
  },
  {
    "id": 10920963,
    "name": "Salé Al Jadida",
    "country": "MA",
    "admin1": "Rabat-Salé-Kénitra",
    "pop": "200000"
  },
  {
    "id": 3448742,
    "name": "São José",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "200000"
  },
  { "id": 2218970, "name": "Az Zāwīyah", "country": "LY", "admin1": "Az Zāwiyah", "pop": "200000" },
  { "id": 1818225, "name": "Yuen Long", "country": "HK", "admin1": "Yuen Long", "pop": "200000" },
  {
    "id": 1818222,
    "name": "Yuen Long San Hui",
    "country": "HK",
    "admin1": "Yuen Long",
    "pop": "200000"
  },
  { "id": 1626103, "name": "Sumedang", "country": "ID", "admin1": "West Java", "pop": "200000" },
  { "id": 1270576, "name": "Gyānpur", "country": "IN", "admin1": "Uttar Pradesh", "pop": "200000" },
  { "id": 1165569, "name": "Shahkot", "country": "PK", "admin1": "Punjab", "pop": "200000" },
  { "id": 1803551, "name": "Beiliu", "country": "CN", "admin1": "Guangxi", "pop": "199769" },
  { "id": 3887127, "name": "Iquique", "country": "CL", "admin1": "Tarapacá", "pop": "199587" },
  { "id": 1565047, "name": "Thuận Thanh", "country": "VN", "admin1": "Bac Ninh", "pop": "199577" },
  {
    "id": 579492,
    "name": "Balakovo",
    "country": "RU",
    "admin1": "Saratov Oblast",
    "pop": "199572"
  },
  { "id": 580922, "name": "Armavir", "country": "RU", "admin1": "Krasnodar Krai", "pop": "199548" },
  { "id": 1175088, "name": "Kamoke", "country": "PK", "admin1": "Punjab", "pop": "199531" },
  { "id": 6822182, "name": "Yachiyo", "country": "JP", "admin1": "Chiba", "pop": "199498" },
  {
    "id": 6545349,
    "name": "Saidpur",
    "country": "BD",
    "admin1": "Rangpur Division",
    "pop": "199422"
  },
  { "id": 1880348, "name": "Punggol", "country": "SG", "admin1": null, "pop": "199400" },
  { "id": 143534, "name": "Āmol", "country": "IR", "admin1": "Māzandarān", "pop": "199382" },
  {
    "id": 9645071,
    "name": "Quận Bốn",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "199329"
  },
  { "id": 361546, "name": "Arīsh", "country": "EG", "admin1": "North Sinai", "pop": "199243" },
  { "id": 1735150, "name": "Rawang", "country": "MY", "admin1": "Selangor", "pop": "199095" },
  { "id": 2650839, "name": "Dudley", "country": "GB", "admin1": "England", "pop": "199059" },
  { "id": 2329660, "name": "Mushin", "country": "NG", "admin1": "Lagos", "pop": "199000" },
  {
    "id": 2119441,
    "name": "Yuzhno-Sakhalinsk",
    "country": "RU",
    "admin1": "Sakhalin Oblast",
    "pop": "198973"
  },
  {
    "id": 2912621,
    "name": "Hagen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "198972"
  },
  { "id": 3640465, "name": "Guacara", "country": "VE", "admin1": "Carabobo", "pop": "198883" },
  {
    "id": 6318856,
    "name": "Valparaíso de Goiás",
    "country": "BR",
    "admin1": "Goiás",
    "pop": "198861"
  },
  { "id": 3099230, "name": "Gliwice", "country": "PL", "admin1": "Silesia", "pop": "198835" },
  { "id": 1529569, "name": "Changji", "country": "CN", "admin1": "Xinjiang", "pop": "198776" },
  { "id": 11611930, "name": "Kodaira", "country": "JP", "admin1": "Tokyo", "pop": "198739" },
  {
    "id": 13512576,
    "name": "Plano Piloto",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "198697"
  },
  { "id": 5516233, "name": "Amarillo", "country": "US", "admin1": "Texas", "pop": "198645" },
  {
    "id": 1275120,
    "name": "Bulandshahr",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "198612"
  },
  { "id": 2657832, "name": "Aberdeen", "country": "GB", "admin1": "Scotland", "pop": "198590" },
  { "id": 3165926, "name": "Taranto", "country": "IT", "admin1": "Apulia", "pop": "198585" },
  {
    "id": 3439214,
    "name": "Capiatá",
    "country": "PY",
    "admin1": "Central Department",
    "pop": "198553"
  },
  { "id": 1643837, "name": "Gorontalo", "country": "ID", "admin1": "Gorontalo", "pop": "198539" },
  { "id": 1811764, "name": "Duyun", "country": "CN", "admin1": "Guizhou", "pop": "198516" },
  { "id": 184707, "name": "Naivasha", "country": "KE", "admin1": "Nakuru County", "pop": "198444" },
  { "id": 1804850, "name": "Kaiyuan", "country": "CN", "admin1": "Yunnan", "pop": "198423" },
  {
    "id": 2844588,
    "name": "Rostock",
    "country": "DE",
    "admin1": "Mecklenburg-Vorpommern",
    "pop": "198293"
  },
  { "id": 3171457, "name": "Parma", "country": "IT", "admin1": "Emilia-Romagna", "pop": "198292" },
  { "id": 1735902, "name": "Sibu", "country": "MY", "admin1": "Sarawak", "pop": "198239" },
  { "id": 751868, "name": "Arnavutköy", "country": "TR", "admin1": "Istanbul", "pop": "198165" },
  { "id": 1861310, "name": "Itami", "country": "JP", "admin1": "Hyōgo", "pop": "198138" },
  { "id": 1800657, "name": "Mentougou", "country": "CN", "admin1": "Beijing", "pop": "197772" },
  { "id": 1275926, "name": "Bhind", "country": "IN", "admin1": "Madhya Pradesh", "pop": "197585" },
  { "id": 5145476, "name": "Akron", "country": "US", "admin1": "Ohio", "pop": "197542" },
  { "id": 3870294, "name": "Talca", "country": "CL", "admin1": "Maule Region", "pop": "197479" },
  {
    "id": 3530594,
    "name": "Ciudad Madero",
    "country": "MX",
    "admin1": "Tamaulipas",
    "pop": "197216"
  },
  { "id": 2315728, "name": "Gemena", "country": "CD", "admin1": "Sud-Ubangi", "pop": "197159" },
  {
    "id": 10263167,
    "name": "Bhālswa Jahangirpur",
    "country": "IN",
    "admin1": "Delhi",
    "pop": "197148"
  },
  { "id": 13512503, "name": "Lushui", "country": "CN", "admin1": "Yunnan", "pop": "197000" },
  {
    "id": 140463,
    "name": "Bīrjand",
    "country": "IR",
    "admin1": "South Khorasan Province",
    "pop": "196982"
  },
  {
    "id": 3083271,
    "name": "Toruń",
    "country": "PL",
    "admin1": "Kujawsko-Pomorskie",
    "pop": "196935"
  },
  { "id": 2521886, "name": "Almería", "country": "ES", "admin1": "Andalusia", "pop": "196851" },
  { "id": 1805798, "name": "Jijiang", "country": "CN", "admin1": "Chongqing", "pop": "196787" },
  {
    "id": 1651944,
    "name": "Vientiane",
    "country": "LA",
    "admin1": "Vientiane Prefecture",
    "pop": "196731"
  },
  {
    "id": 3696417,
    "name": "Huánuco",
    "country": "PE",
    "admin1": "Huánuco Department",
    "pop": "196627"
  },
  {
    "id": 11611627,
    "name": "Higashihiroshima",
    "country": "JP",
    "admin1": "Hiroshima",
    "pop": "196608"
  },
  { "id": 745028, "name": "İzmit", "country": "TR", "admin1": "Kocaeli", "pop": "196571" },
  { "id": 2984114, "name": "Reims", "country": "FR", "admin1": "Grand Est", "pop": "196565" },
  { "id": 1808950, "name": "Hanfeng", "country": "CN", "admin1": "Chongqing", "pop": "196528" },
  { "id": 5814616, "name": "Vancouver", "country": "US", "admin1": "Washington", "pop": "196442" },
  { "id": 4049979, "name": "Birmingham", "country": "US", "admin1": "Alabama", "pop": "196357" },
  { "id": 2462881, "name": "Laayoune", "country": "EH", "admin1": null, "pop": "196331" },
  { "id": 1267076, "name": "Khammam", "country": "IN", "admin1": "Telangana", "pop": "196283" },
  { "id": 294751, "name": "H̱olon", "country": "IL", "admin1": "Tel Aviv", "pop": "196282" },
  { "id": 976361, "name": "Middelburg", "country": "ZA", "admin1": "Mpumalanga", "pop": "196263" },
  { "id": 1843702, "name": "Icheon-si", "country": "KR", "admin1": "Gyeonggi-do", "pop": "196230" },
  {
    "id": 1607508,
    "name": "Phra Pradaeng",
    "country": "TH",
    "admin1": "Samut Prakan",
    "pop": "196129"
  },
  {
    "id": 2427455,
    "name": "Moundou",
    "country": "TD",
    "admin1": "Logone Occidental",
    "pop": "196124"
  },
  { "id": 1257540, "name": "Sambhal", "country": "IN", "admin1": "Uttar Pradesh", "pop": "196109" },
  { "id": 1214658, "name": "Lhokseumawe", "country": "ID", "admin1": "Aceh", "pop": "196067" },
  { "id": 1275899, "name": "Bhiwāni", "country": "IN", "admin1": "Haryana", "pop": "196057" },
  { "id": 563464, "name": "Engels", "country": "RU", "admin1": "Saratov Oblast", "pop": "196011" },
  {
    "id": 4026082,
    "name": "Ciudad Lázaro Cárdenas",
    "country": "MX",
    "admin1": "Michoacán",
    "pop": "196003"
  },
  {
    "id": 1024694,
    "name": "Mocuba",
    "country": "MZ",
    "admin1": "Zambezia Province",
    "pop": "196001"
  },
  { "id": 732770, "name": "Burgas", "country": "BG", "admin1": "Burgas", "pop": "195966" },
  {
    "id": 1283339,
    "name": "Hetauda",
    "country": "NP",
    "admin1": "Bagmati Province",
    "pop": "195951"
  },
  { "id": 3185728, "name": "Durrës", "country": "AL", "admin1": "Durrës County", "pop": "195920" },
  { "id": 1851348, "name": "Suzuka", "country": "JP", "admin1": "Mie", "pop": "195670" },
  {
    "id": 385038,
    "name": "Ar Rifā‘",
    "country": "BH",
    "admin1": "Southern Governorate",
    "pop": "195606"
  },
  { "id": 3432043, "name": "La Plata", "country": "AR", "admin1": "Buenos Aires", "pop": "195443" },
  { "id": 1283318, "name": "Janakpur", "country": "NP", "admin1": "Madhesh", "pop": "195438" },
  { "id": 1260434, "name": "Panvel", "country": "IN", "admin1": "Maharashtra", "pop": "195373" },
  { "id": 1798972, "name": "Peicheng", "country": "CN", "admin1": "Jiangsu", "pop": "195363" },
  {
    "id": 1236854,
    "name": "Maharagama",
    "country": "LK",
    "admin1": "Western Province",
    "pop": "195355"
  },
  {
    "id": 633679,
    "name": "Turku",
    "country": "FI",
    "admin1": "Southwest Finland",
    "pop": "195301"
  },
  { "id": 4076784, "name": "Montgomery", "country": "US", "admin1": "Alabama", "pop": "195287" },
  { "id": 2792413, "name": "Liège", "country": "BE", "admin1": "Wallonia", "pop": "195278" },
  { "id": 1858428, "name": "Kumagaya", "country": "JP", "admin1": "Saitama", "pop": "195277" },
  { "id": 1841988, "name": "Guri-si", "country": "KR", "admin1": "Gyeonggi-do", "pop": "195236" },
  { "id": 1278860, "name": "Ambāla", "country": "IN", "admin1": "Haryana", "pop": "195153" },
  { "id": 4994358, "name": "Grand Rapids", "country": "US", "admin1": "Michigan", "pop": "195097" },
  { "id": 3169921, "name": "Prato", "country": "IT", "admin1": "Tuscany", "pop": "195089" },
  {
    "id": 8223943,
    "name": "Kumarapalayam",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "195071"
  },
  {
    "id": 1283562,
    "name": "Butwāl",
    "country": "NP",
    "admin1": "Lumbini Province",
    "pop": "195054"
  },
  { "id": 1214724, "name": "Langsa", "country": "ID", "admin1": "Aceh", "pop": "194730" },
  { "id": 2455518, "name": "Kayes", "country": "ML", "admin1": "Kayes", "pop": "194716" },
  {
    "id": 354502,
    "name": "Kafr ash Shaykh",
    "country": "EG",
    "admin1": "Kafr el-Sheikh",
    "pop": "194569"
  },
  { "id": 2892518, "name": "Kassel", "country": "DE", "admin1": "Hesse", "pop": "194501" },
  { "id": 2477461, "name": "Tébessa", "country": "DZ", "admin1": "Tébessa", "pop": "194461" },
  {
    "id": 1732676,
    "name": "Kuala Kubu Baharu",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "194387"
  },
  { "id": 193627, "name": "Karuri", "country": "KE", "admin1": "Murang'A", "pop": "194342" },
  { "id": 193624, "name": "Karuri", "country": "KE", "admin1": "Kiambu County", "pop": "194342" },
  { "id": 2417786, "name": "Manéah", "country": "GN", "admin1": "Kindia", "pop": "194297" },
  {
    "id": 496285,
    "name": "Severodvinsk",
    "country": "RU",
    "admin1": "Arkhangelskaya",
    "pop": "194292"
  },
  { "id": 747764, "name": "Düzce", "country": "TR", "admin1": "Düzce", "pop": "194097" },
  { "id": 2328765, "name": "Nnewi", "country": "NG", "admin1": "Anambra", "pop": "193987" },
  { "id": 1848689, "name": "Yamaguchi", "country": "JP", "admin1": "Yamaguchi", "pop": "193966" },
  {
    "id": 3130616,
    "name": "Alcalá de Henares",
    "country": "ES",
    "admin1": "Madrid",
    "pop": "193751"
  },
  { "id": 6947639, "name": "Başakşehir", "country": "TR", "admin1": "Istanbul", "pop": "193750" },
  { "id": 1811619, "name": "Ezhou", "country": "CN", "admin1": "Hubei", "pop": "193652" },
  { "id": 1784712, "name": "Zhengding", "country": "CN", "admin1": "Hebei", "pop": "193524" },
  { "id": 909863, "name": "Luanshya", "country": "ZM", "admin1": "Copperbelt", "pop": "193293" },
  { "id": 7026720, "name": "Bang Khae", "country": "TH", "admin1": "Bangkok", "pop": "193002" },
  {
    "id": 1729085,
    "name": "Bago City",
    "country": "PH",
    "admin1": "Western Visayas",
    "pop": "192993"
  },
  { "id": 1786378, "name": "Yongchuan", "country": "CN", "admin1": "Chongqing", "pop": "192954" },
  { "id": 1849372, "name": "Uji", "country": "JP", "admin1": "Kyoto", "pop": "192925" },
  {
    "id": 1264637,
    "name": "Machilīpatnam",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "192827"
  },
  { "id": 1803842, "name": "Hepu", "country": "CN", "admin1": "Guangxi", "pop": "192813" },
  { "id": 2043837, "name": "Hyesan", "country": "KP", "admin1": "Yanggang-do", "pop": "192680" },
  {
    "id": 3567597,
    "name": "Bayamo",
    "country": "CU",
    "admin1": "Granma Province",
    "pop": "192632"
  },
  {
    "id": 1192366,
    "name": "Pār Naogaon",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "192464"
  },
  { "id": 1792585, "name": "Fuding", "country": "CN", "admin1": "Fujian", "pop": "192352" },
  {
    "id": 3456223,
    "name": "Nossa Senhora do Socorro",
    "country": "BR",
    "admin1": "Sergipe",
    "pop": "192330"
  },
  { "id": 3402591, "name": "Castanhal", "country": "BR", "admin1": "Pará", "pop": "192256" },
  { "id": 3080985, "name": "Zabrze", "country": "PL", "admin1": "Silesia", "pop": "192177" },
  { "id": 140380, "name": "Bojnūrd", "country": "IR", "admin1": "North Khorasan", "pop": "192041" },
  { "id": 2322733, "name": "Surulere", "country": "NG", "admin1": "Lagos", "pop": "191920" },
  { "id": 1806696, "name": "Humen", "country": "CN", "admin1": "Guangdong", "pop": "191891" },
  { "id": 1610780, "name": "Hat Yai", "country": "TH", "admin1": "Songkhla", "pop": "191696" },
  { "id": 2037086, "name": "Haicheng", "country": "CN", "admin1": "Liaoning", "pop": "191651" },
  { "id": 1645895, "name": "Curug", "country": "ID", "admin1": "Banten", "pop": "191406" },
  {
    "id": 3689169,
    "name": "Barrancabermeja",
    "country": "CO",
    "admin1": "Santander Department",
    "pop": "191403"
  },
  { "id": 462444, "name": "Zlatoust", "country": "RU", "admin1": "Chelyabinsk", "pop": "191366" },
  {
    "id": 1514581,
    "name": "Angren",
    "country": "UZ",
    "admin1": "Tashkent Region",
    "pop": "191300"
  },
  { "id": 228853, "name": "Mukono", "country": "UG", "admin1": "Central Region", "pop": "191300" },
  {
    "id": 3530599,
    "name": "Ciudad del Carmen",
    "country": "MX",
    "admin1": "Campeche",
    "pop": "191238"
  },
  {
    "id": 3456166,
    "name": "Nova Friburgo",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "191158"
  },
  { "id": 1162004, "name": "Khairpur Mir’s", "country": "PK", "admin1": "Sindh", "pop": "191044" },
  { "id": 1514879, "name": "Khujand", "country": "TJ", "admin1": "Sughd", "pop": "191000" },
  { "id": 5308480, "name": "Peoria", "country": "US", "admin1": "Arizona", "pop": "190985" },
  {
    "id": 2304121,
    "name": "Ashaiman",
    "country": "GH",
    "admin1": "Greater Accra",
    "pop": "190972"
  },
  {
    "id": 5224151,
    "name": "Providence",
    "country": "US",
    "admin1": "Rhode Island",
    "pop": "190934"
  },
  {
    "id": 1884737,
    "name": "Choa Chu Kang New Town",
    "country": "SG",
    "admin1": null,
    "pop": "190890"
  },
  { "id": 1633037, "name": "Palopo", "country": "ID", "admin1": "South Sulawesi", "pop": "190867" },
  { "id": 1264389, "name": "Mahesāna", "country": "IN", "admin1": "Gujarat", "pop": "190753" },
  { "id": 4634946, "name": "Knoxville", "country": "US", "admin1": "Tennessee", "pop": "190740" },
  { "id": 3121960, "name": "Fuenlabrada", "country": "ES", "admin1": "Madrid", "pop": "190496" },
  { "id": 1862599, "name": "Hino", "country": "JP", "admin1": "Tokyo", "pop": "190435" },
  { "id": 1175864, "name": "Jhelum", "country": "PK", "admin1": "Punjab", "pop": "190425" },
  { "id": 1264407, "name": "Mahbūbnagar", "country": "IN", "admin1": "Telangana", "pop": "190400" },
  { "id": 2965140, "name": "Cork", "country": "IE", "admin1": "Munster", "pop": "190384" },
  { "id": 1608048, "name": "Pak Kret", "country": "TH", "admin1": "Nonthaburi", "pop": "190272" },
  { "id": 1586360, "name": "Cẩm Phả", "country": "VN", "admin1": "Quảng Ninh", "pop": "190232" },
  { "id": 99454, "name": "Al Fallūjah", "country": "IQ", "admin1": "Al Anbar", "pop": "190159" },
  { "id": 1529651, "name": "Jinshanlu", "country": "CN", "admin1": "Xinjiang", "pop": "190064" },
  { "id": 2337207, "name": "Ise-Ekiti", "country": "NG", "admin1": "Ekiti State", "pop": "190063" },
  { "id": 632453, "name": "Vantaa", "country": "FI", "admin1": "Uusimaa", "pop": "190058" },
  {
    "id": 1648186,
    "name": "Bontang",
    "country": "ID",
    "admin1": "East Kalimantan",
    "pop": "189968"
  },
  { "id": 1166652, "name": "Saddiqabad", "country": "PK", "admin1": "Punjab", "pop": "189876" },
  {
    "id": 2190324,
    "name": "Hamilton",
    "country": "NZ",
    "admin1": "Waikato Region",
    "pop": "189700"
  },
  { "id": 1859100, "name": "Kofu", "country": "JP", "admin1": "Yamanashi", "pop": "189591" },
  { "id": 1854902, "name": "Numazu", "country": "JP", "admin1": "Shizuoka", "pop": "189486" },
  { "id": 6825489, "name": "Jōetsu", "country": "JP", "admin1": "Niigata", "pop": "189430" },
  {
    "id": 11184422,
    "name": "Planaltina",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "189412"
  },
  { "id": 5513343, "name": "Sunrise Manor", "country": "US", "admin1": "Nevada", "pop": "189372" },
  { "id": 1257542, "name": "Sambalpur", "country": "IN", "admin1": "Odisha", "pop": "189366" },
  { "id": 484972, "name": "Syzran", "country": "RU", "admin1": "Samara Oblast", "pop": "189338" },
  { "id": 1667982, "name": "Danshui", "country": "TW", "admin1": "Taipei", "pop": "189271" },
  { "id": 3101950, "name": "Bytom", "country": "PL", "admin1": "Silesia", "pop": "189186" },
  { "id": 207570, "name": "Mwene-Ditu", "country": "CD", "admin1": "Lomami", "pop": "189177" },
  {
    "id": 1695743,
    "name": "Panalanoy",
    "country": "PH",
    "admin1": "Eastern Visayas",
    "pop": "189090"
  },
  { "id": 3389353, "name": "Santarém", "country": "BR", "admin1": "Pará", "pop": "189047" },
  { "id": 1809467, "name": "Guixi", "country": "CN", "admin1": "Chongqing", "pop": "188980" },
  { "id": 1854747, "name": "Odawara", "country": "JP", "admin1": "Kanagawa", "pop": "188856" },
  { "id": 3468031, "name": "Camaçari", "country": "BR", "admin1": "Bahia", "pop": "188758" },
  {
    "id": 1638868,
    "name": "Labuan Bajo",
    "country": "ID",
    "admin1": "East Nusa Tenggara",
    "pop": "188724"
  },
  { "id": 1865294, "name": "Anjō", "country": "JP", "admin1": "Aichi", "pop": "188693" },
  { "id": 1002145, "name": "George", "country": "ZA", "admin1": "Western Cape", "pop": "188580" },
  { "id": 1849892, "name": "Tottori-shi", "country": "JP", "admin1": "Tottori", "pop": "188465" },
  { "id": 3118594, "name": "Leganés", "country": "ES", "admin1": "Madrid", "pop": "188425" },
  { "id": 3649833, "name": "Acarigua", "country": "VE", "admin1": "Portuguesa", "pop": "188278" },
  {
    "id": 334609,
    "name": "Hosa’ina",
    "country": "ET",
    "admin1": "Central Ethiopia Regional State",
    "pop": "188200"
  },
  { "id": 7026886, "name": "Sai Mai", "country": "TH", "admin1": "Bangkok", "pop": "188123" },
  { "id": 1285693, "name": "Yawnghwe", "country": "MM", "admin1": "Shan State", "pop": "188083" },
  {
    "id": 1704703,
    "name": "Mabalacat City",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "188050"
  },
  {
    "id": 3670745,
    "name": "Riohacha",
    "country": "CO",
    "admin1": "La Guajira Department",
    "pop": "188014"
  },
  {
    "id": 3450404,
    "name": "Santa Bárbara d'Oeste",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "188000"
  },
  { "id": 1804578, "name": "Laizhou", "country": "CN", "admin1": "Shandong", "pop": "188000" },
  {
    "id": 3451138,
    "name": "Rio Grande",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "187838"
  },
  { "id": 4694482, "name": "Grand Prairie", "country": "US", "admin1": "Texas", "pop": "187809" },
  { "id": 1685755, "name": "Sorsogon", "country": "PH", "admin1": "Bicol Region", "pop": "187670" },
  {
    "id": 10374934,
    "name": "Ait Melloul",
    "country": "MA",
    "admin1": "Souss-Massa",
    "pop": "187652"
  },
  { "id": 2636503, "name": "Sutton", "country": "GB", "admin1": "England", "pop": "187600" },
  { "id": 4341513, "name": "Shreveport", "country": "US", "admin1": "Louisiana", "pop": "187593" },
  { "id": 3121437, "name": "Getafe", "country": "ES", "admin1": "Madrid", "pop": "187525" },
  {
    "id": 9645073,
    "name": "Quận Năm",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "187510"
  },
  { "id": 1275778, "name": "Bhusawal", "country": "IN", "admin1": "Maharashtra", "pop": "187421" },
  {
    "id": 3454865,
    "name": "Alvorada",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "187315"
  },
  { "id": 3530870, "name": "Chilpancingo", "country": "MX", "admin1": "Guerrero", "pop": "187251" },
  {
    "id": 3468376,
    "name": "Cachoeiro de Itapemirim",
    "country": "BR",
    "admin1": "Espírito Santo",
    "pop": "187019"
  },
  {
    "id": 3544091,
    "name": "Pinar del Río",
    "country": "CU",
    "admin1": "Pinar del Río",
    "pop": "186990"
  },
  { "id": 8416933, "name": "Huixing", "country": "CN", "admin1": "Chongqing", "pop": "186972" },
  { "id": 307654, "name": "Kırıkkale", "country": "TR", "admin1": "Kırıkkale", "pop": "186960" },
  { "id": 615532, "name": "Batumi", "country": "GE", "admin1": "Adjara", "pop": "186949" },
  { "id": 5911592, "name": "Burlington", "country": "CA", "admin1": "Ontario", "pop": "186948" },
  {
    "id": 1336143,
    "name": "Pābna",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "186781"
  },
  { "id": 4676740, "name": "Brownsville", "country": "US", "admin1": "Texas", "pop": "186738" },
  { "id": 1815477, "name": "Changyuan", "country": "CN", "admin1": "Chongqing", "pop": "186653" },
  {
    "id": 3564124,
    "name": "Cienfuegos",
    "country": "CU",
    "admin1": "Cienfuegos Province",
    "pop": "186644"
  },
  {
    "id": 295530,
    "name": "Beersheba",
    "country": "IL",
    "admin1": "Southern District",
    "pop": "186600"
  },
  { "id": 2497411, "name": "El Oued", "country": "DZ", "admin1": "El Oued", "pop": "186525" },
  { "id": 4276873, "name": "Overland Park", "country": "US", "admin1": "Kansas", "pop": "186515" },
  {
    "id": 1259064,
    "name": "Raebareli",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "186433"
  },
  { "id": 7910932, "name": "Shangri-La", "country": "CN", "admin1": "Yunnan", "pop": "186400" },
  { "id": 4776024, "name": "Newport News", "country": "US", "admin1": "Virginia", "pop": "186247" },
  { "id": 8417605, "name": "Yangcheng", "country": "CN", "admin1": "Chongqing", "pop": "186242" },
  { "id": 2453348, "name": "Mopti", "country": "ML", "admin1": "Mopti", "pop": "186187" },
  { "id": 248460, "name": "Khuraybat as Sūq", "country": "JO", "admin1": "Amman", "pop": "186158" },
  { "id": 2216885, "name": "Zawiya", "country": "LY", "admin1": "Az Zāwiyah", "pop": "186123" },
  { "id": 3979802, "name": "Zamora", "country": "MX", "admin1": "Michoacán", "pop": "186102" },
  { "id": 1270351, "name": "Haridwar", "country": "IN", "admin1": "Uttarakhand", "pop": "186079" },
  { "id": 380174, "name": "Ad-Damazin", "country": "SD", "admin1": "Blue Nile", "pop": "186051" },
  { "id": 1529531, "name": "Dunhuang", "country": "CN", "admin1": "Gansu", "pop": "186027" },
  { "id": 3003796, "name": "Le Havre", "country": "FR", "admin1": "Normandy", "pop": "185972" },
  { "id": 11127930, "name": "Phusro", "country": "IN", "admin1": "Jharkhand", "pop": "185555" },
  {
    "id": 3110044,
    "name": "Donostia / San Sebastián",
    "country": "ES",
    "admin1": "Basque Country",
    "pop": "185357"
  },
  {
    "id": 3521168,
    "name": "Poza Rica de Hidalgo",
    "country": "MX",
    "admin1": "Veracruz",
    "pop": "185242"
  },
  { "id": 358840, "name": "Bilbeis", "country": "EG", "admin1": "Sharqia", "pop": "185237" },
  {
    "id": 1691444,
    "name": "Roxas City",
    "country": "PH",
    "admin1": "Western Visayas",
    "pop": "185236"
  },
  { "id": 305268, "name": "Kütahya", "country": "TR", "admin1": "Kütahya", "pop": "185008" },
  { "id": 3173331, "name": "Modena", "country": "IT", "admin1": "Emilia-Romagna", "pop": "184732" },
  { "id": 750516, "name": "Bolu", "country": "TR", "admin1": "Bolu", "pop": "184682" },
  { "id": 1849845, "name": "Toyokawa", "country": "JP", "admin1": "Aichi", "pop": "184661" },
  { "id": 1279335, "name": "Adoni", "country": "IN", "admin1": "Andhra Pradesh", "pop": "184625" },
  { "id": 1861107, "name": "Izumi", "country": "JP", "admin1": "Osaka", "pop": "184615" },
  {
    "id": 12157007,
    "name": "Santa Anita - Los Ficus",
    "country": "PE",
    "admin1": "Lima region",
    "pop": "184614"
  },
  { "id": 1785462, "name": "Zaoyang", "country": "CN", "admin1": "Hubei", "pop": "184509" },
  { "id": 9827976, "name": "Paltan", "country": "BD", "admin1": "Dhaka Division", "pop": "184492" },
  { "id": 1963770, "name": "Padalarang", "country": "ID", "admin1": "West Java", "pop": "184182" },
  {
    "id": 1512236,
    "name": "Abakan",
    "country": "RU",
    "admin1": "Khakasiya Republic",
    "pop": "184168"
  },
  { "id": 1631648, "name": "Pemalang", "country": "ID", "admin1": "Central Java", "pop": "184149" },
  { "id": 2758401, "name": "Breda", "country": "NL", "admin1": "North Brabant", "pop": "184126" },
  {
    "id": 1562773,
    "name": "Vĩnh Châu",
    "country": "VN",
    "admin1": "Can Tho City",
    "pop": "183918"
  },
  { "id": 1182092, "name": "Burewala", "country": "PK", "admin1": "Punjab", "pop": "183915" },
  { "id": 2038584, "name": "Baishan", "country": "CN", "admin1": "Jilin", "pop": "183880" },
  { "id": 1255560, "name": "Sūjāngarh", "country": "IN", "admin1": "Rajasthan", "pop": "183808" },
  { "id": 11611487, "name": "Tachikawa", "country": "JP", "admin1": "Tokyo", "pop": "183581" },
  {
    "id": 8555643,
    "name": "Cergy-Pontoise",
    "country": "FR",
    "admin1": "Île-de-France",
    "pop": "183430"
  },
  {
    "id": 101732,
    "name": "Unaizah",
    "country": "SA",
    "admin1": "Al-Qassim Region",
    "pop": "183319"
  },
  { "id": 4076598, "name": "Mobile", "country": "US", "admin1": "Alabama", "pop": "183289" },
  { "id": 2638785, "name": "St Helens", "country": "GB", "admin1": "England", "pop": "183200" },
  {
    "id": 1213547,
    "name": "Tanjungbalai",
    "country": "ID",
    "admin1": "North Sumatra",
    "pop": "183170"
  },
  {
    "id": 4155966,
    "name": "Fort Lauderdale",
    "country": "US",
    "admin1": "Florida",
    "pop": "183146"
  },
  { "id": 1638063, "name": "Lembang", "country": "ID", "admin1": "West Java", "pop": "183130" },
  { "id": 671768, "name": "Oradea", "country": "RO", "admin1": "Bihor County", "pop": "183105" },
  { "id": 160892, "name": "Bunda", "country": "TZ", "admin1": "Mara", "pop": "182970" },
  { "id": 2479536, "name": "Skikda", "country": "DZ", "admin1": "Skikda", "pop": "182903" },
  { "id": 124082, "name": "Mīāneh", "country": "IR", "admin1": "East Azerbaijan", "pop": "182848" },
  {
    "id": 1215957,
    "name": "Tirmiz",
    "country": "UZ",
    "admin1": "Surxondaryo Region",
    "pop": "182800"
  },
  {
    "id": 3460102,
    "name": "Jaraguá do Sul",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "182660"
  },
  { "id": 3644918, "name": "Cúa", "country": "VE", "admin1": "Miranda", "pop": "182558" },
  { "id": 1256052, "name": "Sirsa", "country": "IN", "admin1": "Haryana", "pop": "182534" },
  {
    "id": 1504826,
    "name": "Kamensk-Ural’skiy",
    "country": "RU",
    "admin1": "Sverdlovsk Oblast",
    "pop": "182500"
  },
  {
    "id": 2523630,
    "name": "Reggio Calabria",
    "country": "IT",
    "admin1": "Calabria",
    "pop": "182455"
  },
  {
    "id": 13156932,
    "name": "Dinapur Nizamat",
    "country": "IN",
    "admin1": "Bihar",
    "pop": "182429"
  },
  {
    "id": 5393049,
    "name": "Santa Clarita",
    "country": "US",
    "admin1": "California",
    "pop": "182371"
  },
  { "id": 1014073, "name": "Carletonville", "country": "ZA", "admin1": "Gauteng", "pop": "182304" },
  { "id": 2421535, "name": "Dubréka", "country": "GN", "admin1": "Kindia", "pop": "182296" },
  { "id": 359280, "name": "Banhā", "country": "EG", "admin1": "Qalyubia", "pop": "182254" },
  {
    "id": 1277799,
    "name": "Bahraigh",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "182218"
  },
  { "id": 2852458, "name": "Potsdam", "country": "DE", "admin1": "Brandenburg", "pop": "182112" },
  {
    "id": 1818483,
    "name": "Tsing Yi Town",
    "country": "HK",
    "admin1": "Kwai Tsing District",
    "pop": "182100"
  },
  { "id": 3461879, "name": "Guarapuava", "country": "BR", "admin1": "Paraná", "pop": "182093" },
  { "id": 1308522, "name": "Monywa", "country": "MM", "admin1": "Sagaing Region", "pop": "182011" },
  { "id": 1267885, "name": "Kāraikkudi", "country": "IN", "admin1": "Tamil Nadu", "pop": "181851" },
  { "id": 3649017, "name": "Araure", "country": "VE", "admin1": "Portuguesa", "pop": "181820" },
  {
    "id": 13157013,
    "name": "Sultan Pur Majra",
    "country": "IN",
    "admin1": "Delhi",
    "pop": "181554"
  },
  {
    "id": 1784617,
    "name": "Zhenping Chengguanzhen",
    "country": "CN",
    "admin1": "Henan",
    "pop": "181528"
  },
  { "id": 2038650, "name": "Anda", "country": "CN", "admin1": "Heilongjiang", "pop": "181271" },
  {
    "id": 2122104,
    "name": "Petropavlovsk-Kamchatsky",
    "country": "RU",
    "admin1": "Kamchatka",
    "pop": "181216"
  },
  { "id": 246013, "name": "Wādī as Sīr", "country": "JO", "admin1": "Amman", "pop": "181212" },
  { "id": 4612862, "name": "Chattanooga", "country": "US", "admin1": "Tennessee", "pop": "181099" },
  { "id": 1270711, "name": "Guna", "country": "IN", "admin1": "Madhya Pradesh", "pop": "180935" },
  { "id": 2615876, "name": "Odense", "country": "DK", "admin1": "South Denmark", "pop": "180863" },
  { "id": 2146142, "name": "Townsville", "country": "AU", "admin1": "Queensland", "pop": "180820" },
  { "id": 1626899, "name": "Singosari", "country": "ID", "admin1": "East Java", "pop": "180740" },
  { "id": 3906194, "name": "Sacaba", "country": "BO", "admin1": "Cochabamba", "pop": "180726" },
  {
    "id": 3590979,
    "name": "Quetzaltenango",
    "country": "GT",
    "admin1": "Quetzaltenango",
    "pop": "180706"
  },
  {
    "id": 1212405,
    "name": "Āshuganj City",
    "country": "BD",
    "admin1": "Chittagong",
    "pop": "180654"
  },
  {
    "id": 1274784,
    "name": "Chandannagar",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "180623"
  },
  {
    "id": 1277820,
    "name": "Baharampur",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "180547"
  },
  { "id": 670474, "name": "Ploieşti", "country": "RO", "admin1": "Prahova", "pop": "180540" },
  {
    "id": 3436043,
    "name": "Berazategui",
    "country": "AR",
    "admin1": "Buenos Aires",
    "pop": "180523"
  },
  { "id": 2652053, "name": "Crawley", "country": "GB", "admin1": "England", "pop": "180508" },
  {
    "id": 12501195,
    "name": "Shahuwadi",
    "country": "IN",
    "admin1": "Maharashtra",
    "pop": "180322"
  },
  {
    "id": 1264621,
    "name": "Madanapalle",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "180180"
  },
  {
    "id": 1336144,
    "name": "Tāngāil",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "180144"
  },
  { "id": 1668875, "name": "Shulin", "country": "TW", "admin1": "Taipei", "pop": "180044" },
  { "id": 747712, "name": "Edirne", "country": "TR", "admin1": "Edirne", "pop": "180002" },
  {
    "id": 12492669,
    "name": "Pingwu County",
    "country": "CN",
    "admin1": "Sichuan",
    "pop": "180000"
  },
  { "id": 6087029, "name": "Nepean", "country": "CA", "admin1": "Ontario", "pop": "180000" },
  { "id": 1570656, "name": "Phúc Yên", "country": "VN", "admin1": "Phu Tho", "pop": "180000" },
  { "id": 1316752, "name": "Kyaukpyu", "country": "MM", "admin1": "Rakhine", "pop": "180000" },
  {
    "id": 1256451,
    "name": "Shivpuri",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "179977"
  },
  { "id": 1832847, "name": "Yangju", "country": "KR", "admin1": "Gyeonggi-do", "pop": "179923" },
  {
    "id": 6545348,
    "name": "Praga Południe",
    "country": "PL",
    "admin1": "Mazovia",
    "pop": "179836"
  },
  {
    "id": 912764,
    "name": "Kasama",
    "country": "ZM",
    "admin1": "Northern Province",
    "pop": "179636"
  },
  { "id": 1255349, "name": "Surendranagar", "country": "IN", "admin1": "Gujarat", "pop": "179628" },
  { "id": 2296606, "name": "Obuase", "country": "GH", "admin1": "Ashanti", "pop": "179604" },
  { "id": 112214, "name": "Varāmīn", "country": "IR", "admin1": "Tehran", "pop": "179603" },
  {
    "id": 3454857,
    "name": "Passo Fundo",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "179529"
  },
  { "id": 1706889, "name": "Legaspi", "country": "PH", "admin1": "Bicol Region", "pop": "179481" },
  { "id": 12253704, "name": "Phú Quốc", "country": "VN", "admin1": "An Giang", "pop": "179480" },
  { "id": 508101, "name": "Podolsk", "country": "RU", "admin1": "Moscow Oblast", "pop": "179400" },
  { "id": 2842647, "name": "Saarbrücken", "country": "DE", "admin1": "Saarland", "pop": "179349" },
  { "id": 1630341, "name": "Purwakarta", "country": "ID", "admin1": "West Java", "pop": "179233" },
  { "id": 1513886, "name": "Jizzax", "country": "UZ", "admin1": "Jizzakh Region", "pop": "179200" },
  {
    "id": 3463422,
    "name": "Ferraz de Vasconcelos",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "179198"
  },
  {
    "id": 2337765,
    "name": "Ila Orangun",
    "country": "NG",
    "admin1": "Osun State",
    "pop": "179192"
  },
  { "id": 1261473, "name": "Neyveli", "country": "IN", "admin1": "Tamil Nadu", "pop": "179150" },
  {
    "id": 3472177,
    "name": "Angra dos Reis",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "179120"
  },
  { "id": 1786067, "name": "Qianjiang", "country": "CN", "admin1": "Hubei", "pop": "179079" },
  {
    "id": 2911240,
    "name": "Hamm",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "178967"
  },
  { "id": 1606250, "name": "Si Racha", "country": "TH", "admin1": "Chon Buri", "pop": "178916" },
  { "id": 2476897, "name": "Tiaret", "country": "DZ", "admin1": "Tiaret", "pop": "178915" },
  { "id": 3848950, "name": "La Rioja", "country": "AR", "admin1": "La Rioja", "pop": "178872" },
  { "id": 1256287, "name": "Silchar", "country": "IN", "admin1": "Assam", "pop": "178865" },
  { "id": 2271772, "name": "Amadora", "country": "PT", "admin1": "Lisbon", "pop": "178858" },
  { "id": 3529986, "name": "Cuautitlán", "country": "MX", "admin1": "México", "pop": "178847" },
  { "id": 2646057, "name": "Ipswich", "country": "GB", "admin1": "England", "pop": "178835" },
  { "id": 227812, "name": "Njeru", "country": "UG", "admin1": "Central Region", "pop": "178800" },
  {
    "id": 1055429,
    "name": "Toliara",
    "country": "MG",
    "admin1": "Atsimo-Andrefana",
    "pop": "178725"
  },
  { "id": 2323390, "name": "Saki", "country": "NG", "admin1": "Oyo State", "pop": "178677" },
  { "id": 2498611, "name": "Chlef", "country": "DZ", "admin1": "Chlef", "pop": "178616" },
  { "id": 3558729, "name": "Fontanar", "country": "CU", "admin1": "Havana", "pop": "178601" },
  { "id": 6621166, "name": "Seogwipo", "country": "KR", "admin1": "Jeju-do", "pop": "178552" },
  {
    "id": 1716995,
    "name": "Concepcion",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "178549"
  },
  { "id": 5512909, "name": "Spring Valley", "country": "US", "admin1": "Nevada", "pop": "178395" },
  { "id": 1635283, "name": "Metro", "country": "ID", "admin1": "Lampung", "pop": "178381" },
  {
    "id": 910111,
    "name": "Livingstone",
    "country": "ZM",
    "admin1": "Southern Province",
    "pop": "178361"
  },
  {
    "id": 964349,
    "name": "Potchefstroom",
    "country": "ZA",
    "admin1": "North West",
    "pop": "178285"
  },
  { "id": 5393287, "name": "Santa Rosa", "country": "US", "admin1": "California", "pop": "178127" },
  {
    "id": 1259312,
    "name": "Proddatūr",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "177797"
  },
  { "id": 1295765, "name": "Sittwe", "country": "MM", "admin1": "Rakhine", "pop": "177743" },
  { "id": 145757, "name": "Dundo", "country": "AO", "admin1": "Luanda Norte", "pop": "177604" },
  { "id": 2661604, "name": "Basel", "country": "CH", "admin1": "Basel-City", "pop": "177595" },
  {
    "id": 1309793,
    "name": "Meiktila",
    "country": "MM",
    "admin1": "Mandalay Region",
    "pop": "177442"
  },
  { "id": 233346, "name": "Gulu", "country": "UG", "admin1": "Northern Region", "pop": "177400" },
  { "id": 2750053, "name": "Nijmegen", "country": "NL", "admin1": "Gelderland", "pop": "177359" },
  { "id": 584821, "name": "Tovuz", "country": "AZ", "admin1": "Tovuz District", "pop": "177200" },
  { "id": 355628, "name": "Idkū", "country": "EG", "admin1": "Beheira", "pop": "177152" },
  { "id": 2666199, "name": "Uppsala", "country": "SE", "admin1": "Uppsala", "pop": "177074" },
  { "id": 1269910, "name": "Hugli", "country": "IN", "admin1": "West Bengal", "pop": "177005" },
  { "id": 10263066, "name": "Hashtsāl", "country": "IN", "admin1": "Delhi", "pop": "176877" },
  {
    "id": 3469092,
    "name": "Bragança Paulista",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "176811"
  },
  {
    "id": 3446606,
    "name": "Teresópolis",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "176692"
  },
  {
    "id": 3985604,
    "name": "San Luis Río Colorado",
    "country": "MX",
    "admin1": "Sonora",
    "pop": "176685"
  },
  {
    "id": 3583334,
    "name": "Santa Ana",
    "country": "SV",
    "admin1": "Santa Ana Department",
    "pop": "176661"
  },
  { "id": 5725846, "name": "Eugene", "country": "US", "admin1": "Oregon", "pop": "176654" },
  { "id": 2541479, "name": "Nador", "country": "MA", "admin1": "Oriental", "pop": "176600" },
  {
    "id": 125185,
    "name": "Malāyer",
    "country": "IR",
    "admin1": "Hamadan Province",
    "pop": "176573"
  },
  { "id": 3103402, "name": "Bielsko-Biala", "country": "PL", "admin1": "Silesia", "pop": "176515" },
  { "id": 352733, "name": "Marsá Maţrūḩ", "country": "EG", "admin1": "Matruh", "pop": "176498" },
  { "id": 2759879, "name": "Almere Stad", "country": "NL", "admin1": "Flevoland", "pop": "176432" },
  {
    "id": 3127461,
    "name": "Burgos",
    "country": "ES",
    "admin1": "Castille and León",
    "pop": "176418"
  },
  { "id": 1842966, "name": "Gijang", "country": "KR", "admin1": "Busan", "pop": "176388" },
  {
    "id": 2980291,
    "name": "Saint-Étienne",
    "country": "FR",
    "admin1": "Rhône-Alpes",
    "pop": "176280"
  },
  { "id": 1278708, "name": "Amroha", "country": "IN", "admin1": "Uttar Pradesh", "pop": "176253" },
  { "id": 11612347, "name": "Narashino", "country": "JP", "admin1": "Chiba", "pop": "176197" },
  { "id": 2505329, "name": "Béjaïa", "country": "DZ", "admin1": "Béjaïa", "pop": "176139" },
  { "id": 1784580, "name": "Zhenzhou", "country": "CN", "admin1": "Jiangsu", "pop": "176006" },
  { "id": 5317058, "name": "Tempe", "country": "US", "admin1": "Arizona", "pop": "175826" },
  { "id": 1789137, "name": "Xindi", "country": "CN", "admin1": "Hubei", "pop": "175761" },
  { "id": 5378771, "name": "Oceanside", "country": "US", "admin1": "California", "pop": "175691" },
  { "id": 8416626, "name": "Fengcheng", "country": "CN", "admin1": "Chongqing", "pop": "175576" },
  { "id": 5750162, "name": "Salem", "country": "US", "admin1": "Oregon", "pop": "175535" },
  { "id": 116667, "name": "Sāveh", "country": "IR", "admin1": "Markazi", "pop": "175533" },
  { "id": 2633948, "name": "Wigan", "country": "GB", "admin1": "England", "pop": "175405" },
  {
    "id": 5351515,
    "name": "Garden Grove",
    "country": "US",
    "admin1": "California",
    "pop": "175393"
  },
  { "id": 309527, "name": "Karaman", "country": "TR", "admin1": "Karaman", "pop": "175390" },
  { "id": 6094578, "name": "Oshawa", "country": "CA", "admin1": "Ontario", "pop": "175383" },
  { "id": 126972, "name": "Khowy", "country": "IR", "admin1": "West Azerbaijan", "pop": "175370" },
  { "id": 300614, "name": "Siverek", "country": "TR", "admin1": "Şanlıurfa", "pop": "175341" },
  {
    "id": 3455478,
    "name": "Palhoça",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "175272"
  },
  {
    "id": 5385955,
    "name": "Rancho Cucamonga",
    "country": "US",
    "admin1": "California",
    "pop": "175236"
  },
  { "id": 4149962, "name": "Cape Coral", "country": "US", "admin1": "Florida", "pop": "175229" },
  { "id": 1567032, "name": "Tân Châu", "country": "VN", "admin1": "An Giang", "pop": "175211" },
  { "id": 2036401, "name": "Jiutai", "country": "CN", "admin1": "Jilin", "pop": "175115" },
  {
    "id": 1274304,
    "name": "Chhindwāra",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "175052"
  },
  { "id": 1698829, "name": "Naga", "country": "PH", "admin1": "Bicol Region", "pop": "174931" },
  { "id": 2127733, "name": "Tomakomai", "country": "JP", "admin1": "Hokkaido", "pop": "174806" },
  { "id": 1255062, "name": "Tambaram", "country": "IN", "admin1": "Tamil Nadu", "pop": "174787" },
  {
    "id": 3985344,
    "name": "San Miguel de Allende",
    "country": "MX",
    "admin1": "Guanajuato",
    "pop": "174615"
  },
  { "id": 1647142, "name": "Cianjur", "country": "ID", "admin1": "West Java", "pop": "174587" },
  { "id": 1632937, "name": "Pamulang", "country": "ID", "admin1": "West Java", "pop": "174557" },
  { "id": 2112708, "name": "Hitachi", "country": "JP", "admin1": "Ibaraki", "pop": "174508" },
  { "id": 3386361, "name": "Timon", "country": "BR", "admin1": "Maranhão", "pop": "174465" },
  { "id": 1275984, "name": "Bhetia", "country": "IN", "admin1": "Jharkhand", "pop": "174355" },
  { "id": 2410048, "name": "Bo", "country": "SL", "admin1": "Southern Province", "pop": "174354" },
  { "id": 1260137, "name": "Pathānkot", "country": "IN", "admin1": "Punjab", "pop": "174306" },
  { "id": 1277976, "name": "Badlapur", "country": "IN", "admin1": "Maharashtra", "pop": "174226" },
  { "id": 1985663, "name": "Cikupa", "country": "ID", "admin1": "West Java", "pop": "174041" },
  {
    "id": 3629706,
    "name": "Puerto Cabello",
    "country": "VE",
    "admin1": "Carabobo",
    "pop": "174000"
  },
  { "id": 2111220, "name": "Sakura", "country": "JP", "admin1": "Chiba", "pop": "173740" },
  { "id": 1849498, "name": "Ube", "country": "JP", "admin1": "Yamaguchi", "pop": "173733" },
  { "id": 3658501, "name": "Daule", "country": "EC", "admin1": "Guayas", "pop": "173684" },
  { "id": 1273802, "name": "Cuddalore", "country": "IN", "admin1": "Tamil Nadu", "pop": "173636" },
  { "id": 3109718, "name": "Santander", "country": "ES", "admin1": "Cantabria", "pop": "173635" },
  { "id": 2475687, "name": "Tlemcen", "country": "DZ", "admin1": "Tlemcen", "pop": "173531" },
  {
    "id": 1256237,
    "name": "Shimla",
    "country": "IN",
    "admin1": "Himachal Pradesh",
    "pop": "173503"
  },
  { "id": 417472, "name": "Shāhīn Shahr", "country": "IR", "admin1": "Isfahan", "pop": "173329" },
  { "id": 2651817, "name": "Croydon", "country": "GB", "admin1": "England", "pop": "173314" },
  {
    "id": 1309611,
    "name": "Myeik",
    "country": "MM",
    "admin1": "Tanintharyi Region",
    "pop": "173298"
  },
  { "id": 281124, "name": "Khān Yūnis", "country": "PS", "admin1": "Gaza Strip", "pop": "173183" },
  { "id": 1283460, "name": "Dharān", "country": "NP", "admin1": "Koshi", "pop": "173096" },
  {
    "id": 2522258,
    "name": "Albacete",
    "country": "ES",
    "admin1": "Castille-La Mancha",
    "pop": "173050"
  },
  { "id": 2310046, "name": "Bata", "country": "GQ", "admin1": "Litoral", "pop": "173046" },
  { "id": 1860672, "name": "Kamakura", "country": "JP", "admin1": "Kanagawa", "pop": "172929" },
  { "id": 3530937, "name": "Chicoloapan", "country": "MX", "admin1": "México", "pop": "172919" },
  {
    "id": 8740017,
    "name": "Gadag-Betageri",
    "country": "IN",
    "admin1": "Karnataka",
    "pop": "172813"
  },
  { "id": 1861084, "name": "Izumo", "country": "JP", "admin1": "Shimane", "pop": "172775" },
  { "id": 1803791, "name": "Licheng", "country": "CN", "admin1": "Guangdong", "pop": "172775" },
  { "id": 1271850, "name": "Gadag", "country": "IN", "admin1": "Karnataka", "pop": "172612" },
  {
    "id": 189723,
    "name": "Ongata Rongai",
    "country": "KE",
    "admin1": "Kajiado County",
    "pop": "172569"
  },
  { "id": 3666608, "name": "Tunja", "country": "CO", "admin1": "Boyacá", "pop": "172548" },
  {
    "id": 3906791,
    "name": "Quillacollo",
    "country": "BO",
    "admin1": "Cochabamba",
    "pop": "172405"
  },
  { "id": 3130564, "name": "Alcorcón", "country": "ES", "admin1": "Madrid", "pop": "172384" },
  {
    "id": 202905,
    "name": "Gisenyi",
    "country": "RW",
    "admin1": "Western Province",
    "pop": "172357"
  },
  { "id": 311073, "name": "Isparta", "country": "TR", "admin1": "Isparta", "pop": "172334" },
  { "id": 2634739, "name": "Warrington", "country": "GB", "admin1": "England", "pop": "172330" },
  {
    "id": 598098,
    "name": "Klaipėda",
    "country": "LT",
    "admin1": "Klaipėda County",
    "pop": "172292"
  },
  { "id": 2634853, "name": "Walsall", "country": "GB", "admin1": "England", "pop": "172141" },
  {
    "id": 2905891,
    "name": "Herne",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "172108"
  },
  { "id": 2643097, "name": "Mansfield", "country": "GB", "admin1": "England", "pop": "171958" },
  {
    "id": 3169522,
    "name": "Reggio nell'Emilia",
    "country": "IT",
    "admin1": "Emilia-Romagna",
    "pop": "171944"
  },
  {
    "id": 2519752,
    "name": "Castelló de la Plana",
    "country": "ES",
    "admin1": "Valencia",
    "pop": "171857"
  },
  { "id": 763166, "name": "Olsztyn", "country": "PL", "admin1": "Warmia-Masuria", "pop": "171803" },
  { "id": 1319364, "name": "Kēng Tung", "country": "MM", "admin1": "Shan State", "pop": "171620" },
  {
    "id": 5231851,
    "name": "Sioux Falls",
    "country": "US",
    "admin1": "South Dakota",
    "pop": "171544"
  },
  { "id": 786712, "name": "Prizren", "country": "XK", "admin1": "Prizren", "pop": "171464" },
  { "id": 2037620, "name": "Dongling", "country": "CN", "admin1": "Liaoning", "pop": "171454" },
  { "id": 1622636, "name": "Ungaran", "country": "ID", "admin1": "Central Java", "pop": "171378" },
  { "id": 1849186, "name": "Urayasu", "country": "JP", "admin1": "Chiba", "pop": "171362" },
  { "id": 630429, "name": "Baranovichi", "country": "BY", "admin1": "Brest", "pop": "171361" },
  { "id": 9075789, "name": "Long Khánh", "country": "VN", "admin1": "Dong Nai", "pop": "171276" },
  { "id": 1716198, "name": "Dagupan", "country": "PH", "admin1": "Ilocos", "pop": "171271" },
  { "id": 5379439, "name": "Ontario", "country": "US", "admin1": "California", "pop": "171214" },
  { "id": 7027003, "name": "Watthana", "country": "TH", "admin1": "Bangkok", "pop": "171150" },
  { "id": 1253237, "name": "Verāval", "country": "IN", "admin1": "Gujarat", "pop": "171121" },
  { "id": 1261653, "name": "Navsari", "country": "IN", "admin1": "Gujarat", "pop": "171109" },
  { "id": 1926134, "name": "Imabari", "country": "JP", "admin1": "Ehime", "pop": "170986" },
  { "id": 907770, "name": "Mansa", "country": "ZM", "admin1": "Luapula Province", "pop": "170965" },
  { "id": 5577147, "name": "Fort Collins", "country": "US", "admin1": "Colorado", "pop": "170924" },
  {
    "id": 2867838,
    "name": "Mülheim",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "170921"
  },
  { "id": 1588275, "name": "Bảo Lộc", "country": "VN", "admin1": "Lam Dong", "pop": "170920" },
  { "id": 1734393, "name": "Kulim", "country": "MY", "admin1": "Kedah", "pop": "170889" },
  { "id": 2325592, "name": "Oshodi", "country": "NG", "admin1": "Lagos", "pop": "170870" },
  { "id": 293788, "name": "Ramat Gan", "country": "IL", "admin1": "Tel Aviv", "pop": "170822" },
  { "id": 1277835, "name": "Bahadurgarh", "country": "IN", "admin1": "Haryana", "pop": "170767" },
  { "id": 1344377, "name": "Haldia", "country": "IN", "admin1": "West Bengal", "pop": "170695" },
  { "id": 1518262, "name": "Temirtau", "country": "KZ", "admin1": "Karaganda", "pop": "170600" },
  { "id": 3461563, "name": "Ibirité", "country": "BR", "admin1": "Minas Gerais", "pop": "170537" },
  { "id": 4563243, "name": "Carolina", "country": "PR", "admin1": "Carolina", "pop": "170404" },
  { "id": 1259009, "name": "Rāiganj", "country": "IN", "admin1": "West Bengal", "pop": "170252" },
  { "id": 4409896, "name": "Springfield", "country": "US", "admin1": "Missouri", "pop": "170188" },
  { "id": 2636531, "name": "Sunderland", "country": "GB", "admin1": "England", "pop": "170134" },
  { "id": 1851032, "name": "Takaoka", "country": "JP", "admin1": "Toyama", "pop": "170077" },
  { "id": 1269723, "name": "Malda", "country": "IN", "admin1": "West Bengal", "pop": "170039" },
  { "id": 4005509, "name": "Guadalupe", "country": "MX", "admin1": "Zacatecas", "pop": "170029" },
  { "id": 3471859, "name": "Araçatuba", "country": "BR", "admin1": "São Paulo", "pop": "170024" },
  { "id": 1855189, "name": "Nishio", "country": "JP", "admin1": "Aichi", "pop": "169984" },
  { "id": 3837056, "name": "San Luis", "country": "AR", "admin1": "San Luis", "pop": "169947" },
  { "id": 2485801, "name": "Ouargla", "country": "DZ", "admin1": "Ouargla", "pop": "169928" },
  { "id": 922806, "name": "Kipushi", "country": "CD", "admin1": "Haut-Katanga", "pop": "169635" },
  {
    "id": 1818223,
    "name": "Yuen Long Kau Hui",
    "country": "HK",
    "admin1": "Yuen Long",
    "pop": "169600"
  },
  { "id": 1804586, "name": "Laiyang", "country": "CN", "admin1": "Shandong", "pop": "169594" },
  { "id": 1269135, "name": "Jaunpur", "country": "IN", "admin1": "Uttar Pradesh", "pop": "169572" },
  {
    "id": 13494069,
    "name": "Khlong Sam Wa",
    "country": "TH",
    "admin1": "Bangkok",
    "pop": "169489"
  },
  { "id": 13353695, "name": "Chūō", "country": "JP", "admin1": "Tokyo", "pop": "169179" },
  { "id": 905395, "name": "Mufulira", "country": "ZM", "admin1": "Copperbelt", "pop": "169136" },
  { "id": 10263232, "name": "Deoli", "country": "IN", "admin1": "Delhi", "pop": "169122" },
  {
    "id": 1242833,
    "name": "Jaffna",
    "country": "LK",
    "admin1": "Northern Province",
    "pop": "169102"
  },
  { "id": 686254, "name": "Arad", "country": "RO", "admin1": "Arad County", "pop": "169065" },
  { "id": 3531023, "name": "Chetumal", "country": "MX", "admin1": "Quintana Roo", "pop": "169028" },
  { "id": 1276100, "name": "Bharūch", "country": "IN", "admin1": "Gujarat", "pop": "169007" },
  {
    "id": 1045512,
    "name": "Gurúè",
    "country": "MZ",
    "admin1": "Zambezia Province",
    "pop": "168971"
  },
  {
    "id": 7645166,
    "name": "San Miguel",
    "country": "AR",
    "admin1": "Buenos Aires",
    "pop": "168762"
  },
  { "id": 2130057, "name": "Hirosaki", "country": "JP", "admin1": "Aomori", "pop": "168739" },
  { "id": 3068160, "name": "Pilsen", "country": "CZ", "admin1": "Plzeň Region", "pop": "168733" },
  { "id": 3531200, "name": "Chalco", "country": "MX", "admin1": "México", "pop": "168720" },
  {
    "id": 2972328,
    "name": "Toulon",
    "country": "FR",
    "admin1": "Provence-Alpes-Côte d'Azur",
    "pop": "168701"
  },
  { "id": 1269937, "name": "Hoshiārpur", "country": "IN", "admin1": "Punjab", "pop": "168653" },
  {
    "id": 3453303,
    "name": "Poços de Caldas",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "168641"
  },
  { "id": 3647444, "name": "Calabozo", "country": "VE", "admin1": "Guárico", "pop": "168605" },
  { "id": 281129, "name": "Jabālyā", "country": "PS", "admin1": "Gaza Strip", "pop": "168568" },
  { "id": 4012406, "name": "Cuauhtémoc", "country": "MX", "admin1": "Chihuahua", "pop": "168482" },
  { "id": 3471766, "name": "Araraquara", "country": "BR", "admin1": "São Paulo", "pop": "168468" },
  {
    "id": 3665688,
    "name": "Yopal",
    "country": "CO",
    "admin1": "Casanare Department",
    "pop": "168433"
  },
  { "id": 3433360, "name": "Ituzaingó", "country": "AR", "admin1": "Corrientes", "pop": "168419" },
  { "id": 3682426, "name": "Florencia", "country": "CO", "admin1": "Caquetá", "pop": "168346" },
  { "id": 3452640, "name": "Porto Seguro", "country": "BR", "admin1": "Bahia", "pop": "168326" },
  { "id": 1566566, "name": "Tây Hồ", "country": "VN", "admin1": "Hanoi", "pop": "168300" },
  {
    "id": 1234633,
    "name": "Moratuwa",
    "country": "LK",
    "admin1": "Western Province",
    "pop": "168280"
  },
  {
    "id": 3037656,
    "name": "Angers",
    "country": "FR",
    "admin1": "Pays de la Loire",
    "pop": "168279"
  },
  { "id": 2646277, "name": "Ilford", "country": "GB", "admin1": "England", "pop": "168168" },
  {
    "id": 3451205,
    "name": "Rio das Ostras",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "168099"
  },
  { "id": 255683, "name": "Pátra", "country": "GR", "admin1": "West Greece", "pop": "168034" },
  { "id": 1582436, "name": "Đồng Xoài", "country": "VN", "admin1": "Dong Nai", "pop": "168000" },
  {
    "id": 1185106,
    "name": "Jamālpur",
    "country": "BD",
    "admin1": "Mymensingh Division",
    "pop": "167900"
  },
  { "id": 2129376, "name": "Kushiro", "country": "JP", "admin1": "Hokkaido", "pop": "167875" },
  { "id": 577206, "name": "Berezniki", "country": "RU", "admin1": "Perm Krai", "pop": "167748" },
  { "id": 2348773, "name": "Awka", "country": "NG", "admin1": "Anambra", "pop": "167738" },
  { "id": 472761, "name": "Volgodonsk", "country": "RU", "admin1": "Rostov", "pop": "167731" },
  { "id": 1853483, "name": "Oyama", "country": "JP", "admin1": "Tochigi", "pop": "167647" },
  {
    "id": 2338385,
    "name": "Ijero-Ekiti",
    "country": "NG",
    "admin1": "Ekiti State",
    "pop": "167632"
  },
  { "id": 1268907, "name": "Jīnd", "country": "IN", "admin1": "Haryana", "pop": "167592" },
  { "id": 1498894, "name": "Miass", "country": "RU", "admin1": "Chelyabinsk", "pop": "167500" },
  {
    "id": 1680932,
    "name": "Tuguegarao",
    "country": "PH",
    "admin1": "Cagayan Valley",
    "pop": "167297"
  },
  { "id": 3646382, "name": "Carúpano", "country": "VE", "admin1": "Sucre", "pop": "167187" },
  { "id": 1265683, "name": "Kumbakonam", "country": "IN", "admin1": "Tamil Nadu", "pop": "167155" },
  { "id": 1630997, "name": "Plumbon", "country": "ID", "admin1": "West Java", "pop": "167105" },
  { "id": 518970, "name": "Novocherkassk", "country": "RU", "admin1": "Rostov", "pop": "166974" },
  { "id": 5346111, "name": "Elk Grove", "country": "US", "admin1": "California", "pop": "166913" },
  { "id": 6992326, "name": "Mohali", "country": "IN", "admin1": "Punjab", "pop": "166864" },
  {
    "id": 3458498,
    "name": "Linhares",
    "country": "BR",
    "admin1": "Espírito Santo",
    "pop": "166786"
  },
  {
    "id": 1628884,
    "name": "Sampit",
    "country": "ID",
    "admin1": "Central Kalimantan",
    "pop": "166773"
  },
  { "id": 4613868, "name": "Clarksville", "country": "US", "admin1": "Tennessee", "pop": "166722" },
  { "id": 1818379, "name": "Wan Chai", "country": "HK", "admin1": "Wan Chai", "pop": "166695" },
  {
    "id": 2694762,
    "name": "Linköping",
    "country": "SE",
    "admin1": "Östergötland",
    "pop": "166673"
  },
  { "id": 1861171, "name": "Iwata", "country": "JP", "admin1": "Shizuoka", "pop": "166672" },
  {
    "id": 4168139,
    "name": "Pembroke Pines",
    "country": "US",
    "admin1": "Florida",
    "pop": "166611"
  },
  {
    "id": 3675657,
    "name": "Maicao",
    "country": "CO",
    "admin1": "La Guajira Department",
    "pop": "166603"
  },
  { "id": 2128815, "name": "Obihiro", "country": "JP", "admin1": "Hokkaido", "pop": "166536" },
  { "id": 601734, "name": "Daşoguz", "country": "TM", "admin1": "Daşoguz", "pop": "166500" },
  {
    "id": 1271912,
    "name": "Fatehpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "166480"
  },
  {
    "id": 2856883,
    "name": "Osnabrück",
    "country": "DE",
    "admin1": "Lower Saxony",
    "pop": "166462"
  },
  { "id": 3897347, "name": "Calama", "country": "CL", "admin1": "Antofagasta", "pop": "166334" },
  {
    "id": 6941099,
    "name": "Nepalgunj",
    "country": "NP",
    "admin1": "Lumbini Province",
    "pop": "166258"
  },
  { "id": 3530367, "name": "Comitán", "country": "MX", "admin1": "Chiapas", "pop": "166178" },
  {
    "id": 3631412,
    "name": "Ocumare del Tuy",
    "country": "VE",
    "admin1": "Miranda",
    "pop": "166072"
  },
  { "id": 6822138, "name": "Niiza", "country": "JP", "admin1": "Saitama", "pop": "166017" },
  {
    "id": 5964700,
    "name": "Greater Sudbury",
    "country": "CA",
    "admin1": "Ontario",
    "pop": "166004"
  },
  {
    "id": 2034312,
    "name": "Ulanhot",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "165846"
  },
  {
    "id": 109323,
    "name": "Khobar",
    "country": "SA",
    "admin1": "Eastern Province",
    "pop": "165799"
  },
  { "id": 1794060, "name": "Songcheng", "country": "CN", "admin1": "Fujian", "pop": "165730" },
  {
    "id": 3449324,
    "name": "São Caetano do Sul",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "165655"
  },
  { "id": 1628453, "name": "Sawangan", "country": "ID", "admin1": "West Java", "pop": "165631" },
  {
    "id": 1619485,
    "name": "Bang Khun Thian",
    "country": "TH",
    "admin1": "Bangkok",
    "pop": "165491"
  },
  {
    "id": 4644312,
    "name": "Murfreesboro",
    "country": "US",
    "admin1": "Tennessee",
    "pop": "165430"
  },
  {
    "id": 3453837,
    "name": "Pindamonhangaba",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "165428"
  },
  { "id": 139817, "name": "Bushehr", "country": "IR", "admin1": "Bushehr", "pop": "165377" },
  {
    "id": 2552615,
    "name": "Dar Bouazza",
    "country": "MA",
    "admin1": "Casablanca-Settat",
    "pop": "165295"
  },
  { "id": 1254241, "name": "Tonk", "country": "IN", "admin1": "Rajasthan", "pop": "165294" },
  { "id": 2505530, "name": "Béchar", "country": "DZ", "admin1": "Béchar", "pop": "165241" },
  { "id": 1567148, "name": "Tam Kỳ", "country": "VN", "admin1": "Da Nang City", "pop": "165240" },
  {
    "id": 3462980,
    "name": "Francisco Morato",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "165139"
  },
  { "id": 1308318, "name": "Mu-se", "country": "MM", "admin1": "Shan State", "pop": "165022" },
  { "id": 1253952, "name": "Udupi", "country": "IN", "admin1": "Karnataka", "pop": "165000" },
  { "id": 1650227, "name": "Banjaran", "country": "ID", "admin1": "West Java", "pop": "164952" },
  {
    "id": 1254757,
    "name": "Thenali",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "164937"
  },
  { "id": 946058, "name": "Mthatha", "country": "ZA", "admin1": "Eastern Cape", "pop": "164848" },
  { "id": 2036920, "name": "Hengshan", "country": "CN", "admin1": "Heilongjiang", "pop": "164844" },
  { "id": 2637627, "name": "Slough", "country": "GB", "admin1": "England", "pop": "164793" },
  { "id": 3458930, "name": "Lages", "country": "BR", "admin1": "Santa Catarina", "pop": "164676" },
  {
    "id": 4169171,
    "name": "Port Saint Lucie",
    "country": "US",
    "admin1": "Florida",
    "pop": "164603"
  },
  { "id": 1255969, "name": "Sītāpur", "country": "IN", "admin1": "Uttar Pradesh", "pop": "164435" },
  {
    "id": 3186573,
    "name": "Zenica",
    "country": "BA",
    "admin1": "Federation of B&H",
    "pop": "164423"
  },
  {
    "id": 2831580,
    "name": "Solingen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "164359"
  },
  { "id": 1169692, "name": "Muridke", "country": "PK", "admin1": "Punjab", "pop": "164246" },
  { "id": 1582926, "name": "Ðông Hà", "country": "VN", "admin1": "Quang Tri", "pop": "164228" },
  { "id": 5339631, "name": "Corona", "country": "US", "admin1": "California", "pop": "164226" },
  { "id": 285629, "name": "Ḩawallī", "country": "KW", "admin1": "Hawalli", "pop": "164212" },
  { "id": 152451, "name": "Musoma", "country": "TZ", "admin1": "Mara", "pop": "164172" },
  { "id": 2337490, "name": "Inisa", "country": "NG", "admin1": "Osun State", "pop": "164161" },
  {
    "id": 523064,
    "name": "Nazran",
    "country": "RU",
    "admin1": "Ingushetiya Republic",
    "pop": "164131"
  },
  {
    "id": 3470636,
    "name": "Barra Mansa",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "164052"
  },
  { "id": 1711146, "name": "Ilagan", "country": "PH", "admin1": "Cagayan Valley", "pop": "164020" },
  {
    "id": 2396518,
    "name": "Port-Gentil",
    "country": "GA",
    "admin1": "Ogooué-Maritime",
    "pop": "164018"
  },
  { "id": 1276321, "name": "Bhadrāvati", "country": "IN", "admin1": "Karnataka", "pop": "163903" },
  { "id": 1863431, "name": "Hadano", "country": "JP", "admin1": "Kanagawa", "pop": "163787" },
  { "id": 255274, "name": "Piraeus", "country": "GR", "admin1": "Attica", "pop": "163688" },
  { "id": 7279741, "name": "Vapi", "country": "IN", "admin1": "Gujarat", "pop": "163630" },
  { "id": 2655095, "name": "Bournemouth", "country": "GB", "admin1": "England", "pop": "163600" },
  {
    "id": 268064,
    "name": "Sidon",
    "country": "LB",
    "admin1": "South Governorate",
    "pop": "163554"
  },
  { "id": 287830, "name": "‘Ibrī", "country": "OM", "admin1": "Ad Dhahirah", "pop": "163473" },
  { "id": 197745, "name": "Garissa", "country": "KE", "admin1": "Garissa County", "pop": "163399" },
  { "id": 1262951, "name": "Moga", "country": "IN", "admin1": "Punjab", "pop": "163397" },
  { "id": 2640354, "name": "Peterborough", "country": "GB", "admin1": "England", "pop": "163379" },
  {
    "id": 3672328,
    "name": "Piedecuesta",
    "country": "CO",
    "admin1": "Santander Department",
    "pop": "163362"
  },
  { "id": 1792520, "name": "Tongzhou", "country": "CN", "admin1": "Beijing", "pop": "163326" },
  {
    "id": 2875376,
    "name": "Ludwigshafen am Rhein",
    "country": "DE",
    "admin1": "Rheinland-Pfalz",
    "pop": "163196"
  },
  { "id": 6957690, "name": "Lat Krabang", "country": "TH", "admin1": "Bangkok", "pop": "163175" },
  { "id": 6947641, "name": "Büyükçekmece", "country": "TR", "admin1": "Istanbul", "pop": "163140" },
  { "id": 286621, "name": "Şalālah", "country": "OM", "admin1": "Dhofar", "pop": "163140" },
  {
    "id": 1258831,
    "name": "Rāj-Nāndgaon",
    "country": "IN",
    "admin1": "Chhattisgarh",
    "pop": "163114"
  },
  { "id": 322830, "name": "Aydın", "country": "TR", "admin1": "Aydın", "pop": "163022" },
  { "id": 3682631, "name": "Envigado", "country": "CO", "admin1": "Antioquia", "pop": "163007" },
  { "id": 379303, "name": "Geneina", "country": "SD", "admin1": "Western Darfur", "pop": "162981" },
  { "id": 1818116, "name": "Anbu", "country": "CN", "admin1": "Guangdong", "pop": "162964" },
  { "id": 4710178, "name": "McKinney", "country": "US", "admin1": "Texas", "pop": "162898" },
  { "id": 2487134, "name": "Mostaganem", "country": "DZ", "admin1": "Mostaganem", "pop": "162885" },
  {
    "id": 1514210,
    "name": "Chirchiq",
    "country": "UZ",
    "admin1": "Tashkent Region",
    "pop": "162800"
  },
  {
    "id": 141663,
    "name": "Bandar-e Māhshahr",
    "country": "IR",
    "admin1": "Khuzestan",
    "pop": "162797"
  },
  {
    "id": 2878234,
    "name": "Leverkusen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "162738"
  },
  { "id": 1695462, "name": "Pandi", "country": "PH", "admin1": "Central Luzon", "pop": "162725" },
  { "id": 1718722, "name": "Capas", "country": "PH", "admin1": "Central Luzon", "pop": "162724" },
  { "id": 1799389, "name": "Ning’er", "country": "CN", "admin1": "Yunnan", "pop": "162711" },
  { "id": 2755003, "name": "Haarlem", "country": "NL", "admin1": "North Holland", "pop": "162543" },
  {
    "id": 125446,
    "name": "Mahābād",
    "country": "IR",
    "admin1": "West Azerbaijan",
    "pop": "162434"
  },
  { "id": 2759661, "name": "Arnhem", "country": "NL", "admin1": "Gelderland", "pop": "162424" },
  { "id": 2223763, "name": "Nkongsamba", "country": "CM", "admin1": "Littoral", "pop": "162309" },
  { "id": 3641099, "name": "El Vigía", "country": "VE", "admin1": "Mérida", "pop": "162289" },
  {
    "id": 1258109,
    "name": "Robertsonpet",
    "country": "IN",
    "admin1": "Karnataka",
    "pop": "162230"
  },
  {
    "id": 3464460,
    "name": "Dourados",
    "country": "BR",
    "admin1": "Mato Grosso do Sul",
    "pop": "162202"
  },
  { "id": 191220, "name": "Kitale", "country": "KE", "admin1": "Trans Nzoia", "pop": "162174" },
  { "id": 2322794, "name": "Suleja", "country": "NG", "admin1": "Niger State", "pop": "162135" },
  { "id": 2529317, "name": "Taza", "country": "MA", "admin1": "Fès-Meknès", "pop": "162110" },
  { "id": 2640729, "name": "Oxford", "country": "GB", "admin1": "England", "pop": "162100" },
  { "id": 360716, "name": "Al Maţarīyah", "country": "EG", "admin1": "Dakahlia", "pop": "162045" },
  {
    "id": 3465196,
    "name": "Criciúma",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "161954"
  },
  { "id": 1135689, "name": "Kunduz", "country": "AF", "admin1": "Kunduz", "pop": "161902" },
  { "id": 1811200, "name": "Fengcheng", "country": "CN", "admin1": "Jiangsu", "pop": "161850" },
  { "id": 1564046, "name": "Trảng Bàng", "country": "VN", "admin1": "Tay Ninh", "pop": "161831" },
  { "id": 1253747, "name": "Unnāo", "country": "IN", "admin1": "Uttar Pradesh", "pop": "161671" },
  {
    "id": 2239076,
    "name": "N'dalatando",
    "country": "AO",
    "admin1": "Cuanza Norte",
    "pop": "161584"
  },
  { "id": 1275163, "name": "Budaun", "country": "IN", "admin1": "Uttar Pradesh", "pop": "161555" },
  { "id": 1854703, "name": "Ōgaki", "country": "JP", "admin1": "Gifu", "pop": "161539" },
  { "id": 2641598, "name": "Newport", "country": "GB", "admin1": "Wales", "pop": "161506" },
  {
    "id": 1648759,
    "name": "Bima",
    "country": "ID",
    "admin1": "West Nusa Tenggara",
    "pop": "161362"
  },
  {
    "id": 3893629,
    "name": "Coquimbo",
    "country": "CL",
    "admin1": "Coquimbo Region",
    "pop": "161317"
  },
  {
    "id": 1649541,
    "name": "Baubau",
    "country": "ID",
    "admin1": "Southeast Sulawesi",
    "pop": "161280"
  },
  { "id": 1582173, "name": "Đưc Trọng", "country": "VN", "admin1": "Lam Dong", "pop": "161232" },
  {
    "id": 952734,
    "name": "KwaDukuza",
    "country": "ZA",
    "admin1": "KwaZulu-Natal",
    "pop": "161177"
  },
  { "id": 1856775, "name": "Miyakonojō", "country": "JP", "admin1": "Miyazaki", "pop": "161137" },
  {
    "id": 1264543,
    "name": "Madhyamgram",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "161126"
  },
  { "id": 5364940, "name": "Lancaster", "country": "US", "admin1": "California", "pop": "161103" },
  { "id": 1493467, "name": "Rubtsovsk", "country": "RU", "admin1": "Altai Krai", "pop": "161065" },
  { "id": 1529167, "name": "Tacheng", "country": "CN", "admin1": "Xinjiang", "pop": "161037" },
  { "id": 2419533, "name": "Kindia", "country": "GN", "admin1": "Kindia", "pop": "161024" },
  { "id": 214974, "name": "Kalemie", "country": "CD", "admin1": "Tanganyika", "pop": "160961" },
  { "id": 7026785, "name": "Chatuchak", "country": "TH", "admin1": "Bangkok", "pop": "160906" },
  {
    "id": 3628053,
    "name": "San Juan de los Morros",
    "country": "VE",
    "admin1": "Guárico",
    "pop": "160868"
  },
  { "id": 1907146, "name": "Sayama", "country": "JP", "admin1": "Saitama", "pop": "160843" },
  { "id": 3691674, "name": "Sullana", "country": "PE", "admin1": "Piura", "pop": "160789" },
  {
    "id": 2747351,
    "name": "'s-Hertogenbosch",
    "country": "NL",
    "admin1": "North Brabant",
    "pop": "160783"
  },
  { "id": 715429, "name": "Szeged", "country": "HU", "admin1": "Csongrád", "pop": "160766" },
  { "id": 370737, "name": "Malakal", "country": "SS", "admin1": "Upper Nile", "pop": "160765" },
  {
    "id": 1274033,
    "name": "Chittoor",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "160722"
  },
  { "id": 3988214, "name": "Salamanca", "country": "MX", "admin1": "Guanajuato", "pop": "160682" },
  {
    "id": 1618177,
    "name": "Ban Khlong Prawet",
    "country": "TH",
    "admin1": "Bangkok",
    "pop": "160671"
  },
  { "id": 1577995, "name": "La Gi", "country": "VN", "admin1": "Lam Dong", "pop": "160652" },
  {
    "id": 2803201,
    "name": "Anderlecht",
    "country": "BE",
    "admin1": "Brussels Capital",
    "pop": "160553"
  },
  {
    "id": 523812,
    "name": "Mytishchi",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "160542"
  },
  {
    "id": 3530049,
    "name": "Delegación Cuajimalpa de Morelos",
    "country": "MX",
    "admin1": "Mexico City",
    "pop": "160491"
  },
  { "id": 285066, "name": "Hebron", "country": "PS", "admin1": "West Bank", "pop": "160470" },
  {
    "id": 3584399,
    "name": "Mejicanos",
    "country": "SV",
    "admin1": "San Salvador Department",
    "pop": "160317"
  },
  {
    "id": 1563926,
    "name": "Thành phố Trà Vinh",
    "country": "VN",
    "admin1": "Vinh Long",
    "pop": "160310"
  },
  {
    "id": 1632353,
    "name": "Parepare",
    "country": "ID",
    "admin1": "South Sulawesi",
    "pop": "160309"
  },
  { "id": 1269280, "name": "Jāmuria", "country": "IN", "admin1": "West Bengal", "pop": "160242" },
  {
    "id": 2358946,
    "name": "Koudougou",
    "country": "BF",
    "admin1": "Centre-Ouest",
    "pop": "160239"
  },
  {
    "id": 3466296,
    "name": "Chapecó",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "160157"
  },
  { "id": 1293960, "name": "Taunggyi", "country": "MM", "admin1": "Shan State", "pop": "160115" },
  { "id": 76184, "name": "Dhamār", "country": "YE", "admin1": "Dhamār", "pop": "160114" },
  {
    "id": 499292,
    "name": "Salavat",
    "country": "RU",
    "admin1": "Bashkortostan Republic",
    "pop": "159893"
  },
  { "id": 3996663, "name": "Manzanillo", "country": "MX", "admin1": "Colima", "pop": "159853" },
  { "id": 3595237, "name": "Jalapa", "country": "GT", "admin1": "Jalapa", "pop": "159840" },
  {
    "id": 1873014,
    "name": "Paech’ŏn-ŭp",
    "country": "KP",
    "admin1": "South Hwanghae",
    "pop": "159825"
  },
  { "id": 4459467, "name": "Cary", "country": "US", "admin1": "North Carolina", "pop": "159769" },
  { "id": 3470583, "name": "Barreiras", "country": "BR", "admin1": "Bahia", "pop": "159734" },
  { "id": 2439376, "name": "Tahoua", "country": "NE", "admin1": "Tahoua Region", "pop": "159468" },
  { "id": 4744091, "name": "Alexandria", "country": "US", "admin1": "Virginia", "pop": "159467" },
  { "id": 3518723, "name": "Tuxtepec", "country": "MX", "admin1": "Oaxaca", "pop": "159452" },
  {
    "id": 7483743,
    "name": "Puthia",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "159406"
  },
  { "id": 1784554, "name": "Zhicheng", "country": "CN", "admin1": "Hubei", "pop": "159383" },
  {
    "id": 1884365,
    "name": "Ang Mo Kio New Town",
    "country": "SG",
    "admin1": null,
    "pop": "159340"
  },
  { "id": 189386, "name": "Limuru", "country": "KE", "admin1": "Kiambu County", "pop": "159314" },
  {
    "id": 3538803,
    "name": "San Miguel del Padrón",
    "country": "CU",
    "admin1": "Havana",
    "pop": "159273"
  },
  {
    "id": 3903320,
    "name": "Tarija",
    "country": "BO",
    "admin1": "Tarija Department",
    "pop": "159269"
  },
  {
    "id": 3454783,
    "name": "Patos de Minas",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "159235"
  },
  {
    "id": 2857458,
    "name": "Oldenburg",
    "country": "DE",
    "admin1": "Lower Saxony",
    "pop": "159218"
  },
  { "id": 11468431, "name": "Matsusaka", "country": "JP", "admin1": "Mie", "pop": "159145" },
  { "id": 3837702, "name": "Catamarca", "country": "AR", "admin1": "Catamarca", "pop": "159139" },
  { "id": 1850311, "name": "Tochigi", "country": "JP", "admin1": "Tochigi", "pop": "159056" },
  {
    "id": 2503701,
    "name": "Bordj Bou Arreridj",
    "country": "DZ",
    "admin1": "Bordj Bou Arréridj",
    "pop": "158812"
  },
  {
    "id": 338998,
    "name": "Dīla",
    "country": "ET",
    "admin1": "South Ethiopia Regional State",
    "pop": "158800"
  },
  { "id": 7284820, "name": "Jaigaon", "country": "IN", "admin1": "West Bengal", "pop": "158664" },
  { "id": 1276720, "name": "Batāla", "country": "IN", "admin1": "Punjab", "pop": "158621" },
  { "id": 3014728, "name": "Grenoble", "country": "FR", "admin1": "Rhône-Alpes", "pop": "158552" },
  {
    "id": 3460748,
    "name": "Itapecerica da Serra",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "158522"
  },
  { "id": 91597, "name": "Sāmarrā’", "country": "IQ", "admin1": "Salah ad Din", "pop": "158508" },
  { "id": 759734, "name": "Rzeszów", "country": "PL", "admin1": "Subcarpathia", "pop": "158382" },
  {
    "id": 5317071,
    "name": "Tempe Junction",
    "country": "US",
    "admin1": "Arizona",
    "pop": "158368"
  },
  { "id": 5380698, "name": "Palmdale", "country": "US", "admin1": "California", "pop": "158351" },
  { "id": 1735106, "name": "George Town", "country": "MY", "admin1": "Penang", "pop": "158336" },
  {
    "id": 2498766,
    "name": "El Achir",
    "country": "DZ",
    "admin1": "Bordj Bou Arréridj",
    "pop": "158333"
  },
  { "id": 5355933, "name": "Hayward", "country": "US", "admin1": "California", "pop": "158289" },
  { "id": 1261039, "name": "Orai", "country": "IN", "admin1": "Uttar Pradesh", "pop": "158265" },
  { "id": 1565136, "name": "Thốt Nốt", "country": "VN", "admin1": "Can Tho City", "pop": "158225" },
  {
    "id": 890422,
    "name": "Gweru",
    "country": "ZW",
    "admin1": "Midlands Province",
    "pop": "158200"
  },
  { "id": 3408424, "name": "Abaetetuba", "country": "BR", "admin1": "Pará", "pop": "158188" },
  { "id": 7026787, "name": "Chom Thong", "country": "TH", "admin1": "Bangkok", "pop": "158005" },
  { "id": 3021372, "name": "Dijon", "country": "FR", "admin1": "Bourgogne", "pop": "158002" },
  { "id": 1213614, "name": "Sunggal", "country": "ID", "admin1": "North Sumatra", "pop": "157914" },
  {
    "id": 3460728,
    "name": "Itapetininga",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "157790"
  },
  {
    "id": 2252309,
    "name": "Diourbel",
    "country": "SN",
    "admin1": "Diourbel Region",
    "pop": "157554"
  },
  { "id": 1849429, "name": "Ueda", "country": "JP", "admin1": "Nagano", "pop": "157480" },
  {
    "id": 1819757,
    "name": "Aberdeen",
    "country": "HK",
    "admin1": "Southern District",
    "pop": "157400"
  },
  { "id": 5391295, "name": "Salinas", "country": "US", "admin1": "California", "pop": "157380" },
  { "id": 3529982, "name": "Cuautla", "country": "MX", "admin1": "Morelos", "pop": "157336" },
  { "id": 2766824, "name": "Salzburg", "country": "AT", "admin1": "Salzburg", "pop": "157245" },
  {
    "id": 1214191,
    "name": "Perbaungan",
    "country": "ID",
    "admin1": "North Sumatra",
    "pop": "157174"
  },
  { "id": 1608258, "name": "Nong Chok", "country": "TH", "admin1": "Bangkok", "pop": "157138" },
  { "id": 2014006, "name": "Ussuriysk", "country": "RU", "admin1": "Primorye", "pop": "157068" },
  {
    "id": 11250625,
    "name": "Arif Wala",
    "country": "PK",
    "admin1": "Balochistan",
    "pop": "157063"
  },
  { "id": 2035644, "name": "Nanpiao", "country": "CN", "admin1": "Liaoning", "pop": "157044" },
  { "id": 3174659, "name": "Livorno", "country": "IT", "admin1": "Tuscany", "pop": "157017" },
  { "id": 3838874, "name": "Río Cuarto", "country": "AR", "admin1": "Cordoba", "pop": "157010" },
  { "id": 617239, "name": "Tiraspol", "country": "MD", "admin1": "Transnistria", "pop": "157000" },
  { "id": 335035, "name": "Harar", "country": "ET", "admin1": "Harari", "pop": "157000" },
  { "id": 3402383, "name": "Caxias", "country": "BR", "admin1": "Maranhão", "pop": "156973" },
  { "id": 2649997, "name": "Enfield Town", "country": "GB", "admin1": "England", "pop": "156858" },
  { "id": 940316, "name": "Westonaria", "country": "ZA", "admin1": "Gauteng", "pop": "156831" },
  { "id": 8416218, "name": "Lizhi", "country": "CN", "admin1": "Chongqing", "pop": "156753" },
  { "id": 6822096, "name": "Hitachi-Naka", "country": "JP", "admin1": "Ibaraki", "pop": "156581" },
  { "id": 1257804, "name": "Saharsa", "country": "IN", "admin1": "Bihar", "pop": "156540" },
  { "id": 350789, "name": "Qalyub", "country": "EG", "admin1": "Qalyubia", "pop": "156363" },
  { "id": 3595803, "name": "Escuintla", "country": "GT", "admin1": "Escuintla", "pop": "156313" },
  { "id": 2514169, "name": "Marbella", "country": "ES", "admin1": "Andalusia", "pop": "156295" },
  { "id": 1732687, "name": "Batu Pahat", "country": "MY", "admin1": "Johor", "pop": "156236" },
  { "id": 1735453, "name": "Sitiawan", "country": "MY", "admin1": "Perak", "pop": "156234" },
  {
    "id": 1700868,
    "name": "Mariveles",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "156200"
  },
  {
    "id": 3518135,
    "name": "San Pablo de las Salinas",
    "country": "MX",
    "admin1": "México",
    "pop": "156191"
  },
  { "id": 1152473, "name": "Lampang", "country": "TH", "admin1": "Lampang", "pop": "156139" },
  { "id": 2633352, "name": "York", "country": "GB", "admin1": "England", "pop": "156135" },
  { "id": 1591474, "name": "Bạc Liêu", "country": "VN", "admin1": "Ca Mau", "pop": "156110" },
  { "id": 8299780, "name": "Juja", "country": "KE", "admin1": "Kiambu County", "pop": "156041" },
  { "id": 330118, "name": "Nek’emtē", "country": "ET", "admin1": "Oromiya", "pop": "156000" },
  { "id": 2686657, "name": "Örebro", "country": "SE", "admin1": "Örebro", "pop": "155989" },
  { "id": 2112312, "name": "Katsuta", "country": "JP", "admin1": "Ibaraki", "pop": "155968" },
  { "id": 2309527, "name": "Malabo", "country": "GQ", "admin1": "Bioko Norte", "pop": "155963" },
  {
    "id": 1253200,
    "name": "Vidisha",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "155951"
  },
  { "id": 1563281, "name": "Tuy Hòa", "country": "VN", "admin1": "Dak Lak", "pop": "155921" },
  { "id": 1797632, "name": "Yizhou", "country": "CN", "admin1": "Guangxi", "pop": "155872" },
  { "id": 5400075, "name": "Sunnyvale", "country": "US", "admin1": "California", "pop": "155805" },
  { "id": 2294700, "name": "Tema", "country": "GH", "admin1": "Greater Accra", "pop": "155782" },
  { "id": 3403741, "name": "Camaragibe", "country": "BR", "admin1": "Pernambuco", "pop": "155771" },
  { "id": 2033413, "name": "Yichun", "country": "CN", "admin1": "Heilongjiang", "pop": "155762" },
  { "id": 1582190, "name": "Đức Phổ", "country": "VN", "admin1": "Quang Ngai", "pop": "155743" },
  {
    "id": 3518407,
    "name": "San Martin Texmelucan de Labastida",
    "country": "MX",
    "admin1": "Puebla",
    "pop": "155738"
  },
  { "id": 3460845, "name": "Itajaí", "country": "BR", "admin1": "Santa Catarina", "pop": "155716" },
  { "id": 250336, "name": "Ar Ramthā", "country": "JO", "admin1": "Irbid", "pop": "155693" },
  { "id": 1270407, "name": "Hanumāngarh", "country": "IN", "admin1": "Rajasthan", "pop": "155687" },
  { "id": 783920, "name": "Zemun", "country": "RS", "admin1": "Central Serbia", "pop": "155591" },
  { "id": 3345439, "name": "Telford", "country": "GB", "admin1": "England", "pop": "155570" },
  { "id": 2334327, "name": "Kisi", "country": "NG", "admin1": "Oyo State", "pop": "155510" },
  { "id": 3461408, "name": "Ilhéus", "country": "BR", "admin1": "Bahia", "pop": "155499" },
  {
    "id": 3587923,
    "name": "Villa Canales",
    "country": "GT",
    "admin1": "Guatemala",
    "pop": "155423"
  },
  { "id": 1712051, "name": "Guyong", "country": "PH", "admin1": "Central Luzon", "pop": "155391" },
  {
    "id": 2537406,
    "name": "Settat",
    "country": "MA",
    "admin1": "Casablanca-Settat",
    "pop": "155333"
  },
  { "id": 934154, "name": "Port Louis", "country": "MU", "admin1": "Port Louis", "pop": "155226" },
  {
    "id": 2208032,
    "name": "Tauranga",
    "country": "NZ",
    "admin1": "Bay of Plenty",
    "pop": "155200"
  },
  { "id": 1859675, "name": "Kawanishi", "country": "JP", "admin1": "Hyōgo", "pop": "155165" },
  { "id": 1254657, "name": "Thānesar", "country": "IN", "admin1": "Haryana", "pop": "155152" },
  { "id": 361179, "name": "Al Ḩawāmidīyah", "country": "EG", "admin1": "Giza", "pop": "155055" },
  { "id": 1270239, "name": "Hassan", "country": "IN", "admin1": "Karnataka", "pop": "155006" },
  { "id": 1919014, "name": "Lianghu", "country": "CN", "admin1": "Zhejiang", "pop": "155000" },
  { "id": 2038342, "name": "Beipiao", "country": "CN", "admin1": "Liaoning", "pop": "154999" },
  {
    "id": 6254843,
    "name": "Birendranagar",
    "country": "NP",
    "admin1": "Karnali Pradesh",
    "pop": "154886"
  },
  { "id": 1266486, "name": "Kishangarh", "country": "IN", "admin1": "Rajasthan", "pop": "154886" },
  { "id": 10265162, "name": "Dalūpura", "country": "IN", "admin1": "Delhi", "pop": "154791" },
  { "id": 1809879, "name": "Guangshui", "country": "CN", "admin1": "Hubei", "pop": "154771" },
  { "id": 935264, "name": "Saint-Denis", "country": "RE", "admin1": "Réunion", "pop": "154765" },
  { "id": 683902, "name": "Brăila", "country": "RO", "admin1": "Brăila County", "pop": "154686" },
  {
    "id": 532615,
    "name": "Lyubertsy",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "154650"
  },
  { "id": 217745, "name": "Bumba", "country": "CD", "admin1": "Mongala", "pop": "154586" },
  { "id": 8740322, "name": "Rudrapur", "country": "IN", "admin1": "Uttarakhand", "pop": "154554" },
  {
    "id": 3884373,
    "name": "La Serena",
    "country": "CL",
    "admin1": "Coquimbo Region",
    "pop": "154521"
  },
  {
    "id": 717582,
    "name": "Miskolc",
    "country": "HU",
    "admin1": "Borsod-Abaúj-Zemplén",
    "pop": "154521"
  },
  { "id": 362485, "name": "Abū Kabīr", "country": "EG", "admin1": "Sharqia", "pop": "154466" },
  { "id": 1808872, "name": "Fu’an", "country": "CN", "admin1": "Fujian", "pop": "154439" },
  {
    "id": 7931934,
    "name": "Kitengela",
    "country": "KE",
    "admin1": "Kajiado County",
    "pop": "154436"
  },
  { "id": 4692559, "name": "Frisco", "country": "US", "admin1": "Texas", "pop": "154407" },
  { "id": 2033168, "name": "Zhaodong", "country": "CN", "admin1": "Heilongjiang", "pop": "154406" },
  { "id": 2323090, "name": "Shomolu", "country": "NG", "admin1": "Lagos", "pop": "154390" },
  { "id": 2216349, "name": "Janzūr", "country": "LY", "admin1": "Al Jafārah", "pop": "154389" },
  { "id": 1024552, "name": "Xai-Xai", "country": "MZ", "admin1": "Gaza Province", "pop": "154356" },
  {
    "id": 4951788,
    "name": "Springfield",
    "country": "US",
    "admin1": "Massachusetts",
    "pop": "154341"
  },
  { "id": 1262067, "name": "Nalgonda", "country": "IN", "admin1": "Telangana", "pop": "154326" },
  { "id": 231954, "name": "Katabi", "country": "UG", "admin1": "Central Region", "pop": "154300" },
  {
    "id": 1884178,
    "name": "Gwangyang",
    "country": "KR",
    "admin1": "Jeollanam-do",
    "pop": "154266"
  },
  { "id": 543460, "name": "Kovrov", "country": "RU", "admin1": "Vladimir Oblast", "pop": "154224" },
  { "id": 298033, "name": "Viranşehir", "country": "TR", "admin1": "Şanlıurfa", "pop": "154163" },
  { "id": 1855078, "name": "Noda", "country": "JP", "admin1": "Chiba", "pop": "154114" },
  {
    "id": 3449948,
    "name": "Santana de Parnaíba",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "154105"
  },
  {
    "id": 3511540,
    "name": "San Cristóbal",
    "country": "DO",
    "admin1": "San Cristóbal",
    "pop": "154040"
  },
  {
    "id": 4619947,
    "name": "East Chattanooga",
    "country": "US",
    "admin1": "Tennessee",
    "pop": "154024"
  },
  { "id": 146384, "name": "Limassol", "country": "CY", "admin1": "Limassol", "pop": "154000" },
  { "id": 1860034, "name": "Kariya", "country": "JP", "admin1": "Aichi", "pop": "153834" },
  { "id": 4717782, "name": "Pasadena", "country": "US", "admin1": "Texas", "pop": "153784" },
  { "id": 352181, "name": "Mīt Ghamr", "country": "EG", "admin1": "Dakahlia", "pop": "153754" },
  { "id": 1789273, "name": "Sanshui", "country": "CN", "admin1": "Guangdong", "pop": "153714" },
  { "id": 4431410, "name": "Jackson", "country": "US", "admin1": "Mississippi", "pop": "153701" },
  { "id": 3457000, "name": "Mogi Guaçu", "country": "BR", "admin1": "São Paulo", "pop": "153658" },
  { "id": 2756071, "name": "Enschede", "country": "NL", "admin1": "Overijssel", "pop": "153655" },
  { "id": 1816265, "name": "Boshan", "country": "CN", "admin1": "Shandong", "pop": "153596" },
  { "id": 1270164, "name": "Hazāribāgh", "country": "IN", "admin1": "Jharkhand", "pop": "153595" },
  { "id": 1814786, "name": "Yangchun", "country": "CN", "admin1": "Guangdong", "pop": "153547" },
  { "id": 2479215, "name": "Souk Ahras", "country": "DZ", "admin1": "Souk Ahras", "pop": "153479" },
  {
    "id": 201521,
    "name": "Musanze",
    "country": "RW",
    "admin1": "Northern Province",
    "pop": "153368"
  },
  { "id": 1263220, "name": "Medinīpur", "country": "IN", "admin1": "West Bengal", "pop": "153349" },
  {
    "id": 1846986,
    "name": "Andong",
    "country": "KR",
    "admin1": "Gyeongsangbuk-do",
    "pop": "153348"
  },
  { "id": 1277508, "name": "Bālurghāt", "country": "IN", "admin1": "West Bengal", "pop": "153279" },
  { "id": 5384170, "name": "Pomona", "country": "US", "admin1": "California", "pop": "153266" },
  {
    "id": 3625515,
    "name": "Valle de La Pascua",
    "country": "VE",
    "admin1": "Guárico",
    "pop": "153136"
  },
  { "id": 3943789, "name": "Chincha Alta", "country": "PE", "admin1": "Ica", "pop": "153076" },
  { "id": 2172797, "name": "Cairns", "country": "AU", "admin1": "Queensland", "pop": "153075" },
  { "id": 1271976, "name": "Fyzābād", "country": "IN", "admin1": "Uttar Pradesh", "pop": "153047" },
  { "id": 1273581, "name": "Dinapore", "country": "IN", "admin1": "Bihar", "pop": "152940" },
  { "id": 1812728, "name": "Dingzhou", "country": "CN", "admin1": "Hebei", "pop": "152934" },
  { "id": 4273837, "name": "Kansas City", "country": "US", "admin1": "Kansas", "pop": "152933" },
  {
    "id": 98530,
    "name": "As Samawah",
    "country": "IQ",
    "admin1": "Al Muthanna Governorate",
    "pop": "152890"
  },
  { "id": 1259395, "name": "Porbandar", "country": "IN", "admin1": "Gujarat", "pop": "152760" },
  { "id": 1798919, "name": "Pengpu", "country": "CN", "admin1": "Shanghai", "pop": "152725" },
  { "id": 5427946, "name": "Lakewood", "country": "US", "admin1": "Colorado", "pop": "152597" },
  { "id": 97990, "name": "Baqubah", "country": "IQ", "admin1": "Diyālá", "pop": "152550" },
  {
    "id": 2864118,
    "name": "Neuss",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "152457"
  },
  { "id": 1815302, "name": "Chenghua", "country": "CN", "admin1": "Guangdong", "pop": "152453" },
  {
    "id": 1869446,
    "name": "Songnim-ni",
    "country": "KP",
    "admin1": "North Hwanghae",
    "pop": "152425"
  },
  { "id": 1277397, "name": "Bānda", "country": "IN", "admin1": "Uttar Pradesh", "pop": "152218" },
  {
    "id": 3452525,
    "name": "Pouso Alegre",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "152217"
  },
  { "id": 1586296, "name": "Cần Giuộc", "country": "VN", "admin1": "Tay Ninh", "pop": "152200" },
  { "id": 2035980, "name": "Longfeng", "country": "CN", "admin1": "Heilongjiang", "pop": "152074" },
  { "id": 11204106, "name": "Etwatwa", "country": "ZA", "admin1": "Gauteng", "pop": "151866" },
  { "id": 7279570, "name": "Higashimurayama", "country": "JP", "admin1": "Tokyo", "pop": "151815" },
  {
    "id": 1270079,
    "name": "Hindupur",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "151677"
  },
  { "id": 3471697, "name": "Araucária", "country": "BR", "admin1": "Paraná", "pop": "151666" },
  { "id": 1737486, "name": "Bintulu", "country": "MY", "admin1": "Sarawak", "pop": "151617" },
  { "id": 361661, "name": "Akhmīm", "country": "EG", "admin1": "Sohag", "pop": "151430" },
  {
    "id": 1173491,
    "name": "Kohat",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "151427"
  },
  { "id": 1172035, "name": "Layyah", "country": "PK", "admin1": "Punjab", "pop": "151274" },
  { "id": 355026, "name": "Girga", "country": "EG", "admin1": "Sohag", "pop": "151256" },
  { "id": 2299522, "name": "Koforidua", "country": "GH", "admin1": "Eastern", "pop": "151255" },
  {
    "id": 117392,
    "name": "Saqqez",
    "country": "IR",
    "admin1": "Kurdistan Province",
    "pop": "151237"
  },
  { "id": 3118150, "name": "Logroño", "country": "ES", "admin1": "La Rioja", "pop": "151164" },
  { "id": 1276634, "name": "Beāwar", "country": "IN", "admin1": "Rajasthan", "pop": "151152" },
  { "id": 3399058, "name": "Garanhuns", "country": "BR", "admin1": "Pernambuco", "pop": "151064" },
  { "id": 5346827, "name": "Escondido", "country": "US", "admin1": "California", "pop": "151038" },
  { "id": 13286467, "name": "Ṣuwayliḥ", "country": "JO", "admin1": "Balqa", "pop": "151016" },
  { "id": 315373, "name": "Erzincan", "country": "TR", "admin1": "Erzincan", "pop": "150714" },
  { "id": 307515, "name": "Kırşehir", "country": "TR", "admin1": "Kırşehir", "pop": "150700" },
  {
    "id": 2511401,
    "name": "La Laguna",
    "country": "ES",
    "admin1": "Canary Islands",
    "pop": "150661"
  },
  { "id": 1522203, "name": "Kokshetau", "country": "KZ", "admin1": "Aqmola", "pop": "150649" },
  {
    "id": 1278667,
    "name": "Anantnag",
    "country": "IN",
    "admin1": "Jammu and Kashmir",
    "pop": "150592"
  },
  { "id": 1858445, "name": "Kukichūō", "country": "JP", "admin1": "Saitama", "pop": "150582" },
  { "id": 2521420, "name": "Badajoz", "country": "ES", "admin1": "Extremadura", "pop": "150530" },
  {
    "id": 7302856,
    "name": "Serilingampalle",
    "country": "IN",
    "admin1": "Telangana",
    "pop": "150525"
  },
  { "id": 3895088, "name": "Chillán", "country": "CL", "admin1": "Ñuble", "pop": "150396" },
  { "id": 1648580, "name": "Blitar", "country": "ID", "admin1": "East Java", "pop": "150371" },
  {
    "id": 1578163,
    "name": "Kỳ Anh",
    "country": "VN",
    "admin1": "Hà Tĩnh Province",
    "pop": "150226"
  },
  { "id": 1608236, "name": "Nong Khaem", "country": "TH", "admin1": "Bangkok", "pop": "150218" },
  {
    "id": 3992619,
    "name": "Piedras Negras",
    "country": "MX",
    "admin1": "Coahuila",
    "pop": "150178"
  },
  { "id": 307084, "name": "Kızıltepe", "country": "TR", "admin1": "Mardin", "pop": "150174" },
  { "id": 1856367, "name": "Musashino", "country": "JP", "admin1": "Tokyo", "pop": "150149" },
  {
    "id": 579464,
    "name": "Balashikha",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "150103"
  },
  { "id": 2640101, "name": "Poole", "country": "GB", "admin1": "England", "pop": "150092" },
  { "id": 1259005, "name": "Raigarh", "country": "IN", "admin1": "Chhattisgarh", "pop": "150019" },
  { "id": 942470, "name": "Vryheid", "country": "ZA", "admin1": "KwaZulu-Natal", "pop": "150012" },
  {
    "id": 13118229,
    "name": "Bandar Tasik Puteri",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "150000"
  },
  { "id": 13118091, "name": "Setia Alam", "country": "MY", "admin1": "Selangor", "pop": "150000" },
  { "id": 7473418, "name": "Bercham", "country": "MY", "admin1": "Perak", "pop": "150000" },
  { "id": 7302828, "name": "Malkajgiri", "country": "IN", "admin1": "Telangana", "pop": "150000" },
  {
    "id": 1842944,
    "name": "Gimcheon",
    "country": "KR",
    "admin1": "Gyeongsangbuk-do",
    "pop": "150000"
  },
  {
    "id": 1645457,
    "name": "Dili",
    "country": "TL",
    "admin1": "Dili Municipality",
    "pop": "150000"
  },
  {
    "id": 1163198,
    "name": "Tordher",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "150000"
  },
  { "id": 1256639, "name": "Shāntipur", "country": "IN", "admin1": "West Bengal", "pop": "149983" },
  {
    "id": 3521342,
    "name": "Playa del Carmen",
    "country": "MX",
    "admin1": "Quintana Roo",
    "pop": "149923"
  },
  { "id": 3389321, "name": "Santa Rita", "country": "BR", "admin1": "Paraíba", "pop": "149910" },
  { "id": 3190261, "name": "Split", "country": "HR", "admin1": "Split-Dalmatia", "pop": "149830" },
  { "id": 6545326, "name": "Ursynów", "country": "PL", "admin1": "Mazovia", "pop": "149775" },
  { "id": 4158928, "name": "Hollywood", "country": "US", "admin1": "Florida", "pop": "149728" },
  { "id": 11612583, "name": "Shūnan", "country": "JP", "admin1": "Yamaguchi", "pop": "149632" },
  { "id": 2448085, "name": "Agadez", "country": "NE", "admin1": "Agadez", "pop": "149549" },
  { "id": 2654264, "name": "Burnley", "country": "GB", "admin1": "England", "pop": "149422" },
  {
    "id": 293725,
    "name": "Reẖovot",
    "country": "IL",
    "admin1": "Central District",
    "pop": "149392"
  },
  {
    "id": 1621884,
    "name": "Watampone",
    "country": "ID",
    "admin1": "South Sulawesi",
    "pop": "149336"
  },
  { "id": 2212775, "name": "Sabha", "country": "LY", "admin1": "Sabha District", "pop": "149329" },
  { "id": 358108, "name": "Disūq", "country": "EG", "admin1": "Kafr el-Sheikh", "pop": "149291" },
  { "id": 2525473, "name": "Cagliari", "country": "IT", "admin1": "Sardinia", "pop": "149257" },
  { "id": 2647425, "name": "Harrow", "country": "GB", "admin1": "England", "pop": "149246" },
  {
    "id": 2556272,
    "name": "Berrechid",
    "country": "MA",
    "admin1": "Casablanca-Settat",
    "pop": "149201"
  },
  {
    "id": 3452073,
    "name": "Queimados",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "149093"
  },
  {
    "id": 2244991,
    "name": "Tambacounda",
    "country": "SN",
    "admin1": "Tambacounda",
    "pop": "149071"
  },
  { "id": 2646458, "name": "Huddersfield", "country": "GB", "admin1": "England", "pop": "149017" },
  { "id": 343749, "name": "Ārabī", "country": "ET", "admin1": "Somali", "pop": "148933" },
  { "id": 706524, "name": "Kerch", "country": "UA", "admin1": "Crimea", "pop": "148932" },
  { "id": 6137270, "name": "Saguenay", "country": "CA", "admin1": "Quebec", "pop": "148886" },
  {
    "id": 6317123,
    "name": "Fazenda Rio Grande",
    "country": "BR",
    "admin1": "Paraná",
    "pop": "148873"
  },
  { "id": 1858926, "name": "Komaki", "country": "JP", "admin1": "Aichi", "pop": "148872" },
  { "id": 124721, "name": "Marvdasht", "country": "IR", "admin1": "Fars", "pop": "148858" },
  { "id": 701404, "name": "Melitopol", "country": "UA", "admin1": "Zaporizhzhia", "pop": "148851" },
  { "id": 2037534, "name": "Dunhua", "country": "CN", "admin1": "Jilin", "pop": "148844" },
  { "id": 1275812, "name": "Bhuj", "country": "IN", "admin1": "Gujarat", "pop": "148834" },
  { "id": 1848277, "name": "Yonago", "country": "JP", "admin1": "Tottori", "pop": "148720" },
  { "id": 52407, "name": "Ruqi", "country": "SO", "admin1": "Awdal", "pop": "148702" },
  { "id": 3169361, "name": "Rimini", "country": "IT", "admin1": "Emilia-Romagna", "pop": "148688" },
  { "id": 3137115, "name": "Stavanger", "country": "NO", "admin1": "Rogaland", "pop": "148682" },
  {
    "id": 5927690,
    "name": "Coquitlam",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "148625"
  },
  {
    "id": 108512,
    "name": "Arar",
    "country": "SA",
    "admin1": "Northern Borders Region",
    "pop": "148540"
  },
  { "id": 5405288, "name": "Valencia", "country": "US", "admin1": "California", "pop": "148456" },
  { "id": 6822129, "name": "Tama", "country": "JP", "admin1": "Tokyo", "pop": "148285" },
  { "id": 4907959, "name": "Rockford", "country": "US", "admin1": "Illinois", "pop": "148278" },
  { "id": 3642833, "name": "El Limón", "country": "VE", "admin1": "Aragua", "pop": "148247" },
  {
    "id": 2455914,
    "name": "Kalaban Koro",
    "country": "ML",
    "admin1": "Koulikoro",
    "pop": "148247"
  },
  { "id": 2990363, "name": "Nîmes", "country": "FR", "admin1": "Occitanie", "pop": "148236" },
  { "id": 2650752, "name": "Dundee", "country": "GB", "admin1": "Scotland", "pop": "148210" },
  { "id": 1277100, "name": "Bārākpur", "country": "IN", "admin1": "West Bengal", "pop": "148174" },
  { "id": 3469136, "name": "Botucatu", "country": "BR", "admin1": "São Paulo", "pop": "148130" },
  { "id": 2034638, "name": "Sujiatun", "country": "CN", "admin1": "Liaoning", "pop": "148113" },
  {
    "id": 1651112,
    "name": "Astanajapura",
    "country": "ID",
    "admin1": "West Java",
    "pop": "148047"
  },
  {
    "id": 4013720,
    "name": "Ciudad Delicias",
    "country": "MX",
    "admin1": "Chihuahua",
    "pop": "148045"
  },
  { "id": 2415703, "name": "Siguiri", "country": "GN", "admin1": "Kankan Region", "pop": "148018" },
  { "id": 2239520, "name": "Mbanza Kongo", "country": "AO", "admin1": "Zaire", "pop": "148000" },
  { "id": 4756955, "name": "East Hampton", "country": "US", "admin1": "Virginia", "pop": "147993" },
  { "id": 2036876, "name": "Honggang", "country": "CN", "admin1": "Heilongjiang", "pop": "147977" },
  { "id": 192710, "name": "Kiambu", "country": "KE", "admin1": "Kiambu County", "pop": "147870" },
  {
    "id": 3024635,
    "name": "Clermont-Ferrand",
    "country": "FR",
    "admin1": "Rhône-Alpes",
    "pop": "147865"
  },
  { "id": 4898015, "name": "Joliet", "country": "US", "admin1": "Illinois", "pop": "147861" },
  { "id": 5894171, "name": "Barrie", "country": "CA", "admin1": "Ontario", "pop": "147829" },
  { "id": 1619532, "name": "Bang Kapi", "country": "TH", "admin1": "Bangkok", "pop": "147800" },
  { "id": 4221552, "name": "Savannah", "country": "US", "admin1": "Georgia", "pop": "147780" },
  { "id": 5102466, "name": "Paterson", "country": "US", "admin1": "New Jersey", "pop": "147754" },
  { "id": 546230, "name": "Kolomna", "country": "RU", "admin1": "Moscow Oblast", "pop": "147690" },
  { "id": 1270525, "name": "Hājīpur", "country": "IN", "admin1": "Bihar", "pop": "147688" },
  { "id": 118994, "name": "Rafsanjān", "country": "IR", "admin1": "Kerman", "pop": "147680" },
  { "id": 9081327, "name": "Hòa Thành", "country": "VN", "admin1": "Tay Ninh", "pop": "147666" },
  { "id": 3173529, "name": "Mestre", "country": "IT", "admin1": "Veneto", "pop": "147662" },
  {
    "id": 5282804,
    "name": "Bridgeport",
    "country": "US",
    "admin1": "Connecticut",
    "pop": "147629"
  },
  {
    "id": 789128,
    "name": "Kragujevac",
    "country": "RS",
    "admin1": "Central Serbia",
    "pop": "147473"
  },
  { "id": 610612, "name": "Shevchenko", "country": "KZ", "admin1": "Mangghystaū", "pop": "147443" },
  { "id": 1257086, "name": "Sasarām", "country": "IN", "admin1": "Bihar", "pop": "147408" },
  {
    "id": 3456290,
    "name": "Nilópolis",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "147281"
  },
  { "id": 6822163, "name": "Iruma", "country": "JP", "admin1": "Saitama", "pop": "147166" },
  {
    "id": 3873454,
    "name": "Renca",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "147151"
  },
  { "id": 704508, "name": "Kramatorsk", "country": "UA", "admin1": "Donetsk", "pop": "147145" },
  { "id": 4903279, "name": "Naperville", "country": "US", "admin1": "Illinois", "pop": "147100" },
  { "id": 290340, "name": "Manama", "country": "BH", "admin1": "Manama", "pop": "147074" },
  { "id": 4013516, "name": "Colima", "country": "MX", "admin1": "Colima", "pop": "146965" },
  {
    "id": 1275947,
    "name": "Bhimavaram",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "146961"
  },
  { "id": 258576, "name": "Lárisa", "country": "GR", "admin1": "Thessaly", "pop": "146926" },
  { "id": 2019528, "name": "Nakhodka", "country": "RU", "admin1": "Primorye", "pop": "146920" },
  { "id": 339734, "name": "Debre Birhan", "country": "ET", "admin1": "Amhara", "pop": "146900" },
  {
    "id": 3038354,
    "name": "Aix-en-Provence",
    "country": "FR",
    "admin1": "Provence-Alpes-Côte d'Azur",
    "pop": "146821"
  },
  { "id": 1586350, "name": "Cam Ranh", "country": "VN", "admin1": "Khanh Hoa", "pop": "146771" },
  {
    "id": 3547398,
    "name": "Matanzas",
    "country": "CU",
    "admin1": "Matanzas Province",
    "pop": "146733"
  },
  { "id": 1275539, "name": "Beed", "country": "IN", "admin1": "Maharashtra", "pop": "146709" },
  {
    "id": 8533870,
    "name": "Saint-Quentin-en-Yvelines",
    "country": "FR",
    "admin1": "Île-de-France",
    "pop": "146598"
  },
  {
    "id": 13118145,
    "name": "Bandar Bukit Raja",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "146534"
  },
  { "id": 2655524, "name": "Blackburn", "country": "GB", "admin1": "England", "pop": "146521" },
  {
    "id": 3894242,
    "name": "Colina",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "146207"
  },
  { "id": 10261509, "name": "Burāri", "country": "IN", "admin1": "Delhi", "pop": "146190" },
  { "id": 3086800, "name": "Ruda Śląska", "country": "PL", "admin1": "Silesia", "pop": "146189" },
  {
    "id": 2377457,
    "name": "Nouadhibou",
    "country": "MR",
    "admin1": "Dakhlet Nouadhibou",
    "pop": "146048"
  },
  {
    "id": 3493175,
    "name": "Puerto Plata",
    "country": "DO",
    "admin1": "Puerto Plata",
    "pop": "146000"
  },
  { "id": 1680197, "name": "Urdaneta", "country": "PH", "admin1": "Ilocos", "pop": "145935" },
  {
    "id": 1265859,
    "name": "Krishnanagar",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "145926"
  },
  { "id": 1788816, "name": "Xinji", "country": "CN", "admin1": "Hebei", "pop": "145911" },
  { "id": 3595069, "name": "Jutiapa", "country": "GT", "admin1": "Jutiapa", "pop": "145880" },
  { "id": 3395503, "name": "Marabá", "country": "BR", "admin1": "Pará", "pop": "145860" },
  { "id": 1274056, "name": "Chitradurga", "country": "IN", "admin1": "Karnataka", "pop": "145853" },
  { "id": 7026776, "name": "Bueng Kum", "country": "TH", "admin1": "Bangkok", "pop": "145830" },
  { "id": 2653941, "name": "Cambridge", "country": "GB", "admin1": "England", "pop": "145674" },
  {
    "id": 6317837,
    "name": "Paço do Lumiar",
    "country": "BR",
    "admin1": "Maranhão",
    "pop": "145643"
  },
  {
    "id": 1732721,
    "name": "Kampung Pasir Gudang Baru",
    "country": "MY",
    "admin1": "Johor",
    "pop": "145639"
  },
  { "id": 1646698, "name": "Cikampek", "country": "ID", "admin1": "West Java", "pop": "145620" },
  {
    "id": 1764027,
    "name": "Kampung Sungai Glugur",
    "country": "MY",
    "admin1": "Penang",
    "pop": "145600"
  },
  { "id": 1272648, "name": "Dibrugarh", "country": "IN", "admin1": "Assam", "pop": "145488" },
  { "id": 2488835, "name": "Médéa", "country": "DZ", "admin1": "Medea", "pop": "145441" },
  { "id": 1793700, "name": "Taishan", "country": "CN", "admin1": "Guangdong", "pop": "145440" },
  { "id": 2498392, "name": "El Eulma", "country": "DZ", "admin1": "Sétif", "pop": "145380" },
  { "id": 3046526, "name": "Pécs", "country": "HU", "admin1": "Baranya", "pop": "145347" },
  { "id": 1581755, "name": "Giá Rai", "country": "VN", "admin1": "Ca Mau", "pop": "145340" },
  { "id": 1279403, "name": "Abohar", "country": "IN", "admin1": "Punjab", "pop": "145302" },
  {
    "id": 1254327,
    "name": "Tiruvannamalai",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "145278"
  },
  { "id": 4156404, "name": "Gainesville", "country": "US", "admin1": "Florida", "pop": "145214" },
  { "id": 3435261, "name": "Concordia", "country": "AR", "admin1": "Entre Rios", "pop": "145210" },
  { "id": 1880574, "name": "Kampong Pasir Ris", "country": "SG", "admin1": null, "pop": "145150" },
  { "id": 1864132, "name": "Fujieda", "country": "JP", "admin1": "Shizuoka", "pop": "145032" },
  {
    "id": 3488465,
    "name": "Spanish Town",
    "country": "JM",
    "admin1": "Saint Catherine Parish",
    "pop": "145018"
  },
  { "id": 2655459, "name": "Blackpool", "country": "GB", "admin1": "England", "pop": "145007" },
  { "id": 1512473, "name": "Urganch", "country": "UZ", "admin1": "Xorazm Region", "pop": "145000" },
  { "id": 160961, "name": "Bukoba", "country": "TZ", "admin1": "Kagera", "pop": "144938" },
  { "id": 1268593, "name": "Kaithal", "country": "IN", "admin1": "Haryana", "pop": "144915" },
  { "id": 3030300, "name": "Brest", "country": "FR", "admin1": "Brittany", "pop": "144899" },
  { "id": 2656194, "name": "Basildon", "country": "GB", "admin1": "England", "pop": "144859" },
  {
    "id": 3462964,
    "name": "Franco da Rocha",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "144849"
  },
  {
    "id": 3111108,
    "name": "Salamanca",
    "country": "ES",
    "admin1": "Castille and León",
    "pop": "144825"
  },
  { "id": 4710826, "name": "Mesquite", "country": "US", "admin1": "Texas", "pop": "144788" },
  { "id": 1865005, "name": "Ashikaga", "country": "JP", "admin1": "Tochigi", "pop": "144746" },
  {
    "id": 12217184,
    "name": "Huyện Lâm Hà",
    "country": "VN",
    "admin1": "Lam Dong",
    "pop": "144707"
  },
  { "id": 2038679, "name": "Acheng", "country": "CN", "admin1": "Heilongjiang", "pop": "144665" },
  {
    "id": 5990579,
    "name": "Kelowna",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "144576"
  },
  { "id": 1162959, "name": "Umarkot", "country": "PK", "admin1": "Sindh", "pop": "144558" },
  { "id": 3618030, "name": "León", "country": "NI", "admin1": "León Department", "pop": "144538" },
  { "id": 1860735, "name": "Kakamigahara", "country": "JP", "admin1": "Gifu", "pop": "144521" },
  {
    "id": 3003603,
    "name": "Le Mans",
    "country": "FR",
    "admin1": "Pays de la Loire",
    "pop": "144515"
  },
  { "id": 1171965, "name": "Lodhran", "country": "PK", "admin1": "Punjab", "pop": "144512" },
  {
    "id": 655194,
    "name": "Jyväskylä",
    "country": "FI",
    "admin1": "Central Finland",
    "pop": "144477"
  },
  { "id": 6169141, "name": "Trois-Rivières", "country": "CA", "admin1": "Quebec", "pop": "144472" },
  { "id": 2037075, "name": "Hailin", "country": "CN", "admin1": "Heilongjiang", "pop": "144443" },
  { "id": 6822099, "name": "Tsuchiura", "country": "JP", "admin1": "Ibaraki", "pop": "144399" },
  {
    "id": 563523,
    "name": "Elektrostal’",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "144387"
  },
  { "id": 1277599, "name": "Balasore", "country": "IN", "admin1": "Odisha", "pop": "144373" },
  { "id": 1786395, "name": "Yong’an", "country": "CN", "admin1": "Chongqing", "pop": "144314" },
  { "id": 2516548, "name": "Huelva", "country": "ES", "admin1": "Andalusia", "pop": "144258" },
  { "id": 1513131, "name": "Navoiy", "country": "UZ", "admin1": "Navoiy Region", "pop": "144158" },
  { "id": 5140405, "name": "Syracuse", "country": "US", "admin1": "New York", "pop": "144142" },
  { "id": 3471335, "name": "Atibaia", "country": "BR", "admin1": "São Paulo", "pop": "144088" },
  {
    "id": 295620,
    "name": "Ashkelon",
    "country": "IL",
    "admin1": "Southern District",
    "pop": "144073"
  },
  { "id": 965154, "name": "Pinetown", "country": "ZA", "admin1": "KwaZulu-Natal", "pop": "144026" },
  { "id": 1858067, "name": "Kusatsu", "country": "JP", "admin1": "Shiga", "pop": "143913" },
  { "id": 8417607, "name": "Nanjin", "country": "CN", "admin1": "Chongqing", "pop": "143766" },
  { "id": 5967629, "name": "Guelph", "country": "CA", "admin1": "Ontario", "pop": "143740" },
  { "id": 8408334, "name": "Qianjiang", "country": "CN", "admin1": "Chongqing", "pop": "143727" },
  { "id": 1271107, "name": "Godhra", "country": "IN", "admin1": "Gujarat", "pop": "143644" },
  {
    "id": 2558470,
    "name": "Khemisset",
    "country": "MA",
    "admin1": "Rabat-Salé-Kénitra",
    "pop": "143640"
  },
  { "id": 749780, "name": "Çanakkale", "country": "TR", "admin1": "Canakkale", "pop": "143622" },
  { "id": 5403022, "name": "Torrance", "country": "US", "admin1": "California", "pop": "143592" },
  { "id": 1689510, "name": "San Jose", "country": "PH", "admin1": "Mimaropa", "pop": "143495" },
  {
    "id": 984998,
    "name": "Ladysmith",
    "country": "ZA",
    "admin1": "KwaZulu-Natal",
    "pop": "143446"
  },
  {
    "id": 726848,
    "name": "Stara Zagora",
    "country": "BG",
    "admin1": "Stara Zagora",
    "pop": "143431"
  },
  { "id": 727523, "name": "Ruse", "country": "BG", "admin1": "Ruse", "pop": "143417" },
  { "id": 6325521, "name": "Lévis", "country": "CA", "admin1": "Quebec", "pop": "143414" },
  {
    "id": 2907911,
    "name": "Heidelberg",
    "country": "DE",
    "admin1": "Baden-Wurttemberg",
    "pop": "143345"
  },
  { "id": 4006163, "name": "Fresnillo", "country": "MX", "admin1": "Zacatecas", "pop": "143281" },
  { "id": 2475475, "name": "Touggourt", "country": "DZ", "admin1": "Touggourt", "pop": "143270" },
  { "id": 1256523, "name": "Shillong", "country": "IN", "admin1": "Meghalaya", "pop": "143229" },
  { "id": 5316428, "name": "Surprise", "country": "US", "admin1": "Arizona", "pop": "143148" },
  {
    "id": 2407790,
    "name": "Kenema",
    "country": "SL",
    "admin1": "Eastern Province",
    "pop": "143137"
  },
  { "id": 2641181, "name": "Norwich", "country": "GB", "admin1": "England", "pop": "143135" },
  { "id": 1564555, "name": "Tịnh Biên", "country": "VN", "admin1": "An Giang", "pop": "143098" },
  { "id": 1856584, "name": "Moriguchi", "country": "JP", "admin1": "Osaka", "pop": "143096" },
  {
    "id": 3037854,
    "name": "Amiens",
    "country": "FR",
    "admin1": "Hauts-de-France",
    "pop": "143086"
  },
  { "id": 1586551, "name": "Cai Lậy", "country": "VN", "admin1": "Dong Thap", "pop": "143050" },
  { "id": 3458266, "name": "Macaé", "country": "BR", "admin1": "Rio de Janeiro", "pop": "143029" },
  { "id": 1258178, "name": "Rewāri", "country": "IN", "admin1": "Haryana", "pop": "143021" },
  { "id": 2624886, "name": "Aalborg", "country": "DK", "admin1": "North Denmark", "pop": "142937" },
  {
    "id": 1707123,
    "name": "La Trinidad",
    "country": "PH",
    "admin1": "Cordillera",
    "pop": "142925"
  },
  { "id": 2496049, "name": "Ghardaïa", "country": "DZ", "admin1": "Ghardaia", "pop": "142913" },
  { "id": 1623834, "name": "Timika", "country": "ID", "admin1": "Central Papua", "pop": "142909" },
  {
    "id": 503550,
    "name": "Pyatigorsk",
    "country": "RU",
    "admin1": "Stavropol Kray",
    "pop": "142865"
  },
  {
    "id": 2312888,
    "name": "Mbanza-Ngungu",
    "country": "CD",
    "admin1": "Bas-Congo",
    "pop": "142773"
  },
  { "id": 1894616, "name": "Okinawa", "country": "JP", "admin1": "Okinawa", "pop": "142752" },
  { "id": 2642607, "name": "Middlesbrough", "country": "GB", "admin1": "England", "pop": "142707" },
  {
    "id": 1216187,
    "name": "Shahrisabz",
    "country": "UZ",
    "admin1": "Qashqadaryo",
    "pop": "142700"
  },
  {
    "id": 1878458,
    "name": "Ch’ŏngdan-ŭp",
    "country": "KP",
    "admin1": "South Hwanghae",
    "pop": "142607"
  },
  { "id": 3086586, "name": "Rybnik", "country": "PL", "admin1": "Silesia", "pop": "142510" },
  { "id": 2482572, "name": "Saïda", "country": "DZ", "admin1": "Saida", "pop": "142497" },
  {
    "id": 3188582,
    "name": "Tuzla",
    "country": "BA",
    "admin1": "Federation of B&H",
    "pop": "142486"
  },
  { "id": 1005646, "name": "eMbalenhle", "country": "ZA", "admin1": "Mpumalanga", "pop": "142443" },
  { "id": 3446038, "name": "Trindade", "country": "BR", "admin1": "Goiás", "pop": "142431" },
  { "id": 1174167, "name": "Khanpur", "country": "PK", "admin1": "Punjab", "pop": "142426" },
  {
    "id": 4575352,
    "name": "Columbia",
    "country": "US",
    "admin1": "South Carolina",
    "pop": "142416"
  },
  {
    "id": 1337240,
    "name": "Nawābganj",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "142361"
  },
  { "id": 2545957, "name": "Inezgane", "country": "MA", "admin1": "Souss-Massa", "pop": "142320" },
  { "id": 5381396, "name": "Pasadena", "country": "US", "admin1": "California", "pop": "142250" },
  {
    "id": 2855745,
    "name": "Paderborn",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "142161"
  },
  {
    "id": 6822137,
    "name": "Misato, Saitama",
    "country": "JP",
    "admin1": "Saitama",
    "pop": "142145"
  },
  {
    "id": 1274337,
    "name": "Chhatarpur",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "142128"
  },
  {
    "id": 990930,
    "name": "Kimberley",
    "country": "ZA",
    "admin1": "Northern Cape",
    "pop": "142089"
  },
  {
    "id": 3899887,
    "name": "Alto Hospicio",
    "country": "CL",
    "admin1": "Tarapacá",
    "pop": "142086"
  },
  {
    "id": 3564178,
    "name": "Ciego de Ávila",
    "country": "CU",
    "admin1": "Ciego de Ávila Province",
    "pop": "142027"
  },
  { "id": 349717, "name": "Samālūţ", "country": "EG", "admin1": "Minya", "pop": "142009" },
  { "id": 1805844, "name": "Jieshou", "country": "CN", "admin1": "Anhui", "pop": "141993" },
  {
    "id": 528293,
    "name": "Maykop",
    "country": "RU",
    "admin1": "Adygeya Republic",
    "pop": "141970"
  },
  { "id": 1214882, "name": "Kisaran", "country": "ID", "admin1": "North Sumatra", "pop": "141915" },
  { "id": 1635111, "name": "Mojokerto", "country": "ID", "admin1": "East Java", "pop": "141785" },
  {
    "id": 3682516,
    "name": "Facatativá",
    "country": "CO",
    "admin1": "Cundinamarca",
    "pop": "141762"
  },
  { "id": 1732750, "name": "Masai", "country": "MY", "admin1": "Johor", "pop": "141730" },
  { "id": 3629576, "name": "Punto Fijo", "country": "VE", "admin1": "Falcón", "pop": "141729" },
  {
    "id": 1307835,
    "name": "Myingyan",
    "country": "MM",
    "admin1": "Mandalay Region",
    "pop": "141713"
  },
  {
    "id": 41548,
    "name": "Kamālshahr",
    "country": "IR",
    "admin1": "Alborz Province",
    "pop": "141669"
  },
  {
    "id": 1263834,
    "name": "Mandsaur",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "141667"
  },
  {
    "id": 463355,
    "name": "Zheleznodorozhnyy",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "141648"
  },
  { "id": 1274553, "name": "Chas", "country": "IN", "admin1": "Jharkhand", "pop": "141640" },
  { "id": 130531, "name": "Jahrom", "country": "IR", "admin1": "Fars", "pop": "141634" },
  { "id": 2972191, "name": "Tours", "country": "FR", "admin1": "Centre", "pop": "141621" },
  { "id": 1260777, "name": "Pālanpur", "country": "IN", "admin1": "Gujarat", "pop": "141592" },
  {
    "id": 2291136,
    "name": "Bondoukou",
    "country": "CI",
    "admin1": "Zanzan District",
    "pop": "141568"
  },
  {
    "id": 3598655,
    "name": "Chichicastenango",
    "country": "GT",
    "admin1": "Quiché",
    "pop": "141567"
  },
  { "id": 3108288, "name": "Tarragona", "country": "ES", "admin1": "Catalonia", "pop": "141542" },
  { "id": 81302, "name": "Tobruk", "country": "LY", "admin1": "Al Buţnān", "pop": "141499" },
  {
    "id": 1870648,
    "name": "Sinch’ŏn-ŭp",
    "country": "KP",
    "admin1": "South Hwanghae",
    "pop": "141407"
  },
  {
    "id": 5881791,
    "name": "Abbotsford",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "141397"
  },
  {
    "id": 3468879,
    "name": "Brusque",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "141385"
  },
  { "id": 2655237, "name": "Bolton", "country": "GB", "admin1": "England", "pop": "141331" },
  { "id": 1281105, "name": "Yushu", "country": "CN", "admin1": "Qinghai", "pop": "141308" },
  { "id": 670609, "name": "Piteşti", "country": "RO", "admin1": "Arges", "pop": "141275" },
  {
    "id": 3907584,
    "name": "Potosí",
    "country": "BO",
    "admin1": "Potosí Department",
    "pop": "141251"
  },
  { "id": 1173664, "name": "Khuzdar", "country": "PK", "admin1": "Balochistan", "pop": "141227" },
  {
    "id": 2998286,
    "name": "Limoges",
    "country": "FR",
    "admin1": "Nouvelle-Aquitaine",
    "pop": "141176"
  },
  { "id": 1907299, "name": "Asaka", "country": "JP", "admin1": "Saitama", "pop": "141083" },
  { "id": 3455070, "name": "Paranaguá", "country": "BR", "admin1": "Paraná", "pop": "141013" },
  { "id": 1141269, "name": "Ghazni", "country": "AF", "admin1": "Ghazni", "pop": "141000" },
  { "id": 5379513, "name": "Orange", "country": "US", "admin1": "California", "pop": "140992" },
  { "id": 755330, "name": "Wola", "country": "PL", "admin1": "Mazovia", "pop": "140958" },
  { "id": 8406214, "name": "Sanhe", "country": "CN", "admin1": "Chongqing", "pop": "140954" },
  { "id": 130802, "name": "Īlām", "country": "IR", "admin1": "Ilam Province", "pop": "140940" },
  { "id": 2037222, "name": "Gongzhuling", "country": "CN", "admin1": "Jilin", "pop": "140909" },
  { "id": 1907301, "name": "Shimotoda", "country": "JP", "admin1": "Saitama", "pop": "140899" },
  {
    "id": 3860443,
    "name": "Comodoro Rivadavia",
    "country": "AR",
    "admin1": "Chubut",
    "pop": "140850"
  },
  {
    "id": 1764160,
    "name": "Kampung Sungai Ara",
    "country": "MY",
    "admin1": "Penang",
    "pop": "140849"
  },
  { "id": 5351247, "name": "Fullerton", "country": "US", "admin1": "California", "pop": "140847" },
  { "id": 4703223, "name": "Killeen", "country": "US", "admin1": "Texas", "pop": "140806" },
  {
    "id": 1497337,
    "name": "Norilsk",
    "country": "RU",
    "admin1": "Krasnoyarsk Krai",
    "pop": "140800"
  },
  { "id": 3118514, "name": "Lleida", "country": "ES", "admin1": "Catalonia", "pop": "140797" },
  { "id": 877747, "name": "Mtwara", "country": "TZ", "admin1": "Mtwara", "pop": "140793" },
  { "id": 1170989, "name": "Manjhand", "country": "PK", "admin1": "Sindh", "pop": "140766" },
  { "id": 219057, "name": "Beni", "country": "CD", "admin1": "North Kivu", "pop": "140731" },
  { "id": 339708, "name": "Debre Mark’os", "country": "ET", "admin1": "Amhara", "pop": "140700" },
  {
    "id": 1697497,
    "name": "Norzagaray",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "140697"
  },
  { "id": 970566, "name": "Nigel", "country": "ZA", "admin1": "Gauteng", "pop": "140644" },
  { "id": 2233410, "name": "Buea", "country": "CM", "admin1": "South-West", "pop": "140533" },
  { "id": 1794371, "name": "Shuizhai", "country": "CN", "admin1": "Guangdong", "pop": "140493" },
  {
    "id": 582432,
    "name": "Al’met’yevsk",
    "country": "RU",
    "admin1": "Tatarstan Republic",
    "pop": "140437"
  },
  { "id": 2938913, "name": "Darmstadt", "country": "DE", "admin1": "Hesse", "pop": "140385" },
  { "id": 2146268, "name": "Toowoomba", "country": "AU", "admin1": "Queensland", "pop": "140303" },
  { "id": 4709796, "name": "McAllen", "country": "US", "admin1": "Texas", "pop": "140269" },
  {
    "id": 1265242,
    "name": "Lakhīmpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "140223"
  },
  { "id": 2112576, "name": "Ishinomaki", "country": "JP", "admin1": "Miyagi", "pop": "140151" },
  {
    "id": 973111,
    "name": "Mpumalanga",
    "country": "ZA",
    "admin1": "KwaZulu-Natal",
    "pop": "140121"
  },
  {
    "id": 2744114,
    "name": "Zaanstad",
    "country": "NL",
    "admin1": "North Holland",
    "pop": "140085"
  },
  { "id": 11468429, "name": "Kuwana", "country": "JP", "admin1": "Mie", "pop": "140051" },
  { "id": 3947019, "name": "Ayacucho", "country": "PE", "admin1": "Ayacucho", "pop": "140033" },
  { "id": 3125239, "name": "Chamartín", "country": "ES", "admin1": "Madrid", "pop": "140000" },
  { "id": 2034996, "name": "Shanhaiguan", "country": "CN", "admin1": "Hebei", "pop": "140000" },
  { "id": 286647, "name": "Şaḩam", "country": "OM", "admin1": "Al Batinah North", "pop": "140000" },
  { "id": 245785, "name": "Abéché", "country": "TD", "admin1": "Ouadaï", "pop": "139983" },
  { "id": 255524, "name": "Peristéri", "country": "GR", "admin1": "Attica", "pop": "139981" },
  { "id": 2759821, "name": "Amersfoort", "country": "NL", "admin1": "Utrecht", "pop": "139914" },
  {
    "id": 2073124,
    "name": "Darwin",
    "country": "AU",
    "admin1": "Northern Territory",
    "pop": "139902"
  },
  {
    "id": 11695689,
    "name": "Jeongeup",
    "country": "KR",
    "admin1": "Jeollabuk-do",
    "pop": "139876"
  },
  { "id": 5786882, "name": "Bellevue", "country": "US", "admin1": "Washington", "pop": "139820" },
  { "id": 554233, "name": "Korolev", "country": "RU", "admin1": "Moscow Oblast", "pop": "139798" },
  { "id": 1253468, "name": "Valsād", "country": "IN", "admin1": "Gujarat", "pop": "139764" },
  { "id": 150006, "name": "Shinyanga", "country": "TZ", "admin1": "Shinyanga", "pop": "139727" },
  { "id": 1178231, "name": "Gojra", "country": "PK", "admin1": "Punjab", "pop": "139726" },
  { "id": 2675408, "name": "Sollentuna", "country": "SE", "admin1": "Stockholm", "pop": "139606" },
  { "id": 1848774, "name": "Yaizu", "country": "JP", "admin1": "Shizuoka", "pop": "139578" },
  {
    "id": 1631905,
    "name": "Payakumbuh",
    "country": "ID",
    "admin1": "West Sumatra",
    "pop": "139576"
  },
  { "id": 1273587, "name": "Damoh", "country": "IN", "admin1": "Madhya Pradesh", "pop": "139561" },
  { "id": 343370, "name": "Āsela", "country": "ET", "admin1": "Oromiya", "pop": "139500" },
  { "id": 1270498, "name": "Haldwani", "country": "IN", "admin1": "Uttarakhand", "pop": "139497" },
  { "id": 2337313, "name": "Irewe", "country": "NG", "admin1": "Lagos", "pop": "139494" },
  { "id": 2341355, "name": "Gbongan", "country": "NG", "admin1": "Osun State", "pop": "139485" },
  { "id": 3462672, "name": "Gama", "country": "BR", "admin1": "Federal District", "pop": "139467" },
  { "id": 1822214, "name": "Siem Reap", "country": "KH", "admin1": "Siem Reap", "pop": "139458" },
  { "id": 3486270, "name": "Anaco", "country": "VE", "admin1": "Anzoátegui", "pop": "139397" },
  {
    "id": 1630333,
    "name": "Purwodadi",
    "country": "ID",
    "admin1": "Central Java",
    "pop": "139387"
  },
  { "id": 1859093, "name": "Koga", "country": "JP", "admin1": "Ibaraki", "pop": "139344" },
  { "id": 1270568, "name": "Hābra", "country": "IN", "admin1": "West Bengal", "pop": "139297" },
  { "id": 1627253, "name": "Sidoarjo", "country": "ID", "admin1": "East Java", "pop": "139189" },
  {
    "id": 412800,
    "name": "Şabāḩ as Sālim",
    "country": "KW",
    "admin1": "Mubārak al Kabīr",
    "pop": "139163"
  },
  {
    "id": 3471039,
    "name": "Balneário Camboriú",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "139155"
  },
  { "id": 2659994, "name": "Lausanne", "country": "CH", "admin1": "Vaud", "pop": "139111" },
  {
    "id": 3613533,
    "name": "Choloma",
    "country": "HN",
    "admin1": "Cortés Department",
    "pop": "139100"
  },
  { "id": 2473449, "name": "Kairouan", "country": "TN", "admin1": "Kairouan", "pop": "139070" },
  { "id": 2636882, "name": "Stockport", "country": "GB", "admin1": "England", "pop": "139052" },
  { "id": 2036776, "name": "Huadian", "country": "CN", "admin1": "Jilin", "pop": "139047" },
  { "id": 2229798, "name": "Kousséri", "country": "CM", "admin1": "Far North", "pop": "139024" },
  { "id": 1621613, "name": "Weru", "country": "ID", "admin1": "West Java", "pop": "139004" },
  { "id": 12451089, "name": "Al-'Ubūr", "country": "EG", "admin1": "Qalyubia", "pop": "138987" },
  { "id": 546105, "name": "Kolpino", "country": "RU", "admin1": "St.-Petersburg", "pop": "138979" },
  { "id": 2425791, "name": "Sarh", "country": "TD", "admin1": "Moyen-Chari", "pop": "138928" },
  {
    "id": 1712875,
    "name": "Gingoog",
    "country": "PH",
    "admin1": "Northern Mindanao",
    "pop": "138895"
  },
  {
    "id": 3518692,
    "name": "San Juan del Río",
    "country": "MX",
    "admin1": "Querétaro",
    "pop": "138878"
  },
  {
    "id": 2295458,
    "name": "Sekondi-Takoradi",
    "country": "GH",
    "admin1": "Western",
    "pop": "138872"
  },
  { "id": 10020191, "name": "Liuzhi", "country": "CN", "admin1": "Guizhou", "pop": "138826" },
  { "id": 1698839, "name": "Naga", "country": "PH", "admin1": "Central Visayas", "pop": "138727" },
  { "id": 2037335, "name": "Fuyu", "country": "CN", "admin1": "Jilin", "pop": "138704" },
  { "id": 6180170, "name": "Whitby", "country": "CA", "admin1": "Ontario", "pop": "138501" },
  { "id": 4333177, "name": "Metairie", "country": "US", "admin1": "Louisiana", "pop": "138481" },
  { "id": 1815427, "name": "Chaohu", "country": "CN", "admin1": "Anhui", "pop": "138463" },
  { "id": 1266305, "name": "Kolār", "country": "IN", "admin1": "Karnataka", "pop": "138462" },
  {
    "id": 2472706,
    "name": "Bizerte",
    "country": "TN",
    "admin1": "Bizerte Governorate",
    "pop": "138430"
  },
  { "id": 3626402, "name": "Táriba", "country": "VE", "admin1": "Táchira", "pop": "138402" },
  { "id": 2343784, "name": "Ejigbo", "country": "NG", "admin1": "Osun State", "pop": "138357" },
  {
    "id": 2544001,
    "name": "Ksar El Kebir",
    "country": "MA",
    "admin1": "Tanger-Tetouan-Al Hoceima",
    "pop": "138262"
  },
  {
    "id": 2290582,
    "name": "Dabou",
    "country": "CI",
    "admin1": "Lagunes District",
    "pop": "138083"
  },
  {
    "id": 1884367,
    "name": "Bukit Panjang New Town",
    "country": "SG",
    "admin1": null,
    "pop": "138050"
  },
  { "id": 3393001, "name": "Parnaíba", "country": "BR", "admin1": "Piauí", "pop": "138008" },
  { "id": 2234359, "name": "Bertoua", "country": "CM", "admin1": "East", "pop": "137993" },
  { "id": 3723779, "name": "Jacmel", "country": "HT", "admin1": "Sud-Est", "pop": "137966" },
  {
    "id": 1255647,
    "name": "Srikakulam",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "137944"
  },
  { "id": 1719274, "name": "Candelaria", "country": "PH", "admin1": "Calabarzon", "pop": "137933" },
  { "id": 1562693, "name": "Vĩnh Long", "country": "VN", "admin1": "Vinh Long", "pop": "137870" },
  { "id": 3374333, "name": "Praia", "country": "CV", "admin1": "Praia", "pop": "137868" },
  {
    "id": 3471715,
    "name": "Araruama",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "137773"
  },
  { "id": 12489673, "name": "Liangping", "country": "CN", "admin1": "Chongqing", "pop": "137620" },
  { "id": 353492, "name": "Kirdāsah", "country": "EG", "admin1": "Giza", "pop": "137588" },
  { "id": 3460535, "name": "Itu", "country": "BR", "admin1": "São Paulo", "pop": "137586" },
  { "id": 4566880, "name": "Ponce", "country": "PR", "admin1": "Ponce", "pop": "137491" },
  { "id": 6559683, "name": "Doilungdêqên", "country": "CN", "admin1": "Tibet", "pop": "137451" },
  { "id": 1805857, "name": "Jieshi", "country": "CN", "admin1": "Guangdong", "pop": "137444" },
  { "id": 1808612, "name": "Hejiang", "country": "CN", "admin1": "Sichuan", "pop": "137437" },
  { "id": 1735545, "name": "Pasir Puteh", "country": "MY", "admin1": "Kelantan", "pop": "137400" },
  { "id": 1263814, "name": "Mandya", "country": "IN", "admin1": "Karnataka", "pop": "137358" },
  { "id": 1019330, "name": "Bhisho", "country": "ZA", "admin1": "Eastern Cape", "pop": "137287" },
  { "id": 1626444, "name": "Subang", "country": "ID", "admin1": "West Java", "pop": "137234" },
  {
    "id": 10834495,
    "name": "Madhurampur Dehri",
    "country": "IN",
    "admin1": "Bihar",
    "pop": "137231"
  },
  {
    "id": 1233369,
    "name": "Negombo",
    "country": "LK",
    "admin1": "Western Province",
    "pop": "137223"
  },
  { "id": 261745, "name": "Irákleion", "country": "GR", "admin1": "Crete", "pop": "137154" },
  { "id": 4762894, "name": "Hampton", "country": "US", "admin1": "Virginia", "pop": "137148" },
  { "id": 1922014, "name": "Wuyishan", "country": "CN", "admin1": "Fujian", "pop": "137133" },
  { "id": 4164601, "name": "Miramar", "country": "US", "admin1": "Florida", "pop": "137132" },
  { "id": 358821, "name": "Bilqās", "country": "EG", "admin1": "Dakahlia", "pop": "137080" },
  { "id": 1630058, "name": "Rangkasbitung", "country": "ID", "admin1": "Banten", "pop": "137041" },
  {
    "id": 516215,
    "name": "Odintsovo",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "137041"
  },
  { "id": 3176885, "name": "Foggia", "country": "IT", "admin1": "Apulia", "pop": "137032" },
  { "id": 1069129, "name": "Antsiranana", "country": "MG", "admin1": "Diana", "pop": "136959" },
  {
    "id": 1268715,
    "name": "Kānchrāpāra",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "136954"
  },
  {
    "id": 3589885,
    "name": "San Juan Sacatepéquez",
    "country": "GT",
    "admin1": "Guatemala",
    "pop": "136886"
  },
  { "id": 1857046, "name": "Minoh", "country": "JP", "admin1": "Osaka", "pop": "136868" },
  { "id": 2342490, "name": "Funtua", "country": "NG", "admin1": "Katsina State", "pop": "136811" },
  {
    "id": 6155721,
    "name": "St. Catharines",
    "country": "CA",
    "admin1": "Ontario",
    "pop": "136803"
  },
  {
    "id": 1293625,
    "name": "Dawei",
    "country": "MM",
    "admin1": "Tanintharyi Region",
    "pop": "136783"
  },
  { "id": 2338711, "name": "Igboho", "country": "NG", "admin1": "Oyo State", "pop": "136764" },
  {
    "id": 1215102,
    "name": "Gunungsitoli",
    "country": "ID",
    "admin1": "North Sumatra",
    "pop": "136707"
  },
  { "id": 2759706, "name": "Apeldoorn", "country": "NL", "admin1": "Gelderland", "pop": "136670" },
  { "id": 1570449, "name": "Phủ Lý", "country": "VN", "admin1": "Ninh Binh", "pop": "136654" },
  { "id": 2289887, "name": "Divo", "country": "CI", "admin1": "Gôh-Djiboua", "pop": "136627" },
  { "id": 1794806, "name": "Huinong", "country": "CN", "admin1": "Ningxia", "pop": "136570" },
  { "id": 6822128, "name": "Ebina", "country": "JP", "admin1": "Kanagawa", "pop": "136516" },
  {
    "id": 2543549,
    "name": "Larache",
    "country": "MA",
    "admin1": "Tanger-Tetouan-Al Hoceima",
    "pop": "136505"
  },
  { "id": 3445487, "name": "Varginha", "country": "BR", "admin1": "Minas Gerais", "pop": "136467" },
  { "id": 358600, "name": "Būsh", "country": "EG", "admin1": "Beni Suweif", "pop": "136441" },
  {
    "id": 9166066,
    "name": "Mlolongo",
    "country": "KE",
    "admin1": "Machakos County",
    "pop": "136351"
  },
  { "id": 3467736, "name": "Campo Largo", "country": "BR", "admin1": "Paraná", "pop": "136327" },
  {
    "id": 3986172,
    "name": "San José del Cabo",
    "country": "MX",
    "admin1": "Baja California Sur",
    "pop": "136285"
  },
  {
    "id": 3468403,
    "name": "Cachoeirinha",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "136258"
  },
  { "id": 5784607, "name": "West Valley City", "country": "US", "admin1": "Utah", "pop": "136208" },
  { "id": 1859393, "name": "Kisarazu", "country": "JP", "admin1": "Chiba", "pop": "136166" },
  { "id": 1649881, "name": "Batang", "country": "ID", "admin1": "Central Java", "pop": "136145" },
  { "id": 1810240, "name": "Gejiu", "country": "CN", "admin1": "Yunnan", "pop": "136135" },
  { "id": 685948, "name": "Bacău", "country": "RO", "admin1": "Bacău County", "pop": "136087" },
  { "id": 2356157, "name": "Saaba", "country": "BF", "admin1": "Centre", "pop": "136011" },
  { "id": 1272552, "name": "Dimāpur", "country": "IN", "admin1": "Nagaland", "pop": "135860" },
  { "id": 957487, "name": "Sasolburg", "country": "ZA", "admin1": "Free State", "pop": "135828" },
  { "id": 1777077, "name": "Cheras", "country": "MY", "admin1": "Selangor", "pop": "135823" },
  { "id": 1735093, "name": "Tasek Glugor", "country": "MY", "admin1": "Penang", "pop": "135786" },
  {
    "id": 3877949,
    "name": "Osorno",
    "country": "CL",
    "admin1": "Los Lagos Region",
    "pop": "135773"
  },
  {
    "id": 2036597,
    "name": "Jiagedaqi",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "135760"
  },
  { "id": 12022102, "name": "Tumxuk", "country": "CN", "admin1": "Xinjiang", "pop": "135727" },
  {
    "id": 1185191,
    "name": "Kushtia",
    "country": "BD",
    "admin1": "Khulna Division",
    "pop": "135724"
  },
  {
    "id": 3672110,
    "name": "Pitalito",
    "country": "CO",
    "admin1": "Huila Department",
    "pop": "135711"
  },
  { "id": 630376, "name": "Barysaw", "country": "BY", "admin1": "Minsk", "pop": "135696" },
  { "id": 1727995, "name": "Baliuag", "country": "PH", "admin1": "Central Luzon", "pop": "135679" },
  { "id": 8616124, "name": "Hoàn Kiếm", "country": "VN", "admin1": "Hanoi", "pop": "135618" },
  { "id": 2634491, "name": "West Bromwich", "country": "GB", "admin1": "England", "pop": "135618" },
  { "id": 232713, "name": "Kajansi", "country": "UG", "admin1": "Central Region", "pop": "135600" },
  { "id": 1861464, "name": "Isahaya", "country": "JP", "admin1": "Nagasaki", "pop": "135546" },
  { "id": 4509884, "name": "Dayton", "country": "US", "admin1": "Ohio", "pop": "135512" },
  {
    "id": 1586357,
    "name": "Cẩm Phả Mines",
    "country": "VN",
    "admin1": "Quảng Ninh",
    "pop": "135477"
  },
  { "id": 3591415, "name": "Petapa", "country": "GT", "admin1": "Guatemala", "pop": "135447" },
  { "id": 1264111, "name": "Māler Kotla", "country": "IN", "admin1": "Punjab", "pop": "135424" },
  { "id": 2346615, "name": "Buguma", "country": "NG", "admin1": "Rivers State", "pop": "135404" },
  { "id": 3471758, "name": "Araras", "country": "BR", "admin1": "São Paulo", "pop": "135331" },
  { "id": 1795055, "name": "Shiqiao", "country": "CN", "admin1": "Guangdong", "pop": "135308" },
  { "id": 1299154, "name": "Pyay", "country": "MM", "admin1": "Bago Region", "pop": "135308" },
  { "id": 368277, "name": "Rabak", "country": "SD", "admin1": "White Nile", "pop": "135281" },
  { "id": 1566559, "name": "Tây Ninh", "country": "VN", "admin1": "Tay Ninh", "pop": "135254" },
  { "id": 267008, "name": "Tyre", "country": "LB", "admin1": "South Governorate", "pop": "135204" },
  { "id": 613607, "name": "Kutaisi", "country": "GE", "admin1": "Imereti", "pop": "135201" },
  { "id": 143420, "name": "Andīmeshk", "country": "IR", "admin1": "Khuzestan", "pop": "135116" },
  { "id": 1255927, "name": "Siwān", "country": "IN", "admin1": "Bihar", "pop": "135066" },
  { "id": 3675707, "name": "Madrid", "country": "CO", "admin1": "Cundinamarca", "pop": "135000" },
  { "id": 1730713, "name": "Angono", "country": "PH", "admin1": "Calabarzon", "pop": "134975" },
  {
    "id": 3687230,
    "name": "Cartago",
    "country": "CO",
    "admin1": "Valle del Cauca Department",
    "pop": "134972"
  },
  { "id": 418533, "name": "Shahreẕā", "country": "IR", "admin1": "Isfahan", "pop": "134952" },
  { "id": 1325211, "name": "Hinthada", "country": "MM", "admin1": "Ayeyarwady", "pop": "134947" },
  { "id": 3728474, "name": "Cap-Haïtien", "country": "HT", "admin1": "Nord", "pop": "134815" },
  {
    "id": 1649593,
    "name": "Baturaja",
    "country": "ID",
    "admin1": "South Sumatra",
    "pop": "134759"
  },
  { "id": 1861602, "name": "Inazawa", "country": "JP", "admin1": "Aichi", "pop": "134751" },
  { "id": 1699296, "name": "Rodriguez", "country": "PH", "admin1": "Calabarzon", "pop": "134432" },
  { "id": 1268338, "name": "Kalol", "country": "IN", "admin1": "Gujarat", "pop": "134426" },
  { "id": 2491191, "name": "Laghouat", "country": "DZ", "admin1": "Laghouat", "pop": "134372" },
  {
    "id": 522377,
    "name": "Nevinnomyssk",
    "country": "RU",
    "admin1": "Stavropol Kray",
    "pop": "134345"
  },
  { "id": 1689056, "name": "San Mateo", "country": "PH", "admin1": "Calabarzon", "pop": "134327" },
  { "id": 347634, "name": "Ţahţā", "country": "EG", "admin1": "Sohag", "pop": "134314" },
  { "id": 1689286, "name": "San Juan", "country": "PH", "admin1": "Metro Manila", "pop": "134312" },
  { "id": 667268, "name": "Sibiu", "country": "RO", "admin1": "Sibiu County", "pop": "134309" },
  { "id": 4276614, "name": "Olathe", "country": "US", "admin1": "Kansas", "pop": "134305" },
  {
    "id": 379302,
    "name": "El Geneina Fort",
    "country": "SD",
    "admin1": "Western Darfur",
    "pop": "134264"
  },
  { "id": 2338269, "name": "Ikirun", "country": "NG", "admin1": "Osun State", "pop": "134240" },
  { "id": 8419424, "name": "Shenglilu", "country": "CN", "admin1": "Chongqing", "pop": "134218" },
  {
    "id": 3836846,
    "name": "San Nicolás de los Arroyos",
    "country": "AR",
    "admin1": "Buenos Aires",
    "pop": "134217"
  },
  { "id": 3722286, "name": "Léogâne", "country": "HT", "admin1": "Ouest", "pop": "134190" },
  { "id": 1651887, "name": "Adiwerna", "country": "ID", "admin1": "Central Java", "pop": "134188" },
  { "id": 3403697, "name": "Cametá", "country": "BR", "admin1": "Pará", "pop": "134184" },
  {
    "id": 2353099,
    "name": "Abakaliki",
    "country": "NG",
    "admin1": "Ebonyi State",
    "pop": "134102"
  },
  {
    "id": 3384987,
    "name": "Vitória de Santo Antão",
    "country": "BR",
    "admin1": "Pernambuco",
    "pop": "134084"
  },
  { "id": 3547640, "name": "Marianao", "country": "CU", "admin1": "Havana", "pop": "134057" },
  { "id": 5014051, "name": "Warren", "country": "US", "admin1": "Michigan", "pop": "134056" },
  { "id": 1277264, "name": "Bānkura", "country": "IN", "admin1": "West Bengal", "pop": "133966" },
  { "id": 745169, "name": "İnegol", "country": "TR", "admin1": "Bursa Province", "pop": "133959" },
  { "id": 2130404, "name": "Ebetsu", "country": "JP", "admin1": "Hokkaido", "pop": "133953" },
  {
    "id": 2292852,
    "name": "Anyama",
    "country": "CI",
    "admin1": "Abidjan Autonomous District",
    "pop": "133905"
  },
  { "id": 1805962, "name": "Jiawang", "country": "CN", "admin1": "Jiangsu", "pop": "133861" },
  { "id": 1626932, "name": "Singaraja", "country": "ID", "admin1": "Bali", "pop": "133784" },
  { "id": 1260173, "name": "Pātan", "country": "IN", "admin1": "Gujarat", "pop": "133737" },
  { "id": 2805615, "name": "Würzburg", "country": "DE", "admin1": "Bavaria", "pop": "133731" },
  { "id": 1582886, "name": "Đồng Hới", "country": "VN", "admin1": "Quang Tri", "pop": "133672" },
  { "id": 963230, "name": "Randfontein", "country": "ZA", "admin1": "Gauteng", "pop": "133654" },
  {
    "id": 510808,
    "name": "Pervouralsk",
    "country": "RU",
    "admin1": "Sverdlovsk Oblast",
    "pop": "133600"
  },
  {
    "id": 1270996,
    "name": "Gondā City",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "133583"
  },
  { "id": 1854162, "name": "Ōme", "country": "JP", "admin1": "Tokyo", "pop": "133535" },
  { "id": 347907, "name": "Sinnūris", "country": "EG", "admin1": "Faiyum", "pop": "133532" },
  { "id": 3654215, "name": "Milagro", "country": "EC", "admin1": "Guayas", "pop": "133508" },
  { "id": 3460005, "name": "Jaú", "country": "BR", "admin1": "São Paulo", "pop": "133497" },
  { "id": 5441492, "name": "Thornton", "country": "US", "admin1": "Colorado", "pop": "133451" },
  { "id": 2647356, "name": "Hastings", "country": "GB", "admin1": "England", "pop": "133422" },
  {
    "id": 3868707,
    "name": "Valdivia",
    "country": "CL",
    "admin1": "Los Ríos Region",
    "pop": "133419"
  },
  {
    "id": 1513064,
    "name": "Olmaliq",
    "country": "UZ",
    "admin1": "Tashkent Region",
    "pop": "133400"
  },
  { "id": 2326899, "name": "Okrika", "country": "NG", "admin1": "Rivers State", "pop": "133271" },
  {
    "id": 3450269,
    "name": "Santa Cruz do Sul",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "133230"
  },
  { "id": 2646914, "name": "High Wycombe", "country": "GB", "admin1": "England", "pop": "133204" },
  { "id": 4679195, "name": "Carrollton", "country": "US", "admin1": "Texas", "pop": "133168" },
  {
    "id": 1683881,
    "name": "Talisay",
    "country": "PH",
    "admin1": "Central Visayas",
    "pop": "133148"
  },
  { "id": 2457163, "name": "Gao", "country": "ML", "admin1": "Gao", "pop": "133110" },
  { "id": 1272805, "name": "Dhaulpur", "country": "IN", "admin1": "Rajasthan", "pop": "133075" },
  { "id": 149581, "name": "Tarime", "country": "TZ", "admin1": "Mara", "pop": "133043" },
  { "id": 6074377, "name": "Milton", "country": "CA", "admin1": "Ontario", "pop": "132979" },
  { "id": 2486690, "name": "M'Sila", "country": "DZ", "admin1": "M'Sila", "pop": "132975" },
  { "id": 2111684, "name": "Narita", "country": "JP", "admin1": "Chiba", "pop": "132906" },
  {
    "id": 2400555,
    "name": "Franceville",
    "country": "GA",
    "admin1": "Haut-Ogooué",
    "pop": "132895"
  },
  { "id": 1798473, "name": "Puqi", "country": "CN", "admin1": "Hubei", "pop": "132891" },
  { "id": 1850034, "name": "Tondabayashichō", "country": "JP", "admin1": "Osaka", "pop": "132873" },
  { "id": 1853008, "name": "Sandachō", "country": "JP", "admin1": "Hyōgo", "pop": "132858" },
  {
    "id": 124085,
    "name": "Mīāndoāb",
    "country": "IR",
    "admin1": "West Azerbaijan",
    "pop": "132819"
  },
  { "id": 1270990, "name": "Gondiā", "country": "IN", "admin1": "Maharashtra", "pop": "132813" },
  {
    "id": 548114,
    "name": "Kislovodsk",
    "country": "RU",
    "admin1": "Stavropol Kray",
    "pop": "132771"
  },
  {
    "id": 2787149,
    "name": "Schaerbeek",
    "country": "BE",
    "admin1": "Brussels Capital",
    "pop": "132761"
  },
  { "id": 3633444, "name": "Machiques", "country": "VE", "admin1": "Zulia", "pop": "132734" },
  {
    "id": 2753801,
    "name": "Hoofddorp",
    "country": "NL",
    "admin1": "North Holland",
    "pop": "132734"
  },
  { "id": 1260728, "name": "Palakkad", "country": "IN", "admin1": "Kerala", "pop": "132728" },
  {
    "id": 4574324,
    "name": "Charleston",
    "country": "US",
    "admin1": "South Carolina",
    "pop": "132609"
  },
  {
    "id": 6049429,
    "name": "Langley",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "132603"
  },
  { "id": 5526337, "name": "Midland", "country": "US", "admin1": "Texas", "pop": "132524" },
  { "id": 1864105, "name": "Fujinomiya", "country": "JP", "admin1": "Shizuoka", "pop": "132507" },
  { "id": 2775220, "name": "Innsbruck", "country": "AT", "admin1": "Tyrol", "pop": "132493" },
  { "id": 5992500, "name": "Kingston", "country": "CA", "admin1": "Ontario", "pop": "132485" },
  { "id": 1791272, "name": "Wugang", "country": "CN", "admin1": "Hunan", "pop": "132457" },
  { "id": 2648404, "name": "Gloucester", "country": "GB", "admin1": "England", "pop": "132416" },
  { "id": 4739526, "name": "Waco", "country": "US", "admin1": "Texas", "pop": "132356" },
  { "id": 3564436, "name": "Cerro", "country": "CU", "admin1": "Havana", "pop": "132351" },
  { "id": 1848004, "name": "Zama", "country": "JP", "admin1": "Kanagawa", "pop": "132325" },
  { "id": 566199, "name": "Dimitrovgrad", "country": "RU", "admin1": "Ulyanovsk", "pop": "132226" },
  {
    "id": 2033225,
    "name": "Zhalantun",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "132224"
  },
  { "id": 1276393, "name": "Bettiah", "country": "IN", "admin1": "Bihar", "pop": "132209" },
  { "id": 1195434, "name": "Maijdi", "country": "BD", "admin1": "Chittagong", "pop": "132185" },
  {
    "id": 4005937,
    "name": "San Pedro Garza García",
    "country": "MX",
    "admin1": "Nuevo León",
    "pop": "132128"
  },
  {
    "id": 3448031,
    "name": "Sapucaia do Sul",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "132107"
  },
  { "id": 333373, "name": "Kombolcha", "country": "ET", "admin1": "Amhara", "pop": "132100" },
  {
    "id": 1699054,
    "name": "Muricay",
    "country": "PH",
    "admin1": "Zamboanga Peninsula",
    "pop": "132094"
  },
  {
    "id": 5011148,
    "name": "Sterling Heights",
    "country": "US",
    "admin1": "Michigan",
    "pop": "132052"
  },
  {
    "id": 1150515,
    "name": "Surat Thani",
    "country": "TH",
    "admin1": "Surat Thani",
    "pop": "132040"
  },
  {
    "id": 3177090,
    "name": "Ferrara",
    "country": "IT",
    "admin1": "Emilia-Romagna",
    "pop": "132009"
  },
  {
    "id": 12166273,
    "name": "Quận Đức Thịnh",
    "country": "VN",
    "admin1": "Dong Thap",
    "pop": "132000"
  },
  { "id": 1854083, "name": "Ōmuta", "country": "JP", "admin1": "Fukuoka", "pop": "131974" },
  { "id": 1811028, "name": "Fuji", "country": "CN", "admin1": "Sichuan", "pop": "131927" },
  { "id": 1260637, "name": "Palwal", "country": "IN", "admin1": "Haryana", "pop": "131926" },
  { "id": 776029, "name": "Bielany", "country": "PL", "admin1": "Mazovia", "pop": "131910" },
  { "id": 135423, "name": "Shahrud", "country": "IR", "admin1": "Semnan", "pop": "131889" },
  { "id": 1813344, "name": "Dawukou", "country": "CN", "admin1": "Ningxia", "pop": "131880" },
  { "id": 1722930, "name": "Bulaon", "country": "PH", "admin1": "Central Luzon", "pop": "131818" },
  { "id": 1644409, "name": "Garut", "country": "ID", "admin1": "West Java", "pop": "131809" },
  { "id": 2191562, "name": "Dunedin", "country": "NZ", "admin1": "Otago", "pop": "131800" },
  { "id": 89113, "name": "Ajdabiya", "country": "LY", "admin1": "Al Wāḩāt", "pop": "131773" },
  { "id": 2113164, "name": "Abiko", "country": "JP", "admin1": "Chiba", "pop": "131771" },
  { "id": 1860871, "name": "Kadoma", "country": "JP", "admin1": "Osaka", "pop": "131727" },
  { "id": 1801401, "name": "Majie", "country": "CN", "admin1": "Yunnan", "pop": "131696" },
  { "id": 1182815, "name": "Bhakkar", "country": "PK", "admin1": "Punjab", "pop": "131658" },
  { "id": 2492913, "name": "Jijel", "country": "DZ", "admin1": "Jijel", "pop": "131513" },
  {
    "id": 1636022,
    "name": "Martapura",
    "country": "ID",
    "admin1": "South Kalimantan",
    "pop": "131449"
  },
  {
    "id": 2968254,
    "name": "Villeurbanne",
    "country": "FR",
    "admin1": "Rhône-Alpes",
    "pop": "131445"
  },
  {
    "id": 132938,
    "name": "Gonbad-e Kāvūs",
    "country": "IR",
    "admin1": "Golestan",
    "pop": "131416"
  },
  { "id": 2229411, "name": "Limbe", "country": "CM", "admin1": "South-West", "pop": "131381" },
  { "id": 1258470, "name": "Rānīganj", "country": "IN", "admin1": "West Bengal", "pop": "131261" },
  { "id": 1808336, "name": "Hepo", "country": "CN", "admin1": "Guangdong", "pop": "131238" },
  {
    "id": 1160939,
    "name": "Iranshahr",
    "country": "IR",
    "admin1": "Sistan and Baluchestan",
    "pop": "131232"
  },
  {
    "id": 2596935,
    "name": "Soubré",
    "country": "CI",
    "admin1": "Bas-Sassandra District",
    "pop": "131181"
  },
  { "id": 1853992, "name": "Onomichi", "country": "JP", "admin1": "Hiroshima", "pop": "131170" },
  { "id": 3397909, "name": "Itapipoca", "country": "BR", "admin1": "Ceará", "pop": "131123" },
  { "id": 3401545, "name": "Crato", "country": "BR", "admin1": "Ceará", "pop": "131050" },
  { "id": 4685907, "name": "Denton", "country": "US", "admin1": "Texas", "pop": "131044" },
  { "id": 1314759, "name": "Lashio", "country": "MM", "admin1": "Shan State", "pop": "131016" },
  {
    "id": 1259686,
    "name": "Pīlibhīt",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "131008"
  },
  { "id": 2035002, "name": "Shangzhi", "country": "CN", "admin1": "Heilongjiang", "pop": "131006" },
  {
    "id": 518557,
    "name": "Novomoskovsk",
    "country": "RU",
    "admin1": "Tula Oblast",
    "pop": "130982"
  },
  { "id": 1857568, "name": "Matsubara", "country": "JP", "admin1": "Osaka", "pop": "130855" },
  {
    "id": 2293549,
    "name": "Abengourou",
    "country": "CI",
    "admin1": "Comoé District",
    "pop": "130810"
  },
  { "id": 174018, "name": "Al Bāb", "country": "SY", "admin1": "Aleppo", "pop": "130745" },
  {
    "id": 2034834,
    "name": "Shuangcheng",
    "country": "CN",
    "admin1": "Heilongjiang",
    "pop": "130710"
  },
  { "id": 2649808, "name": "Exeter", "country": "GB", "admin1": "England", "pop": "130709" },
  { "id": 2300379, "name": "Ho", "country": "GH", "admin1": "Volta", "pop": "130701" },
  { "id": 1169278, "name": "Narowal", "country": "PK", "admin1": "Punjab", "pop": "130692" },
  { "id": 1576303, "name": "Lào Cai", "country": "VN", "admin1": "Lao Cai", "pop": "130671" },
  {
    "id": 2219701,
    "name": "Al Ajaylat",
    "country": "LY",
    "admin1": "An Nuqāţ al Khams",
    "pop": "130546"
  },
  { "id": 1605239, "name": "Udon Thani", "country": "TH", "admin1": "Udon Thani", "pop": "130531" },
  { "id": 1735102, "name": "Bayan Lepas", "country": "MY", "admin1": "Penang", "pop": "130455" },
  {
    "id": 1258916,
    "name": "Rajapalayam",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "130442"
  },
  {
    "id": 3665542,
    "name": "Zipaquirá",
    "country": "CO",
    "admin1": "Cundinamarca",
    "pop": "130432"
  },
  { "id": 6925362, "name": "Jīroft", "country": "IR", "admin1": "Kerman", "pop": "130429" },
  { "id": 4850751, "name": "Cedar Rapids", "country": "US", "admin1": "Iowa", "pop": "130405" },
  { "id": 1791056, "name": "Dongyang", "country": "CN", "admin1": "Zhejiang", "pop": "130387" },
  { "id": 1913126, "name": "Nantou", "country": "CN", "admin1": "Guangdong", "pop": "130370" },
  { "id": 1275218, "name": "Botad", "country": "IN", "admin1": "Gujarat", "pop": "130327" },
  { "id": 282615, "name": "Nablus", "country": "PS", "admin1": "West Bank", "pop": "130326" },
  { "id": 4839366, "name": "New Haven", "country": "US", "admin1": "Connecticut", "pop": "130322" },
  { "id": 1805935, "name": "Jiazi", "country": "CN", "admin1": "Guangdong", "pop": "130298" },
  { "id": 2231506, "name": "Foumban", "country": "CM", "admin1": "West", "pop": "130287" },
  { "id": 5388881, "name": "Roseville", "country": "US", "admin1": "California", "pop": "130269" },
  { "id": 3874096, "name": "Quilpué", "country": "CL", "admin1": "Valparaíso", "pop": "130263" },
  { "id": 2455558, "name": "Kati", "country": "ML", "admin1": "Koulikoro", "pop": "130254" },
  {
    "id": 1744246,
    "name": "Seri Kembangan",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "130252"
  },
  { "id": 602150, "name": "Umeå", "country": "SE", "admin1": "Västerbotten", "pop": "130224" },
  { "id": 6694101, "name": "Din Daeng", "country": "TH", "admin1": "Bangkok", "pop": "130220" },
  { "id": 1794035, "name": "Songjiang", "country": "CN", "admin1": "Shanghai", "pop": "130218" },
  { "id": 3471910, "name": "Apucarana", "country": "BR", "admin1": "Paraná", "pop": "130134" },
  { "id": 367644, "name": "Sinnar", "country": "SD", "admin1": "Sinnār", "pop": "130122" },
  {
    "id": 3617723,
    "name": "Masaya",
    "country": "NI",
    "admin1": "Masaya Department",
    "pop": "130113"
  },
  { "id": 5406567, "name": "Visalia", "country": "US", "admin1": "California", "pop": "130104" },
  { "id": 12157008, "name": "San Martin", "country": "PE", "admin1": "Piura", "pop": "130000" },
  { "id": 3351500, "name": "Caála", "country": "AO", "admin1": "Huambo", "pop": "130000" },
  { "id": 3082914, "name": "Tychy", "country": "PL", "admin1": "Silesia", "pop": "130000" },
  { "id": 2635608, "name": "Tottenham", "country": "GB", "admin1": "England", "pop": "130000" },
  {
    "id": 1187530,
    "name": "Sonārgaon",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "130000"
  },
  { "id": 280425, "name": "Aley", "country": "LB", "admin1": "Mont-Liban", "pop": "130000" },
  { "id": 1791325, "name": "Wuda", "country": "CN", "admin1": "Inner Mongolia", "pop": "129922" },
  { "id": 5913695, "name": "Cambridge", "country": "CA", "admin1": "Ontario", "pop": "129920" },
  { "id": 304797, "name": "Mardin", "country": "TR", "admin1": "Mardin", "pop": "129864" },
  { "id": 2743477, "name": "Zwolle", "country": "NL", "admin1": "Overijssel", "pop": "129840" },
  { "id": 64536, "name": "Baidoa", "country": "SO", "admin1": "Bay", "pop": "129839" },
  {
    "id": 1568142,
    "name": "Sầm Sơn",
    "country": "VN",
    "admin1": "Thanh Hóa Province",
    "pop": "129801"
  },
  {
    "id": 13527315,
    "name": "Santo António",
    "country": "CN",
    "admin1": "Guangdong",
    "pop": "129800"
  },
  { "id": 2638671, "name": "Salford", "country": "GB", "admin1": "England", "pop": "129794" },
  {
    "id": 1171123,
    "name": "Mandi Bahauddin",
    "country": "PK",
    "admin1": "Punjab",
    "pop": "129733"
  },
  { "id": 738743, "name": "Tokat", "country": "TR", "admin1": "Tokat Province", "pop": "129702" },
  {
    "id": 2464960,
    "name": "Sukrah",
    "country": "TN",
    "admin1": "Ariana Governorate",
    "pop": "129693"
  },
  { "id": 1571644, "name": "Ô Môn", "country": "VN", "admin1": "Can Tho City", "pop": "129683" },
  { "id": 1713226, "name": "Gapan", "country": "PH", "admin1": "Central Luzon", "pop": "129610" },
  { "id": 1273193, "name": "Deoria", "country": "IN", "admin1": "Uttar Pradesh", "pop": "129570" },
  { "id": 1725863, "name": "Bayambang", "country": "PH", "admin1": "Ilocos", "pop": "129506" },
  { "id": 1170425, "name": "Mianwali", "country": "PK", "admin1": "Punjab", "pop": "129500" },
  { "id": 4151909, "name": "Coral Springs", "country": "US", "admin1": "Florida", "pop": "129485" },
  { "id": 6146143, "name": "Sherbrooke", "country": "CA", "admin1": "Quebec", "pop": "129447" },
  {
    "id": 2641674,
    "name": "Newcastle under Lyme",
    "country": "GB",
    "admin1": "England",
    "pop": "129441"
  },
  {
    "id": 89055,
    "name": "Al Bayḑā’",
    "country": "LY",
    "admin1": "Al Jabal al Akhḑar",
    "pop": "129439"
  },
  { "id": 3450817, "name": "Sabará", "country": "BR", "admin1": "Minas Gerais", "pop": "129380" },
  {
    "id": 3183539,
    "name": "Acilia-Castel Fusano-Ostia Antica",
    "country": "IT",
    "admin1": "Lazio",
    "pop": "129362"
  },
  {
    "id": 5402405,
    "name": "Thousand Oaks",
    "country": "US",
    "admin1": "California",
    "pop": "129339"
  },
  { "id": 4381982, "name": "Columbia", "country": "US", "admin1": "Missouri", "pop": "129330" },
  {
    "id": 3052009,
    "name": "Győr",
    "country": "HU",
    "admin1": "Győr-Moson-Sopron",
    "pop": "129301"
  },
  { "id": 3893656, "name": "Copiapó", "country": "CL", "admin1": "Atacama", "pop": "129280" },
  {
    "id": 3445162,
    "name": "Vespasiano",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "129246"
  },
  { "id": 1858964, "name": "Kokubunji", "country": "JP", "admin1": "Tokyo", "pop": "129242" },
  { "id": 3671116, "name": "Quibdó", "country": "CO", "admin1": "Chocó", "pop": "129237" },
  {
    "id": 2548526,
    "name": "Guelmim",
    "country": "MA",
    "admin1": "Guelmim-Oued Noun",
    "pop": "129200"
  },
  { "id": 3645854, "name": "Charallave", "country": "VE", "admin1": "Miranda", "pop": "129182" },
  {
    "id": 115770,
    "name": "Shahr-e Kord",
    "country": "IR",
    "admin1": "Chaharmahal and Bakhtiari",
    "pop": "129153"
  },
  { "id": 2849483, "name": "Regensburg", "country": "DE", "admin1": "Bavaria", "pop": "129151" },
  { "id": 3675595, "name": "Malambo", "country": "CO", "admin1": "Atlántico", "pop": "129148" },
  { "id": 1861212, "name": "Iwakuni", "country": "JP", "admin1": "Yamaguchi", "pop": "129125" },
  { "id": 1804208, "name": "Leiyang", "country": "CN", "admin1": "Hunan", "pop": "129116" },
  { "id": 776103, "name": "Białołeka", "country": "PL", "admin1": "Mazovia", "pop": "129106" },
  { "id": 1721168, "name": "Cadiz", "country": "PH", "admin1": "Western Visayas", "pop": "129053" },
  { "id": 2387495, "name": "Carnot", "country": "CF", "admin1": "Mambéré", "pop": "129032" },
  { "id": 295548, "name": "Bat Yam", "country": "IL", "admin1": "Tel Aviv", "pop": "129012" },
  { "id": 3979844, "name": "Zacatecas", "country": "MX", "admin1": "Zacatecas", "pop": "129011" },
  { "id": 5097598, "name": "Elizabeth", "country": "US", "admin1": "New Jersey", "pop": "129007" },
  { "id": 321082, "name": "Bingöl", "country": "TR", "admin1": "Bingöl", "pop": "128935" },
  {
    "id": 1185111,
    "name": "Sātkhira",
    "country": "BD",
    "admin1": "Khulna Division",
    "pop": "128918"
  },
  { "id": 3630932, "name": "Palo Negro", "country": "VE", "admin1": "Aragua", "pop": "128875" },
  { "id": 4843564, "name": "Stamford", "country": "US", "admin1": "Connecticut", "pop": "128874" },
  { "id": 169389, "name": "Idlib", "country": "SY", "admin1": "Idlib", "pop": "128840" },
  { "id": 2312393, "name": "Moanda", "country": "CD", "admin1": "Bas-Congo", "pop": "128804" },
  { "id": 90708, "name": "Sīnah", "country": "IQ", "admin1": "Duhok", "pop": "128776" },
  { "id": 6822188, "name": "Ōsaki", "country": "JP", "admin1": "Miyagi", "pop": "128763" },
  { "id": 5339111, "name": "Concord", "country": "US", "admin1": "California", "pop": "128667" },
  { "id": 3931276, "name": "Puno", "country": "PE", "admin1": "Puno", "pop": "128637" },
  {
    "id": 553287,
    "name": "Kamyshin",
    "country": "RU",
    "admin1": "Volgograd Oblast",
    "pop": "128626"
  },
  {
    "id": 12450887,
    "name": "Shuanglonghu",
    "country": "CN",
    "admin1": "Chongqing",
    "pop": "128563"
  },
  { "id": 8441115, "name": "Nimach", "country": "IN", "admin1": "Rajasthan", "pop": "128561" },
  { "id": 354775, "name": "Kafr ad Dawwār", "country": "EG", "admin1": "Beheira", "pop": "128539" },
  {
    "id": 12432982,
    "name": "Águas Claras",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "128486"
  },
  {
    "id": 518976,
    "name": "Novocheboksarsk",
    "country": "RU",
    "admin1": "Chuvash Republic",
    "pop": "128468"
  },
  { "id": 3033123, "name": "Besançon", "country": "FR", "admin1": "Bourgogne", "pop": "128426" },
  { "id": 229911, "name": "Lugazi", "country": "UG", "admin1": "Central Region", "pop": "128400" },
  {
    "id": 13513037,
    "name": "Thành phố Sông Công",
    "country": "VN",
    "admin1": "Thai Nguyen",
    "pop": "128357"
  },
  { "id": 1691490, "name": "Rosario", "country": "PH", "admin1": "Calabarzon", "pop": "128352" },
  { "id": 1266945, "name": "Khardah", "country": "IN", "admin1": "West Bengal", "pop": "128346" },
  { "id": 102527, "name": "Sakakah", "country": "SA", "admin1": "Al Jawf Region", "pop": "128332" },
  {
    "id": 2544333,
    "name": "Khenifra",
    "country": "MA",
    "admin1": "Béni Mellal-Khénifra",
    "pop": "128318"
  },
  { "id": 379149, "name": "Al Manāqil", "country": "SD", "admin1": "Al Jazīrah", "pop": "128297" },
  { "id": 1990589, "name": "Teluknaga", "country": "ID", "admin1": "West Java", "pop": "128275" },
  { "id": 612287, "name": "Rustavi", "country": "GE", "admin1": "Kvemo Kartli", "pop": "128249" },
  {
    "id": 3547867,
    "name": "Manzanillo",
    "country": "CU",
    "admin1": "Granma Province",
    "pop": "128188"
  },
  { "id": 1252770, "name": "Yavatmāl", "country": "IN", "admin1": "Maharashtra", "pop": "128175" },
  { "id": 1270484, "name": "Hālīsahar", "country": "IN", "admin1": "West Bengal", "pop": "128172" },
  {
    "id": 496527,
    "name": "Serpukhov",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "128158"
  },
  { "id": 3670730, "name": "Rionegro", "country": "CO", "admin1": "Antioquia", "pop": "128153" },
  { "id": 1280037, "name": "Shache", "country": "CN", "admin1": "Xinjiang", "pop": "128145" },
  { "id": 1267016, "name": "Khanna", "country": "IN", "admin1": "Punjab", "pop": "128137" },
  { "id": 4543762, "name": "Norman", "country": "US", "admin1": "Oklahoma", "pop": "128026" },
  { "id": 3674292, "name": "Mosquera", "country": "CO", "admin1": "Cundinamarca", "pop": "128012" },
  { "id": 3444866, "name": "Votorantim", "country": "BR", "admin1": "São Paulo", "pop": "127923" },
  { "id": 1586989, "name": "Buôn Hồ", "country": "VN", "admin1": "Dak Lak", "pop": "127920" },
  { "id": 1585281, "name": "Chũ", "country": "VN", "admin1": "Bac Ninh", "pop": "127881" },
  { "id": 2664454, "name": "Västerås", "country": "SE", "admin1": "Västmanland", "pop": "127799" },
  { "id": 1852663, "name": "Seto", "country": "JP", "admin1": "Aichi", "pop": "127792" },
  { "id": 1254309, "name": "Titāgarh", "country": "IN", "admin1": "West Bengal", "pop": "127751" },
  {
    "id": 3090048,
    "name": "Opole",
    "country": "PL",
    "admin1": "Opole Voivodeship",
    "pop": "127676"
  },
  {
    "id": 3359041,
    "name": "Worcester",
    "country": "ZA",
    "admin1": "Western Cape",
    "pop": "127597"
  },
  { "id": 3099759, "name": "Elbląg", "country": "PL", "admin1": "Warmia-Masuria", "pop": "127558" },
  {
    "id": 1185115,
    "name": "Sirajganj",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "127481"
  },
  { "id": 3459943, "name": "Jequié", "country": "BR", "admin1": "Bahia", "pop": "127475" },
  { "id": 3088825, "name": "Płock", "country": "PL", "admin1": "Mazovia", "pop": "127474" },
  {
    "id": 3082707,
    "name": "Wałbrzych",
    "country": "PL",
    "admin1": "Lower Silesia",
    "pop": "127431"
  },
  { "id": 584649, "name": "Yevlakh", "country": "AZ", "admin1": "Yevlax City", "pop": "127400" },
  { "id": 360754, "name": "Al Manzalah", "country": "EG", "admin1": "Dakahlia", "pop": "127394" },
  {
    "id": 363885,
    "name": "Wau",
    "country": "SS",
    "admin1": "Western Bahr al Ghazal",
    "pop": "127384"
  },
  { "id": 4180386, "name": "Athens", "country": "US", "admin1": "Georgia", "pop": "127315" },
  { "id": 2350249, "name": "Amaigbo", "country": "NG", "admin1": "Abia State", "pop": "127300" },
  { "id": 1153671, "name": "Chiang Mai", "country": "TH", "admin1": "Chiang Mai", "pop": "127240" },
  { "id": 2332515, "name": "Lafia", "country": "NG", "admin1": "Nasarawa State", "pop": "127236" },
  { "id": 1885823, "name": "Jiangyou", "country": "CN", "admin1": "Sichuan", "pop": "127225" },
  { "id": 1279891, "name": "Tengyue", "country": "CN", "admin1": "Yunnan", "pop": "127133" },
  { "id": 1796376, "name": "Shajing", "country": "CN", "admin1": "Guangdong", "pop": "127089" },
  { "id": 1790251, "name": "Jinfeng", "country": "CN", "admin1": "Jiangxi", "pop": "127076" },
  {
    "id": 3540667,
    "name": "Sancti Spíritus",
    "country": "CU",
    "admin1": "Sancti Spíritus Province",
    "pop": "127069"
  },
  { "id": 3117164, "name": "Mataró", "country": "ES", "admin1": "Catalonia", "pop": "126988" },
  { "id": 5799625, "name": "Kent", "country": "US", "admin1": "Washington", "pop": "126952" },
  { "id": 1302439, "name": "Pakokku", "country": "MM", "admin1": "Magway", "pop": "126938" },
  { "id": 524294, "name": "Murom", "country": "RU", "admin1": "Vladimir Oblast", "pop": "126931" },
  { "id": 3447651, "name": "Sertãozinho", "country": "BR", "admin1": "São Paulo", "pop": "126887" },
  { "id": 1270216, "name": "Hāthras", "country": "IN", "admin1": "Uttar Pradesh", "pop": "126882" },
  {
    "id": 1692520,
    "name": "Pulong Santa Cruz",
    "country": "PH",
    "admin1": "Calabarzon",
    "pop": "126844"
  },
  { "id": 1639900, "name": "Klaten", "country": "ID", "admin1": "Central Java", "pop": "126831" },
  { "id": 550478, "name": "Khasavyurt", "country": "RU", "admin1": "Dagestan", "pop": "126829" },
  {
    "id": 522942,
    "name": "Neftekamsk",
    "country": "RU",
    "admin1": "Bashkortostan Republic",
    "pop": "126805"
  },
  {
    "id": 5396003,
    "name": "Simi Valley",
    "country": "US",
    "admin1": "California",
    "pop": "126788"
  },
  {
    "id": 1725804,
    "name": "Bayawan",
    "country": "PH",
    "admin1": "Central Visayas",
    "pop": "126744"
  },
  { "id": 1268820, "name": "Jorhat", "country": "IN", "admin1": "Assam", "pop": "126736" },
  { "id": 3634922, "name": "La Victoria", "country": "VE", "admin1": "Aragua", "pop": "126721" },
  { "id": 1168555, "name": "Pakpattan", "country": "PK", "admin1": "Punjab", "pop": "126706" },
  { "id": 1805543, "name": "Jingzhi", "country": "CN", "admin1": "Shandong", "pop": "126703" },
  { "id": 1813812, "name": "Danshui", "country": "CN", "admin1": "Guangdong", "pop": "126701" },
  { "id": 1332083, "name": "Bahawalnagar", "country": "PK", "admin1": "Punjab", "pop": "126700" },
  { "id": 3406429, "name": "Barcarena", "country": "BR", "admin1": "Pará", "pop": "126650" },
  { "id": 2637546, "name": "Solihull", "country": "GB", "admin1": "England", "pop": "126577" },
  {
    "id": 5344994,
    "name": "East Los Angeles",
    "country": "US",
    "admin1": "California",
    "pop": "126496"
  },
  {
    "id": 1265157,
    "name": "Lalitpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "126475"
  },
  { "id": 1642414, "name": "Jombang", "country": "ID", "admin1": "East Java", "pop": "126465" },
  {
    "id": 1039536,
    "name": "Maxixe",
    "country": "MZ",
    "admin1": "Inhambane Province",
    "pop": "126408"
  },
  {
    "id": 1608529,
    "name": "Nakhon Ratchasima",
    "country": "TH",
    "admin1": "Nakhon Ratchasima",
    "pop": "126391"
  },
  {
    "id": 3620381,
    "name": "Chinandega",
    "country": "NI",
    "admin1": "Chinandega Department",
    "pop": "126387"
  },
  {
    "id": 2219960,
    "name": "Al Jadīd",
    "country": "LY",
    "admin1": "Sabha District",
    "pop": "126386"
  },
  {
    "id": 3437863,
    "name": "Lambaré",
    "country": "PY",
    "admin1": "Central Department",
    "pop": "126377"
  },
  { "id": 3445578, "name": "Valinhos", "country": "BR", "admin1": "São Paulo", "pop": "126373" },
  { "id": 1801582, "name": "Macheng", "country": "CN", "admin1": "Hubei", "pop": "126366" },
  { "id": 1861835, "name": "Iizuka", "country": "JP", "admin1": "Fukuoka", "pop": "126364" },
  {
    "id": 1153269,
    "name": "Hua Hin",
    "country": "TH",
    "admin1": "Prachuap Khiri Khan",
    "pop": "126355"
  },
  {
    "id": 3628489,
    "name": "San Carlos del Zulia",
    "country": "VE",
    "admin1": "Zulia",
    "pop": "126353"
  },
  { "id": 281102, "name": "Rafaḩ", "country": "PS", "admin1": "Gaza Strip", "pop": "126305" },
  { "id": 1735168, "name": "Ampang", "country": "MY", "admin1": "Kuala Lumpur", "pop": "126285" },
  { "id": 3407882, "name": "Altamira", "country": "BR", "admin1": "Pará", "pop": "126279" },
  {
    "id": 1270670,
    "name": "Guntakal",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "126270"
  },
  {
    "id": 5393015,
    "name": "Santa Clara",
    "country": "US",
    "admin1": "California",
    "pop": "126215"
  },
  {
    "id": 7279595,
    "name": "Pithampur",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "126200"
  },
  { "id": 1632197, "name": "Paseh", "country": "ID", "admin1": "West Java", "pop": "126181" },
  { "id": 1262710, "name": "Mothīhāri", "country": "IN", "admin1": "Bihar", "pop": "126158" },
  { "id": 11612579, "name": "Koganei", "country": "JP", "admin1": "Tokyo", "pop": "126074" },
  {
    "id": 13527308,
    "name": "Nossa Senhora de Fátima",
    "country": "CN",
    "admin1": "Guangdong",
    "pop": "126000"
  },
  { "id": 4280539, "name": "Topeka", "country": "US", "admin1": "Kansas", "pop": "125963" },
  { "id": 1950953, "name": "Paek'ak", "country": "KP", "admin1": "South Pyongan", "pop": "125924" },
  { "id": 1806881, "name": "Huicheng", "country": "CN", "admin1": "Guangdong", "pop": "125919" },
  {
    "id": 3629710,
    "name": "Puerto Ayacucho",
    "country": "VE",
    "admin1": "Amazonas",
    "pop": "125840"
  },
  { "id": 2341656, "name": "Gashua", "country": "NG", "admin1": "Yobe State", "pop": "125817" },
  { "id": 3728097, "name": "Les Cayes", "country": "HT", "admin1": "Sud", "pop": "125799" },
  { "id": 3168673, "name": "Salerno", "country": "IT", "admin1": "Campania", "pop": "125797" },
  { "id": 350203, "name": "Rosetta", "country": "EG", "admin1": "Beheira", "pop": "125778" },
  {
    "id": 1653316,
    "name": "Savannakhet",
    "country": "LA",
    "admin1": "Savannakhet Province",
    "pop": "125760"
  },
  { "id": 2634677, "name": "Watford", "country": "GB", "admin1": "England", "pop": "125707" },
  { "id": 352354, "name": "Munūf", "country": "EG", "admin1": "Monufia", "pop": "125707" },
  { "id": 746881, "name": "Giresun", "country": "TR", "admin1": "Giresun", "pop": "125682" },
  { "id": 1789703, "name": "Xiazhen", "country": "CN", "admin1": "Shandong", "pop": "125667" },
  {
    "id": 112646,
    "name": "Torbat-e Ḩeydarīyeh",
    "country": "IR",
    "admin1": "Razavi Khorasan",
    "pop": "125633"
  },
  {
    "id": 1879490,
    "name": "Chaeryŏng-ni",
    "country": "KP",
    "admin1": "South Pyongan",
    "pop": "125631"
  },
  { "id": 743882, "name": "Kastamonu", "country": "TR", "admin1": "Kastamonu", "pop": "125622" },
  { "id": 1163967, "name": "Tando Adam", "country": "PK", "admin1": "Sindh", "pop": "125598" },
  { "id": 1268015, "name": "Kanhangad", "country": "IN", "admin1": "Kerala", "pop": "125564" },
  { "id": 250799, "name": "‘Ajlūn", "country": "JO", "admin1": "Ajlun", "pop": "125557" },
  { "id": 748208, "name": "Derince", "country": "TR", "admin1": "Kocaeli", "pop": "125485" },
  {
    "id": 1269578,
    "name": "Jagdalpur",
    "country": "IN",
    "admin1": "Chhattisgarh",
    "pop": "125463"
  },
  { "id": 6845329, "name": "Bang Sue", "country": "TH", "admin1": "Bangkok", "pop": "125440" },
  { "id": 3882428, "name": "Los Ángeles", "country": "CL", "admin1": "Biobío", "pop": "125430" },
  { "id": 1809062, "name": "Haimen", "country": "CN", "admin1": "Guangdong", "pop": "125427" },
  {
    "id": 744562,
    "name": "Karabük",
    "country": "TR",
    "admin1": "Karabük Province",
    "pop": "125403"
  },
  {
    "id": 11205667,
    "name": "Ntuzuma",
    "country": "ZA",
    "admin1": "KwaZulu-Natal",
    "pop": "125394"
  },
  { "id": 1849563, "name": "Tsuruoka", "country": "JP", "admin1": "Yamagata", "pop": "125389" },
  { "id": 2638703, "name": "Saint Peters", "country": "GB", "admin1": "England", "pop": "125370" },
  {
    "id": 3470858,
    "name": "Barbacena",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "125317"
  },
  { "id": 6822153, "name": "Uruma", "country": "JP", "admin1": "Okinawa", "pop": "125303" },
  { "id": 339686, "name": "Debre Tabor", "country": "ET", "admin1": "Amhara", "pop": "125300" },
  { "id": 150930, "name": "Nzega", "country": "TZ", "admin1": "Tabora", "pop": "125193" },
  { "id": 4669635, "name": "Abilene", "country": "US", "admin1": "Texas", "pop": "125182" },
  { "id": 1613549, "name": "Ban Samae Dam", "country": "TH", "admin1": "Bangkok", "pop": "125133" },
  { "id": 1796421, "name": "Shahecheng", "country": "CN", "admin1": "Hebei", "pop": "125132" },
  { "id": 2229748, "name": "Kumbo", "country": "CM", "admin1": "North-West", "pop": "125124" },
  { "id": 3513090, "name": "Willemstad", "country": "CW", "admin1": null, "pop": "125000" },
  { "id": 618605, "name": "Bălţi", "country": "MD", "admin1": "Bălţi", "pop": "125000" },
  { "id": 107781, "name": "Az Zulfī", "country": "SA", "admin1": "Riyadh Region", "pop": "125000" },
  { "id": 96961, "name": "Soran", "country": "IQ", "admin1": "Erbil", "pop": "125000" },
  {
    "id": 1685378,
    "name": "Sultan Kudarat",
    "country": "PH",
    "admin1": "Autonomous Region in Muslim Mindanao",
    "pop": "124965"
  },
  { "id": 295432, "name": "Bet Shemesh", "country": "IL", "admin1": "Jerusalem", "pop": "124957" },
  { "id": 1269605, "name": "Jagādhri", "country": "IN", "admin1": "Haryana", "pop": "124894" },
  { "id": 3827414, "name": "Huixquilucan", "country": "MX", "admin1": "México", "pop": "124846" },
  { "id": 116402, "name": "Semnan", "country": "IR", "admin1": "Semnan", "pop": "124826" },
  {
    "id": 3118532,
    "name": "León",
    "country": "ES",
    "admin1": "Castille and León",
    "pop": "124772"
  },
  {
    "id": 3493146,
    "name": "San Francisco de Macorís",
    "country": "DO",
    "admin1": "Duarte Province",
    "pop": "124763"
  },
  { "id": 2033242, "name": "Yushu", "country": "CN", "admin1": "Jilin", "pop": "124736" },
  { "id": 1665443, "name": "Yuanlin", "country": "TW", "admin1": "Taiwan", "pop": "124725" },
  {
    "id": 3584257,
    "name": "Santa Tecla",
    "country": "SV",
    "admin1": "La Libertad Department",
    "pop": "124694"
  },
  {
    "id": 2407656,
    "name": "Koidu",
    "country": "SL",
    "admin1": "Eastern Province",
    "pop": "124662"
  },
  {
    "id": 3461888,
    "name": "Guarapari",
    "country": "BR",
    "admin1": "Espírito Santo",
    "pop": "124656"
  },
  {
    "id": 3483849,
    "name": "Ciudad Valles",
    "country": "MX",
    "admin1": "San Luis Potosí",
    "pop": "124644"
  },
  { "id": 2357043, "name": "Ouahigouya", "country": "BF", "admin1": "Nord", "pop": "124587" },
  { "id": 1859951, "name": "Kashihara-shi", "country": "JP", "admin1": "Nara", "pop": "124521" },
  { "id": 360048, "name": "Ashmūn", "country": "EG", "admin1": "Monufia", "pop": "124483" },
  { "id": 2751792, "name": "Leeuwarden", "country": "NL", "admin1": "Friesland", "pop": "124481" },
  { "id": 1587976, "name": "Bến Tre", "country": "VN", "admin1": "Vinh Long", "pop": "124449" },
  {
    "id": 3098722,
    "name": "Gorzów Wielkopolski",
    "country": "PL",
    "admin1": "Lubusz",
    "pop": "124430"
  },
  { "id": 3172629, "name": "Monza", "country": "IT", "admin1": "Lombardy", "pop": "124398" },
  {
    "id": 1169027,
    "name": "New Mirpur City",
    "country": "PK",
    "admin1": "Azad Kashmir",
    "pop": "124352"
  },
  { "id": 3925033, "name": "Ji Paraná", "country": "BR", "admin1": "Rondônia", "pop": "124333" },
  { "id": 3686675, "name": "Chía", "country": "CO", "admin1": "Cundinamarca", "pop": "124309" },
  { "id": 623549, "name": "Pinsk", "country": "BY", "admin1": "Brest", "pop": "124295" },
  { "id": 757065, "name": "Targówek", "country": "PL", "admin1": "Mazovia", "pop": "124279" },
  { "id": 1804252, "name": "Lecheng", "country": "CN", "admin1": "Guangdong", "pop": "124268" },
  { "id": 1800130, "name": "Nancun", "country": "CN", "admin1": "Shandong", "pop": "124210" },
  { "id": 124862, "name": "Marand", "country": "IR", "admin1": "East Azerbaijan", "pop": "124191" },
  {
    "id": 359815,
    "name": "As Sinbillāwayn",
    "country": "EG",
    "admin1": "Dakahlia",
    "pop": "124020"
  },
  { "id": 1519843, "name": "Rudnyy", "country": "KZ", "admin1": "Qostanay", "pop": "124000" },
  { "id": 3675692, "name": "Magangué", "country": "CO", "admin1": "Bolívar", "pop": "123982" },
  {
    "id": 3460899,
    "name": "Itaguaí",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "123980"
  },
  { "id": 776251, "name": "Bemowo", "country": "PL", "admin1": "Mazovia", "pop": "123932" },
  { "id": 2994160, "name": "Metz", "country": "FR", "admin1": "Grand Est", "pop": "123914" },
  { "id": 2036403, "name": "Jiupu", "country": "CN", "admin1": "Liaoning", "pop": "123843" },
  { "id": 1273467, "name": "Dārjiling", "country": "IN", "admin1": "West Bengal", "pop": "123797" },
  { "id": 2038438, "name": "Baoshan", "country": "CN", "admin1": "Heilongjiang", "pop": "123791" },
  {
    "id": 3493240,
    "name": "Salvaleón de Higüey",
    "country": "DO",
    "admin1": "La Altagracia Province",
    "pop": "123787"
  },
  {
    "id": 3448519,
    "name": "São Mateus",
    "country": "BR",
    "admin1": "Espírito Santo",
    "pop": "123752"
  },
  { "id": 1292288, "name": "Thaton", "country": "MM", "admin1": "Mon", "pop": "123727" },
  { "id": 11500546, "name": "Kurichchi", "country": "IN", "admin1": "Tamil Nadu", "pop": "123667" },
  { "id": 1637090, "name": "Lumajang", "country": "ID", "admin1": "East Java", "pop": "123626" },
  { "id": 1861450, "name": "Ise", "country": "JP", "admin1": "Mie", "pop": "123533" },
  { "id": 1711982, "name": "Hagonoy", "country": "PH", "admin1": "Central Luzon", "pop": "123531" },
  {
    "id": 3445679,
    "name": "Uruguaiana",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "123480"
  },
  { "id": 301975, "name": "Samandağ", "country": "TR", "admin1": "Hatay", "pop": "123447" },
  {
    "id": 3467081,
    "name": "Caraguatatuba",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "123389"
  },
  { "id": 3397967, "name": "Itaituba", "country": "BR", "admin1": "Pará", "pop": "123314" },
  { "id": 2510542, "name": "Telde", "country": "ES", "admin1": "Canary Islands", "pop": "123265" },
  { "id": 1643078, "name": "Indramayu", "country": "ID", "admin1": "West Java", "pop": "123263" },
  { "id": 2483668, "name": "Relizane", "country": "DZ", "admin1": "Relizane", "pop": "123255" },
  {
    "id": 2503661,
    "name": "Bordj el Kiffan",
    "country": "DZ",
    "admin1": "Algiers",
    "pop": "123246"
  },
  {
    "id": 1528249,
    "name": "Jalal-Abad",
    "country": "KG",
    "admin1": "Jalal-Abad Region",
    "pop": "123239"
  },
  { "id": 7303138, "name": "Kirishima", "country": "JP", "admin1": "Kagoshima", "pop": "123205" },
  { "id": 3522307, "name": "Orizaba", "country": "MX", "admin1": "Veracruz", "pop": "123182" },
  {
    "id": 3470073,
    "name": "Bento Gonçalves",
    "country": "BR",
    "admin1": "Rio Grande do Sul",
    "pop": "123151"
  },
  { "id": 1801799, "name": "Luoyang", "country": "CN", "admin1": "Guangdong", "pop": "123144" },
  { "id": 1163272, "name": "Toba Tek Singh", "country": "PK", "admin1": "Punjab", "pop": "123102" },
  { "id": 3405006, "name": "Bragança", "country": "BR", "admin1": "Pará", "pop": "123082" },
  { "id": 1632276, "name": "Parung", "country": "ID", "admin1": "West Java", "pop": "123078" },
  { "id": 1848445, "name": "Honmachi", "country": "JP", "admin1": "Kumamoto", "pop": "123067" },
  {
    "id": 2806654,
    "name": "Wolfsburg",
    "country": "DE",
    "admin1": "Lower Saxony",
    "pop": "123064"
  },
  { "id": 1855425, "name": "Niihama", "country": "JP", "admin1": "Ehime", "pop": "123059" },
  { "id": 2036536, "name": "Jiaohe", "country": "CN", "admin1": "Jilin", "pop": "123018" },
  { "id": 3446692, "name": "Tatuí", "country": "BR", "admin1": "São Paulo", "pop": "122967" },
  {
    "id": 2518794,
    "name": "Dos Hermanas",
    "country": "ES",
    "admin1": "Andalusia",
    "pop": "122943"
  },
  { "id": 8031389, "name": "Tabuk", "country": "PH", "admin1": "Cordillera", "pop": "122771" },
  { "id": 1684803, "name": "Tabuk", "country": "PH", "admin1": "Cordillera", "pop": "122771" },
  { "id": 1272243, "name": "Dam Dam", "country": "IN", "admin1": "West Bengal", "pop": "122719" },
  { "id": 233312, "name": "Hoima", "country": "UG", "admin1": "Western Region", "pop": "122700" },
  { "id": 3472766, "name": "Alagoinhas", "country": "BR", "admin1": "Bahia", "pop": "122688" },
  { "id": 98245, "name": "Az Zubayr", "country": "IQ", "admin1": "Basra", "pop": "122676" },
  { "id": 1864750, "name": "Beppu", "country": "JP", "admin1": "Oita", "pop": "122643" },
  { "id": 1270370, "name": "Hardoī", "country": "IN", "admin1": "Uttar Pradesh", "pop": "122635" },
  { "id": 3460598, "name": "Itatiba", "country": "BR", "admin1": "São Paulo", "pop": "122581" },
  { "id": 1807112, "name": "Huangzhou", "country": "CN", "admin1": "Hubei", "pop": "122563" },
  {
    "id": 1605245,
    "name": "Ubon Ratchathani",
    "country": "TH",
    "admin1": "Ubon Ratchathani",
    "pop": "122533"
  },
  { "id": 1259163, "name": "Puruliya", "country": "IN", "admin1": "West Bengal", "pop": "122533" },
  { "id": 943882, "name": "Virginia", "country": "ZA", "admin1": "Free State", "pop": "122502" },
  { "id": 1015621, "name": "Brits", "country": "ZA", "admin1": "North West", "pop": "122497" },
  { "id": 3470451, "name": "Barretos", "country": "BR", "admin1": "São Paulo", "pop": "122485" },
  { "id": 6947640, "name": "Beylikdüzü", "country": "TR", "admin1": "Istanbul", "pop": "122452" },
  {
    "id": 2849647,
    "name": "Recklinghausen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "122438"
  },
  { "id": 1788268, "name": "Xiulin", "country": "CN", "admin1": "Hubei", "pop": "122411" },
  { "id": 1784178, "name": "Zhoucun", "country": "CN", "admin1": "Shandong", "pop": "122402" },
  {
    "id": 569154,
    "name": "Cherkessk",
    "country": "RU",
    "admin1": "Karachayevo-Cherkesiya Republic",
    "pop": "122395"
  },
  { "id": 2751283, "name": "Maastricht", "country": "NL", "admin1": "Limburg", "pop": "122378" },
  { "id": 5107129, "name": "Amherst", "country": "US", "admin1": "New York", "pop": "122366" },
  { "id": 3398352, "name": "Igarassu", "country": "BR", "admin1": "Pernambuco", "pop": "122312" },
  { "id": 738927, "name": "Tekirdağ", "country": "TR", "admin1": "Tekirdağ", "pop": "122287" },
  {
    "id": 5406222,
    "name": "Victorville",
    "country": "US",
    "admin1": "California",
    "pop": "122225"
  },
  {
    "id": 2654200,
    "name": "Burton upon Trent",
    "country": "GB",
    "admin1": "England",
    "pop": "122199"
  },
  { "id": 1181073, "name": "Chishtian", "country": "PK", "admin1": "Punjab", "pop": "122199" },
  {
    "id": 1720034,
    "name": "Calumpit",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "122187"
  },
  { "id": 7026837, "name": "Lat Phrao", "country": "TH", "admin1": "Bangkok", "pop": "122182" },
  {
    "id": 2918632,
    "name": "Göttingen",
    "country": "DE",
    "admin1": "Lower Saxony",
    "pop": "122149"
  },
  {
    "id": 13118233,
    "name": "Titiwangsa",
    "country": "MY",
    "admin1": "Kuala Lumpur",
    "pop": "122096"
  },
  { "id": 1607782, "name": "Phasi Charoen", "country": "TH", "admin1": "Bangkok", "pop": "122070" },
  {
    "id": 1113217,
    "name": "Zābol",
    "country": "IR",
    "admin1": "Sistan and Baluchestan",
    "pop": "121989"
  },
  { "id": 2359608, "name": "Kaya", "country": "BF", "admin1": "Centre-Nord", "pop": "121970" },
  { "id": 1790442, "name": "Xiangcheng", "country": "CN", "admin1": "Yunnan", "pop": "121959" },
  {
    "id": 1272842,
    "name": "Dharmavaram",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "121874"
  },
  { "id": 2652618, "name": "Colchester", "country": "GB", "admin1": "England", "pop": "121859" },
  { "id": 345149, "name": "Ādīgrat", "country": "ET", "admin1": "Tigray", "pop": "121800" },
  { "id": 3646487, "name": "Carora", "country": "VE", "admin1": "Lara", "pop": "121741" },
  { "id": 5405380, "name": "Vallejo", "country": "US", "admin1": "California", "pop": "121692" },
  { "id": 2159220, "name": "Mackay", "country": "AU", "admin1": "Queensland", "pop": "121691" },
  {
    "id": 1276320,
    "name": "Bhadreswar",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "121662"
  },
  {
    "id": 135878,
    "name": "Dorūd",
    "country": "IR",
    "admin1": "Lorestan Province",
    "pop": "121638"
  },
  { "id": 2661552, "name": "Bern", "country": "CH", "admin1": "Bern", "pop": "121631" },
  { "id": 1261163, "name": "Nagaon", "country": "IN", "admin1": "Assam", "pop": "121628" },
  { "id": 1253315, "name": "Vejalpur", "country": "IN", "admin1": "Gujarat", "pop": "121610" },
  { "id": 1802420, "name": "Longshui", "country": "CN", "admin1": "Chongqing", "pop": "121609" },
  { "id": 2523083, "name": "Siracusa", "country": "IT", "admin1": "Sicily", "pop": "121605" },
  { "id": 228971, "name": "Mubende", "country": "UG", "admin1": "Central Region", "pop": "121600" },
  { "id": 650224, "name": "Kuopio", "country": "FI", "admin1": "North Savo", "pop": "121557" },
  { "id": 3346821, "name": "Ondjiva", "country": "AO", "admin1": "Cunene", "pop": "121537" },
  { "id": 1023441, "name": "Alberton", "country": "ZA", "admin1": "Gauteng", "pop": "121536" },
  { "id": 1636884, "name": "Magelang", "country": "ID", "admin1": "Central Java", "pop": "121526" },
  { "id": 1274220, "name": "Chikmagalūr", "country": "IN", "admin1": "Karnataka", "pop": "121484" },
  {
    "id": 1524325,
    "name": "Ekibastuz",
    "country": "KZ",
    "admin1": "Pavlodar Region",
    "pop": "121470"
  },
  { "id": 2522013, "name": "Algeciras", "country": "ES", "admin1": "Andalusia", "pop": "121414" },
  { "id": 2742032, "name": "Braga", "country": "PT", "admin1": "Braga", "pop": "121394" },
  { "id": 4330145, "name": "Lafayette", "country": "US", "admin1": "Louisiana", "pop": "121374" },
  { "id": 2035669, "name": "Lianhe", "country": "CN", "admin1": "Heilongjiang", "pop": "121367" },
  { "id": 5336269, "name": "Chico", "country": "US", "admin1": "California", "pop": "121345" },
  { "id": 1276325, "name": "Bhadrak", "country": "IN", "admin1": "Odisha", "pop": "121338" },
  {
    "id": 4839745,
    "name": "North Stamford",
    "country": "US",
    "admin1": "Connecticut",
    "pop": "121230"
  },
  { "id": 3182164, "name": "Bergamo", "country": "IT", "admin1": "Lombardy", "pop": "121200" },
  {
    "id": 1256949,
    "name": "Sawai Madhopur",
    "country": "IN",
    "admin1": "Rajasthan",
    "pop": "121106"
  },
  { "id": 1585317, "name": "Chơn Thành", "country": "VN", "admin1": "Dong Nai", "pop": "121083" },
  {
    "id": 1278827,
    "name": "Ambikāpur",
    "country": "IN",
    "admin1": "Chhattisgarh",
    "pop": "121071"
  },
  { "id": 1730413, "name": "Apalit", "country": "PH", "admin1": "Central Luzon", "pop": "121057" },
  { "id": 4835797, "name": "Hartford", "country": "US", "admin1": "Connecticut", "pop": "121054" },
  {
    "id": 1647866,
    "name": "Bukittinggi",
    "country": "ID",
    "admin1": "West Sumatra",
    "pop": "121028"
  },
  { "id": 2258261, "name": "Dolisie", "country": "CG", "admin1": "Niari", "pop": "121000" },
  { "id": 6318714, "name": "Sorriso", "country": "BR", "admin1": "Mato Grosso", "pop": "120985" },
  { "id": 3644417, "name": "Ejido", "country": "VE", "admin1": "Mérida", "pop": "120978" },
  { "id": 5327684, "name": "Berkeley", "country": "US", "admin1": "California", "pop": "120972" },
  {
    "id": 2033824,
    "name": "Xilin Hot",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "120965"
  },
  {
    "id": 1693239,
    "name": "Plaridel",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "120939"
  },
  {
    "id": 4177887,
    "name": "West Palm Beach",
    "country": "US",
    "admin1": "Florida",
    "pop": "120932"
  },
  { "id": 1859913, "name": "Kashiwara", "country": "JP", "admin1": "Nara", "pop": "120922" },
  { "id": 1861749, "name": "Ikoma", "country": "JP", "admin1": "Nara", "pop": "120741" },
  {
    "id": 2907669,
    "name": "Heilbronn",
    "country": "DE",
    "admin1": "Baden-Wurttemberg",
    "pop": "120733"
  },
  {
    "id": 3165243,
    "name": "Trento",
    "country": "IT",
    "admin1": "Trentino-Alto Adige",
    "pop": "120709"
  },
  { "id": 1165638, "name": "Shahdad Kot", "country": "PK", "admin1": "Sindh", "pop": "120687" },
  { "id": 2895992, "name": "Ingolstadt", "country": "DE", "admin1": "Bavaria", "pop": "120658" },
  {
    "id": 3461936,
    "name": "Guará",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "120641"
  },
  { "id": 1803782, "name": "Lichuan", "country": "CN", "admin1": "Hubei", "pop": "120587" },
  { "id": 1650319, "name": "Bangil", "country": "ID", "admin1": "East Java", "pop": "120551" },
  {
    "id": 11054399,
    "name": "Bukit Bintang",
    "country": "MY",
    "admin1": "Kuala Lumpur",
    "pop": "120529"
  },
  { "id": 2037411, "name": "Fengcheng", "country": "CN", "admin1": "Liaoning", "pop": "120514" },
  { "id": 3638371, "name": "La Concepción", "country": "VE", "admin1": "Zulia", "pop": "120478" },
  { "id": 2820256, "name": "Ulm", "country": "DE", "admin1": "Baden-Wurttemberg", "pop": "120451" },
  { "id": 10265071, "name": "Mandoli", "country": "IN", "admin1": "Delhi", "pop": "120417" },
  { "id": 309647, "name": "Ağrı", "country": "TR", "admin1": "Ağrı", "pop": "120390" },
  { "id": 3628503, "name": "San Carlos", "country": "VE", "admin1": "Cojedes", "pop": "120375" },
  {
    "id": 3081741,
    "name": "Włocławek",
    "country": "PL",
    "admin1": "Kujawsko-Pomorskie",
    "pop": "120339"
  },
  {
    "id": 5178127,
    "name": "Allentown",
    "country": "US",
    "admin1": "Pennsylvania",
    "pop": "120207"
  },
  { "id": 1257055, "name": "Satara", "country": "IN", "admin1": "Maharashtra", "pop": "120195" },
  {
    "id": 13308659,
    "name": "Bao'an Centre",
    "country": "CN",
    "admin1": "Guangdong",
    "pop": "120170"
  },
  {
    "id": 1181439,
    "name": "Charsadda",
    "country": "PK",
    "admin1": "Khyber Pakhtunkhwa",
    "pop": "120170"
  },
  {
    "id": 3438115,
    "name": "Fernando de la Mora",
    "country": "PY",
    "admin1": "Central Department",
    "pop": "120167"
  },
  { "id": 1273892, "name": "Chūru", "country": "IN", "admin1": "Rajasthan", "pop": "120157" },
  { "id": 3171180, "name": "Perugia", "country": "IT", "admin1": "Umbria", "pop": "120137" },
  { "id": 1271675, "name": "Gangāpur", "country": "IN", "admin1": "Rajasthan", "pop": "120115" },
  { "id": 649360, "name": "Lahti", "country": "FI", "admin1": "Paijat-Hame", "pop": "120093" },
  { "id": 2495662, "name": "Guelma", "country": "DZ", "admin1": "Guelma", "pop": "120004" },
  {
    "id": 8504621,
    "name": "Gereida",
    "country": "SD",
    "admin1": "Southern Darfur",
    "pop": "120000"
  },
  { "id": 1784953, "name": "Zhaoyuan", "country": "CN", "admin1": "Shandong", "pop": "120000" },
  { "id": 701822, "name": "Mariupol", "country": "UA", "admin1": "Donetsk", "pop": "120000" },
  {
    "id": 515024,
    "name": "Orekhovo-Zuyevo",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "120000"
  },
  {
    "id": 289011,
    "name": "Rustaq",
    "country": "OM",
    "admin1": "Al Batinah South",
    "pop": "120000"
  },
  {
    "id": 278913,
    "name": "Nabatîyé et Tahta",
    "country": "LB",
    "admin1": "Nabatîyé",
    "pop": "120000"
  },
  { "id": 63400, "name": "Cabudwaaq", "country": "SO", "admin1": "Galguduud", "pop": "120000" },
  {
    "id": 8411054,
    "name": "Madhyapur Thimi",
    "country": "NP",
    "admin1": "Bagmati Province",
    "pop": "119955"
  },
  { "id": 4257227, "name": "Evansville", "country": "US", "admin1": "Indiana", "pop": "119943" },
  {
    "id": 7849539,
    "name": "Bonon",
    "country": "CI",
    "admin1": "Sassandra-Marahoué",
    "pop": "119938"
  },
  {
    "id": 2945756,
    "name": "Bottrop",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "119909"
  },
  { "id": 1178456, "name": "Ghotki", "country": "PK", "admin1": "Sindh", "pop": "119879" },
  {
    "id": 888710,
    "name": "Kwekwe",
    "country": "ZW",
    "admin1": "Midlands Province",
    "pop": "119863"
  },
  { "id": 187968, "name": "Malindi", "country": "KE", "admin1": "Kilifi County", "pop": "119859" },
  { "id": 740483, "name": "Rize", "country": "TR", "admin1": "Rize Province", "pop": "119828" },
  {
    "id": 3472518,
    "name": "Almirante Tamandaré",
    "country": "BR",
    "admin1": "Paraná",
    "pop": "119825"
  },
  { "id": 1176106, "name": "Jaranwala", "country": "PK", "admin1": "Punjab", "pop": "119785" },
  { "id": 4167499, "name": "Palm Bay", "country": "US", "admin1": "Florida", "pop": "119760" },
  { "id": 3450594, "name": "Salto", "country": "BR", "admin1": "São Paulo", "pop": "119736" },
  { "id": 1328872, "name": "Ann", "country": "MM", "admin1": "Rakhine", "pop": "119714" },
  { "id": 2751773, "name": "Leiden", "country": "NL", "admin1": "South Holland", "pop": "119713" },
  { "id": 1605403, "name": "Thon Buri", "country": "TH", "admin1": "Bangkok", "pop": "119708" },
  { "id": 5882873, "name": "Ajax", "country": "CA", "admin1": "Ontario", "pop": "119677" },
  { "id": 3171168, "name": "Pescara", "country": "IT", "admin1": "Abruzzo", "pop": "119554" },
  { "id": 2330028, "name": "Modakeke", "country": "NG", "admin1": "Osun State", "pop": "119529" },
  { "id": 1855095, "name": "Nobeoka", "country": "JP", "admin1": "Miyazaki", "pop": "119521" },
  { "id": 1686547, "name": "Silang", "country": "PH", "admin1": "Calabarzon", "pop": "119475" },
  {
    "id": 2304848,
    "name": "Amanfrom",
    "country": "GH",
    "admin1": "Greater Accra",
    "pop": "119467"
  },
  {
    "id": 400771,
    "name": "Moḩammad Shahr",
    "country": "IR",
    "admin1": "Alborz Province",
    "pop": "119418"
  },
  { "id": 130697, "name": "Īz̄eh", "country": "IR", "admin1": "Khuzestan", "pop": "119399" },
  { "id": 303873, "name": "Nazilli", "country": "TR", "admin1": "Aydın", "pop": "119370" },
  { "id": 1864416, "name": "Daitō", "country": "JP", "admin1": "Osaka", "pop": "119367" },
  { "id": 230166, "name": "Lira", "country": "UG", "admin1": "Northern Region", "pop": "119323" },
  { "id": 3446370, "name": "Toledo", "country": "BR", "admin1": "Paraná", "pop": "119313" },
  {
    "id": 2853969,
    "name": "Pforzheim",
    "country": "DE",
    "admin1": "Baden-Wurttemberg",
    "pop": "119313"
  },
  {
    "id": 1734815,
    "name": "Port Dickson",
    "country": "MY",
    "admin1": "Negeri Sembilan",
    "pop": "119300"
  },
  { "id": 2555467, "name": "Berkane", "country": "MA", "admin1": "Oriental", "pop": "119284" },
  {
    "id": 2756669,
    "name": "Dordrecht",
    "country": "NL",
    "admin1": "South Holland",
    "pop": "119260"
  },
  { "id": 1831797, "name": "Battambang", "country": "KH", "admin1": "Battambang", "pop": "119251" },
  { "id": 2857807, "name": "Offenbach", "country": "DE", "admin1": "Hesse", "pop": "119192" },
  { "id": 3471798, "name": "Arapongas", "country": "BR", "admin1": "Paraná", "pop": "119138" },
  { "id": 2129537, "name": "Kitami", "country": "JP", "admin1": "Hokkaido", "pop": "119135" },
  { "id": 1562548, "name": "Vĩnh Yên", "country": "VN", "admin1": "Phu Tho", "pop": "119128" },
  { "id": 1465594, "name": "Madhavaram", "country": "IN", "admin1": "Tamil Nadu", "pop": "119105" },
  { "id": 3647549, "name": "Cagua", "country": "VE", "admin1": "Aragua", "pop": "119033" },
  {
    "id": 292878,
    "name": "Al Fujairah City",
    "country": "AE",
    "admin1": "Fujairah",
    "pop": "118933"
  },
  {
    "id": 1041190,
    "name": "Mandimba",
    "country": "MZ",
    "admin1": "Niassa Province",
    "pop": "118922"
  },
  {
    "id": 3413829,
    "name": "Reykjavík",
    "country": "IS",
    "admin1": "Capital Region",
    "pop": "118918"
  },
  { "id": 1273687, "name": "Dohad", "country": "IN", "admin1": "Gujarat", "pop": "118846" },
  { "id": 3696378, "name": "Huaraz", "country": "PE", "admin1": "Ancash", "pop": "118836" },
  {
    "id": 3109981,
    "name": "Santa Coloma de Gramenet",
    "country": "ES",
    "admin1": "Catalonia",
    "pop": "118821"
  },
  { "id": 3453535, "name": "Piraquara", "country": "BR", "admin1": "Paraná", "pop": "118730" },
  { "id": 1276856, "name": "Barshi", "country": "IN", "admin1": "Maharashtra", "pop": "118722" },
  { "id": 1280737, "name": "Lhasa", "country": "CN", "admin1": "Tibet", "pop": "118721" },
  { "id": 1591440, "name": "Bắc Quang", "country": "VN", "admin1": "Tuyen Quang", "pop": "118690" },
  { "id": 1787901, "name": "Xunchang", "country": "CN", "admin1": "Sichuan", "pop": "118664" },
  {
    "id": 1580142,
    "name": "Hưng Yên",
    "country": "VN",
    "admin1": "Hưng Yên Province",
    "pop": "118646"
  },
  { "id": 3523149, "name": "Miramar", "country": "MX", "admin1": "Tamaulipas", "pop": "118614" },
  {
    "id": 963516,
    "name": "Queenstown",
    "country": "ZA",
    "admin1": "Eastern Cape",
    "pop": "118599"
  },
  { "id": 1800175, "name": "Nanbin", "country": "CN", "admin1": "Chongqing", "pop": "118597" },
  {
    "id": 1609899,
    "name": "Khlong Luang",
    "country": "TH",
    "admin1": "Pathum Thani",
    "pop": "118551"
  },
  { "id": 1279344, "name": "Ādilābād", "country": "IN", "admin1": "Telangana", "pop": "118526" },
  { "id": 5059163, "name": "Fargo", "country": "US", "admin1": "North Dakota", "pop": "118523" },
  { "id": 2800931, "name": "Brugge", "country": "BE", "admin1": "Flanders", "pop": "118509" },
  { "id": 1268936, "name": "Jhunjhunūn", "country": "IN", "admin1": "Rajasthan", "pop": "118473" },
  {
    "id": 3526798,
    "name": "Iguala de la Independencia",
    "country": "MX",
    "admin1": "Guerrero",
    "pop": "118468"
  },
  { "id": 3447998, "name": "Sarandi", "country": "BR", "admin1": "Paraná", "pop": "118455" },
  { "id": 3447854, "name": "Senador Canedo", "country": "BR", "admin1": "Goiás", "pop": "118451" },
  { "id": 923295, "name": "Zomba", "country": "MW", "admin1": "Southern Region", "pop": "118440" },
  { "id": 1627610, "name": "Sepatan", "country": "ID", "admin1": "West Java", "pop": "118439" },
  { "id": 1702649, "name": "Malita", "country": "PH", "admin1": "Davao Region", "pop": "118438" },
  { "id": 3080165, "name": "Zielona Góra", "country": "PL", "admin1": "Lubusz", "pop": "118433" },
  { "id": 1269065, "name": "Jetpur", "country": "IN", "admin1": "Gujarat", "pop": "118302" },
  { "id": 1253744, "name": "Uppal Kalan", "country": "IN", "admin1": "Telangana", "pop": "118259" },
  { "id": 353183, "name": "Maghāghah", "country": "EG", "admin1": "Minya", "pop": "118223" },
  { "id": 2650497, "name": "Eastbourne", "country": "GB", "admin1": "England", "pop": "118219" },
  {
    "id": 1230089,
    "name": "Pita Kotte",
    "country": "LK",
    "admin1": "Western Province",
    "pop": "118179"
  },
  {
    "id": 1712531,
    "name": "Guiguinto",
    "country": "PH",
    "admin1": "Central Luzon",
    "pop": "118173"
  },
  {
    "id": 1270801,
    "name": "Gudivāda",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "118167"
  },
  {
    "id": 3107784,
    "name": "Torrejón de Ardoz",
    "country": "ES",
    "admin1": "Madrid",
    "pop": "118162"
  },
  {
    "id": 6822148,
    "name": "Aizu-Wakamatsu",
    "country": "JP",
    "admin1": "Fukushima",
    "pop": "118159"
  },
  { "id": 2347954, "name": "Bama", "country": "NG", "admin1": "Borno State", "pop": "118121" },
  { "id": 2337659, "name": "Ilobu", "country": "NG", "admin1": "Osun State", "pop": "118089" },
  {
    "id": 1701537,
    "name": "Manolo Fortich",
    "country": "PH",
    "admin1": "Northern Mindanao",
    "pop": "118075"
  },
  { "id": 3460170, "name": "Jandira", "country": "BR", "admin1": "São Paulo", "pop": "118045" },
  {
    "id": 3461859,
    "name": "Guaratinguetá",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "118044"
  },
  { "id": 3836669, "name": "San Rafael", "country": "AR", "admin1": "Mendoza", "pop": "118009" },
  { "id": 1795860, "name": "Shaoshan", "country": "CN", "admin1": "Hunan", "pop": "118000" },
  {
    "id": 1572526,
    "name": "Nghi Xuân",
    "country": "VN",
    "admin1": "Hà Tĩnh Province",
    "pop": "118000"
  },
  { "id": 1277084, "name": "Bārān", "country": "IN", "admin1": "Rajasthan", "pop": "117992" },
  {
    "id": 1269939,
    "name": "Narmadapuram",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "117988"
  },
  { "id": 1278715, "name": "Amreli", "country": "IN", "admin1": "Gujarat", "pop": "117967" },
  {
    "id": 1608534,
    "name": "Nakhon Pathom",
    "country": "TH",
    "admin1": "Nakhon Pathom",
    "pop": "117927"
  },
  { "id": 1860728, "name": "Kakegawa", "country": "JP", "admin1": "Shizuoka", "pop": "117925" },
  { "id": 352913, "name": "Manfalūţ", "country": "EG", "admin1": "Asyut", "pop": "117925" },
  { "id": 1863209, "name": "Handa", "country": "JP", "admin1": "Aichi", "pop": "117884" },
  { "id": 1790920, "name": "Wushan", "country": "CN", "admin1": "Chongqing", "pop": "117873" },
  { "id": 2395915, "name": "Abomey", "country": "BJ", "admin1": "Zou", "pop": "117824" },
  { "id": 2364104, "name": "Sokodé", "country": "TG", "admin1": "Centrale", "pop": "117811" },
  { "id": 3471830, "name": "Araguari", "country": "BR", "admin1": "Minas Gerais", "pop": "117808" },
  { "id": 757026, "name": "Tarnów", "country": "PL", "admin1": "Lesser Poland", "pop": "117799" },
  { "id": 1619460, "name": "Bangkok Noi", "country": "TH", "admin1": "Bangkok", "pop": "117793" },
  { "id": 2336589, "name": "Jalingo", "country": "NG", "admin1": "Taraba State", "pop": "117757" },
  {
    "id": 6136944,
    "name": "Saanich",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "117735"
  },
  { "id": 233299, "name": "Ibanda", "country": "UG", "admin1": "Western Region", "pop": "117700" },
  {
    "id": 716935,
    "name": "Nyíregyháza",
    "country": "HU",
    "admin1": "Szabolcs-Szatmár-Bereg",
    "pop": "117689"
  },
  { "id": 1852964, "name": "Sano", "country": "JP", "admin1": "Tochigi", "pop": "117669" },
  { "id": 1860063, "name": "Karatsu", "country": "JP", "admin1": "Saga", "pop": "117663" },
  {
    "id": 1512165,
    "name": "Achinsk",
    "country": "RU",
    "admin1": "Krasnoyarsk Krai",
    "pop": "117634"
  },
  {
    "id": 1259297,
    "name": "Pudukkottai",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "117630"
  },
  { "id": 2034754, "name": "Shunyi", "country": "CN", "admin1": "Beijing", "pop": "117623" },
  { "id": 2639093, "name": "Rotherham", "country": "GB", "admin1": "England", "pop": "117618" },
  {
    "id": 3980194,
    "name": "Ciudad de Villa de Álvarez",
    "country": "MX",
    "admin1": "Colima",
    "pop": "117600"
  },
  { "id": 2482908, "name": "Rouiba", "country": "DZ", "admin1": "Algiers", "pop": "117558" },
  { "id": 1650077, "name": "Banyuwangi", "country": "ID", "admin1": "East Java", "pop": "117558" },
  {
    "id": 1213500,
    "name": "Tebingtinggi",
    "country": "ID",
    "admin1": "North Sumatra",
    "pop": "117530"
  },
  { "id": 3718962, "name": "Tigwav", "country": "HT", "admin1": "Ouest", "pop": "117504" },
  {
    "id": 1261848,
    "name": "Narasaraopet",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "117489"
  },
  { "id": 211734, "name": "Lisala", "country": "CD", "admin1": "Mongala", "pop": "117464" },
  { "id": 1184055, "name": "Badin", "country": "PK", "admin1": "Sindh", "pop": "117455" },
  {
    "id": 2362909,
    "name": "Banfora",
    "country": "BF",
    "admin1": "Cascades Region",
    "pop": "117452"
  },
  {
    "id": 3874787,
    "name": "Punta Arenas",
    "country": "CL",
    "admin1": "Region of Magallanes",
    "pop": "117430"
  },
  {
    "id": 889453,
    "name": "Kadoma",
    "country": "ZW",
    "admin1": "Mashonaland West",
    "pop": "117381"
  },
  { "id": 1699755, "name": "Midsayap", "country": "PH", "admin1": "Soccsksargen", "pop": "117365" },
  {
    "id": 1309937,
    "name": "Pyin Oo Lwin",
    "country": "MM",
    "admin1": "Mandalay Region",
    "pop": "117303"
  },
  { "id": 4151316, "name": "Clearwater", "country": "US", "admin1": "Florida", "pop": "117292" },
  {
    "id": 1711718,
    "name": "Himamaylan",
    "country": "PH",
    "admin1": "Western Visayas",
    "pop": "117286"
  },
  { "id": 4391812, "name": "Independence", "country": "US", "admin1": "Missouri", "pop": "117255" },
  {
    "id": 4005143,
    "name": "Heroica Guaymas",
    "country": "MX",
    "admin1": "Sonora",
    "pop": "117253"
  },
  {
    "id": 1640581,
    "name": "Kedungwuni",
    "country": "ID",
    "admin1": "Central Java",
    "pop": "117249"
  },
  { "id": 215976, "name": "Ilebo", "country": "CD", "admin1": "Kasai", "pop": "117245" },
  { "id": 3149318, "name": "Kristiansand", "country": "NO", "admin1": "Agder", "pop": "117237" },
  { "id": 2035966, "name": "Longjing", "country": "CN", "admin1": "Jilin", "pop": "117185" },
  { "id": 986846, "name": "Kroonstad", "country": "ZA", "admin1": "Free State", "pop": "117152" },
  {
    "id": 2848273,
    "name": "Remscheid",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "117118"
  },
  { "id": 5640350, "name": "Billings", "country": "US", "admin1": "Montana", "pop": "117116" },
  { "id": 2262963, "name": "Setúbal", "country": "PT", "admin1": "Setúbal", "pop": "117110" },
  { "id": 3445782, "name": "Umuarama", "country": "BR", "admin1": "Paraná", "pop": "117095" },
  { "id": 792078, "name": "Čačak", "country": "RS", "admin1": "Central Serbia", "pop": "117072" },
  { "id": 4984247, "name": "Ann Arbor", "country": "US", "admin1": "Michigan", "pop": "117070" },
  { "id": 1705536, "name": "Los Baños", "country": "PH", "admin1": "Calabarzon", "pop": "117030" },
  { "id": 2289549, "name": "Duekoué", "country": "CI", "admin1": "Montagnes", "pop": "117023" },
  { "id": 11611628, "name": "Higashikurume", "country": "JP", "admin1": "Tokyo", "pop": "117020" },
  { "id": 1258126, "name": "Rishra", "country": "IN", "admin1": "West Bengal", "pop": "117014" },
  { "id": 6317953, "name": "Pinhais", "country": "BR", "admin1": "Paraná", "pop": "117000" },
  {
    "id": 1500973,
    "name": "Kyzyl",
    "country": "RU",
    "admin1": "Republic of Tyva",
    "pop": "116983"
  },
  { "id": 2520600, "name": "Cadiz", "country": "ES", "admin1": "Andalusia", "pop": "116979" },
  {
    "id": 3100796,
    "name": "Dąbrowa Górnicza",
    "country": "PL",
    "admin1": "Silesia",
    "pop": "116971"
  },
  { "id": 1684681, "name": "Tacurong", "country": "PH", "admin1": "Soccsksargen", "pop": "116945" },
  { "id": 356989, "name": "Fāqūs", "country": "EG", "admin1": "Sharqia", "pop": "116945" },
  { "id": 1862302, "name": "Hōfu", "country": "JP", "admin1": "Yamaguchi", "pop": "116925" },
  { "id": 3348613, "name": "Gabela", "country": "AO", "admin1": "Kwanza Sul", "pop": "116903" },
  { "id": 3682281, "name": "Funza", "country": "CO", "admin1": "Cundinamarca", "pop": "116890" },
  { "id": 1276942, "name": "Baripāda", "country": "IN", "admin1": "Odisha", "pop": "116849" },
  { "id": 1858794, "name": "Kōnosu", "country": "JP", "admin1": "Saitama", "pop": "116828" },
  { "id": 1626560, "name": "Soreang", "country": "ID", "admin1": "West Java", "pop": "116780" },
  {
    "id": 1714781,
    "name": "Dinaig",
    "country": "PH",
    "admin1": "Autonomous Region in Muslim Mindanao",
    "pop": "116768"
  },
  { "id": 2042893, "name": "Manp’o", "country": "KP", "admin1": "Chagang", "pop": "116760" },
  { "id": 1262578, "name": "Muktsar", "country": "IN", "admin1": "Punjab", "pop": "116747" },
  { "id": 5345743, "name": "El Monte", "country": "US", "admin1": "California", "pop": "116732" },
  { "id": 3176746, "name": "Forlì", "country": "IT", "admin1": "Emilia-Romagna", "pop": "116696" },
  {
    "id": 1278083,
    "name": "Azamgarh",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "116644"
  },
  {
    "id": 12432973,
    "name": "Santa Maria",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "116622"
  },
  { "id": 229380, "name": "Masaka", "country": "UG", "admin1": "Central Region", "pop": "116600" },
  { "id": 1184845, "name": "Ahmadpur East", "country": "PK", "admin1": "Punjab", "pop": "116579" },
  { "id": 1584784, "name": "Cờ Đỏ", "country": "VN", "admin1": "Can Tho City", "pop": "116576" },
  {
    "id": 1518542,
    "name": "Taldykorgan",
    "country": "KZ",
    "admin1": "Jetisu Region",
    "pop": "116558"
  },
  { "id": 1809408, "name": "Gulin", "country": "CN", "admin1": "Sichuan", "pop": "116527" },
  { "id": 7026999, "name": "Thung Khru", "country": "TH", "admin1": "Bangkok", "pop": "116473" },
  { "id": 1276895, "name": "Barnāla", "country": "IN", "admin1": "Punjab", "pop": "116449" },
  { "id": 2653261, "name": "Cheltenham", "country": "GB", "admin1": "England", "pop": "116447" },
  { "id": 1252758, "name": "Yelahanka", "country": "IN", "admin1": "Karnataka", "pop": "116447" },
  { "id": 1614295, "name": "Pattaya", "country": "TH", "admin1": "Chon Buri", "pop": "116417" },
  { "id": 1274040, "name": "Chittorgarh", "country": "IN", "admin1": "Rajasthan", "pop": "116406" },
  { "id": 1815276, "name": "Chenggu", "country": "CN", "admin1": "Shaanxi", "pop": "116375" },
  { "id": 1254432, "name": "Tinsukia", "country": "IN", "admin1": "Assam", "pop": "116322" },
  { "id": 5443910, "name": "Westminster", "country": "US", "admin1": "Colorado", "pop": "116317" },
  { "id": 1807301, "name": "Dasha", "country": "CN", "admin1": "Guangdong", "pop": "116307" },
  { "id": 353802, "name": "Kom Ombo", "country": "EG", "admin1": "Aswan", "pop": "116293" },
  {
    "id": 2033536,
    "name": "Yakeshi",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "116284"
  },
  { "id": 2989317, "name": "Orléans", "country": "FR", "admin1": "Centre", "pop": "116269" },
  { "id": 155101, "name": "Makumbako", "country": "TZ", "admin1": "Njombe", "pop": "116232" },
  { "id": 2177091, "name": "Ballarat", "country": "AU", "admin1": "Victoria", "pop": "116201" },
  {
    "id": 1266928,
    "name": "Khargone",
    "country": "IN",
    "admin1": "Madhya Pradesh",
    "pop": "116150"
  },
  { "id": 3632929, "name": "Mariara", "country": "VE", "admin1": "Carabobo", "pop": "116142" },
  { "id": 1714956, "name": "Digos", "country": "PH", "admin1": "Davao Region", "pop": "116122" },
  { "id": 922083, "name": "Tshilenge", "country": "CD", "admin1": "Lualaba", "pop": "116073" },
  {
    "id": 2508287,
    "name": "Aïn Beïda",
    "country": "DZ",
    "admin1": "Oum el Bouaghi",
    "pop": "116064"
  },
  {
    "id": 32909,
    "name": "Shahre Jadide Andisheh",
    "country": "IR",
    "admin1": "Tehran",
    "pop": "116062"
  },
  { "id": 3130583, "name": "Alcobendas", "country": "ES", "admin1": "Madrid", "pop": "116037" },
  { "id": 2419472, "name": "Kissidougou", "country": "GN", "admin1": "Faranah", "pop": "116019" },
  {
    "id": 1819283,
    "name": "San Tung Chung Hang",
    "country": "HK",
    "admin1": "Islands",
    "pop": "116000"
  },
  { "id": 4724129, "name": "Round Rock", "country": "US", "admin1": "Texas", "pop": "115997" },
  { "id": 520068, "name": "Noginsk", "country": "RU", "admin1": "Moscow Oblast", "pop": "115979" },
  { "id": 3626219, "name": "Tinaquillo", "country": "VE", "admin1": "Cojedes", "pop": "115937" },
  {
    "id": 4499379,
    "name": "Wilmington",
    "country": "US",
    "admin1": "North Carolina",
    "pop": "115933"
  },
  {
    "id": 1717641,
    "name": "Cavite City",
    "country": "PH",
    "admin1": "Calabarzon",
    "pop": "115932"
  },
  { "id": 3463140, "name": "Formosa", "country": "BR", "admin1": "Goiás", "pop": "115901" },
  { "id": 3427833, "name": "Tandil", "country": "AR", "admin1": "Buenos Aires", "pop": "115877" },
  {
    "id": 2743856,
    "name": "Zoetermeer",
    "country": "NL",
    "admin1": "South Holland",
    "pop": "115845"
  },
  {
    "id": 3388713,
    "name": "São Gonçalo do Amarante",
    "country": "BR",
    "admin1": "Rio Grande do Norte",
    "pop": "115838"
  },
  {
    "id": 1238992,
    "name": "Sri Jayewardenepura Kotte",
    "country": "LK",
    "admin1": "Western Province",
    "pop": "115826"
  },
  { "id": 6822174, "name": "Nasushiobara", "country": "JP", "admin1": "Tochigi", "pop": "115794" },
  { "id": 3466692, "name": "Catanduva", "country": "BR", "admin1": "São Paulo", "pop": "115791" },
  {
    "id": 3445446,
    "name": "Várzea Paulista",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "115771"
  },
  { "id": 1817441, "name": "Baisha", "country": "CN", "admin1": "Chongqing", "pop": "115761" },
  { "id": 359212, "name": "Banī Mazār", "country": "EG", "admin1": "Minya", "pop": "115759" },
  { "id": 6822152, "name": "Urasoe", "country": "JP", "admin1": "Okinawa", "pop": "115690" },
  { "id": 467978, "name": "Yelets", "country": "RU", "admin1": "Lipetsk Oblast", "pop": "115688" },
  { "id": 7026898, "name": "Suan Luang", "country": "TH", "admin1": "Bangkok", "pop": "115658" },
  { "id": 3114256, "name": "Parla", "country": "ES", "admin1": "Madrid", "pop": "115611" },
  {
    "id": 1574155,
    "name": "Mỹ Hào",
    "country": "VN",
    "admin1": "Hưng Yên Province",
    "pop": "115608"
  },
  { "id": 1818020, "name": "Anliu", "country": "CN", "admin1": "Guangdong", "pop": "115560" },
  {
    "id": 3451329,
    "name": "Ribeirão Pires",
    "country": "BR",
    "admin1": "São Paulo",
    "pop": "115559"
  },
  {
    "id": 13450916,
    "name": "Recanto das Emas",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "115550"
  },
  {
    "id": 13132725,
    "name": "Chunga",
    "country": "ZM",
    "admin1": "Lusaka Province",
    "pop": "115539"
  },
  {
    "id": 511510,
    "name": "Novo-Peredelkino",
    "country": "RU",
    "admin1": "Moscow",
    "pop": "115536"
  },
  {
    "id": 1277780,
    "name": "Baidyabāti",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "115504"
  },
  { "id": 2327143, "name": "Okigwe", "country": "NG", "admin1": "Imo State", "pop": "115499" },
  { "id": 690548, "name": "Uzhhorod", "country": "UA", "admin1": "Zakarpattia", "pop": "115449" },
  { "id": 232066, "name": "Kasese", "country": "UG", "admin1": "Western Region", "pop": "115400" },
  { "id": 1804169, "name": "Lengshuijiang", "country": "CN", "admin1": "Hunan", "pop": "115399" },
  { "id": 1791536, "name": "Tianfu", "country": "CN", "admin1": "Shandong", "pop": "115370" },
  { "id": 5412199, "name": "Arvada", "country": "US", "admin1": "Colorado", "pop": "115368" },
  { "id": 2128574, "name": "Otaru", "country": "JP", "admin1": "Hokkaido", "pop": "115333" },
  { "id": 1682659, "name": "Tayabas", "country": "PH", "admin1": "Calabarzon", "pop": "115318" },
  { "id": 2315419, "name": "Inkisi", "country": "CD", "admin1": "Bas-Congo", "pop": "115317" },
  {
    "id": 1710544,
    "name": "Iriga City",
    "country": "PH",
    "admin1": "Bicol Region",
    "pop": "115306"
  },
  { "id": 933945, "name": "Vacoas", "country": "MU", "admin1": "Plaines Wilhems", "pop": "115289" },
  { "id": 4672989, "name": "Beaumont", "country": "US", "admin1": "Texas", "pop": "115282" },
  { "id": 3183719, "name": "Vlorë", "country": "AL", "admin1": "Vlorë County", "pop": "115261" },
  { "id": 1670106, "name": "Sanxia", "country": "TW", "admin1": "Taipei", "pop": "115185" },
  { "id": 5780026, "name": "Provo", "country": "US", "admin1": "Utah", "pop": "115162" },
  { "id": 1276736, "name": "Bastī", "country": "IN", "admin1": "Uttar Pradesh", "pop": "115115" },
  { "id": 4905687, "name": "Peoria", "country": "US", "admin1": "Illinois", "pop": "115070" },
  { "id": 1513604, "name": "Xiva", "country": "UZ", "admin1": "Xorazm Region", "pop": "115000" },
  { "id": 752015, "name": "Amasya", "country": "TR", "admin1": "Amasya", "pop": "114921" },
  { "id": 3844421, "name": "Mendoza", "country": "AR", "admin1": "Mendoza", "pop": "114893" },
  { "id": 1147290, "name": "Balkh", "country": "AF", "admin1": "Balkh", "pop": "114883" },
  { "id": 1800498, "name": "Mingshui", "country": "CN", "admin1": "Shandong", "pop": "114858" },
  {
    "id": 1570863,
    "name": "Phong Điền",
    "country": "VN",
    "admin1": "Thừa Thiên Huế Province",
    "pop": "114820"
  },
  {
    "id": 7027001,
    "name": "Wang Thonglang",
    "country": "TH",
    "admin1": "Bangkok",
    "pop": "114768"
  },
  { "id": 5334223, "name": "Carlsbad", "country": "US", "admin1": "California", "pop": "114746" },
  { "id": 187896, "name": "Mandera", "country": "KE", "admin1": "Mandera County", "pop": "114718" },
  { "id": 1798131, "name": "Qiaotou", "country": "CN", "admin1": "Qinghai", "pop": "114712" },
  { "id": 1218667, "name": "Mary", "country": "TM", "admin1": "Mary", "pop": "114680" },
  { "id": 1271662, "name": "Gangavati", "country": "IN", "admin1": "Karnataka", "pop": "114642" },
  { "id": 1278815, "name": "Ambur", "country": "IN", "admin1": "Tamil Nadu", "pop": "114608" },
  { "id": 6318694, "name": "Simões Filho", "country": "BR", "admin1": "Bahia", "pop": "114559" },
  { "id": 1271175, "name": "Giridih", "country": "IN", "admin1": "Jharkhand", "pop": "114533" },
  {
    "id": 1692214,
    "name": "Quezon",
    "country": "PH",
    "admin1": "Northern Mindanao",
    "pop": "114521"
  },
  {
    "id": 2473247,
    "name": "Aryanah",
    "country": "TN",
    "admin1": "Ariana Governorate",
    "pop": "114486"
  },
  { "id": 2112656, "name": "Ichinoseki", "country": "JP", "admin1": "Iwate", "pop": "114476" },
  { "id": 2491889, "name": "Khenchela", "country": "DZ", "admin1": "Khenchela", "pop": "114472" },
  { "id": 1609776, "name": "Khon Kaen", "country": "TH", "admin1": "Khon Kaen", "pop": "114459" },
  { "id": 5527554, "name": "Odessa", "country": "US", "admin1": "Texas", "pop": "114428" },
  { "id": 3466696, "name": "Catalão", "country": "BR", "admin1": "Goiás", "pop": "114427" },
  {
    "id": 1163952,
    "name": "Tando Muhammad Khan",
    "country": "PK",
    "admin1": "Sindh",
    "pop": "114406"
  },
  { "id": 4250542, "name": "Springfield", "country": "US", "admin1": "Illinois", "pop": "114394" },
  { "id": 1105728, "name": "Somaroboro", "country": "ZA", "admin1": "Mpumalanga", "pop": "114369" },
  {
    "id": 3688256,
    "name": "Guadalajara de Buga",
    "country": "CO",
    "admin1": "Valle del Cauca Department",
    "pop": "114316"
  },
  { "id": 1632998, "name": "Pamanukan", "country": "ID", "admin1": "West Java", "pop": "114290" },
  { "id": 3402000, "name": "Codó", "country": "BR", "admin1": "Maranhão", "pop": "114275" },
  { "id": 1569684, "name": "Pleiku", "country": "VN", "admin1": "Gia Lai", "pop": "114225" },
  { "id": 5343858, "name": "Downey", "country": "US", "admin1": "California", "pop": "114219" },
  { "id": 1785545, "name": "Yuyao", "country": "CN", "admin1": "Zhejiang", "pop": "114177" },
  { "id": 1863018, "name": "Hatsukaichi", "country": "JP", "admin1": "Hiroshima", "pop": "114173" },
  { "id": 11101593, "name": "Tung Chung", "country": "HK", "admin1": "Islands", "pop": "114100" },
  { "id": 300822, "name": "Siirt", "country": "TR", "admin1": "Siirt", "pop": "114034" },
  { "id": 2033147, "name": "Zhaozhou", "country": "CN", "admin1": "Heilongjiang", "pop": "114009" },
  { "id": 3629614, "name": "Punta Cardón", "country": "VE", "admin1": "Falcón", "pop": "113999" },
  { "id": 6822132, "name": "Akishima", "country": "JP", "admin1": "Tokyo", "pop": "113949" },
  {
    "id": 919544,
    "name": "Chililabombwe",
    "country": "ZM",
    "admin1": "Copperbelt",
    "pop": "113876"
  },
  { "id": 3995019, "name": "Navojoa", "country": "MX", "admin1": "Sonora", "pop": "113836" },
  { "id": 2327879, "name": "Offa", "country": "NG", "admin1": "Kwara State", "pop": "113830" },
  { "id": 1489530, "name": "Tobolsk", "country": "RU", "admin1": "Tyumen Oblast", "pop": "113800" },
  { "id": 11612537, "name": "Tōkai", "country": "JP", "admin1": "Aichi", "pop": "113787" },
  { "id": 1252942, "name": "Wardha", "country": "IN", "admin1": "Maharashtra", "pop": "113759" },
  { "id": 1791765, "name": "Wansheng", "country": "CN", "admin1": "Chongqing", "pop": "113751" },
  { "id": 3463690, "name": "Eunápolis", "country": "BR", "admin1": "Bahia", "pop": "113710" },
  { "id": 1791706, "name": "Wayaobu", "country": "CN", "admin1": "Shaanxi", "pop": "113698" },
  { "id": 1862636, "name": "Hikone", "country": "JP", "admin1": "Shiga", "pop": "113647" },
  { "id": 1856243, "name": "Nagahama", "country": "JP", "admin1": "Shiga", "pop": "113636" },
  { "id": 1798713, "name": "Pingshan", "country": "CN", "admin1": "Guangdong", "pop": "113631" },
  { "id": 2035399, "name": "Songyuan", "country": "CN", "admin1": "Jilin", "pop": "113611" },
  { "id": 1801615, "name": "Maba", "country": "CN", "admin1": "Guangdong", "pop": "113609" },
  { "id": 6822159, "name": "Fujimino", "country": "JP", "admin1": "Saitama", "pop": "113597" },
  { "id": 2651123, "name": "Doncaster", "country": "GB", "admin1": "England", "pop": "113566" },
  {
    "id": 1587759,
    "name": "Bình Thủy",
    "country": "VN",
    "admin1": "Can Tho City",
    "pop": "113565"
  },
  {
    "id": 2944368,
    "name": "Bremerhaven",
    "country": "DE",
    "admin1": "City state Bremen",
    "pop": "113557"
  },
  {
    "id": 1714201,
    "name": "Dumaguete",
    "country": "PH",
    "admin1": "Central Visayas",
    "pop": "113541"
  },
  { "id": 2516395, "name": "Jaén", "country": "ES", "admin1": "Andalusia", "pop": "113457" },
  { "id": 3101619, "name": "Chorzów", "country": "PL", "admin1": "Silesia", "pop": "113430" },
  {
    "id": 2188164,
    "name": "Lower Hutt",
    "country": "NZ",
    "admin1": "Wellington Region",
    "pop": "113400"
  },
  { "id": 2249222, "name": "Louga", "country": "SN", "admin1": "Louga", "pop": "113365" },
  { "id": 2416402, "name": "Kamsar", "country": "GN", "admin1": "Boké Region", "pop": "113350" },
  { "id": 3625207, "name": "Yaritagua", "country": "VE", "admin1": "Yaracuy", "pop": "113343" },
  { "id": 3460960, "name": "Itabira", "country": "BR", "admin1": "Minas Gerais", "pop": "113343" },
  {
    "id": 192785,
    "name": "Khwisero",
    "country": "KE",
    "admin1": "Kakamega County",
    "pop": "113294"
  },
  { "id": 5339840, "name": "Costa Mesa", "country": "US", "admin1": "California", "pop": "113204" },
  { "id": 4164167, "name": "Miami Gardens", "country": "US", "admin1": "Florida", "pop": "113187" },
  { "id": 2653225, "name": "Chesterfield", "country": "GB", "admin1": "England", "pop": "113057" },
  { "id": 4903976, "name": "North Peoria", "country": "US", "admin1": "Illinois", "pop": "113004" },
  {
    "id": 495344,
    "name": "Shchyolkovo",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "113000"
  },
  { "id": 361329, "name": "Al Fashn", "country": "EG", "admin1": "Beni Suweif", "pop": "112999" },
  { "id": 5347335, "name": "Fairfield", "country": "US", "admin1": "California", "pop": "112970" },
  { "id": 3557846, "name": "Guanabacoa", "country": "CU", "admin1": "Havana", "pop": "112964" },
  {
    "id": 998082,
    "name": "Hammanskraal",
    "country": "ZA",
    "admin1": "North West",
    "pop": "112950"
  },
  { "id": 6822184, "name": "Ōshū", "country": "JP", "admin1": "Iwate", "pop": "112937" },
  { "id": 2530048, "name": "Taourirt", "country": "MA", "admin1": "Oriental", "pop": "112908" },
  { "id": 3392734, "name": "Paulo Afonso", "country": "BR", "admin1": "Bahia", "pop": "112870" },
  { "id": 347591, "name": "Ţalkhā", "country": "EG", "admin1": "Dakahlia", "pop": "112851" },
  { "id": 1671444, "name": "Neili", "country": "TW", "admin1": "Taiwan", "pop": "112845" },
  { "id": 1162813, "name": "Vihari", "country": "PK", "admin1": "Punjab", "pop": "112840" },
  { "id": 2034497, "name": "Taonan", "country": "CN", "admin1": "Jilin", "pop": "112819" },
  { "id": 1848382, "name": "Youkaichi", "country": "JP", "admin1": "Shiga", "pop": "112819" },
  { "id": 1859586, "name": "Kazo", "country": "JP", "admin1": "Saitama", "pop": "112792" },
  {
    "id": 3589289,
    "name": "Santa Lucía Cotzumalguapa",
    "country": "GT",
    "admin1": "Escuintla",
    "pop": "112780"
  },
  { "id": 2702979, "name": "Jönköping", "country": "SE", "admin1": "Jönköping", "pop": "112766" },
  { "id": 4998830, "name": "Lansing", "country": "US", "admin1": "Michigan", "pop": "112644" },
  { "id": 1809077, "name": "Haikou", "country": "CN", "admin1": "Yunnan", "pop": "112644" },
  {
    "id": 1274767,
    "name": "Chanduasi",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "112635"
  },
  { "id": 1277939, "name": "Bagaha", "country": "IN", "admin1": "Bihar", "pop": "112634" },
  {
    "id": 1497917,
    "name": "Nefteyugansk",
    "country": "RU",
    "admin1": "Khanty-Mansia",
    "pop": "112632"
  },
  {
    "id": 2847736,
    "name": "Reutlingen",
    "country": "DE",
    "admin1": "Baden-Wurttemberg",
    "pop": "112627"
  },
  { "id": 3625710, "name": "Upata", "country": "VE", "admin1": "Bolívar", "pop": "112617" },
  { "id": 1795857, "name": "Shaowu", "country": "CN", "admin1": "Fujian", "pop": "112585" },
  { "id": 1280570, "name": "Mengmao", "country": "CN", "admin1": "Yunnan", "pop": "112578" },
  {
    "id": 6318738,
    "name": "Tangará da Serra",
    "country": "BR",
    "admin1": "Mato Grosso",
    "pop": "112547"
  },
  { "id": 1638284, "name": "Lawang", "country": "ID", "admin1": "East Java", "pop": "112540" },
  { "id": 3397893, "name": "Itacoatiara", "country": "BR", "admin1": "Amazonas", "pop": "112520" },
  {
    "id": 2554006,
    "name": "Bouskoura",
    "country": "MA",
    "admin1": "Casablanca-Settat",
    "pop": "112501"
  },
  {
    "id": 667873,
    "name": "Satu Mare",
    "country": "RO",
    "admin1": "Satu Mare County",
    "pop": "112490"
  },
  { "id": 3465059, "name": "Cubatão", "country": "BR", "admin1": "São Paulo", "pop": "112476" },
  { "id": 2036337, "name": "Kaiyuan", "country": "CN", "admin1": "Liaoning", "pop": "112462" },
  { "id": 1175156, "name": "Kamalia", "country": "PK", "admin1": "Punjab", "pop": "112426" },
  { "id": 191299, "name": "Kisii", "country": "KE", "admin1": "Kisii County", "pop": "112417" },
  {
    "id": 3058213,
    "name": "Petržalka",
    "country": "SK",
    "admin1": "Bratislava Region",
    "pop": "112380"
  },
  { "id": 1279390, "name": "Achalpur", "country": "IN", "admin1": "Maharashtra", "pop": "112311" },
  { "id": 616635, "name": "Gyumri", "country": "AM", "admin1": "Shirak", "pop": "112301" },
  { "id": 3640226, "name": "Guanare", "country": "VE", "admin1": "Portuguesa", "pop": "112286" },
  { "id": 1916012, "name": "Wuzhishan", "country": "CN", "admin1": "Hainan", "pop": "112269" },
  { "id": 5043473, "name": "Rochester", "country": "US", "admin1": "Minnesota", "pop": "112225" },
  { "id": 1270994, "name": "Gondal", "country": "IN", "admin1": "Gujarat", "pop": "112197" },
  {
    "id": 1203344,
    "name": "Farīdpur",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "112187"
  },
  {
    "id": 3587345,
    "name": "Apopa",
    "country": "SV",
    "admin1": "San Salvador Department",
    "pop": "112158"
  },
  { "id": 1718306, "name": "Carmona", "country": "PH", "admin1": "Calabarzon", "pop": "112140" },
  { "id": 1707404, "name": "Laoag", "country": "PH", "admin1": "Ilocos", "pop": "112117" },
  { "id": 4890864, "name": "Elgin", "country": "US", "admin1": "Illinois", "pop": "112111" },
  { "id": 1261012, "name": "Dharashiv", "country": "IN", "admin1": "Maharashtra", "pop": "112085" },
  { "id": 1789496, "name": "Xigang", "country": "CN", "admin1": "Ningxia", "pop": "112061" },
  {
    "id": 1821263,
    "name": "Taipa",
    "country": "MO",
    "admin1": "Nossa Senhora do Carmo",
    "pop": "112051"
  },
  {
    "id": 1259385,
    "name": "Port Blair",
    "country": "IN",
    "admin1": "Andaman and Nicobar",
    "pop": "112050"
  },
  { "id": 3523183, "name": "Minatitlán", "country": "MX", "admin1": "Veracruz", "pop": "112046" },
  {
    "id": 2343093,
    "name": "Esuk Oron",
    "country": "NG",
    "admin1": "Akwa Ibom State",
    "pop": "112033"
  },
  { "id": 2923544, "name": "Fürth", "country": "DE", "admin1": "Bavaria", "pop": "112025" },
  { "id": 378231, "name": "Atbara", "country": "SD", "admin1": "River Nile", "pop": "112021" },
  { "id": 3454690, "name": "Paulínia", "country": "BR", "admin1": "São Paulo", "pop": "112003" },
  { "id": 3164419, "name": "Vicenza", "country": "IT", "admin1": "Veneto", "pop": "111980" },
  { "id": 4013714, "name": "Ciudad Guzmán", "country": "MX", "admin1": "Jalisco", "pop": "111975" },
  { "id": 5784549, "name": "West Jordan", "country": "US", "admin1": "Utah", "pop": "111946" },
  { "id": 3454847, "name": "Passos", "country": "BR", "admin1": "Minas Gerais", "pop": "111939" },
  { "id": 1277936, "name": "Bagalkot", "country": "IN", "admin1": "Karnataka", "pop": "111933" },
  {
    "id": 3431271,
    "name": "Lomas de Zamora",
    "country": "AR",
    "admin1": "Buenos Aires",
    "pop": "111897"
  },
  { "id": 170592, "name": "Dūmā", "country": "SY", "admin1": "Rif-dimashq", "pop": "111864" },
  { "id": 2657970, "name": "Winterthur", "country": "CH", "admin1": "Zurich", "pop": "111840" },
  {
    "id": 518659,
    "name": "Novokuybyshevsk",
    "country": "RU",
    "admin1": "Samara Oblast",
    "pop": "111800"
  },
  { "id": 2502385, "name": "Bou Saâda", "country": "DZ", "admin1": "M'Sila", "pop": "111787" },
  { "id": 6317548, "name": "Marituba", "country": "BR", "admin1": "Pará", "pop": "111785" },
  { "id": 362973, "name": "Abnūb", "country": "EG", "admin1": "Asyut", "pop": "111785" },
  { "id": 119115, "name": "Qūchān", "country": "IR", "admin1": "Razavi Khorasan", "pop": "111752" },
  { "id": 1639094, "name": "Kuningan", "country": "ID", "admin1": "West Java", "pop": "111742" },
  { "id": 1255344, "name": "Suriāpet", "country": "IN", "admin1": "Telangana", "pop": "111729" },
  {
    "id": 1241622,
    "name": "Kandy",
    "country": "LK",
    "admin1": "Central Province",
    "pop": "111701"
  },
  { "id": 346030, "name": "Zefta", "country": "EG", "admin1": "Gharbia", "pop": "111700" },
  {
    "id": 3456147,
    "name": "Nova Lima",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "111697"
  },
  { "id": 1277324, "name": "Bangaon", "country": "IN", "admin1": "West Bengal", "pop": "111693" },
  { "id": 3471691, "name": "Araxá", "country": "BR", "admin1": "Minas Gerais", "pop": "111691" },
  { "id": 5359488, "name": "Inglewood", "country": "US", "admin1": "California", "pop": "111666" },
  { "id": 307864, "name": "Kilis", "country": "TR", "admin1": "Kilis", "pop": "111648" },
  {
    "id": 3465644,
    "name": "Conselheiro Lafaiete",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "111596"
  },
  { "id": 6163012, "name": "Terrebonne", "country": "CA", "admin1": "Quebec", "pop": "111575" },
  {
    "id": 3451668,
    "name": "Resende",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "111514"
  },
  { "id": 2653266, "name": "Chelmsford", "country": "GB", "admin1": "England", "pop": "111511" },
  {
    "id": 124620,
    "name": "Masjed Soleymān",
    "country": "IR",
    "admin1": "Khuzestan",
    "pop": "111510"
  },
  { "id": 3598465, "name": "Chiquimula", "country": "GT", "admin1": "Chiquimula", "pop": "111505" },
  { "id": 1646492, "name": "Cileunyi", "country": "ID", "admin1": "West Java", "pop": "111476" },
  {
    "id": 7302861,
    "name": "Ashoknagar Kalyangarh",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "111475"
  },
  { "id": 906054, "name": "Mongu", "country": "ZM", "admin1": "Western Province", "pop": "111450" },
  { "id": 2991214, "name": "Mulhouse", "country": "FR", "admin1": "Grand Est", "pop": "111430" },
  {
    "id": 2548830,
    "name": "Al Fqih Ben Çalah",
    "country": "MA",
    "admin1": "Béni Mellal-Khénifra",
    "pop": "111402"
  },
  { "id": 1692565, "name": "Pulilan", "country": "PH", "admin1": "Central Luzon", "pop": "111384" },
  {
    "id": 934765,
    "name": "Beau Bassin-Rose Hill",
    "country": "MU",
    "admin1": "Plaines Wilhems",
    "pop": "111355"
  },
  { "id": 4094455, "name": "Tuscaloosa", "country": "US", "admin1": "Alabama", "pop": "111338" },
  { "id": 3667873, "name": "Sogamoso", "country": "CO", "admin1": "Boyacá", "pop": "111336" },
  { "id": 229278, "name": "Mbale", "country": "UG", "admin1": "Eastern Region", "pop": "111300" },
  {
    "id": 3388376,
    "name": "São Lourenço da Mata",
    "country": "BR",
    "admin1": "Pernambuco",
    "pop": "111249"
  },
  {
    "id": 2992090,
    "name": "Montreuil",
    "country": "FR",
    "admin1": "Île-de-France",
    "pop": "111240"
  },
  { "id": 3165771, "name": "Terni", "country": "IT", "admin1": "Umbria", "pop": "111189" },
  { "id": 1272513, "name": "Deesa", "country": "IN", "admin1": "Gujarat", "pop": "111160" },
  { "id": 1261669, "name": "Navadwīp", "country": "IN", "admin1": "West Bengal", "pop": "111123" },
  { "id": 1732637, "name": "Maran", "country": "MY", "admin1": "Pahang", "pop": "111056" },
  { "id": 1261931, "name": "Nandurbar", "country": "IN", "admin1": "Maharashtra", "pop": "111037" },
  { "id": 6822147, "name": "Kasuga", "country": "JP", "admin1": "Fukuoka", "pop": "111023" },
  { "id": 2328684, "name": "Nsukka", "country": "NG", "admin1": "Enugu State", "pop": "111017" },
  { "id": 2328952, "name": "Nguru", "country": "NG", "admin1": "Yobe State", "pop": "111014" },
  { "id": 980921, "name": "Mabopane", "country": "ZA", "admin1": "Gauteng", "pop": "110972" },
  { "id": 2790471, "name": "Namur", "country": "BE", "admin1": "Wallonia", "pop": "110939" },
  { "id": 1811729, "name": "Encheng", "country": "CN", "admin1": "Guangdong", "pop": "110921" },
  { "id": 738618, "name": "Turhal", "country": "TR", "admin1": "Tokat Province", "pop": "110884" },
  {
    "id": 1581461,
    "name": "Gò Vấp",
    "country": "VN",
    "admin1": "Ho Chi Minh City (HCMC)",
    "pop": "110850"
  },
  {
    "id": 141679,
    "name": "Bandar-e Anzalī",
    "country": "IR",
    "admin1": "Gilan Province",
    "pop": "110826"
  },
  { "id": 4722625, "name": "Richardson", "country": "US", "admin1": "Texas", "pop": "110815" },
  {
    "id": 1220747,
    "name": "Bokhtar",
    "country": "TJ",
    "admin1": "Khatlon Province",
    "pop": "110800"
  },
  { "id": 2339631, "name": "Hadejia", "country": "NG", "admin1": "Jigawa State", "pop": "110753" },
  { "id": 1783940, "name": "Zhuji", "country": "CN", "admin1": "Zhejiang", "pop": "110721" },
  { "id": 2987914, "name": "Perpignan", "country": "FR", "admin1": "Occitanie", "pop": "110706" },
  { "id": 4942618, "name": "Lowell", "country": "US", "admin1": "Massachusetts", "pop": "110699" },
  { "id": 3663529, "name": "Manacapuru", "country": "BR", "admin1": "Amazonas", "pop": "110691" },
  { "id": 3029241, "name": "Caen", "country": "FR", "admin1": "Normandy", "pop": "110624" },
  {
    "id": 3448351,
    "name": "São Pedro da Aldeia",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "110556"
  },
  { "id": 5729485, "name": "Gresham", "country": "US", "admin1": "Oregon", "pop": "110553" },
  { "id": 1285173, "name": "Yenangyaung", "country": "MM", "admin1": "Magway", "pop": "110553" },
  { "id": 5324200, "name": "Antioch", "country": "US", "admin1": "California", "pop": "110542" },
  { "id": 934995, "name": "Manzini", "country": "SZ", "admin1": "Manzini Region", "pop": "110537" },
  {
    "id": 6324733,
    "name": "St. John's",
    "country": "CA",
    "admin1": "Newfoundland and Labrador",
    "pop": "110525"
  },
  { "id": 229362, "name": "Masindi", "country": "UG", "admin1": "Western Region", "pop": "110500" },
  {
    "id": 294514,
    "name": "Kfar Saba",
    "country": "IL",
    "admin1": "Central District",
    "pop": "110456"
  },
  { "id": 1857470, "name": "Matsutō", "country": "JP", "admin1": "Ishikawa", "pop": "110408" },
  {
    "id": 4931972,
    "name": "Cambridge",
    "country": "US",
    "admin1": "Massachusetts",
    "pop": "110402"
  },
  {
    "id": 1255491,
    "name": "Sultānpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "110368"
  },
  {
    "id": 1273292,
    "name": "Delhi Cantonment",
    "country": "IN",
    "admin1": "Delhi",
    "pop": "110351"
  },
  { "id": 1725684, "name": "Bayugan", "country": "PH", "admin1": "Caraga", "pop": "110313" },
  { "id": 1271883, "name": "Firozpur", "country": "IN", "admin1": "Punjab", "pop": "110313" },
  {
    "id": 4471025,
    "name": "High Point",
    "country": "US",
    "admin1": "North Carolina",
    "pop": "110268"
  },
  { "id": 1813425, "name": "Datun", "country": "CN", "admin1": "Jiangsu", "pop": "110258" },
  {
    "id": 5089178,
    "name": "Manchester",
    "country": "US",
    "admin1": "New Hampshire",
    "pop": "110229"
  },
  { "id": 1639362, "name": "Kresek", "country": "ID", "admin1": "West Java", "pop": "110182" },
  {
    "id": 618577,
    "name": "Bender",
    "country": "MD",
    "admin1": "Bender Municipality",
    "pop": "110175"
  },
  { "id": 971534, "name": "Mbombela", "country": "ZA", "admin1": "Mpumalanga", "pop": "110159" },
  { "id": 1880283, "name": "Sembawang Estate", "country": "SG", "admin1": null, "pop": "110090" },
  {
    "id": 3445993,
    "name": "Tubarão",
    "country": "BR",
    "admin1": "Santa Catarina",
    "pop": "110088"
  },
  {
    "id": 2468369,
    "name": "Gabès",
    "country": "TN",
    "admin1": "Gabès Governorate",
    "pop": "110075"
  },
  { "id": 967476, "name": "Orkney", "country": "ZA", "admin1": "North West", "pop": "110052" },
  { "id": 1803367, "name": "Qingnian", "country": "CN", "admin1": "Shandong", "pop": "110046" },
  { "id": 5401395, "name": "Temecula", "country": "US", "admin1": "California", "pop": "110003" },
  {
    "id": 1496503,
    "name": "Noyabrsk",
    "country": "RU",
    "admin1": "Yamalo-Nenets",
    "pop": "110000"
  },
  {
    "id": 1028079,
    "name": "Ressano Garcia",
    "country": "MZ",
    "admin1": "Maputo Province",
    "pop": "110000"
  },
  { "id": 150103, "name": "Sengerema", "country": "TZ", "admin1": "Mwanza", "pop": "110000" },
  { "id": 145724, "name": "Lucapa", "country": "AO", "admin1": "Luanda Norte", "pop": "110000" },
  { "id": 99135, "name": "Kufa", "country": "IQ", "admin1": "An Najaf", "pop": "110000" },
  { "id": 98846, "name": "An Nu‘mānīyah", "country": "IQ", "admin1": "Wāsiţ", "pop": "110000" },
  { "id": 578740, "name": "Bataysk", "country": "RU", "admin1": "Rostov", "pop": "109962" },
  { "id": 3170647, "name": "Pisa", "country": "IT", "admin1": "Tuscany", "pop": "109960" },
  { "id": 1803352, "name": "Linshui", "country": "CN", "admin1": "Hebei", "pop": "109955" },
  { "id": 11611942, "name": "Kamagaya", "country": "JP", "admin1": "Chiba", "pop": "109932" },
  { "id": 2037069, "name": "Hailun", "country": "CN", "admin1": "Heilongjiang", "pop": "109881" },
  {
    "id": 1701124,
    "name": "Maramag",
    "country": "PH",
    "admin1": "Northern Mindanao",
    "pop": "109864"
  },
  { "id": 3050434, "name": "Kecskemét", "country": "HU", "admin1": "Bács-Kiskun", "pop": "109847" },
  { "id": 1538637, "name": "Seversk", "country": "RU", "admin1": "Tomsk Oblast", "pop": "109844" },
  { "id": 1647149, "name": "Ciamis", "country": "ID", "admin1": "West Java", "pop": "109839" },
  { "id": 5375911, "name": "Murrieta", "country": "US", "admin1": "California", "pop": "109830" },
  { "id": 711390, "name": "Brovary", "country": "UA", "admin1": "Kiev", "pop": "109806" },
  { "id": 7026833, "name": "Lak Si", "country": "TH", "admin1": "Bangkok", "pop": "109770" },
  { "id": 2634910, "name": "Wakefield", "country": "GB", "admin1": "England", "pop": "109766" },
  { "id": 5416541, "name": "Centennial", "country": "US", "admin1": "Colorado", "pop": "109741" },
  { "id": 1795184, "name": "Shilong", "country": "CN", "admin1": "Guangdong", "pop": "109733" },
  { "id": 5387428, "name": "Richmond", "country": "US", "admin1": "California", "pop": "109708" },
  { "id": 1565157, "name": "Thới Lai", "country": "VN", "admin1": "Can Tho City", "pop": "109684" },
  {
    "id": 2473164,
    "name": "Sejoumi",
    "country": "TN",
    "admin1": "Tunis Governorate",
    "pop": "109672"
  },
  { "id": 2037685, "name": "Didao", "country": "CN", "admin1": "Heilongjiang", "pop": "109561" },
  {
    "id": 1631733,
    "name": "Pelabuhanratu",
    "country": "ID",
    "admin1": "West Java",
    "pop": "109523"
  },
  { "id": 1857665, "name": "Marugame", "country": "JP", "admin1": "Kagawa", "pop": "109513" },
  { "id": 6825496, "name": "Habikino", "country": "JP", "admin1": "Osaka", "pop": "109479" },
  {
    "id": 580724,
    "name": "Arzamas",
    "country": "RU",
    "admin1": "Nizhny Novgorod Oblast",
    "pop": "109479"
  },
  { "id": 965528, "name": "Phalaborwa", "country": "ZA", "admin1": "Limpopo", "pop": "109468" },
  { "id": 2634838, "name": "Walthamstow", "country": "GB", "admin1": "England", "pop": "109424" },
  { "id": 5435464, "name": "Pueblo", "country": "US", "admin1": "Colorado", "pop": "109412" },
  { "id": 2338403, "name": "Ijebu-Igbo", "country": "NG", "admin1": "Ogun State", "pop": "109261" },
  {
    "id": 496638,
    "name": "Sergiyev Posad",
    "country": "RU",
    "admin1": "Moscow Oblast",
    "pop": "109252"
  },
  {
    "id": 1683877,
    "name": "Talisay",
    "country": "PH",
    "admin1": "Western Visayas",
    "pop": "109204"
  },
  { "id": 3837213, "name": "San Juan", "country": "AR", "admin1": "San Juan", "pop": "109123" },
  { "id": 1256913, "name": "Sehore", "country": "IN", "admin1": "Madhya Pradesh", "pop": "109118" },
  { "id": 1806439, "name": "Jianchang", "country": "CN", "admin1": "Jiangxi", "pop": "109108" },
  { "id": 2036671, "name": "Hulan", "country": "CN", "admin1": "Heilongjiang", "pop": "109104" },
  {
    "id": 3617708,
    "name": "Matagalpa",
    "country": "NI",
    "admin1": "Matagalpa Department",
    "pop": "109089"
  },
  { "id": 6908641, "name": "Khlong Toei", "country": "TH", "admin1": "Bangkok", "pop": "109041" },
  {
    "id": 1500665,
    "name": "Leninsk-Kuznetsky",
    "country": "RU",
    "admin1": "Kuzbass",
    "pop": "109023"
  },
  { "id": 1859405, "name": "Kiryū", "country": "JP", "admin1": "Gunma", "pop": "108991" },
  { "id": 159675, "name": "Handeni", "country": "TZ", "admin1": "Tanga", "pop": "108968" },
  { "id": 1786546, "name": "Zhongxiang", "country": "CN", "admin1": "Hubei", "pop": "108883" },
  { "id": 6166142, "name": "Thunder Bay", "country": "CA", "admin1": "Ontario", "pop": "108843" },
  { "id": 1861164, "name": "Iwatsuki", "country": "JP", "admin1": "Saitama", "pop": "108833" },
  { "id": 4718097, "name": "Pearland", "country": "US", "admin1": "Texas", "pop": "108821" },
  { "id": 2037712, "name": "Dehui", "country": "CN", "admin1": "Jilin", "pop": "108818" },
  { "id": 4845193, "name": "Waterbury", "country": "US", "admin1": "Connecticut", "pop": "108802" },
  { "id": 5577592, "name": "Greeley", "country": "US", "admin1": "Colorado", "pop": "108795" },
  {
    "id": 3031137,
    "name": "Boulogne-Billancourt",
    "country": "FR",
    "admin1": "Île-de-France",
    "pop": "108782"
  },
  { "id": 3096880, "name": "Kalisz", "country": "PL", "admin1": "Greater Poland", "pop": "108759" },
  { "id": 685826, "name": "Baia Mare", "country": "RO", "admin1": "Maramureş", "pop": "108759" },
  { "id": 290503, "name": "Warīsān", "country": "AE", "admin1": "Dubai", "pop": "108759" },
  { "id": 2490098, "name": "Mascara", "country": "DZ", "admin1": "Mascara", "pop": "108629" },
  { "id": 2319668, "name": "Uromi", "country": "NG", "admin1": "Edo State", "pop": "108608" },
  { "id": 158151, "name": "Katumba", "country": "TZ", "admin1": "Mbeya", "pop": "108558" },
  { "id": 1574507, "name": "Móng Cái", "country": "VN", "admin1": "Quảng Ninh", "pop": "108553" },
  { "id": 1858910, "name": "Komatsu", "country": "JP", "admin1": "Ishikawa", "pop": "108509" },
  {
    "id": 5407933,
    "name": "West Covina",
    "country": "US",
    "admin1": "California",
    "pop": "108484"
  },
  { "id": 5503766, "name": "Enterprise", "country": "US", "admin1": "Nevada", "pop": "108481" },
  { "id": 1277240, "name": "Bānsbāria", "country": "IN", "admin1": "West Bengal", "pop": "108474" },
  {
    "id": 3682018,
    "name": "Girón",
    "country": "CO",
    "admin1": "Santander Department",
    "pop": "108466"
  },
  { "id": 1147540, "name": "Baghlān", "country": "AF", "admin1": "Baghlan", "pop": "108449" },
  { "id": 1808916, "name": "Hanjia", "country": "CN", "admin1": "Chongqing", "pop": "108430" },
  {
    "id": 1226260,
    "name": "Trincomalee",
    "country": "LK",
    "admin1": "Eastern Province",
    "pop": "108420"
  },
  {
    "id": 1687801,
    "name": "Santiago",
    "country": "PH",
    "admin1": "Cagayan Valley",
    "pop": "108414"
  },
  { "id": 8403612, "name": "Taibai", "country": "CN", "admin1": "Chongqing", "pop": "108387" },
  { "id": 2651621, "name": "Dagenham", "country": "GB", "admin1": "England", "pop": "108368" },
  { "id": 1787828, "name": "Xuyong", "country": "CN", "admin1": "Sichuan", "pop": "108352" },
  {
    "id": 4589387,
    "name": "North Charleston",
    "country": "US",
    "admin1": "South Carolina",
    "pop": "108304"
  },
  { "id": 286282, "name": "Sohar", "country": "OM", "admin1": "Al Batinah North", "pop": "108274" },
  { "id": 2035610, "name": "Nehe", "country": "CN", "admin1": "Heilongjiang", "pop": "108253" },
  {
    "id": 515879,
    "name": "Oktyabrsky",
    "country": "RU",
    "admin1": "Bashkortostan Republic",
    "pop": "108200"
  },
  {
    "id": 1255254,
    "name": "Tadpatri",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "108171"
  },
  {
    "id": 1255264,
    "name": "Tādepallegūdem",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "108167"
  },
  { "id": 2347059, "name": "Birnin Kebbi", "country": "NG", "admin1": "Kebbi", "pop": "108164" },
  { "id": 1688253, "name": "Santa Cruz", "country": "PH", "admin1": "Calabarzon", "pop": "108145" },
  { "id": 5793933, "name": "Everett", "country": "US", "admin1": "Washington", "pop": "108010" },
  {
    "id": 378699,
    "name": "An Nuhūd",
    "country": "SD",
    "admin1": "West Kordofan State",
    "pop": "108008"
  },
  { "id": 1867429, "name": "Ŭllyul", "country": "KP", "admin1": "South Hwanghae", "pop": "107997" },
  {
    "id": 3191648,
    "name": "Rijeka",
    "country": "HR",
    "admin1": "Primorje-Gorski Kotar",
    "pop": "107964"
  },
  { "id": 1665196, "name": "Douliu", "country": "TW", "admin1": "Taiwan", "pop": "107924" },
  {
    "id": 11427402,
    "name": "Luis Eduardo Magalhães",
    "country": "BR",
    "admin1": "Bahia",
    "pop": "107909"
  },
  {
    "id": 1717911,
    "name": "Catbalogan",
    "country": "PH",
    "admin1": "Eastern Visayas",
    "pop": "107896"
  },
  { "id": 4682464, "name": "College Station", "country": "US", "admin1": "Texas", "pop": "107889" },
  { "id": 250258, "name": "As Salţ", "country": "JO", "admin1": "Balqa", "pop": "107874" },
  { "id": 1856977, "name": "Mishima", "country": "JP", "admin1": "Shizuoka", "pop": "107851" },
  {
    "id": 1269388,
    "name": "Jalpāiguri",
    "country": "IN",
    "admin1": "West Bengal",
    "pop": "107832"
  },
  {
    "id": 2036595,
    "name": "Jalai Nur",
    "country": "CN",
    "admin1": "Inner Mongolia",
    "pop": "107828"
  },
  { "id": 1851193, "name": "Tajimi", "country": "JP", "admin1": "Gifu", "pop": "107818" },
  { "id": 3435607, "name": "Castelar", "country": "AR", "admin1": "Buenos Aires", "pop": "107786" },
  { "id": 4169014, "name": "Pompano Beach", "country": "US", "admin1": "Florida", "pop": "107762" },
  { "id": 1610858, "name": "Dusit", "country": "TH", "admin1": "Bangkok", "pop": "107655" },
  { "id": 2656192, "name": "Basingstoke", "country": "GB", "admin1": "England", "pop": "107642" },
  { "id": 751077, "name": "Bandırma", "country": "TR", "admin1": "Balıkesir", "pop": "107631" },
  { "id": 2643179, "name": "Maidstone", "country": "GB", "admin1": "England", "pop": "107627" },
  { "id": 2034440, "name": "Tieli", "country": "CN", "admin1": "Heilongjiang", "pop": "107621" },
  { "id": 89824, "name": "Umm Qaşr", "country": "IQ", "admin1": "Basra", "pop": "107620" },
  { "id": 3391360, "name": "Santana", "country": "BR", "admin1": "Amapá", "pop": "107618" },
  { "id": 1735076, "name": "Butterworth", "country": "MY", "admin1": "Penang", "pop": "107591" },
  { "id": 1795842, "name": "Shaping", "country": "CN", "admin1": "Guangdong", "pop": "107589" },
  { "id": 2418362, "name": "Labé", "country": "GN", "admin1": "Labé Region", "pop": "107571" },
  {
    "id": 3095049,
    "name": "Koszalin",
    "country": "PL",
    "admin1": "West Pomerania",
    "pop": "107450"
  },
  { "id": 12541728, "name": "South Fulton", "country": "US", "admin1": "Georgia", "pop": "107436" },
  {
    "id": 3181913,
    "name": "Bolzano",
    "country": "IT",
    "admin1": "Trentino-Alto Adige",
    "pop": "107436"
  },
  {
    "id": 1337248,
    "name": "Sherpur",
    "country": "BD",
    "admin1": "Mymensingh Division",
    "pop": "107419"
  },
  { "id": 516436, "name": "Obninsk", "country": "RU", "admin1": "Kaluga Oblast", "pop": "107392" },
  { "id": 1636308, "name": "Manokwari", "country": "ID", "admin1": "West Papua", "pop": "107325" },
  {
    "id": 3682028,
    "name": "Girardot City",
    "country": "CO",
    "admin1": "Cundinamarca",
    "pop": "107324"
  },
  {
    "id": 2886946,
    "name": "Koblenz",
    "country": "DE",
    "admin1": "Rheinland-Pfalz",
    "pop": "107319"
  },
  {
    "id": 3460733,
    "name": "Itaperuna",
    "country": "BR",
    "admin1": "Rio de Janeiro",
    "pop": "107246"
  },
  {
    "id": 2832495,
    "name": "Siegen",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "107242"
  },
  { "id": 3467978, "name": "Cambé", "country": "BR", "admin1": "Paraná", "pop": "107208" },
  {
    "id": 1263797,
    "name": "Mangalagiri",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "107197"
  },
  { "id": 949224, "name": "Thohoyandou", "country": "ZA", "admin1": "Limpopo", "pop": "107144" },
  {
    "id": 288955,
    "name": "As Suwayq",
    "country": "OM",
    "admin1": "Al Batinah North",
    "pop": "107143"
  },
  { "id": 5377995, "name": "Norwalk", "country": "US", "admin1": "California", "pop": "107140" },
  {
    "id": 1560037,
    "name": "Yên Vinh",
    "country": "VN",
    "admin1": "Nghệ An Province",
    "pop": "107082"
  },
  { "id": 789225, "name": "Mitrovicë", "country": "XK", "admin1": "Mitrovica", "pop": "107045" },
  {
    "id": 2636486,
    "name": "Sutton Coldfield",
    "country": "GB",
    "admin1": "England",
    "pop": "107030"
  },
  { "id": 1631992, "name": "Pati", "country": "ID", "admin1": "Central Java", "pop": "107028" },
  {
    "id": 563514,
    "name": "Elista",
    "country": "RU",
    "admin1": "Kalmykiya Republic",
    "pop": "106971"
  },
  { "id": 3404817, "name": "Breves", "country": "BR", "admin1": "Pará", "pop": "106968" },
  { "id": 1290596, "name": "Taungoo", "country": "MM", "admin1": "Bago Region", "pop": "106945" },
  { "id": 2656046, "name": "Bedford", "country": "GB", "admin1": "England", "pop": "106940" },
  {
    "id": 7090987,
    "name": "Bagong Silangan",
    "country": "PH",
    "admin1": "Metro Manila",
    "pop": "106886"
  },
  {
    "id": 1876124,
    "name": "Kangnyŏng",
    "country": "KP",
    "admin1": "South Hwanghae",
    "pop": "106827"
  },
  { "id": 3646190, "name": "Catia La Mar", "country": "VE", "admin1": "Vargas", "pop": "106822" },
  { "id": 5574991, "name": "Boulder", "country": "US", "admin1": "Colorado", "pop": "106803" },
  { "id": 1803886, "name": "Anning", "country": "CN", "admin1": "Yunnan", "pop": "106795" },
  { "id": 1607017, "name": "Rayong", "country": "TH", "admin1": "Rayong", "pop": "106737" },
  { "id": 2210554, "name": "Sirte", "country": "LY", "admin1": "Surt", "pop": "106705" },
  { "id": 569273, "name": "Cherëmushki", "country": "RU", "admin1": "Moscow", "pop": "106587" },
  { "id": 2740637, "name": "Coimbra", "country": "PT", "admin1": "Coimbra", "pop": "106582" },
  { "id": 4531405, "name": "Broken Arrow", "country": "US", "admin1": "Oklahoma", "pop": "106563" },
  { "id": 5341430, "name": "Daly City", "country": "US", "admin1": "California", "pop": "106562" },
  { "id": 6316298, "name": "Açailândia", "country": "BR", "admin1": "Maranhão", "pop": "106550" },
  { "id": 1646678, "name": "Cikarang", "country": "ID", "admin1": "West Java", "pop": "106479" },
  { "id": 2447513, "name": "Arlit", "country": "NE", "admin1": "Agadez", "pop": "106448" },
  { "id": 1568737, "name": "Ba Đồn", "country": "VN", "admin1": "Quang Tri", "pop": "106413" },
  { "id": 1258474, "name": "Ranebennur", "country": "IN", "admin1": "Karnataka", "pop": "106406" },
  {
    "id": 2035970,
    "name": "Longjiang",
    "country": "CN",
    "admin1": "Heilongjiang",
    "pop": "106384"
  },
  { "id": 1897118, "name": "Hwado", "country": "KR", "admin1": "Gyeonggi-do", "pop": "106358" },
  { "id": 1816221, "name": "Buhe", "country": "CN", "admin1": "Hubei", "pop": "106347" },
  { "id": 2324857, "name": "Pindiga", "country": "NG", "admin1": "Gombe State", "pop": "106322" },
  { "id": 712451, "name": "Berdyansk", "country": "UA", "admin1": "Zaporizhzhia", "pop": "106311" },
  { "id": 1667027, "name": "Toufen", "country": "TW", "admin1": "Taiwan", "pop": "106310" },
  { "id": 688105, "name": "Yevpatoriya", "country": "UA", "admin1": "Crimea", "pop": "106202" },
  { "id": 1695097, "name": "Paniqui", "country": "PH", "admin1": "Central Luzon", "pop": "106190" },
  {
    "id": 517836,
    "name": "Novotroitsk",
    "country": "RU",
    "admin1": "Orenburg Oblast",
    "pop": "106186"
  },
  {
    "id": 2950349,
    "name": "Bergisch Gladbach",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "106184"
  },
  { "id": 713716, "name": "Alchevsk", "country": "UA", "admin1": "Luhansk", "pop": "106062" },
  { "id": 1336139, "name": "Rāngāmāti", "country": "BD", "admin1": "Chittagong", "pop": "106060" },
  {
    "id": 1567681,
    "name": "Sơn La",
    "country": "VN",
    "admin1": "Sơn La Province",
    "pop": "106052"
  },
  { "id": 585514, "name": "Mingachevir", "country": "AZ", "admin1": "Mingǝcevir", "pop": "106048" },
  { "id": 3093692, "name": "Legnica", "country": "PL", "admin1": "Lower Silesia", "pop": "106033" },
  { "id": 948542, "name": "Tokoza", "country": "ZA", "admin1": "Gauteng", "pop": "106000" },
  { "id": 6354908, "name": "Sydney", "country": "CA", "admin1": "Nova Scotia", "pop": "105968" },
  { "id": 566532, "name": "Derbent", "country": "RU", "admin1": "Dagestan", "pop": "105965" },
  { "id": 1784820, "name": "Xinghua", "country": "CN", "admin1": "Jiangsu", "pop": "105918" },
  { "id": 1266607, "name": "Khurja", "country": "IN", "admin1": "Uttar Pradesh", "pop": "105909" },
  { "id": 1700360, "name": "Mati", "country": "PH", "admin1": "Davao Region", "pop": "105908" },
  {
    "id": 1651226,
    "name": "Arjawinangun",
    "country": "ID",
    "admin1": "West Java",
    "pop": "105845"
  },
  { "id": 1266489, "name": "Kishanganj", "country": "IN", "admin1": "Bihar", "pop": "105782" },
  { "id": 3514321, "name": "Yautepec", "country": "MX", "admin1": "Morelos", "pop": "105780" },
  { "id": 3460064, "name": "Jataí", "country": "BR", "admin1": "Goiás", "pop": "105729" },
  { "id": 2348595, "name": "Azare", "country": "NG", "admin1": "Bauchi", "pop": "105687" },
  { "id": 1671566, "name": "Nantou", "country": "TW", "admin1": "Taiwan", "pop": "105682" },
  { "id": 3398115, "name": "Ipojuca", "country": "BR", "admin1": "Pernambuco", "pop": "105638" },
  { "id": 1733953, "name": "Lahad Datu", "country": "MY", "admin1": "Sabah", "pop": "105622" },
  {
    "id": 3456117,
    "name": "Nova Serrana",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "105552"
  },
  { "id": 3393106, "name": "Paragominas", "country": "BR", "admin1": "Pará", "pop": "105550" },
  { "id": 217834, "name": "Bukama", "country": "CD", "admin1": "Haut-Lomami", "pop": "105530" },
  { "id": 1259411, "name": "Ponnāni", "country": "IN", "admin1": "Kerala", "pop": "105512" },
  { "id": 1683013, "name": "Tanza", "country": "PH", "admin1": "Metro Manila", "pop": "105510" },
  { "id": 6822179, "name": "Inzai", "country": "JP", "admin1": "Chiba", "pop": "105463" },
  {
    "id": 1185263,
    "name": "Bhairab Bāzār",
    "country": "BD",
    "admin1": "Dhaka Division",
    "pop": "105457"
  },
  { "id": 1793036, "name": "Chengtangcun", "country": "CN", "admin1": "Shandong", "pop": "105456" },
  { "id": 1270090, "name": "Hindaun", "country": "IN", "admin1": "Rajasthan", "pop": "105452" },
  { "id": 1269374, "name": "Jamālpur", "country": "IN", "admin1": "Bihar", "pop": "105434" },
  { "id": 362004, "name": "Abū Tīj", "country": "EG", "admin1": "Asyut", "pop": "105418" },
  {
    "id": 3598122,
    "name": "Coatepeque",
    "country": "GT",
    "admin1": "Quetzaltenango",
    "pop": "105415"
  },
  { "id": 2505653, "name": "Baraki", "country": "DZ", "admin1": "Algiers", "pop": "105402" },
  { "id": 4221333, "name": "Sandy Springs", "country": "US", "admin1": "Georgia", "pop": "105330" },
  { "id": 5331835, "name": "Burbank", "country": "US", "admin1": "California", "pop": "105319" },
  { "id": 1605843, "name": "Taling Chan", "country": "TH", "admin1": "Bangkok", "pop": "105299" },
  { "id": 1580830, "name": "Hòa Bình", "country": "VN", "admin1": "Phu Tho", "pop": "105260" },
  { "id": 935221, "name": "Saint-Paul", "country": "RE", "admin1": "Réunion", "pop": "105240" },
  { "id": 3114965, "name": "Ourense", "country": "ES", "admin1": "Galicia", "pop": "105233" },
  { "id": 1262216, "name": "Nāgaur", "country": "IN", "admin1": "Rajasthan", "pop": "105218" },
  {
    "id": 12432977,
    "name": "Riacho Fundo II",
    "country": "BR",
    "admin1": "Federal District",
    "pop": "105210"
  },
  { "id": 5254962, "name": "Green Bay", "country": "US", "admin1": "Wisconsin", "pop": "105207" },
  { "id": 229139, "name": "Mityana", "country": "UG", "admin1": "Central Region", "pop": "105200" },
  { "id": 105299, "name": "Jizan", "country": "SA", "admin1": "Jazan Region", "pop": "105198" },
  {
    "id": 3515715,
    "name": "Texcoco de Mora",
    "country": "MX",
    "admin1": "México",
    "pop": "105165"
  },
  { "id": 8355932, "name": "Bang Bon", "country": "TH", "admin1": "Bangkok", "pop": "105161" },
  { "id": 700051, "name": "Nikopol", "country": "UA", "admin1": "Dnipropetrovsk", "pop": "105160" },
  { "id": 625324, "name": "Mazyr", "country": "BY", "admin1": "Gomel Oblast", "pop": "105152" },
  { "id": 693468, "name": "Sloviansk", "country": "UA", "admin1": "Donetsk", "pop": "105141" },
  {
    "id": 5393180,
    "name": "Santa Maria",
    "country": "US",
    "admin1": "California",
    "pop": "105093"
  },
  { "id": 3395449, "name": "Maranguape", "country": "BR", "admin1": "Ceará", "pop": "105093" },
  { "id": 3471374, "name": "Assis", "country": "BR", "admin1": "São Paulo", "pop": "105087" },
  {
    "id": 12157013,
    "name": "San Francisco De Borja",
    "country": "PE",
    "admin1": "Lima region",
    "pop": "105076"
  },
  { "id": 12324302, "name": "Yidu", "country": "CN", "admin1": "Shandong", "pop": "105070" },
  { "id": 2990999, "name": "Nancy", "country": "FR", "admin1": "Grand Est", "pop": "105058" },
  { "id": 3159016, "name": "Drammen", "country": "NO", "admin1": "Buskerud", "pop": "105042" },
  { "id": 3453420, "name": "Planaltina", "country": "BR", "admin1": "Goiás", "pop": "105031" },
  { "id": 3407357, "name": "Araguaína", "country": "BR", "admin1": "Tocantins", "pop": "105019" },
  { "id": 1735572, "name": "Kuala Krai", "country": "MY", "admin1": "Kelantan", "pop": "105007" },
  { "id": 1784393, "name": "Zhonghe", "country": "CN", "admin1": "Chongqing", "pop": "105003" },
  {
    "id": 1798422,
    "name": "Puyang Chengguanzhen",
    "country": "CN",
    "admin1": "Henan",
    "pop": "104994"
  },
  { "id": 1861795, "name": "Ikeda", "country": "JP", "admin1": "Osaka", "pop": "104993" },
  { "id": 6176823, "name": "Waterloo", "country": "CA", "admin1": "Ontario", "pop": "104986" },
  { "id": 13157160, "name": "Ambala Sadar", "country": "IN", "admin1": "Haryana", "pop": "104974" },
  { "id": 3598529, "name": "Chinautla", "country": "GT", "admin1": "Guatemala", "pop": "104972" },
  { "id": 7279747, "name": "Bhiwadi", "country": "IN", "admin1": "Rajasthan", "pop": "104921" },
  { "id": 1275103, "name": "Būndi", "country": "IN", "admin1": "Rajasthan", "pop": "104919" },
  { "id": 1263012, "name": "Miryalaguda", "country": "IN", "admin1": "Telangana", "pop": "104918" },
  { "id": 1807544, "name": "Daxing", "country": "CN", "admin1": "Beijing", "pop": "104904" },
  { "id": 1786778, "name": "Yezhou", "country": "CN", "admin1": "Hubei", "pop": "104839" },
  { "id": 4004867, "name": "Parral", "country": "MX", "admin1": "Chihuahua", "pop": "104836" },
  {
    "id": 141584,
    "name": "Bāneh",
    "country": "IR",
    "admin1": "Kurdistan Province",
    "pop": "104799"
  },
  { "id": 1926054, "name": "Saijō", "country": "JP", "admin1": "Ehime", "pop": "104791" },
  { "id": 3458696, "name": "Lavras", "country": "BR", "admin1": "Minas Gerais", "pop": "104761" },
  {
    "id": 3465476,
    "name": "Coronel Fabriciano",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "104736"
  },
  { "id": 2895044, "name": "Jena", "country": "DE", "admin1": "Thuringia", "pop": "104712" },
  { "id": 4741752, "name": "Wichita Falls", "country": "US", "admin1": "Texas", "pop": "104710" },
  { "id": 5907990, "name": "Brantford", "country": "CA", "admin1": "Ontario", "pop": "104688" },
  { "id": 2921232, "name": "Gera", "country": "DE", "admin1": "Thuringia", "pop": "104659" },
  {
    "id": 1563287,
    "name": "Tuyên Quang",
    "country": "VN",
    "admin1": "Tuyen Quang",
    "pop": "104645"
  },
  { "id": 99446, "name": "Al Fāw", "country": "IQ", "admin1": "Basra", "pop": "104569" },
  { "id": 1052944, "name": "Angoche", "country": "MZ", "admin1": "Nampula", "pop": "104540" },
  {
    "id": 11204413,
    "name": "El Mourouj",
    "country": "TN",
    "admin1": "Ben Arous Governorate",
    "pop": "104538"
  },
  { "id": 1645518, "name": "Depok", "country": "ID", "admin1": "Yogyakarta", "pop": "104527" },
  { "id": 2110729, "name": "Toride", "country": "JP", "admin1": "Ibaraki", "pop": "104524" },
  {
    "id": 3194828,
    "name": "Mostar",
    "country": "BA",
    "admin1": "Federation of B&H",
    "pop": "104518"
  },
  {
    "id": 5989045,
    "name": "Kamloops",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "104460"
  },
  {
    "id": 907111,
    "name": "Mazabuka",
    "country": "ZM",
    "admin1": "Southern Province",
    "pop": "104412"
  },
  { "id": 4161438, "name": "Lakeland", "country": "US", "admin1": "Florida", "pop": "104401" },
  {
    "id": 1516589,
    "name": "Zhezqazghan",
    "country": "KZ",
    "admin1": "Ulytau Region",
    "pop": "104357"
  },
  { "id": 8403616, "name": "Pailou", "country": "CN", "admin1": "Chongqing", "pop": "104351" },
  {
    "id": 7281020,
    "name": "Lo Prado",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "104316"
  },
  { "id": 2475744, "name": "Tizi Ouzou", "country": "DZ", "admin1": "Tizi Ouzou", "pop": "104312" },
  { "id": 1798490, "name": "Pulandian", "country": "CN", "admin1": "Liaoning", "pop": "104277" },
  { "id": 2706767, "name": "Helsingborg", "country": "SE", "admin1": "Skåne", "pop": "104250" },
  { "id": 1173378, "name": "Kot Addu", "country": "PK", "admin1": "Punjab", "pop": "104217" },
  {
    "id": 2290964,
    "name": "Bouaflé",
    "country": "CI",
    "admin1": "Sassandra-Marahoué",
    "pop": "104209"
  },
  { "id": 2366152, "name": "Kara", "country": "TG", "admin1": "Kara", "pop": "104207" },
  { "id": 5338122, "name": "Clovis", "country": "US", "admin1": "California", "pop": "104180" },
  { "id": 915883, "name": "Kafue", "country": "ZM", "admin1": "Lusaka Province", "pop": "104174" },
  { "id": 1800829, "name": "Wuchuan", "country": "CN", "admin1": "Guangdong", "pop": "104168" },
  { "id": 3456500, "name": "Muriaé", "country": "BR", "admin1": "Minas Gerais", "pop": "104108" },
  { "id": 2035196, "name": "Salaqi", "country": "CN", "admin1": "Inner Mongolia", "pop": "104090" },
  { "id": 914959, "name": "Kalulushi", "country": "ZM", "admin1": "Copperbelt", "pop": "104046" },
  { "id": 4706057, "name": "Lewisville", "country": "US", "admin1": "Texas", "pop": "104039" },
  {
    "id": 2540689,
    "name": "Oued Zem",
    "country": "MA",
    "admin1": "Béni Mellal-Khénifra",
    "pop": "104029"
  },
  { "id": 1503277, "name": "Kiselëvsk", "country": "RU", "admin1": "Kuzbass", "pop": "104000" },
  {
    "id": 1430991,
    "name": "Soyībug",
    "country": "IN",
    "admin1": "Jammu and Kashmir",
    "pop": "104000"
  },
  { "id": 326406, "name": "Weldiya", "country": "ET", "admin1": "Amhara", "pop": "104000" },
  { "id": 2036418, "name": "Jishu", "country": "CN", "admin1": "Jilin", "pop": "103988" },
  {
    "id": 2549979,
    "name": "El Kelaa des Srarhna",
    "country": "MA",
    "admin1": "Marrakesh-Safi",
    "pop": "103982"
  },
  { "id": 2596934, "name": "Séguéla", "country": "CI", "admin1": "Woroba", "pop": "103980" },
  { "id": 3455729, "name": "Ourinhos", "country": "BR", "admin1": "São Paulo", "pop": "103970" },
  {
    "id": 3588258,
    "name": "Totonicapán",
    "country": "GT",
    "admin1": "Totonicapán",
    "pop": "103952"
  },
  {
    "id": 3408404,
    "name": "Abreu e Lima",
    "country": "BR",
    "admin1": "Pernambuco",
    "pop": "103945"
  },
  { "id": 380173, "name": "Ed Damer", "country": "SD", "admin1": "River Nile", "pop": "103941" },
  { "id": 2633709, "name": "Woking", "country": "GB", "admin1": "England", "pop": "103932" },
  { "id": 1269562, "name": "Jagtiāl", "country": "IN", "admin1": "Telangana", "pop": "103930" },
  { "id": 626081, "name": "Lida", "country": "BY", "admin1": "Grodnenskaya", "pop": "103916" },
  { "id": 1258044, "name": "Roorkee", "country": "IN", "admin1": "Uttarakhand", "pop": "103894" },
  {
    "id": 2842150,
    "name": "Salzgitter",
    "country": "DE",
    "admin1": "Lower Saxony",
    "pop": "103866"
  },
  { "id": 2232239, "name": "Edéa", "country": "CM", "admin1": "Littoral", "pop": "103861" },
  { "id": 1784185, "name": "Yuxi", "country": "CN", "admin1": "Yunnan", "pop": "103829" },
  { "id": 2644487, "name": "Lincoln", "country": "GB", "admin1": "England", "pop": "103813" },
  { "id": 6317781, "name": "Novo Gama", "country": "BR", "admin1": "Goiás", "pop": "103804" },
  { "id": 3453406, "name": "Poá", "country": "BR", "admin1": "São Paulo", "pop": "103765" },
  { "id": 1816865, "name": "Bashan", "country": "CN", "admin1": "Jiangxi", "pop": "103748" },
  { "id": 2328811, "name": "Nkpor", "country": "NG", "admin1": "Anambra", "pop": "103733" },
  {
    "id": 2389086,
    "name": "Berbérati",
    "country": "CF",
    "admin1": "Mambéré-Kadéï",
    "pop": "103713"
  },
  { "id": 3406910, "name": "Bacabal", "country": "BR", "admin1": "Maranhão", "pop": "103711" },
  { "id": 4738214, "name": "Tyler", "country": "US", "admin1": "Texas", "pop": "103700" },
  { "id": 1797091, "name": "Tongren", "country": "CN", "admin1": "Qinghai", "pop": "103700" },
  { "id": 1282027, "name": "Male", "country": "MV", "admin1": "Kaafu Atoll", "pop": "103693" },
  { "id": 5345529, "name": "El Cajon", "country": "US", "admin1": "California", "pop": "103679" },
  {
    "id": 3171058,
    "name": "Piacenza",
    "country": "IT",
    "admin1": "Emilia-Romagna",
    "pop": "103607"
  },
  { "id": 1141857, "name": "Gardez", "country": "AF", "admin1": "Paktia", "pop": "103601" },
  { "id": 607610, "name": "Zhanaozen", "country": "KZ", "admin1": "Mangghystaū", "pop": "103598" },
  {
    "id": 1810724,
    "name": "Gangu Chengguanzhen",
    "country": "CN",
    "admin1": "Gansu",
    "pop": "103589"
  },
  { "id": 3515696, "name": "Teziutlan", "country": "MX", "admin1": "Puebla", "pop": "103583" },
  { "id": 2249782, "name": "Kolda", "country": "SN", "admin1": "Kolda", "pop": "103574" },
  { "id": 1253958, "name": "Udgīr", "country": "IN", "admin1": "Maharashtra", "pop": "103550" },
  { "id": 5392423, "name": "San Mateo", "country": "US", "admin1": "California", "pop": "103536" },
  { "id": 1262209, "name": "Nagda", "country": "IN", "admin1": "Madhya Pradesh", "pop": "103501" },
  {
    "id": 2870221,
    "name": "Moers",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "103487"
  },
  { "id": 4148757, "name": "Brandon", "country": "US", "admin1": "Florida", "pop": "103483" },
  { "id": 683123, "name": "Buzău", "country": "RO", "admin1": "Buzău County", "pop": "103481" },
  { "id": 3111933, "name": "Reus", "country": "ES", "admin1": "Catalonia", "pop": "103477" },
  {
    "id": 1631393,
    "name": "Prabumulih",
    "country": "ID",
    "admin1": "South Sumatra",
    "pop": "103470"
  },
  { "id": 3460974, "name": "Itabaiana", "country": "BR", "admin1": "Sergipe", "pop": "103440" },
  {
    "id": 933778,
    "name": "Francistown",
    "country": "BW",
    "admin1": "City of Francistown",
    "pop": "103417"
  },
  { "id": 1861449, "name": "Isehara", "country": "JP", "admin1": "Kanagawa", "pop": "103401" },
  { "id": 2264268, "name": "Queluz", "country": "PT", "admin1": "Lisbon", "pop": "103399" },
  { "id": 3445859, "name": "Ubá", "country": "BR", "admin1": "Minas Gerais", "pop": "103365" },
  { "id": 1276389, "name": "Betūl", "country": "IN", "admin1": "Madhya Pradesh", "pop": "103330" },
  {
    "id": 1864572,
    "name": "Chikushino-shi",
    "country": "JP",
    "admin1": "Fukuoka",
    "pop": "103311"
  },
  { "id": 298806, "name": "Turgutlu", "country": "TR", "admin1": "Manisa", "pop": "103292" },
  { "id": 1668295, "name": "Taitung", "country": "TW", "admin1": "Taiwan", "pop": "103260" },
  { "id": 2451778, "name": "San", "country": "ML", "admin1": "Ségou", "pop": "103227" },
  { "id": 1269557, "name": "Jahānābād", "country": "IN", "admin1": "Bihar", "pop": "103202" },
  { "id": 6053154, "name": "Lethbridge", "country": "CA", "admin1": "Alberta", "pop": "103197" },
  {
    "id": 476077,
    "name": "Velikiye Luki",
    "country": "RU",
    "admin1": "Pskov Oblast",
    "pop": "103149"
  },
  { "id": 1267579, "name": "Kashipur", "country": "IN", "admin1": "Uttarakhand", "pop": "103138" },
  { "id": 5387288, "name": "Rialto", "country": "US", "admin1": "California", "pop": "103132" },
  { "id": 3460791, "name": "Itanhaém", "country": "BR", "admin1": "São Paulo", "pop": "103102" },
  {
    "id": 1271306,
    "name": "Ghazīpur",
    "country": "IN",
    "admin1": "Uttar Pradesh",
    "pop": "103095"
  },
  {
    "id": 1624877,
    "name": "Tanjung Pandan",
    "country": "ID",
    "admin1": "Bangka–Belitung Islands",
    "pop": "103062"
  },
  {
    "id": 3449521,
    "name": "Santo Antônio de Jesus",
    "country": "BR",
    "admin1": "Bahia",
    "pop": "103055"
  },
  {
    "id": 2338287,
    "name": "Ikere-Ekiti",
    "country": "NG",
    "admin1": "Ekiti State",
    "pop": "103054"
  },
  {
    "id": 2904789,
    "name": "Hildesheim",
    "country": "DE",
    "admin1": "Lower Saxony",
    "pop": "103052"
  },
  { "id": 2176187, "name": "Bendigo", "country": "AU", "admin1": "Victoria", "pop": "103034" },
  {
    "id": 1214073,
    "name": "Rantauprapat",
    "country": "ID",
    "admin1": "North Sumatra",
    "pop": "103009"
  },
  {
    "id": 12261477,
    "name": "Amaravati",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "103000"
  },
  { "id": 8521334, "name": "Nkayi", "country": "CG", "admin1": "Bouenza", "pop": "103000" },
  { "id": 1283161, "name": "Lahān", "country": "NP", "admin1": "Madhesh", "pop": "102955" },
  {
    "id": 3071961,
    "name": "Liberec",
    "country": "CZ",
    "admin1": "Liberecký kraj",
    "pop": "102951"
  },
  {
    "id": 1262260,
    "name": "Nagapattinam",
    "country": "IN",
    "admin1": "Tamil Nadu",
    "pop": "102905"
  },
  {
    "id": 108648,
    "name": "Qurayyat",
    "country": "SA",
    "admin1": "Al Jawf Region",
    "pop": "102903"
  },
  {
    "id": 3488981,
    "name": "Portmore",
    "country": "JM",
    "admin1": "Saint Catherine Parish",
    "pop": "102861"
  },
  { "id": 1275019, "name": "Buxar", "country": "IN", "admin1": "Bihar", "pop": "102861" },
  { "id": 3835994, "name": "Santa Rosa", "country": "AR", "admin1": "La Pampa", "pop": "102860" },
  {
    "id": 3545064,
    "name": "Palma Soriano",
    "country": "CU",
    "admin1": "Santiago de Cuba Province",
    "pop": "102826"
  },
  { "id": 503977, "name": "Pushkino", "country": "RU", "admin1": "Moscow Oblast", "pop": "102816" },
  { "id": 1173687, "name": "Khushāb", "country": "PK", "admin1": "Punjab", "pop": "102793" },
  { "id": 2332504, "name": "Lafiagi", "country": "NG", "admin1": "Kwara State", "pop": "102779" },
  { "id": 3468215, "name": "Caieiras", "country": "BR", "admin1": "São Paulo", "pop": "102775" },
  { "id": 624079, "name": "Orsha", "country": "BY", "admin1": "Vitebsk", "pop": "102759" },
  { "id": 1529363, "name": "Xincheng", "country": "CN", "admin1": "Xinjiang", "pop": "102752" },
  { "id": 1215412, "name": "Belawan", "country": "ID", "admin1": "North Sumatra", "pop": "102707" },
  {
    "id": 670889,
    "name": "Piatra Neamţ",
    "country": "RO",
    "admin1": "Neamț County",
    "pop": "102688"
  },
  { "id": 3647637, "name": "Cabudare", "country": "VE", "admin1": "Lara", "pop": "102686" },
  { "id": 2929567, "name": "Erlangen", "country": "DE", "admin1": "Bavaria", "pop": "102675" },
  { "id": 3817746, "name": "Tepexpan", "country": "MX", "admin1": "México", "pop": "102667" },
  { "id": 2244386, "name": "Tivaouane", "country": "SN", "admin1": "Thiès", "pop": "102658" },
  { "id": 233508, "name": "Entebbe", "country": "UG", "admin1": "Central Region", "pop": "102600" },
  { "id": 4853423, "name": "Davenport", "country": "US", "admin1": "Iowa", "pop": "102582" },
  { "id": 87205, "name": "Darnah", "country": "LY", "admin1": "Darnah", "pop": "102581" },
  { "id": 358269, "name": "Dayrūţ", "country": "EG", "admin1": "Asyut", "pop": "102570" },
  { "id": 5097529, "name": "Edison", "country": "US", "admin1": "New Jersey", "pop": "102548" },
  { "id": 1162456, "name": "Wazirabad", "country": "PK", "admin1": "Punjab", "pop": "102444" },
  { "id": 3892870, "name": "Curicó", "country": "CL", "admin1": "Maule Region", "pop": "102438" },
  { "id": 3509382, "name": "La Vega", "country": "DO", "admin1": "La Vega", "pop": "102426" },
  {
    "id": 1185121,
    "name": "Shāhzādpur",
    "country": "BD",
    "admin1": "Rajshahi Division",
    "pop": "102420"
  },
  { "id": 3515062, "name": "Tulancingo", "country": "MX", "admin1": "Hidalgo", "pop": "102406" },
  { "id": 1848254, "name": "Yono", "country": "JP", "admin1": "Saitama", "pop": "102364" },
  { "id": 4018400, "name": "Apatzingán", "country": "MX", "admin1": "Michoacán", "pop": "102362" },
  { "id": 2082539, "name": "Merauke", "country": "ID", "admin1": "South Papua", "pop": "102351" },
  { "id": 5731371, "name": "Hillsboro", "country": "US", "admin1": "Oregon", "pop": "102347" },
  { "id": 1263494, "name": "Mormugao", "country": "IN", "admin1": "Goa", "pop": "102345" },
  { "id": 1256826, "name": "Seoni", "country": "IN", "admin1": "Madhya Pradesh", "pop": "102343" },
  { "id": 3670502, "name": "Sabanalarga", "country": "CO", "admin1": "Atlántico", "pop": "102334" },
  { "id": 1805270, "name": "Jishou", "country": "CN", "admin1": "Hunan", "pop": "102332" },
  { "id": 183595, "name": "Ngong", "country": "KE", "admin1": "Kajiado County", "pop": "102323" },
  { "id": 2027456, "name": "Artëm", "country": "RU", "admin1": "Primorye", "pop": "102300" },
  { "id": 329114, "name": "Sebeta", "country": "ET", "admin1": "Oromiya", "pop": "102300" },
  { "id": 1849519, "name": "Tsuyama", "country": "JP", "admin1": "Okayama", "pop": "102294" },
  { "id": 3469989, "name": "Birigui", "country": "BR", "admin1": "São Paulo", "pop": "102277" },
  { "id": 1278148, "name": "Aurangābād", "country": "IN", "admin1": "Bihar", "pop": "102244" },
  {
    "id": 3885273,
    "name": "Lampa",
    "country": "CL",
    "admin1": "Santiago Metropolitan",
    "pop": "102234"
  },
  {
    "id": 3460523,
    "name": "Ituiutaba",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "102217"
  },
  { "id": 479411, "name": "Ukhta", "country": "RU", "admin1": "Komi", "pop": "102187" },
  {
    "id": 1151933,
    "name": "Nakhon Si Thammarat",
    "country": "TH",
    "admin1": "Nakhon Si Thammarat",
    "pop": "102152"
  },
  { "id": 3460132, "name": "Japeri", "country": "BR", "admin1": "Rio de Janeiro", "pop": "102149" },
  { "id": 6822216, "name": "Kani", "country": "JP", "admin1": "Gifu", "pop": "102143" },
  { "id": 6648023, "name": "Shuifu", "country": "CN", "admin1": "Yunnan", "pop": "102143" },
  { "id": 6822146, "name": "Ōnojō", "country": "JP", "admin1": "Fukuoka", "pop": "102085" },
  {
    "id": 2219936,
    "name": "Al Jumayl",
    "country": "LY",
    "admin1": "An Nuqāţ al Khams",
    "pop": "102000"
  },
  { "id": 2745641, "name": "Venlo", "country": "NL", "admin1": "Limburg", "pop": "101988" },
  { "id": 3393008, "name": "Parintins", "country": "BR", "admin1": "Amazonas", "pop": "101956" },
  { "id": 3458131, "name": "Mairiporã", "country": "BR", "admin1": "São Paulo", "pop": "101937" },
  { "id": 3172189, "name": "Novara", "country": "IT", "admin1": "Piedmont", "pop": "101916" },
  { "id": 1997228, "name": "Hedong", "country": "CN", "admin1": "Guangdong", "pop": "101825" },
  {
    "id": 1270077,
    "name": "Hinganghāt",
    "country": "IN",
    "admin1": "Maharashtra",
    "pop": "101805"
  },
  { "id": 3406545, "name": "Balsas", "country": "BR", "admin1": "Maranhão", "pop": "101767" },
  {
    "id": 737022,
    "name": "Zonguldak",
    "country": "TR",
    "admin1": "Zonguldak Province",
    "pop": "101749"
  },
  { "id": 311665, "name": "Iğdır", "country": "TR", "admin1": "Iğdır", "pop": "101700" },
  { "id": 6825498, "name": "Kawachi-Nagano", "country": "JP", "admin1": "Osaka", "pop": "101692" },
  { "id": 1272997, "name": "Dhamtari", "country": "IN", "admin1": "Chhattisgarh", "pop": "101677" },
  {
    "id": 5937615,
    "name": "Delta",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "101668"
  },
  {
    "id": 121380,
    "name": "Pārsābād",
    "country": "IR",
    "admin1": "Ardabil Province",
    "pop": "101661"
  },
  { "id": 2633563, "name": "Worcester", "country": "GB", "admin1": "England", "pop": "101659" },
  { "id": 5475352, "name": "Las Cruces", "country": "US", "admin1": "New Mexico", "pop": "101643" },
  { "id": 3044774, "name": "Székesfehérvár", "country": "HU", "admin1": "Fejér", "pop": "101600" },
  { "id": 3459342, "name": "Lagarto", "country": "BR", "admin1": "Sergipe", "pop": "101579" },
  { "id": 2656173, "name": "Bath", "country": "GB", "admin1": "England", "pop": "101557" },
  {
    "id": 2532945,
    "name": "Sidi Slimane",
    "country": "MA",
    "admin1": "Rabat-Salé-Kénitra",
    "pop": "101541"
  },
  { "id": 1861864, "name": "Iida", "country": "JP", "admin1": "Nagano", "pop": "101536" },
  {
    "id": 3649417,
    "name": "Los Puertos de Altagracia",
    "country": "VE",
    "admin1": "Zulia",
    "pop": "101527"
  },
  { "id": 4926563, "name": "South Bend", "country": "US", "admin1": "Indiana", "pop": "101516" },
  {
    "id": 1504682,
    "name": "Kansk",
    "country": "RU",
    "admin1": "Krasnoyarsk Krai",
    "pop": "101502"
  },
  {
    "id": 5921356,
    "name": "Chilliwack",
    "country": "CA",
    "admin1": "British Columbia",
    "pop": "101491"
  },
  {
    "id": 3037044,
    "name": "Argenteuil",
    "country": "FR",
    "admin1": "Île-de-France",
    "pop": "101475"
  },
  {
    "id": 1503772,
    "name": "Khanty-Mansiysk",
    "country": "RU",
    "admin1": "Khanty-Mansia",
    "pop": "101466"
  },
  { "id": 1710470, "name": "Isulan", "country": "PH", "admin1": "Soccsksargen", "pop": "101455" },
  { "id": 2248698, "name": "Mbaké", "country": "SN", "admin1": "Diourbel Region", "pop": "101451" },
  {
    "id": 697889,
    "name": "Pavlohrad",
    "country": "UA",
    "admin1": "Dnipropetrovsk",
    "pop": "101430"
  },
  {
    "id": 741385,
    "name": "Mustafakemalpaşa",
    "country": "TR",
    "admin1": "Bursa Province",
    "pop": "101412"
  },
  { "id": 12640444, "name": "Burayu", "country": "ET", "admin1": "Oromiya", "pop": "101400" },
  {
    "id": 1274213,
    "name": "Chilakalūrupet",
    "country": "IN",
    "admin1": "Andhra Pradesh",
    "pop": "101398"
  },
  { "id": 1264154, "name": "Malappuram", "country": "IN", "admin1": "Kerala", "pop": "101386" },
  { "id": 2232283, "name": "Ébolowa", "country": "CM", "admin1": "South", "pop": "101363" },
  { "id": 5935277, "name": "Dartmouth", "country": "CA", "admin1": "Nova Scotia", "pop": "101343" },
  { "id": 2513076, "name": "Orihuela", "country": "ES", "admin1": "Valencia", "pop": "101321" },
  {
    "id": 1837706,
    "name": "Sangju",
    "country": "KR",
    "admin1": "Gyeongsangbuk-do",
    "pop": "101267"
  },
  { "id": 12750652, "name": "Perling", "country": "MY", "admin1": "Johor", "pop": "101263" },
  {
    "id": 2807363,
    "name": "Witten",
    "country": "DE",
    "admin1": "North Rhine-Westphalia",
    "pop": "101247"
  },
  { "id": 5106834, "name": "Albany", "country": "US", "admin1": "New York", "pop": "101228" },
  {
    "id": 2298330,
    "name": "Medina Estates",
    "country": "GH",
    "admin1": "Greater Accra",
    "pop": "101207"
  },
  { "id": 1181636, "name": "Chakwal", "country": "PK", "admin1": "Punjab", "pop": "101200" },
  { "id": 9534547, "name": "Ngã Bảy", "country": "VN", "admin1": "Can Tho City", "pop": "101192" },
  {
    "id": 3465944,
    "name": "Colatina",
    "country": "BR",
    "admin1": "Espírito Santo",
    "pop": "101190"
  },
  { "id": 2648657, "name": "Gillingham", "country": "GB", "admin1": "England", "pop": "101187" },
  {
    "id": 3446621,
    "name": "Teófilo Otoni",
    "country": "BR",
    "admin1": "Minas Gerais",
    "pop": "101170"
  },
  { "id": 1807738, "name": "Huacheng", "country": "CN", "admin1": "Guangdong", "pop": "101165" },
  {
    "id": 3673662,
    "name": "Ocaña",
    "country": "CO",
    "admin1": "Norte de Santander Department",
    "pop": "101158"
  },
  { "id": 1580400, "name": "Hồng Ngự", "country": "VN", "admin1": "Dong Thap", "pop": "101155" },
  { "id": 2290412, "name": "Daoukro", "country": "CI", "admin1": "Lacs District", "pop": "101136" },
  { "id": 1850152, "name": "Tokuyama", "country": "JP", "admin1": "Yamaguchi", "pop": "101133" },
  { "id": 347296, "name": "Ţimā", "country": "EG", "admin1": "Sohag", "pop": "101130" },
  {
    "id": 1892823,
    "name": "Donghae City",
    "country": "KR",
    "admin1": "Gangwon-do",
    "pop": "101128"
  },
  { "id": 952747, "name": "Standerton", "country": "ZA", "admin1": "Mpumalanga", "pop": "101101" },
  { "id": 1860112, "name": "Kanoya", "country": "JP", "admin1": "Kagoshima", "pop": "101096" },
  { "id": 964315, "name": "Mokopane", "country": "ZA", "admin1": "Limpopo", "pop": "101090" },
  { "id": 358172, "name": "Dikirnis", "country": "EG", "admin1": "Dakahlia", "pop": "101082" },
  {
    "id": 4945121,
    "name": "New Bedford",
    "country": "US",
    "admin1": "Massachusetts",
    "pop": "101079"
  },
  { "id": 126015, "name": "Lāhījān", "country": "IR", "admin1": "Gilan Province", "pop": "101073" },
  { "id": 2792482, "name": "Leuven", "country": "BE", "admin1": "Flanders", "pop": "101032" },
  {
    "id": 1498920,
    "name": "Mezhdurechensk",
    "country": "RU",
    "admin1": "Kuzbass",
    "pop": "101026"
  },
  { "id": 1277214, "name": "Bānswāra", "country": "IN", "admin1": "Rajasthan", "pop": "101017" },
  {
    "id": 1710141,
    "name": "Jolo",
    "country": "PH",
    "admin1": "Autonomous Region in Muslim Mindanao",
    "pop": "101002"
  },
  { "id": 728203, "name": "Pleven", "country": "BG", "admin1": "Pleven", "pop": "100952" },
  { "id": 783263, "name": "Elbasan", "country": "AL", "admin1": "Elbasan County", "pop": "100903" },
  { "id": 1769014, "name": "Ijok", "country": "MY", "admin1": "Selangor", "pop": "100899" },
  { "id": 5406602, "name": "Vista", "country": "US", "admin1": "California", "pop": "100890" },
  { "id": 4152820, "name": "Davie", "country": "US", "admin1": "Florida", "pop": "100882" },
  {
    "id": 7280528,
    "name": "Errachidia",
    "country": "MA",
    "admin1": "Drâa-Tafilalet",
    "pop": "100870"
  },
  { "id": 2294308, "name": "Twifu Praso", "country": "GH", "admin1": "Central", "pop": "100851" },
  { "id": 2267827, "name": "Funchal", "country": "PT", "admin1": "Madeira", "pop": "100847" },
  { "id": 6118158, "name": "Red Deer", "country": "CA", "admin1": "Alberta", "pop": "100844" },
  { "id": 491023, "name": "Solikamsk", "country": "RU", "admin1": "Perm Krai", "pop": "100812" },
  {
    "id": 3610613,
    "name": "El Progreso",
    "country": "HN",
    "admin1": "Yoro Department",
    "pop": "100810"
  },
  {
    "id": 12495083,
    "name": "Chirmiri",
    "country": "IN",
    "admin1": "Chhattisgarh",
    "pop": "100800"
  },
  { "id": 6822097, "name": "Chikusei", "country": "JP", "admin1": "Ibaraki", "pop": "100753" },
  {
    "id": 1625958,
    "name": "Sungailiat",
    "country": "ID",
    "admin1": "Bangka–Belitung Islands",
    "pop": "100750"
  },
  { "id": 3182884, "name": "Arezzo", "country": "IT", "admin1": "Tuscany", "pop": "100734" },
  { "id": 1720508, "name": "Calasiao", "country": "PH", "admin1": "Ilocos", "pop": "100686" },
  {
    "id": 561347,
    "name": "Glazov",
    "country": "RU",
    "admin1": "Udmurtiya Republic",
    "pop": "100676"
  },
  {
    "id": 3988392,
    "name": "Rosarito",
    "country": "MX",
    "admin1": "Baja California",
    "pop": "100660"
  },
  { "id": 261414, "name": "Kallithéa", "country": "GR", "admin1": "Attica", "pop": "100641" },
  { "id": 3708306, "name": "Juan Díaz", "country": "PA", "admin1": "Panamá", "pop": "100636" },
  { "id": 1560349, "name": "Yên Bái", "country": "VN", "admin1": "Lao Cai", "pop": "100631" },
  { "id": 1643761, "name": "Grogol", "country": "ID", "admin1": "Central Java", "pop": "100613" },
  {
    "id": 99226,
    "name": "Nāḩiyat al Iskandarīyah",
    "country": "IQ",
    "admin1": "Bābil",
    "pop": "100600"
  },
  {
    "id": 3591062,
    "name": "Puerto Barrios",
    "country": "GT",
    "admin1": "Izabal Department",
    "pop": "100593"
  },
  { "id": 220075, "name": "Bakwa", "country": "CD", "admin1": "Haut-Uele", "pop": "100575" },
  { "id": 1269653, "name": "Itārsi", "country": "IN", "admin1": "Madhya Pradesh", "pop": "100574" },
  { "id": 1581052, "name": "Hà Tiên", "country": "VN", "admin1": "An Giang", "pop": "100560" },
  { "id": 3633677, "name": "Los Rastrojos", "country": "VE", "admin1": "Lara", "pop": "100497" },
  { "id": 1253367, "name": "Vasco da Gama", "country": "IN", "admin1": "Goa", "pop": "100485" },
  {
    "id": 3109453,
    "name": "Barakaldo",
    "country": "ES",
    "admin1": "Basque Country",
    "pop": "100435"
  },
  { "id": 1804120, "name": "Lianjiang", "country": "CN", "admin1": "Guangdong", "pop": "100341" },
  { "id": 1005125, "name": "Ermelo", "country": "ZA", "admin1": "Mpumalanga", "pop": "100324" },
  {
    "id": 2774326,
    "name": "Klagenfurt am Wörthersee",
    "country": "AT",
    "admin1": "Carinthia",
    "pop": "100316"
  },
  { "id": 1803334, "name": "Linxi", "country": "CN", "admin1": "Hebei", "pop": "100316" },
  { "id": 2244616, "name": "Tiébo", "country": "SN", "admin1": "Diourbel Region", "pop": "100289" },
  { "id": 1271631, "name": "Gangtok", "country": "IN", "admin1": "Sikkim", "pop": "100286" },
  { "id": 1273403, "name": "Datia", "country": "IN", "admin1": "Madhya Pradesh", "pop": "100284" },
  { "id": 1853209, "name": "Sakado", "country": "JP", "admin1": "Saitama", "pop": "100275" },
  { "id": 1853140, "name": "Sakata", "country": "JP", "admin1": "Yamagata", "pop": "100273" },
  {
    "id": 2013952,
    "name": "Ust’-Ilimsk",
    "country": "RU",
    "admin1": "Irkutsk Oblast",
    "pop": "100271"
  },
  { "id": 3121456, "name": "Girona", "country": "ES", "admin1": "Catalonia", "pop": "100266" },
  { "id": 5808189, "name": "Renton", "country": "US", "admin1": "Washington", "pop": "100242" },
  {
    "id": 126409,
    "name": "Kūhdasht",
    "country": "IR",
    "admin1": "Lorestan Province",
    "pop": "100208"
  },
  { "id": 1514192, "name": "Chust", "country": "UZ", "admin1": "Namangan", "pop": "100200" },
  {
    "id": 1242110,
    "name": "Kalmunai",
    "country": "LK",
    "admin1": "Eastern Province",
    "pop": "100171"
  },
  {
    "id": 3165072,
    "name": "Udine",
    "country": "IT",
    "admin1": "Friuli Venezia Giulia",
    "pop": "100170"
  },
  { "id": 1788492, "name": "Xinzhai", "country": "CN", "admin1": "Shandong", "pop": "100168" },
  { "id": 1259827, "name": "Phagwāra", "country": "IN", "admin1": "Punjab", "pop": "100146" },
  { "id": 690688, "name": "Uman", "country": "UA", "admin1": "Cherkasy", "pop": "100135" },
  { "id": 1861091, "name": "Izumisano", "country": "JP", "admin1": "Osaka", "pop": "100131" },
  { "id": 2821164, "name": "Trier", "country": "DE", "admin1": "Rheinland-Pfalz", "pop": "100129" },
  { "id": 1863627, "name": "Ginowan", "country": "JP", "admin1": "Okinawa", "pop": "100125" },
  { "id": 334227, "name": "Inda Silasē", "country": "ET", "admin1": "Tigray", "pop": "100100" },
  {
    "id": 2213618,
    "name": "Qaşr Bin Ghashīr",
    "country": "LY",
    "admin1": "Tripoli",
    "pop": "100069"
  },
  {
    "id": 3494242,
    "name": "Punta Cana",
    "country": "DO",
    "admin1": "La Altagracia Province",
    "pop": "100023"
  },
  { "id": 4782167, "name": "Roanoke", "country": "US", "admin1": "Virginia", "pop": "100011" },
  {
    "id": 13061022,
    "name": "Bandar Mahkota Cheras",
    "country": "MY",
    "admin1": "Selangor",
    "pop": "100000"
  },
  {
    "id": 11670045,
    "name": "Sabt Alalayah",
    "country": "SA",
    "admin1": "'Asir Region",
    "pop": "100000"
  },
  { "id": 7792200, "name": "Seri Manjung", "country": "MY", "admin1": "Perak", "pop": "100000" },
  { "id": 7279599, "name": "Airoli", "country": "IN", "admin1": "Maharashtra", "pop": "100000" },
  { "id": 3189595, "name": "Subotica", "country": "RS", "admin1": "Vojvodina", "pop": "100000" },
  { "id": 2210394, "name": "Tājūrā’", "country": "LY", "admin1": "Tripoli", "pop": "100000" },
  {
    "id": 1871871,
    "name": "P’yŏngsŏng",
    "country": "KP",
    "admin1": "South Pyongan",
    "pop": "100000"
  },
  { "id": 1802171, "name": "Kangding", "country": "CN", "admin1": "Sichuan", "pop": "100000" },
  { "id": 1744763, "name": "Sentul", "country": "MY", "admin1": "Kuala Lumpur", "pop": "100000" },
  { "id": 1170157, "name": "Model Town", "country": "PK", "admin1": "Punjab", "pop": "100000" },
  {
    "id": 201650,
    "name": "Nyagatare",
    "country": "RW",
    "admin1": "Eastern Province",
    "pop": "100000"
  }
]
